(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/_axios@0.19.2@axios/index.js":
/*!***************************************************!*\
  !*** ./node_modules/_axios@0.19.2@axios/index.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./lib/axios */ "./node_modules/_axios@0.19.2@axios/lib/axios.js");

/***/ }),

/***/ "./node_modules/_axios@0.19.2@axios/lib/adapters/xhr.js":
/*!**************************************************************!*\
  !*** ./node_modules/_axios@0.19.2@axios/lib/adapters/xhr.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "./node_modules/_axios@0.19.2@axios/lib/utils.js");
var settle = __webpack_require__(/*! ./../core/settle */ "./node_modules/_axios@0.19.2@axios/lib/core/settle.js");
var buildURL = __webpack_require__(/*! ./../helpers/buildURL */ "./node_modules/_axios@0.19.2@axios/lib/helpers/buildURL.js");
var buildFullPath = __webpack_require__(/*! ../core/buildFullPath */ "./node_modules/_axios@0.19.2@axios/lib/core/buildFullPath.js");
var parseHeaders = __webpack_require__(/*! ./../helpers/parseHeaders */ "./node_modules/_axios@0.19.2@axios/lib/helpers/parseHeaders.js");
var isURLSameOrigin = __webpack_require__(/*! ./../helpers/isURLSameOrigin */ "./node_modules/_axios@0.19.2@axios/lib/helpers/isURLSameOrigin.js");
var createError = __webpack_require__(/*! ../core/createError */ "./node_modules/_axios@0.19.2@axios/lib/core/createError.js");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(/*! ./../helpers/cookies */ "./node_modules/_axios@0.19.2@axios/lib/helpers/cookies.js");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "./node_modules/_axios@0.19.2@axios/lib/axios.js":
/*!*******************************************************!*\
  !*** ./node_modules/_axios@0.19.2@axios/lib/axios.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./utils */ "./node_modules/_axios@0.19.2@axios/lib/utils.js");
var bind = __webpack_require__(/*! ./helpers/bind */ "./node_modules/_axios@0.19.2@axios/lib/helpers/bind.js");
var Axios = __webpack_require__(/*! ./core/Axios */ "./node_modules/_axios@0.19.2@axios/lib/core/Axios.js");
var mergeConfig = __webpack_require__(/*! ./core/mergeConfig */ "./node_modules/_axios@0.19.2@axios/lib/core/mergeConfig.js");
var defaults = __webpack_require__(/*! ./defaults */ "./node_modules/_axios@0.19.2@axios/lib/defaults.js");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(/*! ./cancel/Cancel */ "./node_modules/_axios@0.19.2@axios/lib/cancel/Cancel.js");
axios.CancelToken = __webpack_require__(/*! ./cancel/CancelToken */ "./node_modules/_axios@0.19.2@axios/lib/cancel/CancelToken.js");
axios.isCancel = __webpack_require__(/*! ./cancel/isCancel */ "./node_modules/_axios@0.19.2@axios/lib/cancel/isCancel.js");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(/*! ./helpers/spread */ "./node_modules/_axios@0.19.2@axios/lib/helpers/spread.js");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ "./node_modules/_axios@0.19.2@axios/lib/cancel/Cancel.js":
/*!***************************************************************!*\
  !*** ./node_modules/_axios@0.19.2@axios/lib/cancel/Cancel.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "./node_modules/_axios@0.19.2@axios/lib/cancel/CancelToken.js":
/*!********************************************************************!*\
  !*** ./node_modules/_axios@0.19.2@axios/lib/cancel/CancelToken.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(/*! ./Cancel */ "./node_modules/_axios@0.19.2@axios/lib/cancel/Cancel.js");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "./node_modules/_axios@0.19.2@axios/lib/cancel/isCancel.js":
/*!*****************************************************************!*\
  !*** ./node_modules/_axios@0.19.2@axios/lib/cancel/isCancel.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "./node_modules/_axios@0.19.2@axios/lib/core/Axios.js":
/*!************************************************************!*\
  !*** ./node_modules/_axios@0.19.2@axios/lib/core/Axios.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "./node_modules/_axios@0.19.2@axios/lib/utils.js");
var buildURL = __webpack_require__(/*! ../helpers/buildURL */ "./node_modules/_axios@0.19.2@axios/lib/helpers/buildURL.js");
var InterceptorManager = __webpack_require__(/*! ./InterceptorManager */ "./node_modules/_axios@0.19.2@axios/lib/core/InterceptorManager.js");
var dispatchRequest = __webpack_require__(/*! ./dispatchRequest */ "./node_modules/_axios@0.19.2@axios/lib/core/dispatchRequest.js");
var mergeConfig = __webpack_require__(/*! ./mergeConfig */ "./node_modules/_axios@0.19.2@axios/lib/core/mergeConfig.js");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "./node_modules/_axios@0.19.2@axios/lib/core/InterceptorManager.js":
/*!*************************************************************************!*\
  !*** ./node_modules/_axios@0.19.2@axios/lib/core/InterceptorManager.js ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "./node_modules/_axios@0.19.2@axios/lib/utils.js");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "./node_modules/_axios@0.19.2@axios/lib/core/buildFullPath.js":
/*!********************************************************************!*\
  !*** ./node_modules/_axios@0.19.2@axios/lib/core/buildFullPath.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(/*! ../helpers/isAbsoluteURL */ "./node_modules/_axios@0.19.2@axios/lib/helpers/isAbsoluteURL.js");
var combineURLs = __webpack_require__(/*! ../helpers/combineURLs */ "./node_modules/_axios@0.19.2@axios/lib/helpers/combineURLs.js");

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ "./node_modules/_axios@0.19.2@axios/lib/core/createError.js":
/*!******************************************************************!*\
  !*** ./node_modules/_axios@0.19.2@axios/lib/core/createError.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(/*! ./enhanceError */ "./node_modules/_axios@0.19.2@axios/lib/core/enhanceError.js");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "./node_modules/_axios@0.19.2@axios/lib/core/dispatchRequest.js":
/*!**********************************************************************!*\
  !*** ./node_modules/_axios@0.19.2@axios/lib/core/dispatchRequest.js ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "./node_modules/_axios@0.19.2@axios/lib/utils.js");
var transformData = __webpack_require__(/*! ./transformData */ "./node_modules/_axios@0.19.2@axios/lib/core/transformData.js");
var isCancel = __webpack_require__(/*! ../cancel/isCancel */ "./node_modules/_axios@0.19.2@axios/lib/cancel/isCancel.js");
var defaults = __webpack_require__(/*! ../defaults */ "./node_modules/_axios@0.19.2@axios/lib/defaults.js");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "./node_modules/_axios@0.19.2@axios/lib/core/enhanceError.js":
/*!*******************************************************************!*\
  !*** ./node_modules/_axios@0.19.2@axios/lib/core/enhanceError.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),

/***/ "./node_modules/_axios@0.19.2@axios/lib/core/mergeConfig.js":
/*!******************************************************************!*\
  !*** ./node_modules/_axios@0.19.2@axios/lib/core/mergeConfig.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ../utils */ "./node_modules/_axios@0.19.2@axios/lib/utils.js");

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),

/***/ "./node_modules/_axios@0.19.2@axios/lib/core/settle.js":
/*!*************************************************************!*\
  !*** ./node_modules/_axios@0.19.2@axios/lib/core/settle.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(/*! ./createError */ "./node_modules/_axios@0.19.2@axios/lib/core/createError.js");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "./node_modules/_axios@0.19.2@axios/lib/core/transformData.js":
/*!********************************************************************!*\
  !*** ./node_modules/_axios@0.19.2@axios/lib/core/transformData.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "./node_modules/_axios@0.19.2@axios/lib/utils.js");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ "./node_modules/_axios@0.19.2@axios/lib/defaults.js":
/*!**********************************************************!*\
  !*** ./node_modules/_axios@0.19.2@axios/lib/defaults.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(/*! ./utils */ "./node_modules/_axios@0.19.2@axios/lib/utils.js");
var normalizeHeaderName = __webpack_require__(/*! ./helpers/normalizeHeaderName */ "./node_modules/_axios@0.19.2@axios/lib/helpers/normalizeHeaderName.js");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(/*! ./adapters/xhr */ "./node_modules/_axios@0.19.2@axios/lib/adapters/xhr.js");
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(/*! ./adapters/http */ "./node_modules/_axios@0.19.2@axios/lib/adapters/xhr.js");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../_process@0.11.10@process/browser.js */ "./node_modules/_process@0.11.10@process/browser.js")))

/***/ }),

/***/ "./node_modules/_axios@0.19.2@axios/lib/helpers/bind.js":
/*!**************************************************************!*\
  !*** ./node_modules/_axios@0.19.2@axios/lib/helpers/bind.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "./node_modules/_axios@0.19.2@axios/lib/helpers/buildURL.js":
/*!******************************************************************!*\
  !*** ./node_modules/_axios@0.19.2@axios/lib/helpers/buildURL.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "./node_modules/_axios@0.19.2@axios/lib/utils.js");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "./node_modules/_axios@0.19.2@axios/lib/helpers/combineURLs.js":
/*!*********************************************************************!*\
  !*** ./node_modules/_axios@0.19.2@axios/lib/helpers/combineURLs.js ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "./node_modules/_axios@0.19.2@axios/lib/helpers/cookies.js":
/*!*****************************************************************!*\
  !*** ./node_modules/_axios@0.19.2@axios/lib/helpers/cookies.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "./node_modules/_axios@0.19.2@axios/lib/utils.js");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ "./node_modules/_axios@0.19.2@axios/lib/helpers/isAbsoluteURL.js":
/*!***********************************************************************!*\
  !*** ./node_modules/_axios@0.19.2@axios/lib/helpers/isAbsoluteURL.js ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "./node_modules/_axios@0.19.2@axios/lib/helpers/isURLSameOrigin.js":
/*!*************************************************************************!*\
  !*** ./node_modules/_axios@0.19.2@axios/lib/helpers/isURLSameOrigin.js ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "./node_modules/_axios@0.19.2@axios/lib/utils.js");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ "./node_modules/_axios@0.19.2@axios/lib/helpers/normalizeHeaderName.js":
/*!*****************************************************************************!*\
  !*** ./node_modules/_axios@0.19.2@axios/lib/helpers/normalizeHeaderName.js ***!
  \*****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ../utils */ "./node_modules/_axios@0.19.2@axios/lib/utils.js");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "./node_modules/_axios@0.19.2@axios/lib/helpers/parseHeaders.js":
/*!**********************************************************************!*\
  !*** ./node_modules/_axios@0.19.2@axios/lib/helpers/parseHeaders.js ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "./node_modules/_axios@0.19.2@axios/lib/utils.js");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "./node_modules/_axios@0.19.2@axios/lib/helpers/spread.js":
/*!****************************************************************!*\
  !*** ./node_modules/_axios@0.19.2@axios/lib/helpers/spread.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "./node_modules/_axios@0.19.2@axios/lib/utils.js":
/*!*******************************************************!*\
  !*** ./node_modules/_axios@0.19.2@axios/lib/utils.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(/*! ./helpers/bind */ "./node_modules/_axios@0.19.2@axios/lib/helpers/bind.js");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/aes.js":
/*!********************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/aes.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"), __webpack_require__(/*! ./enc-base64 */ "./node_modules/_crypto-js@3.3.0@crypto-js/enc-base64.js"), __webpack_require__(/*! ./md5 */ "./node_modules/_crypto-js@3.3.0@crypto-js/md5.js"), __webpack_require__(/*! ./evpkdf */ "./node_modules/_crypto-js@3.3.0@crypto-js/evpkdf.js"), __webpack_require__(/*! ./cipher-core */ "./node_modules/_crypto-js@3.3.0@crypto-js/cipher-core.js"));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Lookup tables
	    var SBOX = [];
	    var INV_SBOX = [];
	    var SUB_MIX_0 = [];
	    var SUB_MIX_1 = [];
	    var SUB_MIX_2 = [];
	    var SUB_MIX_3 = [];
	    var INV_SUB_MIX_0 = [];
	    var INV_SUB_MIX_1 = [];
	    var INV_SUB_MIX_2 = [];
	    var INV_SUB_MIX_3 = [];

	    // Compute lookup tables
	    (function () {
	        // Compute double table
	        var d = [];
	        for (var i = 0; i < 256; i++) {
	            if (i < 128) {
	                d[i] = i << 1;
	            } else {
	                d[i] = (i << 1) ^ 0x11b;
	            }
	        }

	        // Walk GF(2^8)
	        var x = 0;
	        var xi = 0;
	        for (var i = 0; i < 256; i++) {
	            // Compute sbox
	            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	            SBOX[x] = sx;
	            INV_SBOX[sx] = x;

	            // Compute multiplication
	            var x2 = d[x];
	            var x4 = d[x2];
	            var x8 = d[x4];

	            // Compute sub bytes, mix columns tables
	            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
	            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
	            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
	            SUB_MIX_3[x] = t;

	            // Compute inv sub bytes, inv mix columns tables
	            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
	            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
	            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
	            INV_SUB_MIX_3[sx] = t;

	            // Compute next counter
	            if (!x) {
	                x = xi = 1;
	            } else {
	                x = x2 ^ d[d[d[x8 ^ x2]]];
	                xi ^= d[d[xi]];
	            }
	        }
	    }());

	    // Precomputed Rcon lookup
	    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];

	    /**
	     * AES block cipher algorithm.
	     */
	    var AES = C_algo.AES = BlockCipher.extend({
	        _doReset: function () {
	            // Skip reset of nRounds has been set before and key did not change
	            if (this._nRounds && this._keyPriorReset === this._key) {
	                return;
	            }

	            // Shortcuts
	            var key = this._keyPriorReset = this._key;
	            var keyWords = key.words;
	            var keySize = key.sigBytes / 4;

	            // Compute number of rounds
	            var nRounds = this._nRounds = keySize + 6;

	            // Compute number of key schedule rows
	            var ksRows = (nRounds + 1) * 4;

	            // Compute key schedule
	            var keySchedule = this._keySchedule = [];
	            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
	                if (ksRow < keySize) {
	                    keySchedule[ksRow] = keyWords[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 1];

	                    if (!(ksRow % keySize)) {
	                        // Rot word
	                        t = (t << 8) | (t >>> 24);

	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];

	                        // Mix Rcon
	                        t ^= RCON[(ksRow / keySize) | 0] << 24;
	                    } else if (keySize > 6 && ksRow % keySize == 4) {
	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
	                    }

	                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
	                }
	            }

	            // Compute inv key schedule
	            var invKeySchedule = this._invKeySchedule = [];
	            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
	                var ksRow = ksRows - invKsRow;

	                if (invKsRow % 4) {
	                    var t = keySchedule[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 4];
	                }

	                if (invKsRow < 4 || ksRow <= 4) {
	                    invKeySchedule[invKsRow] = t;
	                } else {
	                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
	                                               INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
	                }
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
	        },

	        decryptBlock: function (M, offset) {
	            // Swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;

	            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);

	            // Inv swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;
	        },

	        _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
	            // Shortcut
	            var nRounds = this._nRounds;

	            // Get input, add round key
	            var s0 = M[offset]     ^ keySchedule[0];
	            var s1 = M[offset + 1] ^ keySchedule[1];
	            var s2 = M[offset + 2] ^ keySchedule[2];
	            var s3 = M[offset + 3] ^ keySchedule[3];

	            // Key schedule row counter
	            var ksRow = 4;

	            // Rounds
	            for (var round = 1; round < nRounds; round++) {
	                // Shift rows, sub bytes, mix columns, add round key
	                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
	                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
	                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
	                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];

	                // Update state
	                s0 = t0;
	                s1 = t1;
	                s2 = t2;
	                s3 = t3;
	            }

	            // Shift rows, sub bytes, add round key
	            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];

	            // Set output
	            M[offset]     = t0;
	            M[offset + 1] = t1;
	            M[offset + 2] = t2;
	            M[offset + 3] = t3;
	        },

	        keySize: 256/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */
	    C.AES = BlockCipher._createHelper(AES);
	}());


	return CryptoJS.AES;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/cipher-core.js":
/*!****************************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/cipher-core.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"), __webpack_require__(/*! ./evpkdf */ "./node_modules/_crypto-js@3.3.0@crypto-js/evpkdf.js"));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * Cipher core components.
	 */
	CryptoJS.lib.Cipher || (function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var Base64 = C_enc.Base64;
	    var C_algo = C.algo;
	    var EvpKDF = C_algo.EvpKDF;

	    /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */
	    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */
	        cfg: Base.extend(),

	        /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createEncryptor: function (key, cfg) {
	            return this.create(this._ENC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createDecryptor: function (key, cfg) {
	            return this.create(this._DEC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */
	        init: function (xformMode, key, cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Store transform mode and key
	            this._xformMode = xformMode;
	            this._key = key;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-cipher logic
	            this._doReset();
	        },

	        /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */
	        process: function (dataUpdate) {
	            // Append
	            this._append(dataUpdate);

	            // Process available blocks
	            return this._process();
	        },

	        /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */
	        finalize: function (dataUpdate) {
	            // Final data update
	            if (dataUpdate) {
	                this._append(dataUpdate);
	            }

	            // Perform concrete-cipher logic
	            var finalProcessedData = this._doFinalize();

	            return finalProcessedData;
	        },

	        keySize: 128/32,

	        ivSize: 128/32,

	        _ENC_XFORM_MODE: 1,

	        _DEC_XFORM_MODE: 2,

	        /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */
	        _createHelper: (function () {
	            function selectCipherStrategy(key) {
	                if (typeof key == 'string') {
	                    return PasswordBasedCipher;
	                } else {
	                    return SerializableCipher;
	                }
	            }

	            return function (cipher) {
	                return {
	                    encrypt: function (message, key, cfg) {
	                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
	                    },

	                    decrypt: function (ciphertext, key, cfg) {
	                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
	                    }
	                };
	            };
	        }())
	    });

	    /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */
	    var StreamCipher = C_lib.StreamCipher = Cipher.extend({
	        _doFinalize: function () {
	            // Process partial blocks
	            var finalProcessedBlocks = this._process(!!'flush');

	            return finalProcessedBlocks;
	        },

	        blockSize: 1
	    });

	    /**
	     * Mode namespace.
	     */
	    var C_mode = C.mode = {};

	    /**
	     * Abstract base block cipher mode template.
	     */
	    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
	        /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */
	        createEncryptor: function (cipher, iv) {
	            return this.Encryptor.create(cipher, iv);
	        },

	        /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */
	        createDecryptor: function (cipher, iv) {
	            return this.Decryptor.create(cipher, iv);
	        },

	        /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */
	        init: function (cipher, iv) {
	            this._cipher = cipher;
	            this._iv = iv;
	        }
	    });

	    /**
	     * Cipher Block Chaining mode.
	     */
	    var CBC = C_mode.CBC = (function () {
	        /**
	         * Abstract base CBC mode.
	         */
	        var CBC = BlockCipherMode.extend();

	        /**
	         * CBC encryptor.
	         */
	        CBC.Encryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // XOR and encrypt
	                xorBlock.call(this, words, offset, blockSize);
	                cipher.encryptBlock(words, offset);

	                // Remember this block to use with next block
	                this._prevBlock = words.slice(offset, offset + blockSize);
	            }
	        });

	        /**
	         * CBC decryptor.
	         */
	        CBC.Decryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // Remember this block to use with next block
	                var thisBlock = words.slice(offset, offset + blockSize);

	                // Decrypt and XOR
	                cipher.decryptBlock(words, offset);
	                xorBlock.call(this, words, offset, blockSize);

	                // This block becomes the previous block
	                this._prevBlock = thisBlock;
	            }
	        });

	        function xorBlock(words, offset, blockSize) {
	            // Shortcut
	            var iv = this._iv;

	            // Choose mixing block
	            if (iv) {
	                var block = iv;

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            } else {
	                var block = this._prevBlock;
	            }

	            // XOR blocks
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= block[i];
	            }
	        }

	        return CBC;
	    }());

	    /**
	     * Padding namespace.
	     */
	    var C_pad = C.pad = {};

	    /**
	     * PKCS #5/7 padding strategy.
	     */
	    var Pkcs7 = C_pad.Pkcs7 = {
	        /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */
	        pad: function (data, blockSize) {
	            // Shortcut
	            var blockSizeBytes = blockSize * 4;

	            // Count padding bytes
	            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	            // Create padding word
	            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;

	            // Create padding
	            var paddingWords = [];
	            for (var i = 0; i < nPaddingBytes; i += 4) {
	                paddingWords.push(paddingWord);
	            }
	            var padding = WordArray.create(paddingWords, nPaddingBytes);

	            // Add padding
	            data.concat(padding);
	        },

	        /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */
	        unpad: function (data) {
	            // Get number of padding bytes from last byte
	            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	            // Remove padding
	            data.sigBytes -= nPaddingBytes;
	        }
	    };

	    /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */
	    var BlockCipher = C_lib.BlockCipher = Cipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */
	        cfg: Cipher.cfg.extend({
	            mode: CBC,
	            padding: Pkcs7
	        }),

	        reset: function () {
	            // Reset cipher
	            Cipher.reset.call(this);

	            // Shortcuts
	            var cfg = this.cfg;
	            var iv = cfg.iv;
	            var mode = cfg.mode;

	            // Reset block mode
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                var modeCreator = mode.createEncryptor;
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                var modeCreator = mode.createDecryptor;
	                // Keep at least one block in the buffer for unpadding
	                this._minBufferSize = 1;
	            }

	            if (this._mode && this._mode.__creator == modeCreator) {
	                this._mode.init(this, iv && iv.words);
	            } else {
	                this._mode = modeCreator.call(mode, this, iv && iv.words);
	                this._mode.__creator = modeCreator;
	            }
	        },

	        _doProcessBlock: function (words, offset) {
	            this._mode.processBlock(words, offset);
	        },

	        _doFinalize: function () {
	            // Shortcut
	            var padding = this.cfg.padding;

	            // Finalize
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                // Pad data
	                padding.pad(this._data, this.blockSize);

	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');

	                // Unpad data
	                padding.unpad(finalProcessedBlocks);
	            }

	            return finalProcessedBlocks;
	        },

	        blockSize: 128/32
	    });

	    /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */
	    var CipherParams = C_lib.CipherParams = Base.extend({
	        /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */
	        init: function (cipherParams) {
	            this.mixIn(cipherParams);
	        },

	        /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */
	        toString: function (formatter) {
	            return (formatter || this.formatter).stringify(this);
	        }
	    });

	    /**
	     * Format namespace.
	     */
	    var C_format = C.format = {};

	    /**
	     * OpenSSL formatting strategy.
	     */
	    var OpenSSLFormatter = C_format.OpenSSL = {
	        /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            // Shortcuts
	            var ciphertext = cipherParams.ciphertext;
	            var salt = cipherParams.salt;

	            // Format
	            if (salt) {
	                var wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
	            } else {
	                var wordArray = ciphertext;
	            }

	            return wordArray.toString(Base64);
	        },

	        /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */
	        parse: function (openSSLStr) {
	            // Parse base64
	            var ciphertext = Base64.parse(openSSLStr);

	            // Shortcut
	            var ciphertextWords = ciphertext.words;

	            // Test for salt
	            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
	                // Extract salt
	                var salt = WordArray.create(ciphertextWords.slice(2, 4));

	                // Remove salt from ciphertext
	                ciphertextWords.splice(0, 4);
	                ciphertext.sigBytes -= 16;
	            }

	            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
	        }
	    };

	    /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */
	    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */
	        cfg: Base.extend({
	            format: OpenSSLFormatter
	        }),

	        /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Encrypt
	            var encryptor = cipher.createEncryptor(key, cfg);
	            var ciphertext = encryptor.finalize(message);

	            // Shortcut
	            var cipherCfg = encryptor.cfg;

	            // Create and return serializable cipher params
	            return CipherParams.create({
	                ciphertext: ciphertext,
	                key: key,
	                iv: cipherCfg.iv,
	                algorithm: cipher,
	                mode: cipherCfg.mode,
	                padding: cipherCfg.padding,
	                blockSize: cipher.blockSize,
	                formatter: cfg.format
	            });
	        },

	        /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Decrypt
	            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);

	            return plaintext;
	        },

	        /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */
	        _parse: function (ciphertext, format) {
	            if (typeof ciphertext == 'string') {
	                return format.parse(ciphertext, this);
	            } else {
	                return ciphertext;
	            }
	        }
	    });

	    /**
	     * Key derivation function namespace.
	     */
	    var C_kdf = C.kdf = {};

	    /**
	     * OpenSSL key derivation function.
	     */
	    var OpenSSLKdf = C_kdf.OpenSSL = {
	        /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */
	        execute: function (password, keySize, ivSize, salt) {
	            // Generate random salt
	            if (!salt) {
	                salt = WordArray.random(64/8);
	            }

	            // Derive key and IV
	            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);

	            // Separate key and IV
	            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
	            key.sigBytes = keySize * 4;

	            // Return params
	            return CipherParams.create({ key: key, iv: iv, salt: salt });
	        }
	    };

	    /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */
	    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */
	        cfg: SerializableCipher.cfg.extend({
	            kdf: OpenSSLKdf
	        }),

	        /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Encrypt
	            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);

	            // Mix in derived params
	            ciphertext.mixIn(derivedParams);

	            return ciphertext;
	        },

	        /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Decrypt
	            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);

	            return plaintext;
	        }
	    });
	}());


}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js":
/*!*********************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/core.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else {}
}(this, function () {

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {
	    /*
	     * Local polyfil of Object.create
	     */
	    var create = Object.create || (function () {
	        function F() {};

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }())

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var i = 0; i < thatSigBytes; i += 4) {
	                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            var r = (function (m_w) {
	                var m_w = m_w;
	                var m_z = 0x3ade68b1;
	                var mask = 0xffffffff;

	                return function () {
	                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
	                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
	                    var result = ((m_z << 0x10) + m_w) & mask;
	                    result /= 0x100000000;
	                    result += 0.5;
	                    return result * (Math.random() > .5 ? 1 : -1);
	                }
	            });

	            for (var i = 0, rcache; i < nBytes; i += 4) {
	                var _r = r((rcache || Math.random()) * 0x100000000);

	                rcache = _r() * 0x3ade67b7;
	                words.push((_r() * 0x100000000) | 0);
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                var processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/enc-base64.js":
/*!***************************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/enc-base64.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    var Base64 = C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                    reverseMap = this._reverseMap = [];
	                    for (var j = 0; j < map.length; j++) {
	                        reverseMap[map.charCodeAt(j)] = j;
	                    }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	      var words = [];
	      var nBytes = 0;
	      for (var i = 0; i < base64StrLength; i++) {
	          if (i % 4) {
	              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	              words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
	              nBytes++;
	          }
	      }
	      return WordArray.create(words, nBytes);
	    }
	}());


	return CryptoJS.enc.Base64;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/enc-utf16.js":
/*!**************************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/enc-utf16.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * UTF-16 BE encoding strategy.
	     */
	    var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
	        /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff;
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= utf16Str.charCodeAt(i) << (16 - (i % 2) * 16);
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    /**
	     * UTF-16 LE encoding strategy.
	     */
	    C_enc.Utf16LE = {
	        /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = swapEndian((words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff);
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << (16 - (i % 2) * 16));
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    function swapEndian(word) {
	        return ((word << 8) & 0xff00ff00) | ((word >>> 8) & 0x00ff00ff);
	    }
	}());


	return CryptoJS.enc.Utf16;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/evpkdf.js":
/*!***********************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/evpkdf.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"), __webpack_require__(/*! ./sha1 */ "./node_modules/_crypto-js@3.3.0@crypto-js/sha1.js"), __webpack_require__(/*! ./hmac */ "./node_modules/_crypto-js@3.3.0@crypto-js/hmac.js"));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var MD5 = C_algo.MD5;

	    /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */
	    var EvpKDF = C_algo.EvpKDF = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: MD5,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init hasher
	            var hasher = cfg.hasher.create();

	            // Initial values
	            var derivedKey = WordArray.create();

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                if (block) {
	                    hasher.update(block);
	                }
	                var block = hasher.update(password).finalize(salt);
	                hasher.reset();

	                // Iterations
	                for (var i = 1; i < iterations; i++) {
	                    block = hasher.finalize(block);
	                    hasher.reset();
	                }

	                derivedKey.concat(block);
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.EvpKDF = function (password, salt, cfg) {
	        return EvpKDF.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.EvpKDF;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/format-hex.js":
/*!***************************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/format-hex.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"), __webpack_require__(/*! ./cipher-core */ "./node_modules/_crypto-js@3.3.0@crypto-js/cipher-core.js"));
	}
	else {}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var CipherParams = C_lib.CipherParams;
	    var C_enc = C.enc;
	    var Hex = C_enc.Hex;
	    var C_format = C.format;

	    var HexFormatter = C_format.Hex = {
	        /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            return cipherParams.ciphertext.toString(Hex);
	        },

	        /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */
	        parse: function (input) {
	            var ciphertext = Hex.parse(input);
	            return CipherParams.create({ ciphertext: ciphertext });
	        }
	    };
	}());


	return CryptoJS.format.Hex;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/hmac.js":
/*!*********************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/hmac.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    var HMAC = C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/index.js":
/*!**********************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/index.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"), __webpack_require__(/*! ./x64-core */ "./node_modules/_crypto-js@3.3.0@crypto-js/x64-core.js"), __webpack_require__(/*! ./lib-typedarrays */ "./node_modules/_crypto-js@3.3.0@crypto-js/lib-typedarrays.js"), __webpack_require__(/*! ./enc-utf16 */ "./node_modules/_crypto-js@3.3.0@crypto-js/enc-utf16.js"), __webpack_require__(/*! ./enc-base64 */ "./node_modules/_crypto-js@3.3.0@crypto-js/enc-base64.js"), __webpack_require__(/*! ./md5 */ "./node_modules/_crypto-js@3.3.0@crypto-js/md5.js"), __webpack_require__(/*! ./sha1 */ "./node_modules/_crypto-js@3.3.0@crypto-js/sha1.js"), __webpack_require__(/*! ./sha256 */ "./node_modules/_crypto-js@3.3.0@crypto-js/sha256.js"), __webpack_require__(/*! ./sha224 */ "./node_modules/_crypto-js@3.3.0@crypto-js/sha224.js"), __webpack_require__(/*! ./sha512 */ "./node_modules/_crypto-js@3.3.0@crypto-js/sha512.js"), __webpack_require__(/*! ./sha384 */ "./node_modules/_crypto-js@3.3.0@crypto-js/sha384.js"), __webpack_require__(/*! ./sha3 */ "./node_modules/_crypto-js@3.3.0@crypto-js/sha3.js"), __webpack_require__(/*! ./ripemd160 */ "./node_modules/_crypto-js@3.3.0@crypto-js/ripemd160.js"), __webpack_require__(/*! ./hmac */ "./node_modules/_crypto-js@3.3.0@crypto-js/hmac.js"), __webpack_require__(/*! ./pbkdf2 */ "./node_modules/_crypto-js@3.3.0@crypto-js/pbkdf2.js"), __webpack_require__(/*! ./evpkdf */ "./node_modules/_crypto-js@3.3.0@crypto-js/evpkdf.js"), __webpack_require__(/*! ./cipher-core */ "./node_modules/_crypto-js@3.3.0@crypto-js/cipher-core.js"), __webpack_require__(/*! ./mode-cfb */ "./node_modules/_crypto-js@3.3.0@crypto-js/mode-cfb.js"), __webpack_require__(/*! ./mode-ctr */ "./node_modules/_crypto-js@3.3.0@crypto-js/mode-ctr.js"), __webpack_require__(/*! ./mode-ctr-gladman */ "./node_modules/_crypto-js@3.3.0@crypto-js/mode-ctr-gladman.js"), __webpack_require__(/*! ./mode-ofb */ "./node_modules/_crypto-js@3.3.0@crypto-js/mode-ofb.js"), __webpack_require__(/*! ./mode-ecb */ "./node_modules/_crypto-js@3.3.0@crypto-js/mode-ecb.js"), __webpack_require__(/*! ./pad-ansix923 */ "./node_modules/_crypto-js@3.3.0@crypto-js/pad-ansix923.js"), __webpack_require__(/*! ./pad-iso10126 */ "./node_modules/_crypto-js@3.3.0@crypto-js/pad-iso10126.js"), __webpack_require__(/*! ./pad-iso97971 */ "./node_modules/_crypto-js@3.3.0@crypto-js/pad-iso97971.js"), __webpack_require__(/*! ./pad-zeropadding */ "./node_modules/_crypto-js@3.3.0@crypto-js/pad-zeropadding.js"), __webpack_require__(/*! ./pad-nopadding */ "./node_modules/_crypto-js@3.3.0@crypto-js/pad-nopadding.js"), __webpack_require__(/*! ./format-hex */ "./node_modules/_crypto-js@3.3.0@crypto-js/format-hex.js"), __webpack_require__(/*! ./aes */ "./node_modules/_crypto-js@3.3.0@crypto-js/aes.js"), __webpack_require__(/*! ./tripledes */ "./node_modules/_crypto-js@3.3.0@crypto-js/tripledes.js"), __webpack_require__(/*! ./rc4 */ "./node_modules/_crypto-js@3.3.0@crypto-js/rc4.js"), __webpack_require__(/*! ./rabbit */ "./node_modules/_crypto-js@3.3.0@crypto-js/rabbit.js"), __webpack_require__(/*! ./rabbit-legacy */ "./node_modules/_crypto-js@3.3.0@crypto-js/rabbit-legacy.js"));
	}
	else {}
}(this, function (CryptoJS) {

	return CryptoJS;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/lib-typedarrays.js":
/*!********************************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/lib-typedarrays.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Check if typed arrays are supported
	    if (typeof ArrayBuffer != 'function') {
	        return;
	    }

	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;

	    // Reference original init
	    var superInit = WordArray.init;

	    // Augment WordArray.init to handle typed arrays
	    var subInit = WordArray.init = function (typedArray) {
	        // Convert buffers to uint8
	        if (typedArray instanceof ArrayBuffer) {
	            typedArray = new Uint8Array(typedArray);
	        }

	        // Convert other array views to uint8
	        if (
	            typedArray instanceof Int8Array ||
	            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
	            typedArray instanceof Int16Array ||
	            typedArray instanceof Uint16Array ||
	            typedArray instanceof Int32Array ||
	            typedArray instanceof Uint32Array ||
	            typedArray instanceof Float32Array ||
	            typedArray instanceof Float64Array
	        ) {
	            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
	        }

	        // Handle Uint8Array
	        if (typedArray instanceof Uint8Array) {
	            // Shortcut
	            var typedArrayByteLength = typedArray.byteLength;

	            // Extract bytes
	            var words = [];
	            for (var i = 0; i < typedArrayByteLength; i++) {
	                words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
	            }

	            // Initialize this word array
	            superInit.call(this, words, typedArrayByteLength);
	        } else {
	            // Else call normal init
	            superInit.apply(this, arguments);
	        }
	    };

	    subInit.prototype = WordArray;
	}());


	return CryptoJS.lib.WordArray;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/md5.js":
/*!********************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/md5.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"));
	}
	else {}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var T = [];

	    // Compute constants
	    (function () {
	        for (var i = 0; i < 64; i++) {
	            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
	        }
	    }());

	    /**
	     * MD5 hash algorithm.
	     */
	    var MD5 = C_algo.MD5 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }

	            // Shortcuts
	            var H = this._hash.words;

	            var M_offset_0  = M[offset + 0];
	            var M_offset_1  = M[offset + 1];
	            var M_offset_2  = M[offset + 2];
	            var M_offset_3  = M[offset + 3];
	            var M_offset_4  = M[offset + 4];
	            var M_offset_5  = M[offset + 5];
	            var M_offset_6  = M[offset + 6];
	            var M_offset_7  = M[offset + 7];
	            var M_offset_8  = M[offset + 8];
	            var M_offset_9  = M[offset + 9];
	            var M_offset_10 = M[offset + 10];
	            var M_offset_11 = M[offset + 11];
	            var M_offset_12 = M[offset + 12];
	            var M_offset_13 = M[offset + 13];
	            var M_offset_14 = M[offset + 14];
	            var M_offset_15 = M[offset + 15];

	            // Working varialbes
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];

	            // Computation
	            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
	            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
	            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
	            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
	            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
	            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
	            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
	            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
	            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
	            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
	            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
	            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
	            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
	            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
	            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
	            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

	            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
	            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
	            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
	            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
	            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
	            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
	            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
	            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
	            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
	            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
	            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
	            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
	            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
	            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
	            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
	            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

	            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
	            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
	            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
	            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
	            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
	            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
	            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
	            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
	            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
	            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
	            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
	            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
	            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
	            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
	            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
	            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

	            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
	            d = II(d, a, b, c, M_offset_7,  10, T[49]);
	            c = II(c, d, a, b, M_offset_14, 15, T[50]);
	            b = II(b, c, d, a, M_offset_5,  21, T[51]);
	            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
	            d = II(d, a, b, c, M_offset_3,  10, T[53]);
	            c = II(c, d, a, b, M_offset_10, 15, T[54]);
	            b = II(b, c, d, a, M_offset_1,  21, T[55]);
	            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
	            d = II(d, a, b, c, M_offset_15, 10, T[57]);
	            c = II(c, d, a, b, M_offset_6,  15, T[58]);
	            b = II(b, c, d, a, M_offset_13, 21, T[59]);
	            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
	            d = II(d, a, b, c, M_offset_11, 10, T[61]);
	            c = II(c, d, a, b, M_offset_2,  15, T[62]);
	            b = II(b, c, d, a, M_offset_9,  21, T[63]);

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

	            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
	            var nBitsTotalL = nBitsTotal;
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
	                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
	            );
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
	            );

	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                // Shortcut
	                var H_i = H[i];

	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    function FF(a, b, c, d, x, s, t) {
	        var n = a + ((b & c) | (~b & d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function GG(a, b, c, d, x, s, t) {
	        var n = a + ((b & d) | (c & ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function HH(a, b, c, d, x, s, t) {
	        var n = a + (b ^ c ^ d) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function II(a, b, c, d, x, s, t) {
	        var n = a + (c ^ (b | ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */
	    C.MD5 = Hasher._createHelper(MD5);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */
	    C.HmacMD5 = Hasher._createHmacHelper(MD5);
	}(Math));


	return CryptoJS.MD5;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/mode-cfb.js":
/*!*************************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/mode-cfb.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"), __webpack_require__(/*! ./cipher-core */ "./node_modules/_crypto-js@3.3.0@crypto-js/cipher-core.js"));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * Cipher Feedback block mode.
	 */
	CryptoJS.mode.CFB = (function () {
	    var CFB = CryptoJS.lib.BlockCipherMode.extend();

	    CFB.Encryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // Remember this block to use with next block
	            this._prevBlock = words.slice(offset, offset + blockSize);
	        }
	    });

	    CFB.Decryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            // Remember this block to use with next block
	            var thisBlock = words.slice(offset, offset + blockSize);

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // This block becomes the previous block
	            this._prevBlock = thisBlock;
	        }
	    });

	    function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
	        // Shortcut
	        var iv = this._iv;

	        // Generate keystream
	        if (iv) {
	            var keystream = iv.slice(0);

	            // Remove IV for subsequent blocks
	            this._iv = undefined;
	        } else {
	            var keystream = this._prevBlock;
	        }
	        cipher.encryptBlock(keystream, 0);

	        // Encrypt
	        for (var i = 0; i < blockSize; i++) {
	            words[offset + i] ^= keystream[i];
	        }
	    }

	    return CFB;
	}());


	return CryptoJS.mode.CFB;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/mode-ctr-gladman.js":
/*!*********************************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/mode-ctr-gladman.js ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"), __webpack_require__(/*! ./cipher-core */ "./node_modules/_crypto-js@3.3.0@crypto-js/cipher-core.js"));
	}
	else {}
}(this, function (CryptoJS) {

	/** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */
	CryptoJS.mode.CTRGladman = (function () {
	    var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();

		function incWord(word)
		{
			if (((word >> 24) & 0xff) === 0xff) { //overflow
			var b1 = (word >> 16)&0xff;
			var b2 = (word >> 8)&0xff;
			var b3 = word & 0xff;

			if (b1 === 0xff) // overflow b1
			{
			b1 = 0;
			if (b2 === 0xff)
			{
				b2 = 0;
				if (b3 === 0xff)
				{
					b3 = 0;
				}
				else
				{
					++b3;
				}
			}
			else
			{
				++b2;
			}
			}
			else
			{
			++b1;
			}

			word = 0;
			word += (b1 << 16);
			word += (b2 << 8);
			word += b3;
			}
			else
			{
			word += (0x01 << 24);
			}
			return word;
		}

		function incCounter(counter)
		{
			if ((counter[0] = incWord(counter[0])) === 0)
			{
				// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
				counter[1] = incWord(counter[1]);
			}
			return counter;
		}

	    var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }

				incCounter(counter);

				var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTRGladman.Decryptor = Encryptor;

	    return CTRGladman;
	}());




	return CryptoJS.mode.CTRGladman;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/mode-ctr.js":
/*!*************************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/mode-ctr.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"), __webpack_require__(/*! ./cipher-core */ "./node_modules/_crypto-js@3.3.0@crypto-js/cipher-core.js"));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * Counter block mode.
	 */
	CryptoJS.mode.CTR = (function () {
	    var CTR = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = CTR.Encryptor = CTR.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Increment counter
	            counter[blockSize - 1] = (counter[blockSize - 1] + 1) | 0

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTR.Decryptor = Encryptor;

	    return CTR;
	}());


	return CryptoJS.mode.CTR;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/mode-ecb.js":
/*!*************************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/mode-ecb.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"), __webpack_require__(/*! ./cipher-core */ "./node_modules/_crypto-js@3.3.0@crypto-js/cipher-core.js"));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * Electronic Codebook block mode.
	 */
	CryptoJS.mode.ECB = (function () {
	    var ECB = CryptoJS.lib.BlockCipherMode.extend();

	    ECB.Encryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.encryptBlock(words, offset);
	        }
	    });

	    ECB.Decryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.decryptBlock(words, offset);
	        }
	    });

	    return ECB;
	}());


	return CryptoJS.mode.ECB;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/mode-ofb.js":
/*!*************************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/mode-ofb.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"), __webpack_require__(/*! ./cipher-core */ "./node_modules/_crypto-js@3.3.0@crypto-js/cipher-core.js"));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * Output Feedback block mode.
	 */
	CryptoJS.mode.OFB = (function () {
	    var OFB = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = OFB.Encryptor = OFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var keystream = this._keystream;

	            // Generate keystream
	            if (iv) {
	                keystream = this._keystream = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    OFB.Decryptor = Encryptor;

	    return OFB;
	}());


	return CryptoJS.mode.OFB;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/pad-ansix923.js":
/*!*****************************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/pad-ansix923.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"), __webpack_require__(/*! ./cipher-core */ "./node_modules/_crypto-js@3.3.0@crypto-js/cipher-core.js"));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * ANSI X.923 padding strategy.
	 */
	CryptoJS.pad.AnsiX923 = {
	    pad: function (data, blockSize) {
	        // Shortcuts
	        var dataSigBytes = data.sigBytes;
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;

	        // Compute last byte position
	        var lastBytePos = dataSigBytes + nPaddingBytes - 1;

	        // Pad
	        data.clamp();
	        data.words[lastBytePos >>> 2] |= nPaddingBytes << (24 - (lastBytePos % 4) * 8);
	        data.sigBytes += nPaddingBytes;
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Ansix923;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/pad-iso10126.js":
/*!*****************************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/pad-iso10126.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"), __webpack_require__(/*! ./cipher-core */ "./node_modules/_crypto-js@3.3.0@crypto-js/cipher-core.js"));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * ISO 10126 padding strategy.
	 */
	CryptoJS.pad.Iso10126 = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	        // Pad
	        data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).
	             concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Iso10126;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/pad-iso97971.js":
/*!*****************************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/pad-iso97971.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"), __webpack_require__(/*! ./cipher-core */ "./node_modules/_crypto-js@3.3.0@crypto-js/cipher-core.js"));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */
	CryptoJS.pad.Iso97971 = {
	    pad: function (data, blockSize) {
	        // Add 0x80 byte
	        data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));

	        // Zero pad the rest
	        CryptoJS.pad.ZeroPadding.pad(data, blockSize);
	    },

	    unpad: function (data) {
	        // Remove zero padding
	        CryptoJS.pad.ZeroPadding.unpad(data);

	        // Remove one more byte -- the 0x80 byte
	        data.sigBytes--;
	    }
	};


	return CryptoJS.pad.Iso97971;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/pad-nopadding.js":
/*!******************************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/pad-nopadding.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"), __webpack_require__(/*! ./cipher-core */ "./node_modules/_crypto-js@3.3.0@crypto-js/cipher-core.js"));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * A noop padding strategy.
	 */
	CryptoJS.pad.NoPadding = {
	    pad: function () {
	    },

	    unpad: function () {
	    }
	};


	return CryptoJS.pad.NoPadding;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/pad-zeropadding.js":
/*!********************************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/pad-zeropadding.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"), __webpack_require__(/*! ./cipher-core */ "./node_modules/_crypto-js@3.3.0@crypto-js/cipher-core.js"));
	}
	else {}
}(this, function (CryptoJS) {

	/**
	 * Zero padding strategy.
	 */
	CryptoJS.pad.ZeroPadding = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Pad
	        data.clamp();
	        data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
	    },

	    unpad: function (data) {
	        // Shortcut
	        var dataWords = data.words;

	        // Unpad
	        var i = data.sigBytes - 1;
	        while (!((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
	            i--;
	        }
	        data.sigBytes = i + 1;
	    }
	};


	return CryptoJS.pad.ZeroPadding;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/pbkdf2.js":
/*!***********************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/pbkdf2.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"), __webpack_require__(/*! ./sha1 */ "./node_modules/_crypto-js@3.3.0@crypto-js/sha1.js"), __webpack_require__(/*! ./hmac */ "./node_modules/_crypto-js@3.3.0@crypto-js/hmac.js"));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA1 = C_algo.SHA1;
	    var HMAC = C_algo.HMAC;

	    /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */
	    var PBKDF2 = C_algo.PBKDF2 = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA1
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: SHA1,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init HMAC
	            var hmac = HMAC.create(cfg.hasher, password);

	            // Initial values
	            var derivedKey = WordArray.create();
	            var blockIndex = WordArray.create([0x00000001]);

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var blockIndexWords = blockIndex.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                var block = hmac.update(salt).finalize(blockIndex);
	                hmac.reset();

	                // Shortcuts
	                var blockWords = block.words;
	                var blockWordsLength = blockWords.length;

	                // Iterations
	                var intermediate = block;
	                for (var i = 1; i < iterations; i++) {
	                    intermediate = hmac.finalize(intermediate);
	                    hmac.reset();

	                    // Shortcut
	                    var intermediateWords = intermediate.words;

	                    // XOR intermediate with block
	                    for (var j = 0; j < blockWordsLength; j++) {
	                        blockWords[j] ^= intermediateWords[j];
	                    }
	                }

	                derivedKey.concat(block);
	                blockIndexWords[0]++;
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.PBKDF2 = function (password, salt, cfg) {
	        return PBKDF2.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.PBKDF2;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/rabbit-legacy.js":
/*!******************************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/rabbit-legacy.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"), __webpack_require__(/*! ./enc-base64 */ "./node_modules/_crypto-js@3.3.0@crypto-js/enc-base64.js"), __webpack_require__(/*! ./md5 */ "./node_modules/_crypto-js@3.3.0@crypto-js/md5.js"), __webpack_require__(/*! ./evpkdf */ "./node_modules/_crypto-js@3.3.0@crypto-js/evpkdf.js"), __webpack_require__(/*! ./cipher-core */ "./node_modules/_crypto-js@3.3.0@crypto-js/cipher-core.js"));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */
	    var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */
	    C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
	}());


	return CryptoJS.RabbitLegacy;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/rabbit.js":
/*!***********************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/rabbit.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"), __webpack_require__(/*! ./enc-base64 */ "./node_modules/_crypto-js@3.3.0@crypto-js/enc-base64.js"), __webpack_require__(/*! ./md5 */ "./node_modules/_crypto-js@3.3.0@crypto-js/md5.js"), __webpack_require__(/*! ./evpkdf */ "./node_modules/_crypto-js@3.3.0@crypto-js/evpkdf.js"), __webpack_require__(/*! ./cipher-core */ "./node_modules/_crypto-js@3.3.0@crypto-js/cipher-core.js"));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm
	     */
	    var Rabbit = C_algo.Rabbit = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                K[i] = (((K[i] << 8)  | (K[i] >>> 24)) & 0x00ff00ff) |
	                       (((K[i] << 24) | (K[i] >>> 8))  & 0xff00ff00);
	            }

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */
	    C.Rabbit = StreamCipher._createHelper(Rabbit);
	}());


	return CryptoJS.Rabbit;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/rc4.js":
/*!********************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/rc4.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"), __webpack_require__(/*! ./enc-base64 */ "./node_modules/_crypto-js@3.3.0@crypto-js/enc-base64.js"), __webpack_require__(/*! ./md5 */ "./node_modules/_crypto-js@3.3.0@crypto-js/md5.js"), __webpack_require__(/*! ./evpkdf */ "./node_modules/_crypto-js@3.3.0@crypto-js/evpkdf.js"), __webpack_require__(/*! ./cipher-core */ "./node_modules/_crypto-js@3.3.0@crypto-js/cipher-core.js"));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    /**
	     * RC4 stream cipher algorithm.
	     */
	    var RC4 = C_algo.RC4 = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;
	            var keySigBytes = key.sigBytes;

	            // Init sbox
	            var S = this._S = [];
	            for (var i = 0; i < 256; i++) {
	                S[i] = i;
	            }

	            // Key setup
	            for (var i = 0, j = 0; i < 256; i++) {
	                var keyByteIndex = i % keySigBytes;
	                var keyByte = (keyWords[keyByteIndex >>> 2] >>> (24 - (keyByteIndex % 4) * 8)) & 0xff;

	                j = (j + S[i] + keyByte) % 256;

	                // Swap
	                var t = S[i];
	                S[i] = S[j];
	                S[j] = t;
	            }

	            // Counters
	            this._i = this._j = 0;
	        },

	        _doProcessBlock: function (M, offset) {
	            M[offset] ^= generateKeystreamWord.call(this);
	        },

	        keySize: 256/32,

	        ivSize: 0
	    });

	    function generateKeystreamWord() {
	        // Shortcuts
	        var S = this._S;
	        var i = this._i;
	        var j = this._j;

	        // Generate keystream word
	        var keystreamWord = 0;
	        for (var n = 0; n < 4; n++) {
	            i = (i + 1) % 256;
	            j = (j + S[i]) % 256;

	            // Swap
	            var t = S[i];
	            S[i] = S[j];
	            S[j] = t;

	            keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
	        }

	        // Update counters
	        this._i = i;
	        this._j = j;

	        return keystreamWord;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4 = StreamCipher._createHelper(RC4);

	    /**
	     * Modified RC4 stream cipher algorithm.
	     */
	    var RC4Drop = C_algo.RC4Drop = RC4.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */
	        cfg: RC4.cfg.extend({
	            drop: 192
	        }),

	        _doReset: function () {
	            RC4._doReset.call(this);

	            // Drop
	            for (var i = this.cfg.drop; i > 0; i--) {
	                generateKeystreamWord.call(this);
	            }
	        }
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4Drop = StreamCipher._createHelper(RC4Drop);
	}());


	return CryptoJS.RC4;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/ripemd160.js":
/*!**************************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/ripemd160.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"));
	}
	else {}
}(this, function (CryptoJS) {

	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var _zl = WordArray.create([
	        0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	        7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	        3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	        1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	        4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13]);
	    var _zr = WordArray.create([
	        5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	        6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	        15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	        8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	        12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11]);
	    var _sl = WordArray.create([
	         11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	        7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	        11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	          11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	        9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ]);
	    var _sr = WordArray.create([
	        8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	        9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	        9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	        15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	        8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ]);

	    var _hl =  WordArray.create([ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
	    var _hr =  WordArray.create([ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);

	    /**
	     * RIPEMD160 hash algorithm.
	     */
	    var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
	        _doReset: function () {
	            this._hash  = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
	        },

	        _doProcessBlock: function (M, offset) {

	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                // Swap
	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }
	            // Shortcut
	            var H  = this._hash.words;
	            var hl = _hl.words;
	            var hr = _hr.words;
	            var zl = _zl.words;
	            var zr = _zr.words;
	            var sl = _sl.words;
	            var sr = _sr.words;

	            // Working variables
	            var al, bl, cl, dl, el;
	            var ar, br, cr, dr, er;

	            ar = al = H[0];
	            br = bl = H[1];
	            cr = cl = H[2];
	            dr = dl = H[3];
	            er = el = H[4];
	            // Computation
	            var t;
	            for (var i = 0; i < 80; i += 1) {
	                t = (al +  M[offset+zl[i]])|0;
	                if (i<16){
		            t +=  f1(bl,cl,dl) + hl[0];
	                } else if (i<32) {
		            t +=  f2(bl,cl,dl) + hl[1];
	                } else if (i<48) {
		            t +=  f3(bl,cl,dl) + hl[2];
	                } else if (i<64) {
		            t +=  f4(bl,cl,dl) + hl[3];
	                } else {// if (i<80) {
		            t +=  f5(bl,cl,dl) + hl[4];
	                }
	                t = t|0;
	                t =  rotl(t,sl[i]);
	                t = (t+el)|0;
	                al = el;
	                el = dl;
	                dl = rotl(cl, 10);
	                cl = bl;
	                bl = t;

	                t = (ar + M[offset+zr[i]])|0;
	                if (i<16){
		            t +=  f5(br,cr,dr) + hr[0];
	                } else if (i<32) {
		            t +=  f4(br,cr,dr) + hr[1];
	                } else if (i<48) {
		            t +=  f3(br,cr,dr) + hr[2];
	                } else if (i<64) {
		            t +=  f2(br,cr,dr) + hr[3];
	                } else {// if (i<80) {
		            t +=  f1(br,cr,dr) + hr[4];
	                }
	                t = t|0;
	                t =  rotl(t,sr[i]) ;
	                t = (t+er)|0;
	                ar = er;
	                er = dr;
	                dr = rotl(cr, 10);
	                cr = br;
	                br = t;
	            }
	            // Intermediate hash value
	            t    = (H[1] + cl + dr)|0;
	            H[1] = (H[2] + dl + er)|0;
	            H[2] = (H[3] + el + ar)|0;
	            H[3] = (H[4] + al + br)|0;
	            H[4] = (H[0] + bl + cr)|0;
	            H[0] =  t;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	            );
	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 5; i++) {
	                // Shortcut
	                var H_i = H[i];

	                // Swap
	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });


	    function f1(x, y, z) {
	        return ((x) ^ (y) ^ (z));

	    }

	    function f2(x, y, z) {
	        return (((x)&(y)) | ((~x)&(z)));
	    }

	    function f3(x, y, z) {
	        return (((x) | (~(y))) ^ (z));
	    }

	    function f4(x, y, z) {
	        return (((x) & (z)) | ((y)&(~(z))));
	    }

	    function f5(x, y, z) {
	        return ((x) ^ ((y) |(~(z))));

	    }

	    function rotl(x,n) {
	        return (x<<n) | (x>>>(32-n));
	    }


	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */
	    C.RIPEMD160 = Hasher._createHelper(RIPEMD160);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */
	    C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
	}(Math));


	return CryptoJS.RIPEMD160;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/sha1.js":
/*!*********************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/sha1.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-1 hash algorithm.
	     */
	    var SHA1 = C_algo.SHA1 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476,
	                0xc3d2e1f0
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];

	            // Computation
	            for (var i = 0; i < 80; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                    W[i] = (n << 1) | (n >>> 31);
	                }

	                var t = ((a << 5) | (a >>> 27)) + e + W[i];
	                if (i < 20) {
	                    t += ((b & c) | (~b & d)) + 0x5a827999;
	                } else if (i < 40) {
	                    t += (b ^ c ^ d) + 0x6ed9eba1;
	                } else if (i < 60) {
	                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
	                } else /* if (i < 80) */ {
	                    t += (b ^ c ^ d) - 0x359d3e2a;
	                }

	                e = d;
	                d = c;
	                c = (b << 30) | (b >>> 2);
	                b = a;
	                a = t;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */
	    C.SHA1 = Hasher._createHelper(SHA1);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */
	    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	}());


	return CryptoJS.SHA1;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/sha224.js":
/*!***********************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/sha224.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"), __webpack_require__(/*! ./sha256 */ "./node_modules/_crypto-js@3.3.0@crypto-js/sha256.js"));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA256 = C_algo.SHA256;

	    /**
	     * SHA-224 hash algorithm.
	     */
	    var SHA224 = C_algo.SHA224 = SHA256.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
	                0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA256._doFinalize.call(this);

	            hash.sigBytes -= 4;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */
	    C.SHA224 = SHA256._createHelper(SHA224);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */
	    C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
	}());


	return CryptoJS.SHA224;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/sha256.js":
/*!***********************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/sha256.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"));
	}
	else {}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/sha3.js":
/*!*********************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/sha3.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"), __webpack_require__(/*! ./x64-core */ "./node_modules/_crypto-js@3.3.0@crypto-js/x64-core.js"));
	}
	else {}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var C_algo = C.algo;

	    // Constants tables
	    var RHO_OFFSETS = [];
	    var PI_INDEXES  = [];
	    var ROUND_CONSTANTS = [];

	    // Compute Constants
	    (function () {
	        // Compute rho offset constants
	        var x = 1, y = 0;
	        for (var t = 0; t < 24; t++) {
	            RHO_OFFSETS[x + 5 * y] = ((t + 1) * (t + 2) / 2) % 64;

	            var newX = y % 5;
	            var newY = (2 * x + 3 * y) % 5;
	            x = newX;
	            y = newY;
	        }

	        // Compute pi index constants
	        for (var x = 0; x < 5; x++) {
	            for (var y = 0; y < 5; y++) {
	                PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
	            }
	        }

	        // Compute round constants
	        var LFSR = 0x01;
	        for (var i = 0; i < 24; i++) {
	            var roundConstantMsw = 0;
	            var roundConstantLsw = 0;

	            for (var j = 0; j < 7; j++) {
	                if (LFSR & 0x01) {
	                    var bitPosition = (1 << j) - 1;
	                    if (bitPosition < 32) {
	                        roundConstantLsw ^= 1 << bitPosition;
	                    } else /* if (bitPosition >= 32) */ {
	                        roundConstantMsw ^= 1 << (bitPosition - 32);
	                    }
	                }

	                // Compute next LFSR
	                if (LFSR & 0x80) {
	                    // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
	                    LFSR = (LFSR << 1) ^ 0x71;
	                } else {
	                    LFSR <<= 1;
	                }
	            }

	            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
	        }
	    }());

	    // Reusable objects for temporary values
	    var T = [];
	    (function () {
	        for (var i = 0; i < 25; i++) {
	            T[i] = X64Word.create();
	        }
	    }());

	    /**
	     * SHA-3 hash algorithm.
	     */
	    var SHA3 = C_algo.SHA3 = Hasher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */
	        cfg: Hasher.cfg.extend({
	            outputLength: 512
	        }),

	        _doReset: function () {
	            var state = this._state = []
	            for (var i = 0; i < 25; i++) {
	                state[i] = new X64Word.init();
	            }

	            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var state = this._state;
	            var nBlockSizeLanes = this.blockSize / 2;

	            // Absorb
	            for (var i = 0; i < nBlockSizeLanes; i++) {
	                // Shortcuts
	                var M2i  = M[offset + 2 * i];
	                var M2i1 = M[offset + 2 * i + 1];

	                // Swap endian
	                M2i = (
	                    (((M2i << 8)  | (M2i >>> 24)) & 0x00ff00ff) |
	                    (((M2i << 24) | (M2i >>> 8))  & 0xff00ff00)
	                );
	                M2i1 = (
	                    (((M2i1 << 8)  | (M2i1 >>> 24)) & 0x00ff00ff) |
	                    (((M2i1 << 24) | (M2i1 >>> 8))  & 0xff00ff00)
	                );

	                // Absorb message into state
	                var lane = state[i];
	                lane.high ^= M2i1;
	                lane.low  ^= M2i;
	            }

	            // Rounds
	            for (var round = 0; round < 24; round++) {
	                // Theta
	                for (var x = 0; x < 5; x++) {
	                    // Mix column lanes
	                    var tMsw = 0, tLsw = 0;
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        tMsw ^= lane.high;
	                        tLsw ^= lane.low;
	                    }

	                    // Temporary values
	                    var Tx = T[x];
	                    Tx.high = tMsw;
	                    Tx.low  = tLsw;
	                }
	                for (var x = 0; x < 5; x++) {
	                    // Shortcuts
	                    var Tx4 = T[(x + 4) % 5];
	                    var Tx1 = T[(x + 1) % 5];
	                    var Tx1Msw = Tx1.high;
	                    var Tx1Lsw = Tx1.low;

	                    // Mix surrounding columns
	                    var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
	                    var tLsw = Tx4.low  ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        lane.high ^= tMsw;
	                        lane.low  ^= tLsw;
	                    }
	                }

	                // Rho Pi
	                for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
	                    // Shortcuts
	                    var lane = state[laneIndex];
	                    var laneMsw = lane.high;
	                    var laneLsw = lane.low;
	                    var rhoOffset = RHO_OFFSETS[laneIndex];

	                    // Rotate lanes
	                    if (rhoOffset < 32) {
	                        var tMsw = (laneMsw << rhoOffset) | (laneLsw >>> (32 - rhoOffset));
	                        var tLsw = (laneLsw << rhoOffset) | (laneMsw >>> (32 - rhoOffset));
	                    } else /* if (rhoOffset >= 32) */ {
	                        var tMsw = (laneLsw << (rhoOffset - 32)) | (laneMsw >>> (64 - rhoOffset));
	                        var tLsw = (laneMsw << (rhoOffset - 32)) | (laneLsw >>> (64 - rhoOffset));
	                    }

	                    // Transpose lanes
	                    var TPiLane = T[PI_INDEXES[laneIndex]];
	                    TPiLane.high = tMsw;
	                    TPiLane.low  = tLsw;
	                }

	                // Rho pi at x = y = 0
	                var T0 = T[0];
	                var state0 = state[0];
	                T0.high = state0.high;
	                T0.low  = state0.low;

	                // Chi
	                for (var x = 0; x < 5; x++) {
	                    for (var y = 0; y < 5; y++) {
	                        // Shortcuts
	                        var laneIndex = x + 5 * y;
	                        var lane = state[laneIndex];
	                        var TLane = T[laneIndex];
	                        var Tx1Lane = T[((x + 1) % 5) + 5 * y];
	                        var Tx2Lane = T[((x + 2) % 5) + 5 * y];

	                        // Mix rows
	                        lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
	                        lane.low  = TLane.low  ^ (~Tx1Lane.low  & Tx2Lane.low);
	                    }
	                }

	                // Iota
	                var lane = state[0];
	                var roundConstant = ROUND_CONSTANTS[round];
	                lane.high ^= roundConstant.high;
	                lane.low  ^= roundConstant.low;;
	            }
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;
	            var blockSizeBits = this.blockSize * 32;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - nBitsLeft % 32);
	            dataWords[((Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits) >>> 5) - 1] |= 0x80;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var state = this._state;
	            var outputLengthBytes = this.cfg.outputLength / 8;
	            var outputLengthLanes = outputLengthBytes / 8;

	            // Squeeze
	            var hashWords = [];
	            for (var i = 0; i < outputLengthLanes; i++) {
	                // Shortcuts
	                var lane = state[i];
	                var laneMsw = lane.high;
	                var laneLsw = lane.low;

	                // Swap endian
	                laneMsw = (
	                    (((laneMsw << 8)  | (laneMsw >>> 24)) & 0x00ff00ff) |
	                    (((laneMsw << 24) | (laneMsw >>> 8))  & 0xff00ff00)
	                );
	                laneLsw = (
	                    (((laneLsw << 8)  | (laneLsw >>> 24)) & 0x00ff00ff) |
	                    (((laneLsw << 24) | (laneLsw >>> 8))  & 0xff00ff00)
	                );

	                // Squeeze state to retrieve hash
	                hashWords.push(laneLsw);
	                hashWords.push(laneMsw);
	            }

	            // Return final computed hash
	            return new WordArray.init(hashWords, outputLengthBytes);
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);

	            var state = clone._state = this._state.slice(0);
	            for (var i = 0; i < 25; i++) {
	                state[i] = state[i].clone();
	            }

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */
	    C.SHA3 = Hasher._createHelper(SHA3);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */
	    C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
	}(Math));


	return CryptoJS.SHA3;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/sha384.js":
/*!***********************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/sha384.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"), __webpack_require__(/*! ./x64-core */ "./node_modules/_crypto-js@3.3.0@crypto-js/x64-core.js"), __webpack_require__(/*! ./sha512 */ "./node_modules/_crypto-js@3.3.0@crypto-js/sha512.js"));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;
	    var SHA512 = C_algo.SHA512;

	    /**
	     * SHA-384 hash algorithm.
	     */
	    var SHA384 = C_algo.SHA384 = SHA512.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507),
	                new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939),
	                new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511),
	                new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA512._doFinalize.call(this);

	            hash.sigBytes -= 16;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */
	    C.SHA384 = SHA512._createHelper(SHA384);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */
	    C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
	}());


	return CryptoJS.SHA384;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/sha512.js":
/*!***********************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/sha512.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"), __webpack_require__(/*! ./x64-core */ "./node_modules/_crypto-js@3.3.0@crypto-js/x64-core.js"));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;

	    function X64Word_create() {
	        return X64Word.create.apply(X64Word, arguments);
	    }

	    // Constants
	    var K = [
	        X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd),
	        X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc),
	        X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019),
	        X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118),
	        X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe),
	        X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2),
	        X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1),
	        X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694),
	        X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3),
	        X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65),
	        X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483),
	        X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5),
	        X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210),
	        X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4),
	        X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725),
	        X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70),
	        X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926),
	        X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df),
	        X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8),
	        X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b),
	        X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001),
	        X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30),
	        X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910),
	        X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8),
	        X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53),
	        X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8),
	        X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb),
	        X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3),
	        X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60),
	        X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec),
	        X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9),
	        X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b),
	        X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207),
	        X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178),
	        X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6),
	        X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b),
	        X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493),
	        X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c),
	        X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a),
	        X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)
	    ];

	    // Reusable objects
	    var W = [];
	    (function () {
	        for (var i = 0; i < 80; i++) {
	            W[i] = X64Word_create();
	        }
	    }());

	    /**
	     * SHA-512 hash algorithm.
	     */
	    var SHA512 = C_algo.SHA512 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b),
	                new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1),
	                new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f),
	                new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var H = this._hash.words;

	            var H0 = H[0];
	            var H1 = H[1];
	            var H2 = H[2];
	            var H3 = H[3];
	            var H4 = H[4];
	            var H5 = H[5];
	            var H6 = H[6];
	            var H7 = H[7];

	            var H0h = H0.high;
	            var H0l = H0.low;
	            var H1h = H1.high;
	            var H1l = H1.low;
	            var H2h = H2.high;
	            var H2l = H2.low;
	            var H3h = H3.high;
	            var H3l = H3.low;
	            var H4h = H4.high;
	            var H4l = H4.low;
	            var H5h = H5.high;
	            var H5l = H5.low;
	            var H6h = H6.high;
	            var H6l = H6.low;
	            var H7h = H7.high;
	            var H7l = H7.low;

	            // Working variables
	            var ah = H0h;
	            var al = H0l;
	            var bh = H1h;
	            var bl = H1l;
	            var ch = H2h;
	            var cl = H2l;
	            var dh = H3h;
	            var dl = H3l;
	            var eh = H4h;
	            var el = H4l;
	            var fh = H5h;
	            var fl = H5l;
	            var gh = H6h;
	            var gl = H6l;
	            var hh = H7h;
	            var hl = H7l;

	            // Rounds
	            for (var i = 0; i < 80; i++) {
	                // Shortcut
	                var Wi = W[i];

	                // Extend message
	                if (i < 16) {
	                    var Wih = Wi.high = M[offset + i * 2]     | 0;
	                    var Wil = Wi.low  = M[offset + i * 2 + 1] | 0;
	                } else {
	                    // Gamma0
	                    var gamma0x  = W[i - 15];
	                    var gamma0xh = gamma0x.high;
	                    var gamma0xl = gamma0x.low;
	                    var gamma0h  = ((gamma0xh >>> 1) | (gamma0xl << 31)) ^ ((gamma0xh >>> 8) | (gamma0xl << 24)) ^ (gamma0xh >>> 7);
	                    var gamma0l  = ((gamma0xl >>> 1) | (gamma0xh << 31)) ^ ((gamma0xl >>> 8) | (gamma0xh << 24)) ^ ((gamma0xl >>> 7) | (gamma0xh << 25));

	                    // Gamma1
	                    var gamma1x  = W[i - 2];
	                    var gamma1xh = gamma1x.high;
	                    var gamma1xl = gamma1x.low;
	                    var gamma1h  = ((gamma1xh >>> 19) | (gamma1xl << 13)) ^ ((gamma1xh << 3) | (gamma1xl >>> 29)) ^ (gamma1xh >>> 6);
	                    var gamma1l  = ((gamma1xl >>> 19) | (gamma1xh << 13)) ^ ((gamma1xl << 3) | (gamma1xh >>> 29)) ^ ((gamma1xl >>> 6) | (gamma1xh << 26));

	                    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	                    var Wi7  = W[i - 7];
	                    var Wi7h = Wi7.high;
	                    var Wi7l = Wi7.low;

	                    var Wi16  = W[i - 16];
	                    var Wi16h = Wi16.high;
	                    var Wi16l = Wi16.low;

	                    var Wil = gamma0l + Wi7l;
	                    var Wih = gamma0h + Wi7h + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0);
	                    var Wil = Wil + gamma1l;
	                    var Wih = Wih + gamma1h + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0);
	                    var Wil = Wil + Wi16l;
	                    var Wih = Wih + Wi16h + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0);

	                    Wi.high = Wih;
	                    Wi.low  = Wil;
	                }

	                var chh  = (eh & fh) ^ (~eh & gh);
	                var chl  = (el & fl) ^ (~el & gl);
	                var majh = (ah & bh) ^ (ah & ch) ^ (bh & ch);
	                var majl = (al & bl) ^ (al & cl) ^ (bl & cl);

	                var sigma0h = ((ah >>> 28) | (al << 4))  ^ ((ah << 30)  | (al >>> 2)) ^ ((ah << 25) | (al >>> 7));
	                var sigma0l = ((al >>> 28) | (ah << 4))  ^ ((al << 30)  | (ah >>> 2)) ^ ((al << 25) | (ah >>> 7));
	                var sigma1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((eh << 23) | (el >>> 9));
	                var sigma1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((el << 23) | (eh >>> 9));

	                // t1 = h + sigma1 + ch + K[i] + W[i]
	                var Ki  = K[i];
	                var Kih = Ki.high;
	                var Kil = Ki.low;

	                var t1l = hl + sigma1l;
	                var t1h = hh + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0);
	                var t1l = t1l + chl;
	                var t1h = t1h + chh + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0);
	                var t1l = t1l + Kil;
	                var t1h = t1h + Kih + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0);
	                var t1l = t1l + Wil;
	                var t1h = t1h + Wih + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0);

	                // t2 = sigma0 + maj
	                var t2l = sigma0l + majl;
	                var t2h = sigma0h + majh + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0);

	                // Update working variables
	                hh = gh;
	                hl = gl;
	                gh = fh;
	                gl = fl;
	                fh = eh;
	                fl = el;
	                el = (dl + t1l) | 0;
	                eh = (dh + t1h + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0;
	                dh = ch;
	                dl = cl;
	                ch = bh;
	                cl = bl;
	                bh = ah;
	                bl = al;
	                al = (t1l + t2l) | 0;
	                ah = (t1h + t2h + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0;
	            }

	            // Intermediate hash value
	            H0l = H0.low  = (H0l + al);
	            H0.high = (H0h + ah + ((H0l >>> 0) < (al >>> 0) ? 1 : 0));
	            H1l = H1.low  = (H1l + bl);
	            H1.high = (H1h + bh + ((H1l >>> 0) < (bl >>> 0) ? 1 : 0));
	            H2l = H2.low  = (H2l + cl);
	            H2.high = (H2h + ch + ((H2l >>> 0) < (cl >>> 0) ? 1 : 0));
	            H3l = H3.low  = (H3l + dl);
	            H3.high = (H3h + dh + ((H3l >>> 0) < (dl >>> 0) ? 1 : 0));
	            H4l = H4.low  = (H4l + el);
	            H4.high = (H4h + eh + ((H4l >>> 0) < (el >>> 0) ? 1 : 0));
	            H5l = H5.low  = (H5l + fl);
	            H5.high = (H5h + fh + ((H5l >>> 0) < (fl >>> 0) ? 1 : 0));
	            H6l = H6.low  = (H6l + gl);
	            H6.high = (H6h + gh + ((H6l >>> 0) < (gl >>> 0) ? 1 : 0));
	            H7l = H7.low  = (H7l + hl);
	            H7.high = (H7h + hh + ((H7l >>> 0) < (hl >>> 0) ? 1 : 0));
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 31] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Convert hash to 32-bit word array before returning
	            var hash = this._hash.toX32();

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        },

	        blockSize: 1024/32
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */
	    C.SHA512 = Hasher._createHelper(SHA512);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */
	    C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
	}());


	return CryptoJS.SHA512;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/tripledes.js":
/*!**************************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/tripledes.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"), __webpack_require__(/*! ./enc-base64 */ "./node_modules/_crypto-js@3.3.0@crypto-js/enc-base64.js"), __webpack_require__(/*! ./md5 */ "./node_modules/_crypto-js@3.3.0@crypto-js/md5.js"), __webpack_require__(/*! ./evpkdf */ "./node_modules/_crypto-js@3.3.0@crypto-js/evpkdf.js"), __webpack_require__(/*! ./cipher-core */ "./node_modules/_crypto-js@3.3.0@crypto-js/cipher-core.js"));
	}
	else {}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Permuted Choice 1 constants
	    var PC1 = [
	        57, 49, 41, 33, 25, 17, 9,  1,
	        58, 50, 42, 34, 26, 18, 10, 2,
	        59, 51, 43, 35, 27, 19, 11, 3,
	        60, 52, 44, 36, 63, 55, 47, 39,
	        31, 23, 15, 7,  62, 54, 46, 38,
	        30, 22, 14, 6,  61, 53, 45, 37,
	        29, 21, 13, 5,  28, 20, 12, 4
	    ];

	    // Permuted Choice 2 constants
	    var PC2 = [
	        14, 17, 11, 24, 1,  5,
	        3,  28, 15, 6,  21, 10,
	        23, 19, 12, 4,  26, 8,
	        16, 7,  27, 20, 13, 2,
	        41, 52, 31, 37, 47, 55,
	        30, 40, 51, 45, 33, 48,
	        44, 49, 39, 56, 34, 53,
	        46, 42, 50, 36, 29, 32
	    ];

	    // Cumulative bit shift constants
	    var BIT_SHIFTS = [1,  2,  4,  6,  8,  10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];

	    // SBOXes and round permutation constants
	    var SBOX_P = [
	        {
	            0x0: 0x808200,
	            0x10000000: 0x8000,
	            0x20000000: 0x808002,
	            0x30000000: 0x2,
	            0x40000000: 0x200,
	            0x50000000: 0x808202,
	            0x60000000: 0x800202,
	            0x70000000: 0x800000,
	            0x80000000: 0x202,
	            0x90000000: 0x800200,
	            0xa0000000: 0x8200,
	            0xb0000000: 0x808000,
	            0xc0000000: 0x8002,
	            0xd0000000: 0x800002,
	            0xe0000000: 0x0,
	            0xf0000000: 0x8202,
	            0x8000000: 0x0,
	            0x18000000: 0x808202,
	            0x28000000: 0x8202,
	            0x38000000: 0x8000,
	            0x48000000: 0x808200,
	            0x58000000: 0x200,
	            0x68000000: 0x808002,
	            0x78000000: 0x2,
	            0x88000000: 0x800200,
	            0x98000000: 0x8200,
	            0xa8000000: 0x808000,
	            0xb8000000: 0x800202,
	            0xc8000000: 0x800002,
	            0xd8000000: 0x8002,
	            0xe8000000: 0x202,
	            0xf8000000: 0x800000,
	            0x1: 0x8000,
	            0x10000001: 0x2,
	            0x20000001: 0x808200,
	            0x30000001: 0x800000,
	            0x40000001: 0x808002,
	            0x50000001: 0x8200,
	            0x60000001: 0x200,
	            0x70000001: 0x800202,
	            0x80000001: 0x808202,
	            0x90000001: 0x808000,
	            0xa0000001: 0x800002,
	            0xb0000001: 0x8202,
	            0xc0000001: 0x202,
	            0xd0000001: 0x800200,
	            0xe0000001: 0x8002,
	            0xf0000001: 0x0,
	            0x8000001: 0x808202,
	            0x18000001: 0x808000,
	            0x28000001: 0x800000,
	            0x38000001: 0x200,
	            0x48000001: 0x8000,
	            0x58000001: 0x800002,
	            0x68000001: 0x2,
	            0x78000001: 0x8202,
	            0x88000001: 0x8002,
	            0x98000001: 0x800202,
	            0xa8000001: 0x202,
	            0xb8000001: 0x808200,
	            0xc8000001: 0x800200,
	            0xd8000001: 0x0,
	            0xe8000001: 0x8200,
	            0xf8000001: 0x808002
	        },
	        {
	            0x0: 0x40084010,
	            0x1000000: 0x4000,
	            0x2000000: 0x80000,
	            0x3000000: 0x40080010,
	            0x4000000: 0x40000010,
	            0x5000000: 0x40084000,
	            0x6000000: 0x40004000,
	            0x7000000: 0x10,
	            0x8000000: 0x84000,
	            0x9000000: 0x40004010,
	            0xa000000: 0x40000000,
	            0xb000000: 0x84010,
	            0xc000000: 0x80010,
	            0xd000000: 0x0,
	            0xe000000: 0x4010,
	            0xf000000: 0x40080000,
	            0x800000: 0x40004000,
	            0x1800000: 0x84010,
	            0x2800000: 0x10,
	            0x3800000: 0x40004010,
	            0x4800000: 0x40084010,
	            0x5800000: 0x40000000,
	            0x6800000: 0x80000,
	            0x7800000: 0x40080010,
	            0x8800000: 0x80010,
	            0x9800000: 0x0,
	            0xa800000: 0x4000,
	            0xb800000: 0x40080000,
	            0xc800000: 0x40000010,
	            0xd800000: 0x84000,
	            0xe800000: 0x40084000,
	            0xf800000: 0x4010,
	            0x10000000: 0x0,
	            0x11000000: 0x40080010,
	            0x12000000: 0x40004010,
	            0x13000000: 0x40084000,
	            0x14000000: 0x40080000,
	            0x15000000: 0x10,
	            0x16000000: 0x84010,
	            0x17000000: 0x4000,
	            0x18000000: 0x4010,
	            0x19000000: 0x80000,
	            0x1a000000: 0x80010,
	            0x1b000000: 0x40000010,
	            0x1c000000: 0x84000,
	            0x1d000000: 0x40004000,
	            0x1e000000: 0x40000000,
	            0x1f000000: 0x40084010,
	            0x10800000: 0x84010,
	            0x11800000: 0x80000,
	            0x12800000: 0x40080000,
	            0x13800000: 0x4000,
	            0x14800000: 0x40004000,
	            0x15800000: 0x40084010,
	            0x16800000: 0x10,
	            0x17800000: 0x40000000,
	            0x18800000: 0x40084000,
	            0x19800000: 0x40000010,
	            0x1a800000: 0x40004010,
	            0x1b800000: 0x80010,
	            0x1c800000: 0x0,
	            0x1d800000: 0x4010,
	            0x1e800000: 0x40080010,
	            0x1f800000: 0x84000
	        },
	        {
	            0x0: 0x104,
	            0x100000: 0x0,
	            0x200000: 0x4000100,
	            0x300000: 0x10104,
	            0x400000: 0x10004,
	            0x500000: 0x4000004,
	            0x600000: 0x4010104,
	            0x700000: 0x4010000,
	            0x800000: 0x4000000,
	            0x900000: 0x4010100,
	            0xa00000: 0x10100,
	            0xb00000: 0x4010004,
	            0xc00000: 0x4000104,
	            0xd00000: 0x10000,
	            0xe00000: 0x4,
	            0xf00000: 0x100,
	            0x80000: 0x4010100,
	            0x180000: 0x4010004,
	            0x280000: 0x0,
	            0x380000: 0x4000100,
	            0x480000: 0x4000004,
	            0x580000: 0x10000,
	            0x680000: 0x10004,
	            0x780000: 0x104,
	            0x880000: 0x4,
	            0x980000: 0x100,
	            0xa80000: 0x4010000,
	            0xb80000: 0x10104,
	            0xc80000: 0x10100,
	            0xd80000: 0x4000104,
	            0xe80000: 0x4010104,
	            0xf80000: 0x4000000,
	            0x1000000: 0x4010100,
	            0x1100000: 0x10004,
	            0x1200000: 0x10000,
	            0x1300000: 0x4000100,
	            0x1400000: 0x100,
	            0x1500000: 0x4010104,
	            0x1600000: 0x4000004,
	            0x1700000: 0x0,
	            0x1800000: 0x4000104,
	            0x1900000: 0x4000000,
	            0x1a00000: 0x4,
	            0x1b00000: 0x10100,
	            0x1c00000: 0x4010000,
	            0x1d00000: 0x104,
	            0x1e00000: 0x10104,
	            0x1f00000: 0x4010004,
	            0x1080000: 0x4000000,
	            0x1180000: 0x104,
	            0x1280000: 0x4010100,
	            0x1380000: 0x0,
	            0x1480000: 0x10004,
	            0x1580000: 0x4000100,
	            0x1680000: 0x100,
	            0x1780000: 0x4010004,
	            0x1880000: 0x10000,
	            0x1980000: 0x4010104,
	            0x1a80000: 0x10104,
	            0x1b80000: 0x4000004,
	            0x1c80000: 0x4000104,
	            0x1d80000: 0x4010000,
	            0x1e80000: 0x4,
	            0x1f80000: 0x10100
	        },
	        {
	            0x0: 0x80401000,
	            0x10000: 0x80001040,
	            0x20000: 0x401040,
	            0x30000: 0x80400000,
	            0x40000: 0x0,
	            0x50000: 0x401000,
	            0x60000: 0x80000040,
	            0x70000: 0x400040,
	            0x80000: 0x80000000,
	            0x90000: 0x400000,
	            0xa0000: 0x40,
	            0xb0000: 0x80001000,
	            0xc0000: 0x80400040,
	            0xd0000: 0x1040,
	            0xe0000: 0x1000,
	            0xf0000: 0x80401040,
	            0x8000: 0x80001040,
	            0x18000: 0x40,
	            0x28000: 0x80400040,
	            0x38000: 0x80001000,
	            0x48000: 0x401000,
	            0x58000: 0x80401040,
	            0x68000: 0x0,
	            0x78000: 0x80400000,
	            0x88000: 0x1000,
	            0x98000: 0x80401000,
	            0xa8000: 0x400000,
	            0xb8000: 0x1040,
	            0xc8000: 0x80000000,
	            0xd8000: 0x400040,
	            0xe8000: 0x401040,
	            0xf8000: 0x80000040,
	            0x100000: 0x400040,
	            0x110000: 0x401000,
	            0x120000: 0x80000040,
	            0x130000: 0x0,
	            0x140000: 0x1040,
	            0x150000: 0x80400040,
	            0x160000: 0x80401000,
	            0x170000: 0x80001040,
	            0x180000: 0x80401040,
	            0x190000: 0x80000000,
	            0x1a0000: 0x80400000,
	            0x1b0000: 0x401040,
	            0x1c0000: 0x80001000,
	            0x1d0000: 0x400000,
	            0x1e0000: 0x40,
	            0x1f0000: 0x1000,
	            0x108000: 0x80400000,
	            0x118000: 0x80401040,
	            0x128000: 0x0,
	            0x138000: 0x401000,
	            0x148000: 0x400040,
	            0x158000: 0x80000000,
	            0x168000: 0x80001040,
	            0x178000: 0x40,
	            0x188000: 0x80000040,
	            0x198000: 0x1000,
	            0x1a8000: 0x80001000,
	            0x1b8000: 0x80400040,
	            0x1c8000: 0x1040,
	            0x1d8000: 0x80401000,
	            0x1e8000: 0x400000,
	            0x1f8000: 0x401040
	        },
	        {
	            0x0: 0x80,
	            0x1000: 0x1040000,
	            0x2000: 0x40000,
	            0x3000: 0x20000000,
	            0x4000: 0x20040080,
	            0x5000: 0x1000080,
	            0x6000: 0x21000080,
	            0x7000: 0x40080,
	            0x8000: 0x1000000,
	            0x9000: 0x20040000,
	            0xa000: 0x20000080,
	            0xb000: 0x21040080,
	            0xc000: 0x21040000,
	            0xd000: 0x0,
	            0xe000: 0x1040080,
	            0xf000: 0x21000000,
	            0x800: 0x1040080,
	            0x1800: 0x21000080,
	            0x2800: 0x80,
	            0x3800: 0x1040000,
	            0x4800: 0x40000,
	            0x5800: 0x20040080,
	            0x6800: 0x21040000,
	            0x7800: 0x20000000,
	            0x8800: 0x20040000,
	            0x9800: 0x0,
	            0xa800: 0x21040080,
	            0xb800: 0x1000080,
	            0xc800: 0x20000080,
	            0xd800: 0x21000000,
	            0xe800: 0x1000000,
	            0xf800: 0x40080,
	            0x10000: 0x40000,
	            0x11000: 0x80,
	            0x12000: 0x20000000,
	            0x13000: 0x21000080,
	            0x14000: 0x1000080,
	            0x15000: 0x21040000,
	            0x16000: 0x20040080,
	            0x17000: 0x1000000,
	            0x18000: 0x21040080,
	            0x19000: 0x21000000,
	            0x1a000: 0x1040000,
	            0x1b000: 0x20040000,
	            0x1c000: 0x40080,
	            0x1d000: 0x20000080,
	            0x1e000: 0x0,
	            0x1f000: 0x1040080,
	            0x10800: 0x21000080,
	            0x11800: 0x1000000,
	            0x12800: 0x1040000,
	            0x13800: 0x20040080,
	            0x14800: 0x20000000,
	            0x15800: 0x1040080,
	            0x16800: 0x80,
	            0x17800: 0x21040000,
	            0x18800: 0x40080,
	            0x19800: 0x21040080,
	            0x1a800: 0x0,
	            0x1b800: 0x21000000,
	            0x1c800: 0x1000080,
	            0x1d800: 0x40000,
	            0x1e800: 0x20040000,
	            0x1f800: 0x20000080
	        },
	        {
	            0x0: 0x10000008,
	            0x100: 0x2000,
	            0x200: 0x10200000,
	            0x300: 0x10202008,
	            0x400: 0x10002000,
	            0x500: 0x200000,
	            0x600: 0x200008,
	            0x700: 0x10000000,
	            0x800: 0x0,
	            0x900: 0x10002008,
	            0xa00: 0x202000,
	            0xb00: 0x8,
	            0xc00: 0x10200008,
	            0xd00: 0x202008,
	            0xe00: 0x2008,
	            0xf00: 0x10202000,
	            0x80: 0x10200000,
	            0x180: 0x10202008,
	            0x280: 0x8,
	            0x380: 0x200000,
	            0x480: 0x202008,
	            0x580: 0x10000008,
	            0x680: 0x10002000,
	            0x780: 0x2008,
	            0x880: 0x200008,
	            0x980: 0x2000,
	            0xa80: 0x10002008,
	            0xb80: 0x10200008,
	            0xc80: 0x0,
	            0xd80: 0x10202000,
	            0xe80: 0x202000,
	            0xf80: 0x10000000,
	            0x1000: 0x10002000,
	            0x1100: 0x10200008,
	            0x1200: 0x10202008,
	            0x1300: 0x2008,
	            0x1400: 0x200000,
	            0x1500: 0x10000000,
	            0x1600: 0x10000008,
	            0x1700: 0x202000,
	            0x1800: 0x202008,
	            0x1900: 0x0,
	            0x1a00: 0x8,
	            0x1b00: 0x10200000,
	            0x1c00: 0x2000,
	            0x1d00: 0x10002008,
	            0x1e00: 0x10202000,
	            0x1f00: 0x200008,
	            0x1080: 0x8,
	            0x1180: 0x202000,
	            0x1280: 0x200000,
	            0x1380: 0x10000008,
	            0x1480: 0x10002000,
	            0x1580: 0x2008,
	            0x1680: 0x10202008,
	            0x1780: 0x10200000,
	            0x1880: 0x10202000,
	            0x1980: 0x10200008,
	            0x1a80: 0x2000,
	            0x1b80: 0x202008,
	            0x1c80: 0x200008,
	            0x1d80: 0x0,
	            0x1e80: 0x10000000,
	            0x1f80: 0x10002008
	        },
	        {
	            0x0: 0x100000,
	            0x10: 0x2000401,
	            0x20: 0x400,
	            0x30: 0x100401,
	            0x40: 0x2100401,
	            0x50: 0x0,
	            0x60: 0x1,
	            0x70: 0x2100001,
	            0x80: 0x2000400,
	            0x90: 0x100001,
	            0xa0: 0x2000001,
	            0xb0: 0x2100400,
	            0xc0: 0x2100000,
	            0xd0: 0x401,
	            0xe0: 0x100400,
	            0xf0: 0x2000000,
	            0x8: 0x2100001,
	            0x18: 0x0,
	            0x28: 0x2000401,
	            0x38: 0x2100400,
	            0x48: 0x100000,
	            0x58: 0x2000001,
	            0x68: 0x2000000,
	            0x78: 0x401,
	            0x88: 0x100401,
	            0x98: 0x2000400,
	            0xa8: 0x2100000,
	            0xb8: 0x100001,
	            0xc8: 0x400,
	            0xd8: 0x2100401,
	            0xe8: 0x1,
	            0xf8: 0x100400,
	            0x100: 0x2000000,
	            0x110: 0x100000,
	            0x120: 0x2000401,
	            0x130: 0x2100001,
	            0x140: 0x100001,
	            0x150: 0x2000400,
	            0x160: 0x2100400,
	            0x170: 0x100401,
	            0x180: 0x401,
	            0x190: 0x2100401,
	            0x1a0: 0x100400,
	            0x1b0: 0x1,
	            0x1c0: 0x0,
	            0x1d0: 0x2100000,
	            0x1e0: 0x2000001,
	            0x1f0: 0x400,
	            0x108: 0x100400,
	            0x118: 0x2000401,
	            0x128: 0x2100001,
	            0x138: 0x1,
	            0x148: 0x2000000,
	            0x158: 0x100000,
	            0x168: 0x401,
	            0x178: 0x2100400,
	            0x188: 0x2000001,
	            0x198: 0x2100000,
	            0x1a8: 0x0,
	            0x1b8: 0x2100401,
	            0x1c8: 0x100401,
	            0x1d8: 0x400,
	            0x1e8: 0x2000400,
	            0x1f8: 0x100001
	        },
	        {
	            0x0: 0x8000820,
	            0x1: 0x20000,
	            0x2: 0x8000000,
	            0x3: 0x20,
	            0x4: 0x20020,
	            0x5: 0x8020820,
	            0x6: 0x8020800,
	            0x7: 0x800,
	            0x8: 0x8020000,
	            0x9: 0x8000800,
	            0xa: 0x20800,
	            0xb: 0x8020020,
	            0xc: 0x820,
	            0xd: 0x0,
	            0xe: 0x8000020,
	            0xf: 0x20820,
	            0x80000000: 0x800,
	            0x80000001: 0x8020820,
	            0x80000002: 0x8000820,
	            0x80000003: 0x8000000,
	            0x80000004: 0x8020000,
	            0x80000005: 0x20800,
	            0x80000006: 0x20820,
	            0x80000007: 0x20,
	            0x80000008: 0x8000020,
	            0x80000009: 0x820,
	            0x8000000a: 0x20020,
	            0x8000000b: 0x8020800,
	            0x8000000c: 0x0,
	            0x8000000d: 0x8020020,
	            0x8000000e: 0x8000800,
	            0x8000000f: 0x20000,
	            0x10: 0x20820,
	            0x11: 0x8020800,
	            0x12: 0x20,
	            0x13: 0x800,
	            0x14: 0x8000800,
	            0x15: 0x8000020,
	            0x16: 0x8020020,
	            0x17: 0x20000,
	            0x18: 0x0,
	            0x19: 0x20020,
	            0x1a: 0x8020000,
	            0x1b: 0x8000820,
	            0x1c: 0x8020820,
	            0x1d: 0x20800,
	            0x1e: 0x820,
	            0x1f: 0x8000000,
	            0x80000010: 0x20000,
	            0x80000011: 0x800,
	            0x80000012: 0x8020020,
	            0x80000013: 0x20820,
	            0x80000014: 0x20,
	            0x80000015: 0x8020000,
	            0x80000016: 0x8000000,
	            0x80000017: 0x8000820,
	            0x80000018: 0x8020820,
	            0x80000019: 0x8000020,
	            0x8000001a: 0x8000800,
	            0x8000001b: 0x0,
	            0x8000001c: 0x20800,
	            0x8000001d: 0x820,
	            0x8000001e: 0x20020,
	            0x8000001f: 0x8020800
	        }
	    ];

	    // Masks that select the SBOX input
	    var SBOX_MASK = [
	        0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000,
	        0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f
	    ];

	    /**
	     * DES block cipher algorithm.
	     */
	    var DES = C_algo.DES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Select 56 bits according to PC1
	            var keyBits = [];
	            for (var i = 0; i < 56; i++) {
	                var keyBitPos = PC1[i] - 1;
	                keyBits[i] = (keyWords[keyBitPos >>> 5] >>> (31 - keyBitPos % 32)) & 1;
	            }

	            // Assemble 16 subkeys
	            var subKeys = this._subKeys = [];
	            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
	                // Create subkey
	                var subKey = subKeys[nSubKey] = [];

	                // Shortcut
	                var bitShift = BIT_SHIFTS[nSubKey];

	                // Select 48 bits according to PC2
	                for (var i = 0; i < 24; i++) {
	                    // Select from the left 28 key bits
	                    subKey[(i / 6) | 0] |= keyBits[((PC2[i] - 1) + bitShift) % 28] << (31 - i % 6);

	                    // Select from the right 28 key bits
	                    subKey[4 + ((i / 6) | 0)] |= keyBits[28 + (((PC2[i + 24] - 1) + bitShift) % 28)] << (31 - i % 6);
	                }

	                // Since each subkey is applied to an expanded 32-bit input,
	                // the subkey can be broken into 8 values scaled to 32-bits,
	                // which allows the key to be used without expansion
	                subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
	                for (var i = 1; i < 7; i++) {
	                    subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
	                }
	                subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
	            }

	            // Compute inverse subkeys
	            var invSubKeys = this._invSubKeys = [];
	            for (var i = 0; i < 16; i++) {
	                invSubKeys[i] = subKeys[15 - i];
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._subKeys);
	        },

	        decryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._invSubKeys);
	        },

	        _doCryptBlock: function (M, offset, subKeys) {
	            // Get input
	            this._lBlock = M[offset];
	            this._rBlock = M[offset + 1];

	            // Initial permutation
	            exchangeLR.call(this, 4,  0x0f0f0f0f);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeLR.call(this, 1,  0x55555555);

	            // Rounds
	            for (var round = 0; round < 16; round++) {
	                // Shortcuts
	                var subKey = subKeys[round];
	                var lBlock = this._lBlock;
	                var rBlock = this._rBlock;

	                // Feistel function
	                var f = 0;
	                for (var i = 0; i < 8; i++) {
	                    f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
	                }
	                this._lBlock = rBlock;
	                this._rBlock = lBlock ^ f;
	            }

	            // Undo swap from last round
	            var t = this._lBlock;
	            this._lBlock = this._rBlock;
	            this._rBlock = t;

	            // Final permutation
	            exchangeLR.call(this, 1,  0x55555555);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeLR.call(this, 4,  0x0f0f0f0f);

	            // Set output
	            M[offset] = this._lBlock;
	            M[offset + 1] = this._rBlock;
	        },

	        keySize: 64/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    // Swap bits across the left and right words
	    function exchangeLR(offset, mask) {
	        var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
	        this._rBlock ^= t;
	        this._lBlock ^= t << offset;
	    }

	    function exchangeRL(offset, mask) {
	        var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
	        this._lBlock ^= t;
	        this._rBlock ^= t << offset;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */
	    C.DES = BlockCipher._createHelper(DES);

	    /**
	     * Triple-DES block cipher algorithm.
	     */
	    var TripleDES = C_algo.TripleDES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Create DES instances
	            this._des1 = DES.createEncryptor(WordArray.create(keyWords.slice(0, 2)));
	            this._des2 = DES.createEncryptor(WordArray.create(keyWords.slice(2, 4)));
	            this._des3 = DES.createEncryptor(WordArray.create(keyWords.slice(4, 6)));
	        },

	        encryptBlock: function (M, offset) {
	            this._des1.encryptBlock(M, offset);
	            this._des2.decryptBlock(M, offset);
	            this._des3.encryptBlock(M, offset);
	        },

	        decryptBlock: function (M, offset) {
	            this._des3.decryptBlock(M, offset);
	            this._des2.encryptBlock(M, offset);
	            this._des1.decryptBlock(M, offset);
	        },

	        keySize: 192/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */
	    C.TripleDES = BlockCipher._createHelper(TripleDES);
	}());


	return CryptoJS.TripleDES;

}));

/***/ }),

/***/ "./node_modules/_crypto-js@3.3.0@crypto-js/x64-core.js":
/*!*************************************************************!*\
  !*** ./node_modules/_crypto-js@3.3.0@crypto-js/x64-core.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(/*! ./core */ "./node_modules/_crypto-js@3.3.0@crypto-js/core.js"));
	}
	else {}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var X32WordArray = C_lib.WordArray;

	    /**
	     * x64 namespace.
	     */
	    var C_x64 = C.x64 = {};

	    /**
	     * A 64-bit word.
	     */
	    var X64Word = C_x64.Word = Base.extend({
	        /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */
	        init: function (high, low) {
	            this.high = high;
	            this.low = low;
	        }

	        /**
	         * Bitwise NOTs this word.
	         *
	         * @return {X64Word} A new x64-Word object after negating.
	         *
	         * @example
	         *
	         *     var negated = x64Word.not();
	         */
	        // not: function () {
	            // var high = ~this.high;
	            // var low = ~this.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ANDs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to AND with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ANDing.
	         *
	         * @example
	         *
	         *     var anded = x64Word.and(anotherX64Word);
	         */
	        // and: function (word) {
	            // var high = this.high & word.high;
	            // var low = this.low & word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to OR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ORing.
	         *
	         * @example
	         *
	         *     var ored = x64Word.or(anotherX64Word);
	         */
	        // or: function (word) {
	            // var high = this.high | word.high;
	            // var low = this.low | word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise XORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to XOR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after XORing.
	         *
	         * @example
	         *
	         *     var xored = x64Word.xor(anotherX64Word);
	         */
	        // xor: function (word) {
	            // var high = this.high ^ word.high;
	            // var low = this.low ^ word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the left.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftL(25);
	         */
	        // shiftL: function (n) {
	            // if (n < 32) {
	                // var high = (this.high << n) | (this.low >>> (32 - n));
	                // var low = this.low << n;
	            // } else {
	                // var high = this.low << (n - 32);
	                // var low = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the right.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftR(7);
	         */
	        // shiftR: function (n) {
	            // if (n < 32) {
	                // var low = (this.low >>> n) | (this.high << (32 - n));
	                // var high = this.high >>> n;
	            // } else {
	                // var low = this.high >>> (n - 32);
	                // var high = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Rotates this word n bits to the left.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotL(25);
	         */
	        // rotL: function (n) {
	            // return this.shiftL(n).or(this.shiftR(64 - n));
	        // },

	        /**
	         * Rotates this word n bits to the right.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotR(7);
	         */
	        // rotR: function (n) {
	            // return this.shiftR(n).or(this.shiftL(64 - n));
	        // },

	        /**
	         * Adds this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to add with this word.
	         *
	         * @return {X64Word} A new x64-Word object after adding.
	         *
	         * @example
	         *
	         *     var added = x64Word.add(anotherX64Word);
	         */
	        // add: function (word) {
	            // var low = (this.low + word.low) | 0;
	            // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
	            // var high = (this.high + word.high + carry) | 0;

	            // return X64Word.create(high, low);
	        // }
	    });

	    /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var X64WordArray = C_x64.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 8;
	            }
	        },

	        /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */
	        toX32: function () {
	            // Shortcuts
	            var x64Words = this.words;
	            var x64WordsLength = x64Words.length;

	            // Convert
	            var x32Words = [];
	            for (var i = 0; i < x64WordsLength; i++) {
	                var x64Word = x64Words[i];
	                x32Words.push(x64Word.high);
	                x32Words.push(x64Word.low);
	            }

	            return X32WordArray.create(x32Words, this.sigBytes);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);

	            // Clone "words" array
	            var words = clone.words = this.words.slice(0);

	            // Clone each X64Word object
	            var wordsLength = words.length;
	            for (var i = 0; i < wordsLength; i++) {
	                words[i] = words[i].clone();
	            }

	            return clone;
	        }
	    });
	}());


	return CryptoJS;

}));

/***/ }),

/***/ "./node_modules/_js-md5@0.7.3@js-md5/src/md5.js":
/*!******************************************************!*\
  !*** ./node_modules/_js-md5@0.7.3@js-md5/src/md5.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * [js-md5]{@link https://github.com/emn178/js-md5}
 *
 * @namespace md5
 * @version 0.7.3
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2017
 * @license MIT
 */
(function () {
  'use strict';

  var ERROR = 'input is invalid type';
  var WINDOW = typeof window === 'object';
  var root = WINDOW ? window : {};
  if (root.JS_MD5_NO_WINDOW) {
    WINDOW = false;
  }
  var WEB_WORKER = !WINDOW && typeof self === 'object';
  var NODE_JS = !root.JS_MD5_NO_NODE_JS && typeof process === 'object' && process.versions && process.versions.node;
  if (NODE_JS) {
    root = global;
  } else if (WEB_WORKER) {
    root = self;
  }
  var COMMON_JS = !root.JS_MD5_NO_COMMON_JS && typeof module === 'object' && module.exports;
  var AMD =  true && __webpack_require__(/*! !webpack amd options */ "./node_modules/_webpack@4.46.0@webpack/buildin/amd-options.js");
  var ARRAY_BUFFER = !root.JS_MD5_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
  var HEX_CHARS = '0123456789abcdef'.split('');
  var EXTRA = [128, 32768, 8388608, -2147483648];
  var SHIFT = [0, 8, 16, 24];
  var OUTPUT_TYPES = ['hex', 'array', 'digest', 'buffer', 'arrayBuffer', 'base64'];
  var BASE64_ENCODE_CHAR = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');

  var blocks = [], buffer8;
  if (ARRAY_BUFFER) {
    var buffer = new ArrayBuffer(68);
    buffer8 = new Uint8Array(buffer);
    blocks = new Uint32Array(buffer);
  }

  if (root.JS_MD5_NO_NODE_JS || !Array.isArray) {
    Array.isArray = function (obj) {
      return Object.prototype.toString.call(obj) === '[object Array]';
    };
  }

  if (ARRAY_BUFFER && (root.JS_MD5_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) {
    ArrayBuffer.isView = function (obj) {
      return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
  }

  /**
   * @method hex
   * @memberof md5
   * @description Output hash as hex string
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {String} Hex string
   * @example
   * md5.hex('The quick brown fox jumps over the lazy dog');
   * // equal to
   * md5('The quick brown fox jumps over the lazy dog');
   */
  /**
   * @method digest
   * @memberof md5
   * @description Output hash as bytes array
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Array} Bytes array
   * @example
   * md5.digest('The quick brown fox jumps over the lazy dog');
   */
  /**
   * @method array
   * @memberof md5
   * @description Output hash as bytes array
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Array} Bytes array
   * @example
   * md5.array('The quick brown fox jumps over the lazy dog');
   */
  /**
   * @method arrayBuffer
   * @memberof md5
   * @description Output hash as ArrayBuffer
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {ArrayBuffer} ArrayBuffer
   * @example
   * md5.arrayBuffer('The quick brown fox jumps over the lazy dog');
   */
  /**
   * @method buffer
   * @deprecated This maybe confuse with Buffer in node.js. Please use arrayBuffer instead.
   * @memberof md5
   * @description Output hash as ArrayBuffer
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {ArrayBuffer} ArrayBuffer
   * @example
   * md5.buffer('The quick brown fox jumps over the lazy dog');
   */
  /**
   * @method base64
   * @memberof md5
   * @description Output hash as base64 string
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {String} base64 string
   * @example
   * md5.base64('The quick brown fox jumps over the lazy dog');
   */
  var createOutputMethod = function (outputType) {
    return function (message) {
      return new Md5(true).update(message)[outputType]();
    };
  };

  /**
   * @method create
   * @memberof md5
   * @description Create Md5 object
   * @returns {Md5} Md5 object.
   * @example
   * var hash = md5.create();
   */
  /**
   * @method update
   * @memberof md5
   * @description Create and update Md5 object
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Md5} Md5 object.
   * @example
   * var hash = md5.update('The quick brown fox jumps over the lazy dog');
   * // equal to
   * var hash = md5.create();
   * hash.update('The quick brown fox jumps over the lazy dog');
   */
  var createMethod = function () {
    var method = createOutputMethod('hex');
    if (NODE_JS) {
      method = nodeWrap(method);
    }
    method.create = function () {
      return new Md5();
    };
    method.update = function (message) {
      return method.create().update(message);
    };
    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
      var type = OUTPUT_TYPES[i];
      method[type] = createOutputMethod(type);
    }
    return method;
  };

  var nodeWrap = function (method) {
    var crypto = eval("require('crypto')");
    var Buffer = eval("require('buffer').Buffer");
    var nodeMethod = function (message) {
      if (typeof message === 'string') {
        return crypto.createHash('md5').update(message, 'utf8').digest('hex');
      } else {
        if (message === null || message === undefined) {
          throw ERROR;
        } else if (message.constructor === ArrayBuffer) {
          message = new Uint8Array(message);
        }
      }
      if (Array.isArray(message) || ArrayBuffer.isView(message) ||
        message.constructor === Buffer) {
        return crypto.createHash('md5').update(new Buffer(message)).digest('hex');
      } else {
        return method(message);
      }
    };
    return nodeMethod;
  };

  /**
   * Md5 class
   * @class Md5
   * @description This is internal class.
   * @see {@link md5.create}
   */
  function Md5(sharedMemory) {
    if (sharedMemory) {
      blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] =
      blocks[4] = blocks[5] = blocks[6] = blocks[7] =
      blocks[8] = blocks[9] = blocks[10] = blocks[11] =
      blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
      this.blocks = blocks;
      this.buffer8 = buffer8;
    } else {
      if (ARRAY_BUFFER) {
        var buffer = new ArrayBuffer(68);
        this.buffer8 = new Uint8Array(buffer);
        this.blocks = new Uint32Array(buffer);
      } else {
        this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      }
    }
    this.h0 = this.h1 = this.h2 = this.h3 = this.start = this.bytes = this.hBytes = 0;
    this.finalized = this.hashed = false;
    this.first = true;
  }

  /**
   * @method update
   * @memberof Md5
   * @instance
   * @description Update hash
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Md5} Md5 object.
   * @see {@link md5.update}
   */
  Md5.prototype.update = function (message) {
    if (this.finalized) {
      return;
    }

    var notString, type = typeof message;
    if (type !== 'string') {
      if (type === 'object') {
        if (message === null) {
          throw ERROR;
        } else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) {
          message = new Uint8Array(message);
        } else if (!Array.isArray(message)) {
          if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) {
            throw ERROR;
          }
        }
      } else {
        throw ERROR;
      }
      notString = true;
    }
    var code, index = 0, i, length = message.length, blocks = this.blocks;
    var buffer8 = this.buffer8;

    while (index < length) {
      if (this.hashed) {
        this.hashed = false;
        blocks[0] = blocks[16];
        blocks[16] = blocks[1] = blocks[2] = blocks[3] =
        blocks[4] = blocks[5] = blocks[6] = blocks[7] =
        blocks[8] = blocks[9] = blocks[10] = blocks[11] =
        blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
      }

      if (notString) {
        if (ARRAY_BUFFER) {
          for (i = this.start; index < length && i < 64; ++index) {
            buffer8[i++] = message[index];
          }
        } else {
          for (i = this.start; index < length && i < 64; ++index) {
            blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
          }
        }
      } else {
        if (ARRAY_BUFFER) {
          for (i = this.start; index < length && i < 64; ++index) {
            code = message.charCodeAt(index);
            if (code < 0x80) {
              buffer8[i++] = code;
            } else if (code < 0x800) {
              buffer8[i++] = 0xc0 | (code >> 6);
              buffer8[i++] = 0x80 | (code & 0x3f);
            } else if (code < 0xd800 || code >= 0xe000) {
              buffer8[i++] = 0xe0 | (code >> 12);
              buffer8[i++] = 0x80 | ((code >> 6) & 0x3f);
              buffer8[i++] = 0x80 | (code & 0x3f);
            } else {
              code = 0x10000 + (((code & 0x3ff) << 10) | (message.charCodeAt(++index) & 0x3ff));
              buffer8[i++] = 0xf0 | (code >> 18);
              buffer8[i++] = 0x80 | ((code >> 12) & 0x3f);
              buffer8[i++] = 0x80 | ((code >> 6) & 0x3f);
              buffer8[i++] = 0x80 | (code & 0x3f);
            }
          }
        } else {
          for (i = this.start; index < length && i < 64; ++index) {
            code = message.charCodeAt(index);
            if (code < 0x80) {
              blocks[i >> 2] |= code << SHIFT[i++ & 3];
            } else if (code < 0x800) {
              blocks[i >> 2] |= (0xc0 | (code >> 6)) << SHIFT[i++ & 3];
              blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
            } else if (code < 0xd800 || code >= 0xe000) {
              blocks[i >> 2] |= (0xe0 | (code >> 12)) << SHIFT[i++ & 3];
              blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
              blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
            } else {
              code = 0x10000 + (((code & 0x3ff) << 10) | (message.charCodeAt(++index) & 0x3ff));
              blocks[i >> 2] |= (0xf0 | (code >> 18)) << SHIFT[i++ & 3];
              blocks[i >> 2] |= (0x80 | ((code >> 12) & 0x3f)) << SHIFT[i++ & 3];
              blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
              blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
            }
          }
        }
      }
      this.lastByteIndex = i;
      this.bytes += i - this.start;
      if (i >= 64) {
        this.start = i - 64;
        this.hash();
        this.hashed = true;
      } else {
        this.start = i;
      }
    }
    if (this.bytes > 4294967295) {
      this.hBytes += this.bytes / 4294967296 << 0;
      this.bytes = this.bytes % 4294967296;
    }
    return this;
  };

  Md5.prototype.finalize = function () {
    if (this.finalized) {
      return;
    }
    this.finalized = true;
    var blocks = this.blocks, i = this.lastByteIndex;
    blocks[i >> 2] |= EXTRA[i & 3];
    if (i >= 56) {
      if (!this.hashed) {
        this.hash();
      }
      blocks[0] = blocks[16];
      blocks[16] = blocks[1] = blocks[2] = blocks[3] =
      blocks[4] = blocks[5] = blocks[6] = blocks[7] =
      blocks[8] = blocks[9] = blocks[10] = blocks[11] =
      blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
    }
    blocks[14] = this.bytes << 3;
    blocks[15] = this.hBytes << 3 | this.bytes >>> 29;
    this.hash();
  };

  Md5.prototype.hash = function () {
    var a, b, c, d, bc, da, blocks = this.blocks;

    if (this.first) {
      a = blocks[0] - 680876937;
      a = (a << 7 | a >>> 25) - 271733879 << 0;
      d = (-1732584194 ^ a & 2004318071) + blocks[1] - 117830708;
      d = (d << 12 | d >>> 20) + a << 0;
      c = (-271733879 ^ (d & (a ^ -271733879))) + blocks[2] - 1126478375;
      c = (c << 17 | c >>> 15) + d << 0;
      b = (a ^ (c & (d ^ a))) + blocks[3] - 1316259209;
      b = (b << 22 | b >>> 10) + c << 0;
    } else {
      a = this.h0;
      b = this.h1;
      c = this.h2;
      d = this.h3;
      a += (d ^ (b & (c ^ d))) + blocks[0] - 680876936;
      a = (a << 7 | a >>> 25) + b << 0;
      d += (c ^ (a & (b ^ c))) + blocks[1] - 389564586;
      d = (d << 12 | d >>> 20) + a << 0;
      c += (b ^ (d & (a ^ b))) + blocks[2] + 606105819;
      c = (c << 17 | c >>> 15) + d << 0;
      b += (a ^ (c & (d ^ a))) + blocks[3] - 1044525330;
      b = (b << 22 | b >>> 10) + c << 0;
    }

    a += (d ^ (b & (c ^ d))) + blocks[4] - 176418897;
    a = (a << 7 | a >>> 25) + b << 0;
    d += (c ^ (a & (b ^ c))) + blocks[5] + 1200080426;
    d = (d << 12 | d >>> 20) + a << 0;
    c += (b ^ (d & (a ^ b))) + blocks[6] - 1473231341;
    c = (c << 17 | c >>> 15) + d << 0;
    b += (a ^ (c & (d ^ a))) + blocks[7] - 45705983;
    b = (b << 22 | b >>> 10) + c << 0;
    a += (d ^ (b & (c ^ d))) + blocks[8] + 1770035416;
    a = (a << 7 | a >>> 25) + b << 0;
    d += (c ^ (a & (b ^ c))) + blocks[9] - 1958414417;
    d = (d << 12 | d >>> 20) + a << 0;
    c += (b ^ (d & (a ^ b))) + blocks[10] - 42063;
    c = (c << 17 | c >>> 15) + d << 0;
    b += (a ^ (c & (d ^ a))) + blocks[11] - 1990404162;
    b = (b << 22 | b >>> 10) + c << 0;
    a += (d ^ (b & (c ^ d))) + blocks[12] + 1804603682;
    a = (a << 7 | a >>> 25) + b << 0;
    d += (c ^ (a & (b ^ c))) + blocks[13] - 40341101;
    d = (d << 12 | d >>> 20) + a << 0;
    c += (b ^ (d & (a ^ b))) + blocks[14] - 1502002290;
    c = (c << 17 | c >>> 15) + d << 0;
    b += (a ^ (c & (d ^ a))) + blocks[15] + 1236535329;
    b = (b << 22 | b >>> 10) + c << 0;
    a += (c ^ (d & (b ^ c))) + blocks[1] - 165796510;
    a = (a << 5 | a >>> 27) + b << 0;
    d += (b ^ (c & (a ^ b))) + blocks[6] - 1069501632;
    d = (d << 9 | d >>> 23) + a << 0;
    c += (a ^ (b & (d ^ a))) + blocks[11] + 643717713;
    c = (c << 14 | c >>> 18) + d << 0;
    b += (d ^ (a & (c ^ d))) + blocks[0] - 373897302;
    b = (b << 20 | b >>> 12) + c << 0;
    a += (c ^ (d & (b ^ c))) + blocks[5] - 701558691;
    a = (a << 5 | a >>> 27) + b << 0;
    d += (b ^ (c & (a ^ b))) + blocks[10] + 38016083;
    d = (d << 9 | d >>> 23) + a << 0;
    c += (a ^ (b & (d ^ a))) + blocks[15] - 660478335;
    c = (c << 14 | c >>> 18) + d << 0;
    b += (d ^ (a & (c ^ d))) + blocks[4] - 405537848;
    b = (b << 20 | b >>> 12) + c << 0;
    a += (c ^ (d & (b ^ c))) + blocks[9] + 568446438;
    a = (a << 5 | a >>> 27) + b << 0;
    d += (b ^ (c & (a ^ b))) + blocks[14] - 1019803690;
    d = (d << 9 | d >>> 23) + a << 0;
    c += (a ^ (b & (d ^ a))) + blocks[3] - 187363961;
    c = (c << 14 | c >>> 18) + d << 0;
    b += (d ^ (a & (c ^ d))) + blocks[8] + 1163531501;
    b = (b << 20 | b >>> 12) + c << 0;
    a += (c ^ (d & (b ^ c))) + blocks[13] - 1444681467;
    a = (a << 5 | a >>> 27) + b << 0;
    d += (b ^ (c & (a ^ b))) + blocks[2] - 51403784;
    d = (d << 9 | d >>> 23) + a << 0;
    c += (a ^ (b & (d ^ a))) + blocks[7] + 1735328473;
    c = (c << 14 | c >>> 18) + d << 0;
    b += (d ^ (a & (c ^ d))) + blocks[12] - 1926607734;
    b = (b << 20 | b >>> 12) + c << 0;
    bc = b ^ c;
    a += (bc ^ d) + blocks[5] - 378558;
    a = (a << 4 | a >>> 28) + b << 0;
    d += (bc ^ a) + blocks[8] - 2022574463;
    d = (d << 11 | d >>> 21) + a << 0;
    da = d ^ a;
    c += (da ^ b) + blocks[11] + 1839030562;
    c = (c << 16 | c >>> 16) + d << 0;
    b += (da ^ c) + blocks[14] - 35309556;
    b = (b << 23 | b >>> 9) + c << 0;
    bc = b ^ c;
    a += (bc ^ d) + blocks[1] - 1530992060;
    a = (a << 4 | a >>> 28) + b << 0;
    d += (bc ^ a) + blocks[4] + 1272893353;
    d = (d << 11 | d >>> 21) + a << 0;
    da = d ^ a;
    c += (da ^ b) + blocks[7] - 155497632;
    c = (c << 16 | c >>> 16) + d << 0;
    b += (da ^ c) + blocks[10] - 1094730640;
    b = (b << 23 | b >>> 9) + c << 0;
    bc = b ^ c;
    a += (bc ^ d) + blocks[13] + 681279174;
    a = (a << 4 | a >>> 28) + b << 0;
    d += (bc ^ a) + blocks[0] - 358537222;
    d = (d << 11 | d >>> 21) + a << 0;
    da = d ^ a;
    c += (da ^ b) + blocks[3] - 722521979;
    c = (c << 16 | c >>> 16) + d << 0;
    b += (da ^ c) + blocks[6] + 76029189;
    b = (b << 23 | b >>> 9) + c << 0;
    bc = b ^ c;
    a += (bc ^ d) + blocks[9] - 640364487;
    a = (a << 4 | a >>> 28) + b << 0;
    d += (bc ^ a) + blocks[12] - 421815835;
    d = (d << 11 | d >>> 21) + a << 0;
    da = d ^ a;
    c += (da ^ b) + blocks[15] + 530742520;
    c = (c << 16 | c >>> 16) + d << 0;
    b += (da ^ c) + blocks[2] - 995338651;
    b = (b << 23 | b >>> 9) + c << 0;
    a += (c ^ (b | ~d)) + blocks[0] - 198630844;
    a = (a << 6 | a >>> 26) + b << 0;
    d += (b ^ (a | ~c)) + blocks[7] + 1126891415;
    d = (d << 10 | d >>> 22) + a << 0;
    c += (a ^ (d | ~b)) + blocks[14] - 1416354905;
    c = (c << 15 | c >>> 17) + d << 0;
    b += (d ^ (c | ~a)) + blocks[5] - 57434055;
    b = (b << 21 | b >>> 11) + c << 0;
    a += (c ^ (b | ~d)) + blocks[12] + 1700485571;
    a = (a << 6 | a >>> 26) + b << 0;
    d += (b ^ (a | ~c)) + blocks[3] - 1894986606;
    d = (d << 10 | d >>> 22) + a << 0;
    c += (a ^ (d | ~b)) + blocks[10] - 1051523;
    c = (c << 15 | c >>> 17) + d << 0;
    b += (d ^ (c | ~a)) + blocks[1] - 2054922799;
    b = (b << 21 | b >>> 11) + c << 0;
    a += (c ^ (b | ~d)) + blocks[8] + 1873313359;
    a = (a << 6 | a >>> 26) + b << 0;
    d += (b ^ (a | ~c)) + blocks[15] - 30611744;
    d = (d << 10 | d >>> 22) + a << 0;
    c += (a ^ (d | ~b)) + blocks[6] - 1560198380;
    c = (c << 15 | c >>> 17) + d << 0;
    b += (d ^ (c | ~a)) + blocks[13] + 1309151649;
    b = (b << 21 | b >>> 11) + c << 0;
    a += (c ^ (b | ~d)) + blocks[4] - 145523070;
    a = (a << 6 | a >>> 26) + b << 0;
    d += (b ^ (a | ~c)) + blocks[11] - 1120210379;
    d = (d << 10 | d >>> 22) + a << 0;
    c += (a ^ (d | ~b)) + blocks[2] + 718787259;
    c = (c << 15 | c >>> 17) + d << 0;
    b += (d ^ (c | ~a)) + blocks[9] - 343485551;
    b = (b << 21 | b >>> 11) + c << 0;

    if (this.first) {
      this.h0 = a + 1732584193 << 0;
      this.h1 = b - 271733879 << 0;
      this.h2 = c - 1732584194 << 0;
      this.h3 = d + 271733878 << 0;
      this.first = false;
    } else {
      this.h0 = this.h0 + a << 0;
      this.h1 = this.h1 + b << 0;
      this.h2 = this.h2 + c << 0;
      this.h3 = this.h3 + d << 0;
    }
  };

  /**
   * @method hex
   * @memberof Md5
   * @instance
   * @description Output hash as hex string
   * @returns {String} Hex string
   * @see {@link md5.hex}
   * @example
   * hash.hex();
   */
  Md5.prototype.hex = function () {
    this.finalize();

    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3;

    return HEX_CHARS[(h0 >> 4) & 0x0F] + HEX_CHARS[h0 & 0x0F] +
      HEX_CHARS[(h0 >> 12) & 0x0F] + HEX_CHARS[(h0 >> 8) & 0x0F] +
      HEX_CHARS[(h0 >> 20) & 0x0F] + HEX_CHARS[(h0 >> 16) & 0x0F] +
      HEX_CHARS[(h0 >> 28) & 0x0F] + HEX_CHARS[(h0 >> 24) & 0x0F] +
      HEX_CHARS[(h1 >> 4) & 0x0F] + HEX_CHARS[h1 & 0x0F] +
      HEX_CHARS[(h1 >> 12) & 0x0F] + HEX_CHARS[(h1 >> 8) & 0x0F] +
      HEX_CHARS[(h1 >> 20) & 0x0F] + HEX_CHARS[(h1 >> 16) & 0x0F] +
      HEX_CHARS[(h1 >> 28) & 0x0F] + HEX_CHARS[(h1 >> 24) & 0x0F] +
      HEX_CHARS[(h2 >> 4) & 0x0F] + HEX_CHARS[h2 & 0x0F] +
      HEX_CHARS[(h2 >> 12) & 0x0F] + HEX_CHARS[(h2 >> 8) & 0x0F] +
      HEX_CHARS[(h2 >> 20) & 0x0F] + HEX_CHARS[(h2 >> 16) & 0x0F] +
      HEX_CHARS[(h2 >> 28) & 0x0F] + HEX_CHARS[(h2 >> 24) & 0x0F] +
      HEX_CHARS[(h3 >> 4) & 0x0F] + HEX_CHARS[h3 & 0x0F] +
      HEX_CHARS[(h3 >> 12) & 0x0F] + HEX_CHARS[(h3 >> 8) & 0x0F] +
      HEX_CHARS[(h3 >> 20) & 0x0F] + HEX_CHARS[(h3 >> 16) & 0x0F] +
      HEX_CHARS[(h3 >> 28) & 0x0F] + HEX_CHARS[(h3 >> 24) & 0x0F];
  };

  /**
   * @method toString
   * @memberof Md5
   * @instance
   * @description Output hash as hex string
   * @returns {String} Hex string
   * @see {@link md5.hex}
   * @example
   * hash.toString();
   */
  Md5.prototype.toString = Md5.prototype.hex;

  /**
   * @method digest
   * @memberof Md5
   * @instance
   * @description Output hash as bytes array
   * @returns {Array} Bytes array
   * @see {@link md5.digest}
   * @example
   * hash.digest();
   */
  Md5.prototype.digest = function () {
    this.finalize();

    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3;
    return [
      h0 & 0xFF, (h0 >> 8) & 0xFF, (h0 >> 16) & 0xFF, (h0 >> 24) & 0xFF,
      h1 & 0xFF, (h1 >> 8) & 0xFF, (h1 >> 16) & 0xFF, (h1 >> 24) & 0xFF,
      h2 & 0xFF, (h2 >> 8) & 0xFF, (h2 >> 16) & 0xFF, (h2 >> 24) & 0xFF,
      h3 & 0xFF, (h3 >> 8) & 0xFF, (h3 >> 16) & 0xFF, (h3 >> 24) & 0xFF
    ];
  };

  /**
   * @method array
   * @memberof Md5
   * @instance
   * @description Output hash as bytes array
   * @returns {Array} Bytes array
   * @see {@link md5.array}
   * @example
   * hash.array();
   */
  Md5.prototype.array = Md5.prototype.digest;

  /**
   * @method arrayBuffer
   * @memberof Md5
   * @instance
   * @description Output hash as ArrayBuffer
   * @returns {ArrayBuffer} ArrayBuffer
   * @see {@link md5.arrayBuffer}
   * @example
   * hash.arrayBuffer();
   */
  Md5.prototype.arrayBuffer = function () {
    this.finalize();

    var buffer = new ArrayBuffer(16);
    var blocks = new Uint32Array(buffer);
    blocks[0] = this.h0;
    blocks[1] = this.h1;
    blocks[2] = this.h2;
    blocks[3] = this.h3;
    return buffer;
  };

  /**
   * @method buffer
   * @deprecated This maybe confuse with Buffer in node.js. Please use arrayBuffer instead.
   * @memberof Md5
   * @instance
   * @description Output hash as ArrayBuffer
   * @returns {ArrayBuffer} ArrayBuffer
   * @see {@link md5.buffer}
   * @example
   * hash.buffer();
   */
  Md5.prototype.buffer = Md5.prototype.arrayBuffer;

  /**
   * @method base64
   * @memberof Md5
   * @instance
   * @description Output hash as base64 string
   * @returns {String} base64 string
   * @see {@link md5.base64}
   * @example
   * hash.base64();
   */
  Md5.prototype.base64 = function () {
    var v1, v2, v3, base64Str = '', bytes = this.array();
    for (var i = 0; i < 15;) {
      v1 = bytes[i++];
      v2 = bytes[i++];
      v3 = bytes[i++];
      base64Str += BASE64_ENCODE_CHAR[v1 >>> 2] +
        BASE64_ENCODE_CHAR[(v1 << 4 | v2 >>> 4) & 63] +
        BASE64_ENCODE_CHAR[(v2 << 2 | v3 >>> 6) & 63] +
        BASE64_ENCODE_CHAR[v3 & 63];
    }
    v1 = bytes[i];
    base64Str += BASE64_ENCODE_CHAR[v1 >>> 2] +
      BASE64_ENCODE_CHAR[(v1 << 4) & 63] +
      '==';
    return base64Str;
  };

  var exports = createMethod();

  if (COMMON_JS) {
    module.exports = exports;
  } else {
    /**
     * @method md5
     * @description Md5 hash function, export to global in browsers.
     * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
     * @returns {String} md5 hashes
     * @example
     * md5(''); // d41d8cd98f00b204e9800998ecf8427e
     * md5('The quick brown fox jumps over the lazy dog'); // 9e107d9d372bb6826bd81d3542a419d6
     * md5('The quick brown fox jumps over the lazy dog.'); // e4d909c290d0fb1ca068ffaddf22cbd0
     *
     * // It also supports UTF-8 encoding
     * md5('中文'); // a7bac2239fcdcb3a067903d8077c4a07
     *
     * // It also supports byte `Array`, `Uint8Array`, `ArrayBuffer`
     * md5([]); // d41d8cd98f00b204e9800998ecf8427e
     * md5(new Uint8Array([])); // d41d8cd98f00b204e9800998ecf8427e
     */
    root.md5 = exports;
    if (AMD) {
      !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
        return exports;
      }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
  }
})();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../_process@0.11.10@process/browser.js */ "./node_modules/_process@0.11.10@process/browser.js"), __webpack_require__(/*! ./../../_webpack@4.46.0@webpack/buildin/global.js */ "./node_modules/_webpack@4.46.0@webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/JSEncrypt.js":
/*!******************************************************************!*\
  !*** ./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/JSEncrypt.js ***!
  \******************************************************************/
/*! exports provided: JSEncrypt */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JSEncrypt", function() { return JSEncrypt; });
/* harmony import */ var _lib_jsbn_base64__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./lib/jsbn/base64 */ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsbn/base64.js");
/* harmony import */ var _JSEncryptRSAKey__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./JSEncryptRSAKey */ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/JSEncryptRSAKey.js");
/* harmony import */ var _version_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./version.json */ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/version.json");
var _version_json__WEBPACK_IMPORTED_MODULE_2___namespace = /*#__PURE__*/__webpack_require__.t(/*! ./version.json */ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/version.json", 1);



/**
 *
 * @param {Object} [options = {}] - An object to customize JSEncrypt behaviour
 * possible parameters are:
 * - default_key_size        {number}  default: 1024 the key size in bit
 * - default_public_exponent {string}  default: '010001' the hexadecimal representation of the public exponent
 * - log                     {boolean} default: false whether log warn/error or not
 * @constructor
 */
var JSEncrypt = /** @class */ (function () {
    function JSEncrypt(options) {
        options = options || {};
        this.default_key_size = options.default_key_size ? parseInt(options.default_key_size, 10) : 1024;
        this.default_public_exponent = options.default_public_exponent || "010001"; // 65537 default openssl public exponent for rsa key type
        this.log = options.log || false;
        // The private and public key.
        this.key = null;
    }
    /**
     * Method to set the rsa key parameter (one method is enough to set both the public
     * and the private key, since the private key contains the public key paramenters)
     * Log a warning if logs are enabled
     * @param {Object|string} key the pem encoded string or an object (with or without header/footer)
     * @public
     */
    JSEncrypt.prototype.setKey = function (key) {
        if (this.log && this.key) {
            console.warn("A key was already set, overriding existing.");
        }
        this.key = new _JSEncryptRSAKey__WEBPACK_IMPORTED_MODULE_1__["JSEncryptRSAKey"](key);
    };
    /**
     * Proxy method for setKey, for api compatibility
     * @see setKey
     * @public
     */
    JSEncrypt.prototype.setPrivateKey = function (privkey) {
        // Create the key.
        this.setKey(privkey);
    };
    /**
     * Proxy method for setKey, for api compatibility
     * @see setKey
     * @public
     */
    JSEncrypt.prototype.setPublicKey = function (pubkey) {
        // Sets the public key.
        this.setKey(pubkey);
    };
    /**
     * Proxy method for RSAKey object's decrypt, decrypt the string using the private
     * components of the rsa key object. Note that if the object was not set will be created
     * on the fly (by the getKey method) using the parameters passed in the JSEncrypt constructor
     * @param {string} str base64 encoded crypted string to decrypt
     * @return {string} the decrypted string
     * @public
     */
    JSEncrypt.prototype.decrypt = function (str) {
        // Return the decrypted string.
        try {
            return this.getKey().decrypt(Object(_lib_jsbn_base64__WEBPACK_IMPORTED_MODULE_0__["b64tohex"])(str));
        }
        catch (ex) {
            return false;
        }
    };
    /**
     * Proxy method for RSAKey object's encrypt, encrypt the string using the public
     * components of the rsa key object. Note that if the object was not set will be created
     * on the fly (by the getKey method) using the parameters passed in the JSEncrypt constructor
     * @param {string} str the string to encrypt
     * @return {string} the encrypted string encoded in base64
     * @public
     */
    JSEncrypt.prototype.encrypt = function (str) {
        // Return the encrypted string.
        try {
            return Object(_lib_jsbn_base64__WEBPACK_IMPORTED_MODULE_0__["hex2b64"])(this.getKey().encrypt(str));
        }
        catch (ex) {
            return false;
        }
    };
    /**
     * Proxy method for RSAKey object's sign.
     * @param {string} str the string to sign
     * @param {function} digestMethod hash method
     * @param {string} digestName the name of the hash algorithm
     * @return {string} the signature encoded in base64
     * @public
     */
    JSEncrypt.prototype.sign = function (str, digestMethod, digestName) {
        // return the RSA signature of 'str' in 'hex' format.
        try {
            return Object(_lib_jsbn_base64__WEBPACK_IMPORTED_MODULE_0__["hex2b64"])(this.getKey().sign(str, digestMethod, digestName));
        }
        catch (ex) {
            return false;
        }
    };
    /**
     * Proxy method for RSAKey object's verify.
     * @param {string} str the string to verify
     * @param {string} signature the signature encoded in base64 to compare the string to
     * @param {function} digestMethod hash method
     * @return {boolean} whether the data and signature match
     * @public
     */
    JSEncrypt.prototype.verify = function (str, signature, digestMethod) {
        // Return the decrypted 'digest' of the signature.
        try {
            return this.getKey().verify(str, Object(_lib_jsbn_base64__WEBPACK_IMPORTED_MODULE_0__["b64tohex"])(signature), digestMethod);
        }
        catch (ex) {
            return false;
        }
    };
    /**
     * Getter for the current JSEncryptRSAKey object. If it doesn't exists a new object
     * will be created and returned
     * @param {callback} [cb] the callback to be called if we want the key to be generated
     * in an async fashion
     * @returns {JSEncryptRSAKey} the JSEncryptRSAKey object
     * @public
     */
    JSEncrypt.prototype.getKey = function (cb) {
        // Only create new if it does not exist.
        if (!this.key) {
            // Get a new private key.
            this.key = new _JSEncryptRSAKey__WEBPACK_IMPORTED_MODULE_1__["JSEncryptRSAKey"]();
            if (cb && {}.toString.call(cb) === "[object Function]") {
                this.key.generateAsync(this.default_key_size, this.default_public_exponent, cb);
                return;
            }
            // Generate the key.
            this.key.generate(this.default_key_size, this.default_public_exponent);
        }
        return this.key;
    };
    /**
     * Returns the pem encoded representation of the private key
     * If the key doesn't exists a new key will be created
     * @returns {string} pem encoded representation of the private key WITH header and footer
     * @public
     */
    JSEncrypt.prototype.getPrivateKey = function () {
        // Return the private representation of this key.
        return this.getKey().getPrivateKey();
    };
    /**
     * Returns the pem encoded representation of the private key
     * If the key doesn't exists a new key will be created
     * @returns {string} pem encoded representation of the private key WITHOUT header and footer
     * @public
     */
    JSEncrypt.prototype.getPrivateKeyB64 = function () {
        // Return the private representation of this key.
        return this.getKey().getPrivateBaseKeyB64();
    };
    /**
     * Returns the pem encoded representation of the public key
     * If the key doesn't exists a new key will be created
     * @returns {string} pem encoded representation of the public key WITH header and footer
     * @public
     */
    JSEncrypt.prototype.getPublicKey = function () {
        // Return the private representation of this key.
        return this.getKey().getPublicKey();
    };
    /**
     * Returns the pem encoded representation of the public key
     * If the key doesn't exists a new key will be created
     * @returns {string} pem encoded representation of the public key WITHOUT header and footer
     * @public
     */
    JSEncrypt.prototype.getPublicKeyB64 = function () {
        // Return the private representation of this key.
        return this.getKey().getPublicBaseKeyB64();
    };
    JSEncrypt.version = _version_json__WEBPACK_IMPORTED_MODULE_2__.version;
    return JSEncrypt;
}());



/***/ }),

/***/ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/JSEncryptRSAKey.js":
/*!************************************************************************!*\
  !*** ./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/JSEncryptRSAKey.js ***!
  \************************************************************************/
/*! exports provided: JSEncryptRSAKey */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JSEncryptRSAKey", function() { return JSEncryptRSAKey; });
/* harmony import */ var _lib_jsbn_base64__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./lib/jsbn/base64 */ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsbn/base64.js");
/* harmony import */ var _lib_asn1js_hex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./lib/asn1js/hex */ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/asn1js/hex.js");
/* harmony import */ var _lib_asn1js_base64__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./lib/asn1js/base64 */ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/asn1js/base64.js");
/* harmony import */ var _lib_asn1js_asn1__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./lib/asn1js/asn1 */ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/asn1js/asn1.js");
/* harmony import */ var _lib_jsbn_rsa__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./lib/jsbn/rsa */ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsbn/rsa.js");
/* harmony import */ var _lib_jsbn_jsbn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./lib/jsbn/jsbn */ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsbn/jsbn.js");
/* harmony import */ var _lib_jsrsasign_asn1_1_0__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./lib/jsrsasign/asn1-1.0 */ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsrsasign/asn1-1.0.js");
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







/**
 * Create a new JSEncryptRSAKey that extends Tom Wu's RSA key object.
 * This object is just a decorator for parsing the key parameter
 * @param {string|Object} key - The key in string format, or an object containing
 * the parameters needed to build a RSAKey object.
 * @constructor
 */
var JSEncryptRSAKey = /** @class */ (function (_super) {
    __extends(JSEncryptRSAKey, _super);
    function JSEncryptRSAKey(key) {
        var _this = _super.call(this) || this;
        // Call the super constructor.
        //  RSAKey.call(this);
        // If a key key was provided.
        if (key) {
            // If this is a string...
            if (typeof key === "string") {
                _this.parseKey(key);
            }
            else if (JSEncryptRSAKey.hasPrivateKeyProperty(key) ||
                JSEncryptRSAKey.hasPublicKeyProperty(key)) {
                // Set the values for the key.
                _this.parsePropertiesFrom(key);
            }
        }
        return _this;
    }
    /**
     * Method to parse a pem encoded string containing both a public or private key.
     * The method will translate the pem encoded string in a der encoded string and
     * will parse private key and public key parameters. This method accepts public key
     * in the rsaencryption pkcs #1 format (oid: 1.2.840.113549.1.1.1).
     *
     * @todo Check how many rsa formats use the same format of pkcs #1.
     *
     * The format is defined as:
     * PublicKeyInfo ::= SEQUENCE {
     *   algorithm       AlgorithmIdentifier,
     *   PublicKey       BIT STRING
     * }
     * Where AlgorithmIdentifier is:
     * AlgorithmIdentifier ::= SEQUENCE {
     *   algorithm       OBJECT IDENTIFIER,     the OID of the enc algorithm
     *   parameters      ANY DEFINED BY algorithm OPTIONAL (NULL for PKCS #1)
     * }
     * and PublicKey is a SEQUENCE encapsulated in a BIT STRING
     * RSAPublicKey ::= SEQUENCE {
     *   modulus           INTEGER,  -- n
     *   publicExponent    INTEGER   -- e
     * }
     * it's possible to examine the structure of the keys obtained from openssl using
     * an asn.1 dumper as the one used here to parse the components: http://lapo.it/asn1js/
     * @argument {string} pem the pem encoded string, can include the BEGIN/END header/footer
     * @private
     */
    JSEncryptRSAKey.prototype.parseKey = function (pem) {
        try {
            var modulus = 0;
            var public_exponent = 0;
            var reHex = /^\s*(?:[0-9A-Fa-f][0-9A-Fa-f]\s*)+$/;
            var der = reHex.test(pem) ? _lib_asn1js_hex__WEBPACK_IMPORTED_MODULE_1__["Hex"].decode(pem) : _lib_asn1js_base64__WEBPACK_IMPORTED_MODULE_2__["Base64"].unarmor(pem);
            var asn1 = _lib_asn1js_asn1__WEBPACK_IMPORTED_MODULE_3__["ASN1"].decode(der);
            // Fixes a bug with OpenSSL 1.0+ private keys
            if (asn1.sub.length === 3) {
                asn1 = asn1.sub[2].sub[0];
            }
            if (asn1.sub.length === 9) {
                // Parse the private key.
                modulus = asn1.sub[1].getHexStringValue(); // bigint
                this.n = Object(_lib_jsbn_jsbn__WEBPACK_IMPORTED_MODULE_5__["parseBigInt"])(modulus, 16);
                public_exponent = asn1.sub[2].getHexStringValue(); // int
                this.e = parseInt(public_exponent, 16);
                var private_exponent = asn1.sub[3].getHexStringValue(); // bigint
                this.d = Object(_lib_jsbn_jsbn__WEBPACK_IMPORTED_MODULE_5__["parseBigInt"])(private_exponent, 16);
                var prime1 = asn1.sub[4].getHexStringValue(); // bigint
                this.p = Object(_lib_jsbn_jsbn__WEBPACK_IMPORTED_MODULE_5__["parseBigInt"])(prime1, 16);
                var prime2 = asn1.sub[5].getHexStringValue(); // bigint
                this.q = Object(_lib_jsbn_jsbn__WEBPACK_IMPORTED_MODULE_5__["parseBigInt"])(prime2, 16);
                var exponent1 = asn1.sub[6].getHexStringValue(); // bigint
                this.dmp1 = Object(_lib_jsbn_jsbn__WEBPACK_IMPORTED_MODULE_5__["parseBigInt"])(exponent1, 16);
                var exponent2 = asn1.sub[7].getHexStringValue(); // bigint
                this.dmq1 = Object(_lib_jsbn_jsbn__WEBPACK_IMPORTED_MODULE_5__["parseBigInt"])(exponent2, 16);
                var coefficient = asn1.sub[8].getHexStringValue(); // bigint
                this.coeff = Object(_lib_jsbn_jsbn__WEBPACK_IMPORTED_MODULE_5__["parseBigInt"])(coefficient, 16);
            }
            else if (asn1.sub.length === 2) {
                // Parse the public key.
                var bit_string = asn1.sub[1];
                var sequence = bit_string.sub[0];
                modulus = sequence.sub[0].getHexStringValue();
                this.n = Object(_lib_jsbn_jsbn__WEBPACK_IMPORTED_MODULE_5__["parseBigInt"])(modulus, 16);
                public_exponent = sequence.sub[1].getHexStringValue();
                this.e = parseInt(public_exponent, 16);
            }
            else {
                return false;
            }
            return true;
        }
        catch (ex) {
            return false;
        }
    };
    /**
     * Translate rsa parameters in a hex encoded string representing the rsa key.
     *
     * The translation follow the ASN.1 notation :
     * RSAPrivateKey ::= SEQUENCE {
     *   version           Version,
     *   modulus           INTEGER,  -- n
     *   publicExponent    INTEGER,  -- e
     *   privateExponent   INTEGER,  -- d
     *   prime1            INTEGER,  -- p
     *   prime2            INTEGER,  -- q
     *   exponent1         INTEGER,  -- d mod (p1)
     *   exponent2         INTEGER,  -- d mod (q-1)
     *   coefficient       INTEGER,  -- (inverse of q) mod p
     * }
     * @returns {string}  DER Encoded String representing the rsa private key
     * @private
     */
    JSEncryptRSAKey.prototype.getPrivateBaseKey = function () {
        var options = {
            array: [
                new _lib_jsrsasign_asn1_1_0__WEBPACK_IMPORTED_MODULE_6__["KJUR"].asn1.DERInteger({ int: 0 }),
                new _lib_jsrsasign_asn1_1_0__WEBPACK_IMPORTED_MODULE_6__["KJUR"].asn1.DERInteger({ bigint: this.n }),
                new _lib_jsrsasign_asn1_1_0__WEBPACK_IMPORTED_MODULE_6__["KJUR"].asn1.DERInteger({ int: this.e }),
                new _lib_jsrsasign_asn1_1_0__WEBPACK_IMPORTED_MODULE_6__["KJUR"].asn1.DERInteger({ bigint: this.d }),
                new _lib_jsrsasign_asn1_1_0__WEBPACK_IMPORTED_MODULE_6__["KJUR"].asn1.DERInteger({ bigint: this.p }),
                new _lib_jsrsasign_asn1_1_0__WEBPACK_IMPORTED_MODULE_6__["KJUR"].asn1.DERInteger({ bigint: this.q }),
                new _lib_jsrsasign_asn1_1_0__WEBPACK_IMPORTED_MODULE_6__["KJUR"].asn1.DERInteger({ bigint: this.dmp1 }),
                new _lib_jsrsasign_asn1_1_0__WEBPACK_IMPORTED_MODULE_6__["KJUR"].asn1.DERInteger({ bigint: this.dmq1 }),
                new _lib_jsrsasign_asn1_1_0__WEBPACK_IMPORTED_MODULE_6__["KJUR"].asn1.DERInteger({ bigint: this.coeff })
            ]
        };
        var seq = new _lib_jsrsasign_asn1_1_0__WEBPACK_IMPORTED_MODULE_6__["KJUR"].asn1.DERSequence(options);
        return seq.getEncodedHex();
    };
    /**
     * base64 (pem) encoded version of the DER encoded representation
     * @returns {string} pem encoded representation without header and footer
     * @public
     */
    JSEncryptRSAKey.prototype.getPrivateBaseKeyB64 = function () {
        return Object(_lib_jsbn_base64__WEBPACK_IMPORTED_MODULE_0__["hex2b64"])(this.getPrivateBaseKey());
    };
    /**
     * Translate rsa parameters in a hex encoded string representing the rsa public key.
     * The representation follow the ASN.1 notation :
     * PublicKeyInfo ::= SEQUENCE {
     *   algorithm       AlgorithmIdentifier,
     *   PublicKey       BIT STRING
     * }
     * Where AlgorithmIdentifier is:
     * AlgorithmIdentifier ::= SEQUENCE {
     *   algorithm       OBJECT IDENTIFIER,     the OID of the enc algorithm
     *   parameters      ANY DEFINED BY algorithm OPTIONAL (NULL for PKCS #1)
     * }
     * and PublicKey is a SEQUENCE encapsulated in a BIT STRING
     * RSAPublicKey ::= SEQUENCE {
     *   modulus           INTEGER,  -- n
     *   publicExponent    INTEGER   -- e
     * }
     * @returns {string} DER Encoded String representing the rsa public key
     * @private
     */
    JSEncryptRSAKey.prototype.getPublicBaseKey = function () {
        var first_sequence = new _lib_jsrsasign_asn1_1_0__WEBPACK_IMPORTED_MODULE_6__["KJUR"].asn1.DERSequence({
            array: [
                new _lib_jsrsasign_asn1_1_0__WEBPACK_IMPORTED_MODULE_6__["KJUR"].asn1.DERObjectIdentifier({ oid: "1.2.840.113549.1.1.1" }),
                new _lib_jsrsasign_asn1_1_0__WEBPACK_IMPORTED_MODULE_6__["KJUR"].asn1.DERNull()
            ]
        });
        var second_sequence = new _lib_jsrsasign_asn1_1_0__WEBPACK_IMPORTED_MODULE_6__["KJUR"].asn1.DERSequence({
            array: [
                new _lib_jsrsasign_asn1_1_0__WEBPACK_IMPORTED_MODULE_6__["KJUR"].asn1.DERInteger({ bigint: this.n }),
                new _lib_jsrsasign_asn1_1_0__WEBPACK_IMPORTED_MODULE_6__["KJUR"].asn1.DERInteger({ int: this.e })
            ]
        });
        var bit_string = new _lib_jsrsasign_asn1_1_0__WEBPACK_IMPORTED_MODULE_6__["KJUR"].asn1.DERBitString({
            hex: "00" + second_sequence.getEncodedHex()
        });
        var seq = new _lib_jsrsasign_asn1_1_0__WEBPACK_IMPORTED_MODULE_6__["KJUR"].asn1.DERSequence({
            array: [
                first_sequence,
                bit_string
            ]
        });
        return seq.getEncodedHex();
    };
    /**
     * base64 (pem) encoded version of the DER encoded representation
     * @returns {string} pem encoded representation without header and footer
     * @public
     */
    JSEncryptRSAKey.prototype.getPublicBaseKeyB64 = function () {
        return Object(_lib_jsbn_base64__WEBPACK_IMPORTED_MODULE_0__["hex2b64"])(this.getPublicBaseKey());
    };
    /**
     * wrap the string in block of width chars. The default value for rsa keys is 64
     * characters.
     * @param {string} str the pem encoded string without header and footer
     * @param {Number} [width=64] - the length the string has to be wrapped at
     * @returns {string}
     * @private
     */
    JSEncryptRSAKey.wordwrap = function (str, width) {
        width = width || 64;
        if (!str) {
            return str;
        }
        var regex = "(.{1," + width + "})( +|$\n?)|(.{1," + width + "})";
        return str.match(RegExp(regex, "g")).join("\n");
    };
    /**
     * Retrieve the pem encoded private key
     * @returns {string} the pem encoded private key with header/footer
     * @public
     */
    JSEncryptRSAKey.prototype.getPrivateKey = function () {
        var key = "-----BEGIN RSA PRIVATE KEY-----\n";
        key += JSEncryptRSAKey.wordwrap(this.getPrivateBaseKeyB64()) + "\n";
        key += "-----END RSA PRIVATE KEY-----";
        return key;
    };
    /**
     * Retrieve the pem encoded public key
     * @returns {string} the pem encoded public key with header/footer
     * @public
     */
    JSEncryptRSAKey.prototype.getPublicKey = function () {
        var key = "-----BEGIN PUBLIC KEY-----\n";
        key += JSEncryptRSAKey.wordwrap(this.getPublicBaseKeyB64()) + "\n";
        key += "-----END PUBLIC KEY-----";
        return key;
    };
    /**
     * Check if the object contains the necessary parameters to populate the rsa modulus
     * and public exponent parameters.
     * @param {Object} [obj={}] - An object that may contain the two public key
     * parameters
     * @returns {boolean} true if the object contains both the modulus and the public exponent
     * properties (n and e)
     * @todo check for types of n and e. N should be a parseable bigInt object, E should
     * be a parseable integer number
     * @private
     */
    JSEncryptRSAKey.hasPublicKeyProperty = function (obj) {
        obj = obj || {};
        return (obj.hasOwnProperty("n") &&
            obj.hasOwnProperty("e"));
    };
    /**
     * Check if the object contains ALL the parameters of an RSA key.
     * @param {Object} [obj={}] - An object that may contain nine rsa key
     * parameters
     * @returns {boolean} true if the object contains all the parameters needed
     * @todo check for types of the parameters all the parameters but the public exponent
     * should be parseable bigint objects, the public exponent should be a parseable integer number
     * @private
     */
    JSEncryptRSAKey.hasPrivateKeyProperty = function (obj) {
        obj = obj || {};
        return (obj.hasOwnProperty("n") &&
            obj.hasOwnProperty("e") &&
            obj.hasOwnProperty("d") &&
            obj.hasOwnProperty("p") &&
            obj.hasOwnProperty("q") &&
            obj.hasOwnProperty("dmp1") &&
            obj.hasOwnProperty("dmq1") &&
            obj.hasOwnProperty("coeff"));
    };
    /**
     * Parse the properties of obj in the current rsa object. Obj should AT LEAST
     * include the modulus and public exponent (n, e) parameters.
     * @param {Object} obj - the object containing rsa parameters
     * @private
     */
    JSEncryptRSAKey.prototype.parsePropertiesFrom = function (obj) {
        this.n = obj.n;
        this.e = obj.e;
        if (obj.hasOwnProperty("d")) {
            this.d = obj.d;
            this.p = obj.p;
            this.q = obj.q;
            this.dmp1 = obj.dmp1;
            this.dmq1 = obj.dmq1;
            this.coeff = obj.coeff;
        }
    };
    return JSEncryptRSAKey;
}(_lib_jsbn_rsa__WEBPACK_IMPORTED_MODULE_4__["RSAKey"]));



/***/ }),

/***/ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/index.js":
/*!**************************************************************!*\
  !*** ./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/index.js ***!
  \**************************************************************/
/*! exports provided: JSEncrypt, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _JSEncrypt__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./JSEncrypt */ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/JSEncrypt.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JSEncrypt", function() { return _JSEncrypt__WEBPACK_IMPORTED_MODULE_0__["JSEncrypt"]; });



/* harmony default export */ __webpack_exports__["default"] = (_JSEncrypt__WEBPACK_IMPORTED_MODULE_0__["JSEncrypt"]);


/***/ }),

/***/ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/asn1js/asn1.js":
/*!************************************************************************!*\
  !*** ./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/asn1js/asn1.js ***!
  \************************************************************************/
/*! exports provided: Stream, ASN1, ASN1Tag */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Stream", function() { return Stream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ASN1", function() { return ASN1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ASN1Tag", function() { return ASN1Tag; });
/* harmony import */ var _int10__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./int10 */ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/asn1js/int10.js");
// ASN.1 JavaScript decoder
// Copyright (c) 2008-2014 Lapo Luchini <lapo@lapo.it>
// Permission to use, copy, modify, and/or distribute this software for any
// purpose with or without fee is hereby granted, provided that the above
// copyright notice and this permission notice appear in all copies.
//
// THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
// WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
// MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
// ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
// WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
// ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
// OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
/*jshint browser: true, strict: true, immed: true, latedef: true, undef: true, regexdash: false */
/*global oids */

var ellipsis = "\u2026";
var reTimeS = /^(\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/;
var reTimeL = /^(\d\d\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/;
function stringCut(str, len) {
    if (str.length > len) {
        str = str.substring(0, len) + ellipsis;
    }
    return str;
}
var Stream = /** @class */ (function () {
    function Stream(enc, pos) {
        this.hexDigits = "0123456789ABCDEF";
        if (enc instanceof Stream) {
            this.enc = enc.enc;
            this.pos = enc.pos;
        }
        else {
            // enc should be an array or a binary string
            this.enc = enc;
            this.pos = pos;
        }
    }
    Stream.prototype.get = function (pos) {
        if (pos === undefined) {
            pos = this.pos++;
        }
        if (pos >= this.enc.length) {
            throw new Error("Requesting byte offset " + pos + " on a stream of length " + this.enc.length);
        }
        return ("string" === typeof this.enc) ? this.enc.charCodeAt(pos) : this.enc[pos];
    };
    Stream.prototype.hexByte = function (b) {
        return this.hexDigits.charAt((b >> 4) & 0xF) + this.hexDigits.charAt(b & 0xF);
    };
    Stream.prototype.hexDump = function (start, end, raw) {
        var s = "";
        for (var i = start; i < end; ++i) {
            s += this.hexByte(this.get(i));
            if (raw !== true) {
                switch (i & 0xF) {
                    case 0x7:
                        s += "  ";
                        break;
                    case 0xF:
                        s += "\n";
                        break;
                    default:
                        s += " ";
                }
            }
        }
        return s;
    };
    Stream.prototype.isASCII = function (start, end) {
        for (var i = start; i < end; ++i) {
            var c = this.get(i);
            if (c < 32 || c > 176) {
                return false;
            }
        }
        return true;
    };
    Stream.prototype.parseStringISO = function (start, end) {
        var s = "";
        for (var i = start; i < end; ++i) {
            s += String.fromCharCode(this.get(i));
        }
        return s;
    };
    Stream.prototype.parseStringUTF = function (start, end) {
        var s = "";
        for (var i = start; i < end;) {
            var c = this.get(i++);
            if (c < 128) {
                s += String.fromCharCode(c);
            }
            else if ((c > 191) && (c < 224)) {
                s += String.fromCharCode(((c & 0x1F) << 6) | (this.get(i++) & 0x3F));
            }
            else {
                s += String.fromCharCode(((c & 0x0F) << 12) | ((this.get(i++) & 0x3F) << 6) | (this.get(i++) & 0x3F));
            }
        }
        return s;
    };
    Stream.prototype.parseStringBMP = function (start, end) {
        var str = "";
        var hi;
        var lo;
        for (var i = start; i < end;) {
            hi = this.get(i++);
            lo = this.get(i++);
            str += String.fromCharCode((hi << 8) | lo);
        }
        return str;
    };
    Stream.prototype.parseTime = function (start, end, shortYear) {
        var s = this.parseStringISO(start, end);
        var m = (shortYear ? reTimeS : reTimeL).exec(s);
        if (!m) {
            return "Unrecognized time: " + s;
        }
        if (shortYear) {
            // to avoid querying the timer, use the fixed range [1970, 2069]
            // it will conform with ITU X.400 [-10, +40] sliding window until 2030
            m[1] = +m[1];
            m[1] += (+m[1] < 70) ? 2000 : 1900;
        }
        s = m[1] + "-" + m[2] + "-" + m[3] + " " + m[4];
        if (m[5]) {
            s += ":" + m[5];
            if (m[6]) {
                s += ":" + m[6];
                if (m[7]) {
                    s += "." + m[7];
                }
            }
        }
        if (m[8]) {
            s += " UTC";
            if (m[8] != "Z") {
                s += m[8];
                if (m[9]) {
                    s += ":" + m[9];
                }
            }
        }
        return s;
    };
    Stream.prototype.parseInteger = function (start, end) {
        var v = this.get(start);
        var neg = (v > 127);
        var pad = neg ? 255 : 0;
        var len;
        var s = "";
        // skip unuseful bits (not allowed in DER)
        while (v == pad && ++start < end) {
            v = this.get(start);
        }
        len = end - start;
        if (len === 0) {
            return neg ? -1 : 0;
        }
        // show bit length of huge integers
        if (len > 4) {
            s = v;
            len <<= 3;
            while (((+s ^ pad) & 0x80) == 0) {
                s = +s << 1;
                --len;
            }
            s = "(" + len + " bit)\n";
        }
        // decode the integer
        if (neg) {
            v = v - 256;
        }
        var n = new _int10__WEBPACK_IMPORTED_MODULE_0__["Int10"](v);
        for (var i = start + 1; i < end; ++i) {
            n.mulAdd(256, this.get(i));
        }
        return s + n.toString();
    };
    Stream.prototype.parseBitString = function (start, end, maxLength) {
        var unusedBit = this.get(start);
        var lenBit = ((end - start - 1) << 3) - unusedBit;
        var intro = "(" + lenBit + " bit)\n";
        var s = "";
        for (var i = start + 1; i < end; ++i) {
            var b = this.get(i);
            var skip = (i == end - 1) ? unusedBit : 0;
            for (var j = 7; j >= skip; --j) {
                s += (b >> j) & 1 ? "1" : "0";
            }
            if (s.length > maxLength) {
                return intro + stringCut(s, maxLength);
            }
        }
        return intro + s;
    };
    Stream.prototype.parseOctetString = function (start, end, maxLength) {
        if (this.isASCII(start, end)) {
            return stringCut(this.parseStringISO(start, end), maxLength);
        }
        var len = end - start;
        var s = "(" + len + " byte)\n";
        maxLength /= 2; // we work in bytes
        if (len > maxLength) {
            end = start + maxLength;
        }
        for (var i = start; i < end; ++i) {
            s += this.hexByte(this.get(i));
        }
        if (len > maxLength) {
            s += ellipsis;
        }
        return s;
    };
    Stream.prototype.parseOID = function (start, end, maxLength) {
        var s = "";
        var n = new _int10__WEBPACK_IMPORTED_MODULE_0__["Int10"]();
        var bits = 0;
        for (var i = start; i < end; ++i) {
            var v = this.get(i);
            n.mulAdd(128, v & 0x7F);
            bits += 7;
            if (!(v & 0x80)) { // finished
                if (s === "") {
                    n = n.simplify();
                    if (n instanceof _int10__WEBPACK_IMPORTED_MODULE_0__["Int10"]) {
                        n.sub(80);
                        s = "2." + n.toString();
                    }
                    else {
                        var m = n < 80 ? n < 40 ? 0 : 1 : 2;
                        s = m + "." + (n - m * 40);
                    }
                }
                else {
                    s += "." + n.toString();
                }
                if (s.length > maxLength) {
                    return stringCut(s, maxLength);
                }
                n = new _int10__WEBPACK_IMPORTED_MODULE_0__["Int10"]();
                bits = 0;
            }
        }
        if (bits > 0) {
            s += ".incomplete";
        }
        return s;
    };
    return Stream;
}());

var ASN1 = /** @class */ (function () {
    function ASN1(stream, header, length, tag, sub) {
        if (!(tag instanceof ASN1Tag)) {
            throw new Error("Invalid tag value.");
        }
        this.stream = stream;
        this.header = header;
        this.length = length;
        this.tag = tag;
        this.sub = sub;
    }
    ASN1.prototype.typeName = function () {
        switch (this.tag.tagClass) {
            case 0: // universal
                switch (this.tag.tagNumber) {
                    case 0x00:
                        return "EOC";
                    case 0x01:
                        return "BOOLEAN";
                    case 0x02:
                        return "INTEGER";
                    case 0x03:
                        return "BIT_STRING";
                    case 0x04:
                        return "OCTET_STRING";
                    case 0x05:
                        return "NULL";
                    case 0x06:
                        return "OBJECT_IDENTIFIER";
                    case 0x07:
                        return "ObjectDescriptor";
                    case 0x08:
                        return "EXTERNAL";
                    case 0x09:
                        return "REAL";
                    case 0x0A:
                        return "ENUMERATED";
                    case 0x0B:
                        return "EMBEDDED_PDV";
                    case 0x0C:
                        return "UTF8String";
                    case 0x10:
                        return "SEQUENCE";
                    case 0x11:
                        return "SET";
                    case 0x12:
                        return "NumericString";
                    case 0x13:
                        return "PrintableString"; // ASCII subset
                    case 0x14:
                        return "TeletexString"; // aka T61String
                    case 0x15:
                        return "VideotexString";
                    case 0x16:
                        return "IA5String"; // ASCII
                    case 0x17:
                        return "UTCTime";
                    case 0x18:
                        return "GeneralizedTime";
                    case 0x19:
                        return "GraphicString";
                    case 0x1A:
                        return "VisibleString"; // ASCII subset
                    case 0x1B:
                        return "GeneralString";
                    case 0x1C:
                        return "UniversalString";
                    case 0x1E:
                        return "BMPString";
                }
                return "Universal_" + this.tag.tagNumber.toString();
            case 1:
                return "Application_" + this.tag.tagNumber.toString();
            case 2:
                return "[" + this.tag.tagNumber.toString() + "]"; // Context
            case 3:
                return "Private_" + this.tag.tagNumber.toString();
        }
    };
    ASN1.prototype.content = function (maxLength) {
        if (this.tag === undefined) {
            return null;
        }
        if (maxLength === undefined) {
            maxLength = Infinity;
        }
        var content = this.posContent();
        var len = Math.abs(this.length);
        if (!this.tag.isUniversal()) {
            if (this.sub !== null) {
                return "(" + this.sub.length + " elem)";
            }
            return this.stream.parseOctetString(content, content + len, maxLength);
        }
        switch (this.tag.tagNumber) {
            case 0x01: // BOOLEAN
                return (this.stream.get(content) === 0) ? "false" : "true";
            case 0x02: // INTEGER
                return this.stream.parseInteger(content, content + len);
            case 0x03: // BIT_STRING
                return this.sub ? "(" + this.sub.length + " elem)" :
                    this.stream.parseBitString(content, content + len, maxLength);
            case 0x04: // OCTET_STRING
                return this.sub ? "(" + this.sub.length + " elem)" :
                    this.stream.parseOctetString(content, content + len, maxLength);
            // case 0x05: // NULL
            case 0x06: // OBJECT_IDENTIFIER
                return this.stream.parseOID(content, content + len, maxLength);
            // case 0x07: // ObjectDescriptor
            // case 0x08: // EXTERNAL
            // case 0x09: // REAL
            // case 0x0A: // ENUMERATED
            // case 0x0B: // EMBEDDED_PDV
            case 0x10: // SEQUENCE
            case 0x11: // SET
                if (this.sub !== null) {
                    return "(" + this.sub.length + " elem)";
                }
                else {
                    return "(no elem)";
                }
            case 0x0C: // UTF8String
                return stringCut(this.stream.parseStringUTF(content, content + len), maxLength);
            case 0x12: // NumericString
            case 0x13: // PrintableString
            case 0x14: // TeletexString
            case 0x15: // VideotexString
            case 0x16: // IA5String
            // case 0x19: // GraphicString
            case 0x1A: // VisibleString
                // case 0x1B: // GeneralString
                // case 0x1C: // UniversalString
                return stringCut(this.stream.parseStringISO(content, content + len), maxLength);
            case 0x1E: // BMPString
                return stringCut(this.stream.parseStringBMP(content, content + len), maxLength);
            case 0x17: // UTCTime
            case 0x18: // GeneralizedTime
                return this.stream.parseTime(content, content + len, (this.tag.tagNumber == 0x17));
        }
        return null;
    };
    ASN1.prototype.toString = function () {
        return this.typeName() + "@" + this.stream.pos + "[header:" + this.header + ",length:" + this.length + ",sub:" + ((this.sub === null) ? "null" : this.sub.length) + "]";
    };
    ASN1.prototype.toPrettyString = function (indent) {
        if (indent === undefined) {
            indent = "";
        }
        var s = indent + this.typeName() + " @" + this.stream.pos;
        if (this.length >= 0) {
            s += "+";
        }
        s += this.length;
        if (this.tag.tagConstructed) {
            s += " (constructed)";
        }
        else if ((this.tag.isUniversal() && ((this.tag.tagNumber == 0x03) || (this.tag.tagNumber == 0x04))) && (this.sub !== null)) {
            s += " (encapsulates)";
        }
        s += "\n";
        if (this.sub !== null) {
            indent += "  ";
            for (var i = 0, max = this.sub.length; i < max; ++i) {
                s += this.sub[i].toPrettyString(indent);
            }
        }
        return s;
    };
    ASN1.prototype.posStart = function () {
        return this.stream.pos;
    };
    ASN1.prototype.posContent = function () {
        return this.stream.pos + this.header;
    };
    ASN1.prototype.posEnd = function () {
        return this.stream.pos + this.header + Math.abs(this.length);
    };
    ASN1.prototype.toHexString = function () {
        return this.stream.hexDump(this.posStart(), this.posEnd(), true);
    };
    ASN1.decodeLength = function (stream) {
        var buf = stream.get();
        var len = buf & 0x7F;
        if (len == buf) {
            return len;
        }
        // no reason to use Int10, as it would be a huge buffer anyways
        if (len > 6) {
            throw new Error("Length over 48 bits not supported at position " + (stream.pos - 1));
        }
        if (len === 0) {
            return null;
        } // undefined
        buf = 0;
        for (var i = 0; i < len; ++i) {
            buf = (buf * 256) + stream.get();
        }
        return buf;
    };
    /**
     * Retrieve the hexadecimal value (as a string) of the current ASN.1 element
     * @returns {string}
     * @public
     */
    ASN1.prototype.getHexStringValue = function () {
        var hexString = this.toHexString();
        var offset = this.header * 2;
        var length = this.length * 2;
        return hexString.substr(offset, length);
    };
    ASN1.decode = function (str) {
        var stream;
        if (!(str instanceof Stream)) {
            stream = new Stream(str, 0);
        }
        else {
            stream = str;
        }
        var streamStart = new Stream(stream);
        var tag = new ASN1Tag(stream);
        var len = ASN1.decodeLength(stream);
        var start = stream.pos;
        var header = start - streamStart.pos;
        var sub = null;
        var getSub = function () {
            var ret = [];
            if (len !== null) {
                // definite length
                var end = start + len;
                while (stream.pos < end) {
                    ret[ret.length] = ASN1.decode(stream);
                }
                if (stream.pos != end) {
                    throw new Error("Content size is not correct for container starting at offset " + start);
                }
            }
            else {
                // undefined length
                try {
                    for (;;) {
                        var s = ASN1.decode(stream);
                        if (s.tag.isEOC()) {
                            break;
                        }
                        ret[ret.length] = s;
                    }
                    len = start - stream.pos; // undefined lengths are represented as negative values
                }
                catch (e) {
                    throw new Error("Exception while decoding undefined length content: " + e);
                }
            }
            return ret;
        };
        if (tag.tagConstructed) {
            // must have valid content
            sub = getSub();
        }
        else if (tag.isUniversal() && ((tag.tagNumber == 0x03) || (tag.tagNumber == 0x04))) {
            // sometimes BitString and OctetString are used to encapsulate ASN.1
            try {
                if (tag.tagNumber == 0x03) {
                    if (stream.get() != 0) {
                        throw new Error("BIT STRINGs with unused bits cannot encapsulate.");
                    }
                }
                sub = getSub();
                for (var i = 0; i < sub.length; ++i) {
                    if (sub[i].tag.isEOC()) {
                        throw new Error("EOC is not supposed to be actual content.");
                    }
                }
            }
            catch (e) {
                // but silently ignore when they don't
                sub = null;
            }
        }
        if (sub === null) {
            if (len === null) {
                throw new Error("We can't skip over an invalid tag with undefined length at offset " + start);
            }
            stream.pos = start + Math.abs(len);
        }
        return new ASN1(streamStart, header, len, tag, sub);
    };
    return ASN1;
}());

var ASN1Tag = /** @class */ (function () {
    function ASN1Tag(stream) {
        var buf = stream.get();
        this.tagClass = buf >> 6;
        this.tagConstructed = ((buf & 0x20) !== 0);
        this.tagNumber = buf & 0x1F;
        if (this.tagNumber == 0x1F) { // long tag
            var n = new _int10__WEBPACK_IMPORTED_MODULE_0__["Int10"]();
            do {
                buf = stream.get();
                n.mulAdd(128, buf & 0x7F);
            } while (buf & 0x80);
            this.tagNumber = n.simplify();
        }
    }
    ASN1Tag.prototype.isUniversal = function () {
        return this.tagClass === 0x00;
    };
    ASN1Tag.prototype.isEOC = function () {
        return this.tagClass === 0x00 && this.tagNumber === 0x00;
    };
    return ASN1Tag;
}());



/***/ }),

/***/ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/asn1js/base64.js":
/*!**************************************************************************!*\
  !*** ./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/asn1js/base64.js ***!
  \**************************************************************************/
/*! exports provided: Base64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Base64", function() { return Base64; });
// Base64 JavaScript decoder
// Copyright (c) 2008-2013 Lapo Luchini <lapo@lapo.it>
// Permission to use, copy, modify, and/or distribute this software for any
// purpose with or without fee is hereby granted, provided that the above
// copyright notice and this permission notice appear in all copies.
//
// THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
// WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
// MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
// ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
// WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
// ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
// OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
/*jshint browser: true, strict: true, immed: true, latedef: true, undef: true, regexdash: false */
var decoder;
var Base64 = {
    decode: function (a) {
        var i;
        if (decoder === undefined) {
            var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
            var ignore = "= \f\n\r\t\u00A0\u2028\u2029";
            decoder = Object.create(null);
            for (i = 0; i < 64; ++i) {
                decoder[b64.charAt(i)] = i;
            }
            decoder['-'] = 62; //+
            decoder['_'] = 63; //-
            for (i = 0; i < ignore.length; ++i) {
                decoder[ignore.charAt(i)] = -1;
            }
        }
        var out = [];
        var bits = 0;
        var char_count = 0;
        for (i = 0; i < a.length; ++i) {
            var c = a.charAt(i);
            if (c == "=") {
                break;
            }
            c = decoder[c];
            if (c == -1) {
                continue;
            }
            if (c === undefined) {
                throw new Error("Illegal character at offset " + i);
            }
            bits |= c;
            if (++char_count >= 4) {
                out[out.length] = (bits >> 16);
                out[out.length] = (bits >> 8) & 0xFF;
                out[out.length] = bits & 0xFF;
                bits = 0;
                char_count = 0;
            }
            else {
                bits <<= 6;
            }
        }
        switch (char_count) {
            case 1:
                throw new Error("Base64 encoding incomplete: at least 2 bits missing");
            case 2:
                out[out.length] = (bits >> 10);
                break;
            case 3:
                out[out.length] = (bits >> 16);
                out[out.length] = (bits >> 8) & 0xFF;
                break;
        }
        return out;
    },
    re: /-----BEGIN [^-]+-----([A-Za-z0-9+\/=\s]+)-----END [^-]+-----|begin-base64[^\n]+\n([A-Za-z0-9+\/=\s]+)====/,
    unarmor: function (a) {
        var m = Base64.re.exec(a);
        if (m) {
            if (m[1]) {
                a = m[1];
            }
            else if (m[2]) {
                a = m[2];
            }
            else {
                throw new Error("RegExp out of sync");
            }
        }
        return Base64.decode(a);
    }
};


/***/ }),

/***/ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/asn1js/hex.js":
/*!***********************************************************************!*\
  !*** ./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/asn1js/hex.js ***!
  \***********************************************************************/
/*! exports provided: Hex */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Hex", function() { return Hex; });
// Hex JavaScript decoder
// Copyright (c) 2008-2013 Lapo Luchini <lapo@lapo.it>
// Permission to use, copy, modify, and/or distribute this software for any
// purpose with or without fee is hereby granted, provided that the above
// copyright notice and this permission notice appear in all copies.
//
// THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
// WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
// MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
// ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
// WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
// ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
// OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
/*jshint browser: true, strict: true, immed: true, latedef: true, undef: true, regexdash: false */
var decoder;
var Hex = {
    decode: function (a) {
        var i;
        if (decoder === undefined) {
            var hex = "0123456789ABCDEF";
            var ignore = " \f\n\r\t\u00A0\u2028\u2029";
            decoder = {};
            for (i = 0; i < 16; ++i) {
                decoder[hex.charAt(i)] = i;
            }
            hex = hex.toLowerCase();
            for (i = 10; i < 16; ++i) {
                decoder[hex.charAt(i)] = i;
            }
            for (i = 0; i < ignore.length; ++i) {
                decoder[ignore.charAt(i)] = -1;
            }
        }
        var out = [];
        var bits = 0;
        var char_count = 0;
        for (i = 0; i < a.length; ++i) {
            var c = a.charAt(i);
            if (c == "=") {
                break;
            }
            c = decoder[c];
            if (c == -1) {
                continue;
            }
            if (c === undefined) {
                throw new Error("Illegal character at offset " + i);
            }
            bits |= c;
            if (++char_count >= 2) {
                out[out.length] = bits;
                bits = 0;
                char_count = 0;
            }
            else {
                bits <<= 4;
            }
        }
        if (char_count) {
            throw new Error("Hex encoding incomplete: 4 bits missing");
        }
        return out;
    }
};


/***/ }),

/***/ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/asn1js/int10.js":
/*!*************************************************************************!*\
  !*** ./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/asn1js/int10.js ***!
  \*************************************************************************/
/*! exports provided: Int10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Int10", function() { return Int10; });
// Big integer base-10 printing library
// Copyright (c) 2014 Lapo Luchini <lapo@lapo.it>
// Permission to use, copy, modify, and/or distribute this software for any
// purpose with or without fee is hereby granted, provided that the above
// copyright notice and this permission notice appear in all copies.
//
// THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
// WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
// MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
// ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
// WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
// ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
// OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
/*jshint browser: true, strict: true, immed: true, latedef: true, undef: true, regexdash: false */
var max = 10000000000000; // biggest integer that can still fit 2^53 when multiplied by 256
var Int10 = /** @class */ (function () {
    function Int10(value) {
        this.buf = [+value || 0];
    }
    Int10.prototype.mulAdd = function (m, c) {
        // assert(m <= 256)
        var b = this.buf;
        var l = b.length;
        var i;
        var t;
        for (i = 0; i < l; ++i) {
            t = b[i] * m + c;
            if (t < max) {
                c = 0;
            }
            else {
                c = 0 | (t / max);
                t -= c * max;
            }
            b[i] = t;
        }
        if (c > 0) {
            b[i] = c;
        }
    };
    Int10.prototype.sub = function (c) {
        // assert(m <= 256)
        var b = this.buf;
        var l = b.length;
        var i;
        var t;
        for (i = 0; i < l; ++i) {
            t = b[i] - c;
            if (t < 0) {
                t += max;
                c = 1;
            }
            else {
                c = 0;
            }
            b[i] = t;
        }
        while (b[b.length - 1] === 0) {
            b.pop();
        }
    };
    Int10.prototype.toString = function (base) {
        if ((base || 10) != 10) {
            throw new Error("only base 10 is supported");
        }
        var b = this.buf;
        var s = b[b.length - 1].toString();
        for (var i = b.length - 2; i >= 0; --i) {
            s += (max + b[i]).toString().substring(1);
        }
        return s;
    };
    Int10.prototype.valueOf = function () {
        var b = this.buf;
        var v = 0;
        for (var i = b.length - 1; i >= 0; --i) {
            v = v * max + b[i];
        }
        return v;
    };
    Int10.prototype.simplify = function () {
        var b = this.buf;
        return (b.length == 1) ? b[0] : this;
    };
    return Int10;
}());



/***/ }),

/***/ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsbn/base64.js":
/*!************************************************************************!*\
  !*** ./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsbn/base64.js ***!
  \************************************************************************/
/*! exports provided: hex2b64, b64tohex, b64toBA */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hex2b64", function() { return hex2b64; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b64tohex", function() { return b64tohex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b64toBA", function() { return b64toBA; });
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./util */ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsbn/util.js");

var b64map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var b64pad = "=";
function hex2b64(h) {
    var i;
    var c;
    var ret = "";
    for (i = 0; i + 3 <= h.length; i += 3) {
        c = parseInt(h.substring(i, i + 3), 16);
        ret += b64map.charAt(c >> 6) + b64map.charAt(c & 63);
    }
    if (i + 1 == h.length) {
        c = parseInt(h.substring(i, i + 1), 16);
        ret += b64map.charAt(c << 2);
    }
    else if (i + 2 == h.length) {
        c = parseInt(h.substring(i, i + 2), 16);
        ret += b64map.charAt(c >> 2) + b64map.charAt((c & 3) << 4);
    }
    while ((ret.length & 3) > 0) {
        ret += b64pad;
    }
    return ret;
}
// convert a base64 string to hex
function b64tohex(s) {
    var ret = "";
    var i;
    var k = 0; // b64 state, 0-3
    var slop = 0;
    for (i = 0; i < s.length; ++i) {
        if (s.charAt(i) == b64pad) {
            break;
        }
        var v = b64map.indexOf(s.charAt(i));
        if (v < 0) {
            continue;
        }
        if (k == 0) {
            ret += Object(_util__WEBPACK_IMPORTED_MODULE_0__["int2char"])(v >> 2);
            slop = v & 3;
            k = 1;
        }
        else if (k == 1) {
            ret += Object(_util__WEBPACK_IMPORTED_MODULE_0__["int2char"])((slop << 2) | (v >> 4));
            slop = v & 0xf;
            k = 2;
        }
        else if (k == 2) {
            ret += Object(_util__WEBPACK_IMPORTED_MODULE_0__["int2char"])(slop);
            ret += Object(_util__WEBPACK_IMPORTED_MODULE_0__["int2char"])(v >> 2);
            slop = v & 3;
            k = 3;
        }
        else {
            ret += Object(_util__WEBPACK_IMPORTED_MODULE_0__["int2char"])((slop << 2) | (v >> 4));
            ret += Object(_util__WEBPACK_IMPORTED_MODULE_0__["int2char"])(v & 0xf);
            k = 0;
        }
    }
    if (k == 1) {
        ret += Object(_util__WEBPACK_IMPORTED_MODULE_0__["int2char"])(slop << 2);
    }
    return ret;
}
// convert a base64 string to a byte/number array
function b64toBA(s) {
    // piggyback on b64tohex for now, optimize later
    var h = b64tohex(s);
    var i;
    var a = [];
    for (i = 0; 2 * i < h.length; ++i) {
        a[i] = parseInt(h.substring(2 * i, 2 * i + 2), 16);
    }
    return a;
}


/***/ }),

/***/ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsbn/jsbn.js":
/*!**********************************************************************!*\
  !*** ./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsbn/jsbn.js ***!
  \**********************************************************************/
/*! exports provided: BigInteger, nbi, parseBigInt, intAt, nbv, nbits */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BigInteger", function() { return BigInteger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nbi", function() { return nbi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseBigInt", function() { return parseBigInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intAt", function() { return intAt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nbv", function() { return nbv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nbits", function() { return nbits; });
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./util */ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsbn/util.js");
// Copyright (c) 2005  Tom Wu
// All Rights Reserved.
// See "LICENSE" for details.
// Basic JavaScript BN library - subset useful for RSA encryption.

// Bits per digit
var dbits;
// JavaScript engine analysis
var canary = 0xdeadbeefcafe;
var j_lm = ((canary & 0xffffff) == 0xefcafe);
//#region
var lowprimes = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997];
var lplim = (1 << 26) / lowprimes[lowprimes.length - 1];
//#endregion
// (public) Constructor
var BigInteger = /** @class */ (function () {
    function BigInteger(a, b, c) {
        if (a != null) {
            if ("number" == typeof a) {
                this.fromNumber(a, b, c);
            }
            else if (b == null && "string" != typeof a) {
                this.fromString(a, 256);
            }
            else {
                this.fromString(a, b);
            }
        }
    }
    //#region PUBLIC
    // BigInteger.prototype.toString = bnToString;
    // (public) return string representation in given radix
    BigInteger.prototype.toString = function (b) {
        if (this.s < 0) {
            return "-" + this.negate().toString(b);
        }
        var k;
        if (b == 16) {
            k = 4;
        }
        else if (b == 8) {
            k = 3;
        }
        else if (b == 2) {
            k = 1;
        }
        else if (b == 32) {
            k = 5;
        }
        else if (b == 4) {
            k = 2;
        }
        else {
            return this.toRadix(b);
        }
        var km = (1 << k) - 1;
        var d;
        var m = false;
        var r = "";
        var i = this.t;
        var p = this.DB - (i * this.DB) % k;
        if (i-- > 0) {
            if (p < this.DB && (d = this[i] >> p) > 0) {
                m = true;
                r = Object(_util__WEBPACK_IMPORTED_MODULE_0__["int2char"])(d);
            }
            while (i >= 0) {
                if (p < k) {
                    d = (this[i] & ((1 << p) - 1)) << (k - p);
                    d |= this[--i] >> (p += this.DB - k);
                }
                else {
                    d = (this[i] >> (p -= k)) & km;
                    if (p <= 0) {
                        p += this.DB;
                        --i;
                    }
                }
                if (d > 0) {
                    m = true;
                }
                if (m) {
                    r += Object(_util__WEBPACK_IMPORTED_MODULE_0__["int2char"])(d);
                }
            }
        }
        return m ? r : "0";
    };
    // BigInteger.prototype.negate = bnNegate;
    // (public) -this
    BigInteger.prototype.negate = function () {
        var r = nbi();
        BigInteger.ZERO.subTo(this, r);
        return r;
    };
    // BigInteger.prototype.abs = bnAbs;
    // (public) |this|
    BigInteger.prototype.abs = function () {
        return (this.s < 0) ? this.negate() : this;
    };
    // BigInteger.prototype.compareTo = bnCompareTo;
    // (public) return + if this > a, - if this < a, 0 if equal
    BigInteger.prototype.compareTo = function (a) {
        var r = this.s - a.s;
        if (r != 0) {
            return r;
        }
        var i = this.t;
        r = i - a.t;
        if (r != 0) {
            return (this.s < 0) ? -r : r;
        }
        while (--i >= 0) {
            if ((r = this[i] - a[i]) != 0) {
                return r;
            }
        }
        return 0;
    };
    // BigInteger.prototype.bitLength = bnBitLength;
    // (public) return the number of bits in "this"
    BigInteger.prototype.bitLength = function () {
        if (this.t <= 0) {
            return 0;
        }
        return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ (this.s & this.DM));
    };
    // BigInteger.prototype.mod = bnMod;
    // (public) this mod a
    BigInteger.prototype.mod = function (a) {
        var r = nbi();
        this.abs().divRemTo(a, null, r);
        if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) {
            a.subTo(r, r);
        }
        return r;
    };
    // BigInteger.prototype.modPowInt = bnModPowInt;
    // (public) this^e % m, 0 <= e < 2^32
    BigInteger.prototype.modPowInt = function (e, m) {
        var z;
        if (e < 256 || m.isEven()) {
            z = new Classic(m);
        }
        else {
            z = new Montgomery(m);
        }
        return this.exp(e, z);
    };
    // BigInteger.prototype.clone = bnClone;
    // (public)
    BigInteger.prototype.clone = function () {
        var r = nbi();
        this.copyTo(r);
        return r;
    };
    // BigInteger.prototype.intValue = bnIntValue;
    // (public) return value as integer
    BigInteger.prototype.intValue = function () {
        if (this.s < 0) {
            if (this.t == 1) {
                return this[0] - this.DV;
            }
            else if (this.t == 0) {
                return -1;
            }
        }
        else if (this.t == 1) {
            return this[0];
        }
        else if (this.t == 0) {
            return 0;
        }
        // assumes 16 < DB < 32
        return ((this[1] & ((1 << (32 - this.DB)) - 1)) << this.DB) | this[0];
    };
    // BigInteger.prototype.byteValue = bnByteValue;
    // (public) return value as byte
    BigInteger.prototype.byteValue = function () {
        return (this.t == 0) ? this.s : (this[0] << 24) >> 24;
    };
    // BigInteger.prototype.shortValue = bnShortValue;
    // (public) return value as short (assumes DB>=16)
    BigInteger.prototype.shortValue = function () {
        return (this.t == 0) ? this.s : (this[0] << 16) >> 16;
    };
    // BigInteger.prototype.signum = bnSigNum;
    // (public) 0 if this == 0, 1 if this > 0
    BigInteger.prototype.signum = function () {
        if (this.s < 0) {
            return -1;
        }
        else if (this.t <= 0 || (this.t == 1 && this[0] <= 0)) {
            return 0;
        }
        else {
            return 1;
        }
    };
    // BigInteger.prototype.toByteArray = bnToByteArray;
    // (public) convert to bigendian byte array
    BigInteger.prototype.toByteArray = function () {
        var i = this.t;
        var r = [];
        r[0] = this.s;
        var p = this.DB - (i * this.DB) % 8;
        var d;
        var k = 0;
        if (i-- > 0) {
            if (p < this.DB && (d = this[i] >> p) != (this.s & this.DM) >> p) {
                r[k++] = d | (this.s << (this.DB - p));
            }
            while (i >= 0) {
                if (p < 8) {
                    d = (this[i] & ((1 << p) - 1)) << (8 - p);
                    d |= this[--i] >> (p += this.DB - 8);
                }
                else {
                    d = (this[i] >> (p -= 8)) & 0xff;
                    if (p <= 0) {
                        p += this.DB;
                        --i;
                    }
                }
                if ((d & 0x80) != 0) {
                    d |= -256;
                }
                if (k == 0 && (this.s & 0x80) != (d & 0x80)) {
                    ++k;
                }
                if (k > 0 || d != this.s) {
                    r[k++] = d;
                }
            }
        }
        return r;
    };
    // BigInteger.prototype.equals = bnEquals;
    BigInteger.prototype.equals = function (a) {
        return (this.compareTo(a) == 0);
    };
    // BigInteger.prototype.min = bnMin;
    BigInteger.prototype.min = function (a) {
        return (this.compareTo(a) < 0) ? this : a;
    };
    // BigInteger.prototype.max = bnMax;
    BigInteger.prototype.max = function (a) {
        return (this.compareTo(a) > 0) ? this : a;
    };
    // BigInteger.prototype.and = bnAnd;
    BigInteger.prototype.and = function (a) {
        var r = nbi();
        this.bitwiseTo(a, _util__WEBPACK_IMPORTED_MODULE_0__["op_and"], r);
        return r;
    };
    // BigInteger.prototype.or = bnOr;
    BigInteger.prototype.or = function (a) {
        var r = nbi();
        this.bitwiseTo(a, _util__WEBPACK_IMPORTED_MODULE_0__["op_or"], r);
        return r;
    };
    // BigInteger.prototype.xor = bnXor;
    BigInteger.prototype.xor = function (a) {
        var r = nbi();
        this.bitwiseTo(a, _util__WEBPACK_IMPORTED_MODULE_0__["op_xor"], r);
        return r;
    };
    // BigInteger.prototype.andNot = bnAndNot;
    BigInteger.prototype.andNot = function (a) {
        var r = nbi();
        this.bitwiseTo(a, _util__WEBPACK_IMPORTED_MODULE_0__["op_andnot"], r);
        return r;
    };
    // BigInteger.prototype.not = bnNot;
    // (public) ~this
    BigInteger.prototype.not = function () {
        var r = nbi();
        for (var i = 0; i < this.t; ++i) {
            r[i] = this.DM & ~this[i];
        }
        r.t = this.t;
        r.s = ~this.s;
        return r;
    };
    // BigInteger.prototype.shiftLeft = bnShiftLeft;
    // (public) this << n
    BigInteger.prototype.shiftLeft = function (n) {
        var r = nbi();
        if (n < 0) {
            this.rShiftTo(-n, r);
        }
        else {
            this.lShiftTo(n, r);
        }
        return r;
    };
    // BigInteger.prototype.shiftRight = bnShiftRight;
    // (public) this >> n
    BigInteger.prototype.shiftRight = function (n) {
        var r = nbi();
        if (n < 0) {
            this.lShiftTo(-n, r);
        }
        else {
            this.rShiftTo(n, r);
        }
        return r;
    };
    // BigInteger.prototype.getLowestSetBit = bnGetLowestSetBit;
    // (public) returns index of lowest 1-bit (or -1 if none)
    BigInteger.prototype.getLowestSetBit = function () {
        for (var i = 0; i < this.t; ++i) {
            if (this[i] != 0) {
                return i * this.DB + Object(_util__WEBPACK_IMPORTED_MODULE_0__["lbit"])(this[i]);
            }
        }
        if (this.s < 0) {
            return this.t * this.DB;
        }
        return -1;
    };
    // BigInteger.prototype.bitCount = bnBitCount;
    // (public) return number of set bits
    BigInteger.prototype.bitCount = function () {
        var r = 0;
        var x = this.s & this.DM;
        for (var i = 0; i < this.t; ++i) {
            r += Object(_util__WEBPACK_IMPORTED_MODULE_0__["cbit"])(this[i] ^ x);
        }
        return r;
    };
    // BigInteger.prototype.testBit = bnTestBit;
    // (public) true iff nth bit is set
    BigInteger.prototype.testBit = function (n) {
        var j = Math.floor(n / this.DB);
        if (j >= this.t) {
            return (this.s != 0);
        }
        return ((this[j] & (1 << (n % this.DB))) != 0);
    };
    // BigInteger.prototype.setBit = bnSetBit;
    // (public) this | (1<<n)
    BigInteger.prototype.setBit = function (n) {
        return this.changeBit(n, _util__WEBPACK_IMPORTED_MODULE_0__["op_or"]);
    };
    // BigInteger.prototype.clearBit = bnClearBit;
    // (public) this & ~(1<<n)
    BigInteger.prototype.clearBit = function (n) {
        return this.changeBit(n, _util__WEBPACK_IMPORTED_MODULE_0__["op_andnot"]);
    };
    // BigInteger.prototype.flipBit = bnFlipBit;
    // (public) this ^ (1<<n)
    BigInteger.prototype.flipBit = function (n) {
        return this.changeBit(n, _util__WEBPACK_IMPORTED_MODULE_0__["op_xor"]);
    };
    // BigInteger.prototype.add = bnAdd;
    // (public) this + a
    BigInteger.prototype.add = function (a) {
        var r = nbi();
        this.addTo(a, r);
        return r;
    };
    // BigInteger.prototype.subtract = bnSubtract;
    // (public) this - a
    BigInteger.prototype.subtract = function (a) {
        var r = nbi();
        this.subTo(a, r);
        return r;
    };
    // BigInteger.prototype.multiply = bnMultiply;
    // (public) this * a
    BigInteger.prototype.multiply = function (a) {
        var r = nbi();
        this.multiplyTo(a, r);
        return r;
    };
    // BigInteger.prototype.divide = bnDivide;
    // (public) this / a
    BigInteger.prototype.divide = function (a) {
        var r = nbi();
        this.divRemTo(a, r, null);
        return r;
    };
    // BigInteger.prototype.remainder = bnRemainder;
    // (public) this % a
    BigInteger.prototype.remainder = function (a) {
        var r = nbi();
        this.divRemTo(a, null, r);
        return r;
    };
    // BigInteger.prototype.divideAndRemainder = bnDivideAndRemainder;
    // (public) [this/a,this%a]
    BigInteger.prototype.divideAndRemainder = function (a) {
        var q = nbi();
        var r = nbi();
        this.divRemTo(a, q, r);
        return [q, r];
    };
    // BigInteger.prototype.modPow = bnModPow;
    // (public) this^e % m (HAC 14.85)
    BigInteger.prototype.modPow = function (e, m) {
        var i = e.bitLength();
        var k;
        var r = nbv(1);
        var z;
        if (i <= 0) {
            return r;
        }
        else if (i < 18) {
            k = 1;
        }
        else if (i < 48) {
            k = 3;
        }
        else if (i < 144) {
            k = 4;
        }
        else if (i < 768) {
            k = 5;
        }
        else {
            k = 6;
        }
        if (i < 8) {
            z = new Classic(m);
        }
        else if (m.isEven()) {
            z = new Barrett(m);
        }
        else {
            z = new Montgomery(m);
        }
        // precomputation
        var g = [];
        var n = 3;
        var k1 = k - 1;
        var km = (1 << k) - 1;
        g[1] = z.convert(this);
        if (k > 1) {
            var g2 = nbi();
            z.sqrTo(g[1], g2);
            while (n <= km) {
                g[n] = nbi();
                z.mulTo(g2, g[n - 2], g[n]);
                n += 2;
            }
        }
        var j = e.t - 1;
        var w;
        var is1 = true;
        var r2 = nbi();
        var t;
        i = nbits(e[j]) - 1;
        while (j >= 0) {
            if (i >= k1) {
                w = (e[j] >> (i - k1)) & km;
            }
            else {
                w = (e[j] & ((1 << (i + 1)) - 1)) << (k1 - i);
                if (j > 0) {
                    w |= e[j - 1] >> (this.DB + i - k1);
                }
            }
            n = k;
            while ((w & 1) == 0) {
                w >>= 1;
                --n;
            }
            if ((i -= n) < 0) {
                i += this.DB;
                --j;
            }
            if (is1) { // ret == 1, don't bother squaring or multiplying it
                g[w].copyTo(r);
                is1 = false;
            }
            else {
                while (n > 1) {
                    z.sqrTo(r, r2);
                    z.sqrTo(r2, r);
                    n -= 2;
                }
                if (n > 0) {
                    z.sqrTo(r, r2);
                }
                else {
                    t = r;
                    r = r2;
                    r2 = t;
                }
                z.mulTo(r2, g[w], r);
            }
            while (j >= 0 && (e[j] & (1 << i)) == 0) {
                z.sqrTo(r, r2);
                t = r;
                r = r2;
                r2 = t;
                if (--i < 0) {
                    i = this.DB - 1;
                    --j;
                }
            }
        }
        return z.revert(r);
    };
    // BigInteger.prototype.modInverse = bnModInverse;
    // (public) 1/this % m (HAC 14.61)
    BigInteger.prototype.modInverse = function (m) {
        var ac = m.isEven();
        if ((this.isEven() && ac) || m.signum() == 0) {
            return BigInteger.ZERO;
        }
        var u = m.clone();
        var v = this.clone();
        var a = nbv(1);
        var b = nbv(0);
        var c = nbv(0);
        var d = nbv(1);
        while (u.signum() != 0) {
            while (u.isEven()) {
                u.rShiftTo(1, u);
                if (ac) {
                    if (!a.isEven() || !b.isEven()) {
                        a.addTo(this, a);
                        b.subTo(m, b);
                    }
                    a.rShiftTo(1, a);
                }
                else if (!b.isEven()) {
                    b.subTo(m, b);
                }
                b.rShiftTo(1, b);
            }
            while (v.isEven()) {
                v.rShiftTo(1, v);
                if (ac) {
                    if (!c.isEven() || !d.isEven()) {
                        c.addTo(this, c);
                        d.subTo(m, d);
                    }
                    c.rShiftTo(1, c);
                }
                else if (!d.isEven()) {
                    d.subTo(m, d);
                }
                d.rShiftTo(1, d);
            }
            if (u.compareTo(v) >= 0) {
                u.subTo(v, u);
                if (ac) {
                    a.subTo(c, a);
                }
                b.subTo(d, b);
            }
            else {
                v.subTo(u, v);
                if (ac) {
                    c.subTo(a, c);
                }
                d.subTo(b, d);
            }
        }
        if (v.compareTo(BigInteger.ONE) != 0) {
            return BigInteger.ZERO;
        }
        if (d.compareTo(m) >= 0) {
            return d.subtract(m);
        }
        if (d.signum() < 0) {
            d.addTo(m, d);
        }
        else {
            return d;
        }
        if (d.signum() < 0) {
            return d.add(m);
        }
        else {
            return d;
        }
    };
    // BigInteger.prototype.pow = bnPow;
    // (public) this^e
    BigInteger.prototype.pow = function (e) {
        return this.exp(e, new NullExp());
    };
    // BigInteger.prototype.gcd = bnGCD;
    // (public) gcd(this,a) (HAC 14.54)
    BigInteger.prototype.gcd = function (a) {
        var x = (this.s < 0) ? this.negate() : this.clone();
        var y = (a.s < 0) ? a.negate() : a.clone();
        if (x.compareTo(y) < 0) {
            var t = x;
            x = y;
            y = t;
        }
        var i = x.getLowestSetBit();
        var g = y.getLowestSetBit();
        if (g < 0) {
            return x;
        }
        if (i < g) {
            g = i;
        }
        if (g > 0) {
            x.rShiftTo(g, x);
            y.rShiftTo(g, y);
        }
        while (x.signum() > 0) {
            if ((i = x.getLowestSetBit()) > 0) {
                x.rShiftTo(i, x);
            }
            if ((i = y.getLowestSetBit()) > 0) {
                y.rShiftTo(i, y);
            }
            if (x.compareTo(y) >= 0) {
                x.subTo(y, x);
                x.rShiftTo(1, x);
            }
            else {
                y.subTo(x, y);
                y.rShiftTo(1, y);
            }
        }
        if (g > 0) {
            y.lShiftTo(g, y);
        }
        return y;
    };
    // BigInteger.prototype.isProbablePrime = bnIsProbablePrime;
    // (public) test primality with certainty >= 1-.5^t
    BigInteger.prototype.isProbablePrime = function (t) {
        var i;
        var x = this.abs();
        if (x.t == 1 && x[0] <= lowprimes[lowprimes.length - 1]) {
            for (i = 0; i < lowprimes.length; ++i) {
                if (x[0] == lowprimes[i]) {
                    return true;
                }
            }
            return false;
        }
        if (x.isEven()) {
            return false;
        }
        i = 1;
        while (i < lowprimes.length) {
            var m = lowprimes[i];
            var j = i + 1;
            while (j < lowprimes.length && m < lplim) {
                m *= lowprimes[j++];
            }
            m = x.modInt(m);
            while (i < j) {
                if (m % lowprimes[i++] == 0) {
                    return false;
                }
            }
        }
        return x.millerRabin(t);
    };
    //#endregion PUBLIC
    //#region PROTECTED
    // BigInteger.prototype.copyTo = bnpCopyTo;
    // (protected) copy this to r
    BigInteger.prototype.copyTo = function (r) {
        for (var i = this.t - 1; i >= 0; --i) {
            r[i] = this[i];
        }
        r.t = this.t;
        r.s = this.s;
    };
    // BigInteger.prototype.fromInt = bnpFromInt;
    // (protected) set from integer value x, -DV <= x < DV
    BigInteger.prototype.fromInt = function (x) {
        this.t = 1;
        this.s = (x < 0) ? -1 : 0;
        if (x > 0) {
            this[0] = x;
        }
        else if (x < -1) {
            this[0] = x + this.DV;
        }
        else {
            this.t = 0;
        }
    };
    // BigInteger.prototype.fromString = bnpFromString;
    // (protected) set from string and radix
    BigInteger.prototype.fromString = function (s, b) {
        var k;
        if (b == 16) {
            k = 4;
        }
        else if (b == 8) {
            k = 3;
        }
        else if (b == 256) {
            k = 8;
            /* byte array */
        }
        else if (b == 2) {
            k = 1;
        }
        else if (b == 32) {
            k = 5;
        }
        else if (b == 4) {
            k = 2;
        }
        else {
            this.fromRadix(s, b);
            return;
        }
        this.t = 0;
        this.s = 0;
        var i = s.length;
        var mi = false;
        var sh = 0;
        while (--i >= 0) {
            var x = (k == 8) ? (+s[i]) & 0xff : intAt(s, i);
            if (x < 0) {
                if (s.charAt(i) == "-") {
                    mi = true;
                }
                continue;
            }
            mi = false;
            if (sh == 0) {
                this[this.t++] = x;
            }
            else if (sh + k > this.DB) {
                this[this.t - 1] |= (x & ((1 << (this.DB - sh)) - 1)) << sh;
                this[this.t++] = (x >> (this.DB - sh));
            }
            else {
                this[this.t - 1] |= x << sh;
            }
            sh += k;
            if (sh >= this.DB) {
                sh -= this.DB;
            }
        }
        if (k == 8 && ((+s[0]) & 0x80) != 0) {
            this.s = -1;
            if (sh > 0) {
                this[this.t - 1] |= ((1 << (this.DB - sh)) - 1) << sh;
            }
        }
        this.clamp();
        if (mi) {
            BigInteger.ZERO.subTo(this, this);
        }
    };
    // BigInteger.prototype.clamp = bnpClamp;
    // (protected) clamp off excess high words
    BigInteger.prototype.clamp = function () {
        var c = this.s & this.DM;
        while (this.t > 0 && this[this.t - 1] == c) {
            --this.t;
        }
    };
    // BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
    // (protected) r = this << n*DB
    BigInteger.prototype.dlShiftTo = function (n, r) {
        var i;
        for (i = this.t - 1; i >= 0; --i) {
            r[i + n] = this[i];
        }
        for (i = n - 1; i >= 0; --i) {
            r[i] = 0;
        }
        r.t = this.t + n;
        r.s = this.s;
    };
    // BigInteger.prototype.drShiftTo = bnpDRShiftTo;
    // (protected) r = this >> n*DB
    BigInteger.prototype.drShiftTo = function (n, r) {
        for (var i = n; i < this.t; ++i) {
            r[i - n] = this[i];
        }
        r.t = Math.max(this.t - n, 0);
        r.s = this.s;
    };
    // BigInteger.prototype.lShiftTo = bnpLShiftTo;
    // (protected) r = this << n
    BigInteger.prototype.lShiftTo = function (n, r) {
        var bs = n % this.DB;
        var cbs = this.DB - bs;
        var bm = (1 << cbs) - 1;
        var ds = Math.floor(n / this.DB);
        var c = (this.s << bs) & this.DM;
        for (var i = this.t - 1; i >= 0; --i) {
            r[i + ds + 1] = (this[i] >> cbs) | c;
            c = (this[i] & bm) << bs;
        }
        for (var i = ds - 1; i >= 0; --i) {
            r[i] = 0;
        }
        r[ds] = c;
        r.t = this.t + ds + 1;
        r.s = this.s;
        r.clamp();
    };
    // BigInteger.prototype.rShiftTo = bnpRShiftTo;
    // (protected) r = this >> n
    BigInteger.prototype.rShiftTo = function (n, r) {
        r.s = this.s;
        var ds = Math.floor(n / this.DB);
        if (ds >= this.t) {
            r.t = 0;
            return;
        }
        var bs = n % this.DB;
        var cbs = this.DB - bs;
        var bm = (1 << bs) - 1;
        r[0] = this[ds] >> bs;
        for (var i = ds + 1; i < this.t; ++i) {
            r[i - ds - 1] |= (this[i] & bm) << cbs;
            r[i - ds] = this[i] >> bs;
        }
        if (bs > 0) {
            r[this.t - ds - 1] |= (this.s & bm) << cbs;
        }
        r.t = this.t - ds;
        r.clamp();
    };
    // BigInteger.prototype.subTo = bnpSubTo;
    // (protected) r = this - a
    BigInteger.prototype.subTo = function (a, r) {
        var i = 0;
        var c = 0;
        var m = Math.min(a.t, this.t);
        while (i < m) {
            c += this[i] - a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        if (a.t < this.t) {
            c -= a.s;
            while (i < this.t) {
                c += this[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += this.s;
        }
        else {
            c += this.s;
            while (i < a.t) {
                c -= a[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c -= a.s;
        }
        r.s = (c < 0) ? -1 : 0;
        if (c < -1) {
            r[i++] = this.DV + c;
        }
        else if (c > 0) {
            r[i++] = c;
        }
        r.t = i;
        r.clamp();
    };
    // BigInteger.prototype.multiplyTo = bnpMultiplyTo;
    // (protected) r = this * a, r != this,a (HAC 14.12)
    // "this" should be the larger one if appropriate.
    BigInteger.prototype.multiplyTo = function (a, r) {
        var x = this.abs();
        var y = a.abs();
        var i = x.t;
        r.t = i + y.t;
        while (--i >= 0) {
            r[i] = 0;
        }
        for (i = 0; i < y.t; ++i) {
            r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
        }
        r.s = 0;
        r.clamp();
        if (this.s != a.s) {
            BigInteger.ZERO.subTo(r, r);
        }
    };
    // BigInteger.prototype.squareTo = bnpSquareTo;
    // (protected) r = this^2, r != this (HAC 14.16)
    BigInteger.prototype.squareTo = function (r) {
        var x = this.abs();
        var i = r.t = 2 * x.t;
        while (--i >= 0) {
            r[i] = 0;
        }
        for (i = 0; i < x.t - 1; ++i) {
            var c = x.am(i, x[i], r, 2 * i, 0, 1);
            if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
                r[i + x.t] -= x.DV;
                r[i + x.t + 1] = 1;
            }
        }
        if (r.t > 0) {
            r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
        }
        r.s = 0;
        r.clamp();
    };
    // BigInteger.prototype.divRemTo = bnpDivRemTo;
    // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
    // r != q, this != m.  q or r may be null.
    BigInteger.prototype.divRemTo = function (m, q, r) {
        var pm = m.abs();
        if (pm.t <= 0) {
            return;
        }
        var pt = this.abs();
        if (pt.t < pm.t) {
            if (q != null) {
                q.fromInt(0);
            }
            if (r != null) {
                this.copyTo(r);
            }
            return;
        }
        if (r == null) {
            r = nbi();
        }
        var y = nbi();
        var ts = this.s;
        var ms = m.s;
        var nsh = this.DB - nbits(pm[pm.t - 1]); // normalize modulus
        if (nsh > 0) {
            pm.lShiftTo(nsh, y);
            pt.lShiftTo(nsh, r);
        }
        else {
            pm.copyTo(y);
            pt.copyTo(r);
        }
        var ys = y.t;
        var y0 = y[ys - 1];
        if (y0 == 0) {
            return;
        }
        var yt = y0 * (1 << this.F1) + ((ys > 1) ? y[ys - 2] >> this.F2 : 0);
        var d1 = this.FV / yt;
        var d2 = (1 << this.F1) / yt;
        var e = 1 << this.F2;
        var i = r.t;
        var j = i - ys;
        var t = (q == null) ? nbi() : q;
        y.dlShiftTo(j, t);
        if (r.compareTo(t) >= 0) {
            r[r.t++] = 1;
            r.subTo(t, r);
        }
        BigInteger.ONE.dlShiftTo(ys, t);
        t.subTo(y, y); // "negative" y so we can replace sub with am later
        while (y.t < ys) {
            y[y.t++] = 0;
        }
        while (--j >= 0) {
            // Estimate quotient digit
            var qd = (r[--i] == y0) ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
            if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) { // Try it out
                y.dlShiftTo(j, t);
                r.subTo(t, r);
                while (r[i] < --qd) {
                    r.subTo(t, r);
                }
            }
        }
        if (q != null) {
            r.drShiftTo(ys, q);
            if (ts != ms) {
                BigInteger.ZERO.subTo(q, q);
            }
        }
        r.t = ys;
        r.clamp();
        if (nsh > 0) {
            r.rShiftTo(nsh, r);
        } // Denormalize remainder
        if (ts < 0) {
            BigInteger.ZERO.subTo(r, r);
        }
    };
    // BigInteger.prototype.invDigit = bnpInvDigit;
    // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
    // justification:
    //         xy == 1 (mod m)
    //         xy =  1+km
    //   xy(2-xy) = (1+km)(1-km)
    // x[y(2-xy)] = 1-k^2m^2
    // x[y(2-xy)] == 1 (mod m^2)
    // if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
    // should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
    // JS multiply "overflows" differently from C/C++, so care is needed here.
    BigInteger.prototype.invDigit = function () {
        if (this.t < 1) {
            return 0;
        }
        var x = this[0];
        if ((x & 1) == 0) {
            return 0;
        }
        var y = x & 3; // y == 1/x mod 2^2
        y = (y * (2 - (x & 0xf) * y)) & 0xf; // y == 1/x mod 2^4
        y = (y * (2 - (x & 0xff) * y)) & 0xff; // y == 1/x mod 2^8
        y = (y * (2 - (((x & 0xffff) * y) & 0xffff))) & 0xffff; // y == 1/x mod 2^16
        // last step - calculate inverse mod DV directly;
        // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
        y = (y * (2 - x * y % this.DV)) % this.DV; // y == 1/x mod 2^dbits
        // we really want the negative inverse, and -DV < y < DV
        return (y > 0) ? this.DV - y : -y;
    };
    // BigInteger.prototype.isEven = bnpIsEven;
    // (protected) true iff this is even
    BigInteger.prototype.isEven = function () {
        return ((this.t > 0) ? (this[0] & 1) : this.s) == 0;
    };
    // BigInteger.prototype.exp = bnpExp;
    // (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
    BigInteger.prototype.exp = function (e, z) {
        if (e > 0xffffffff || e < 1) {
            return BigInteger.ONE;
        }
        var r = nbi();
        var r2 = nbi();
        var g = z.convert(this);
        var i = nbits(e) - 1;
        g.copyTo(r);
        while (--i >= 0) {
            z.sqrTo(r, r2);
            if ((e & (1 << i)) > 0) {
                z.mulTo(r2, g, r);
            }
            else {
                var t = r;
                r = r2;
                r2 = t;
            }
        }
        return z.revert(r);
    };
    // BigInteger.prototype.chunkSize = bnpChunkSize;
    // (protected) return x s.t. r^x < DV
    BigInteger.prototype.chunkSize = function (r) {
        return Math.floor(Math.LN2 * this.DB / Math.log(r));
    };
    // BigInteger.prototype.toRadix = bnpToRadix;
    // (protected) convert to radix string
    BigInteger.prototype.toRadix = function (b) {
        if (b == null) {
            b = 10;
        }
        if (this.signum() == 0 || b < 2 || b > 36) {
            return "0";
        }
        var cs = this.chunkSize(b);
        var a = Math.pow(b, cs);
        var d = nbv(a);
        var y = nbi();
        var z = nbi();
        var r = "";
        this.divRemTo(d, y, z);
        while (y.signum() > 0) {
            r = (a + z.intValue()).toString(b).substr(1) + r;
            y.divRemTo(d, y, z);
        }
        return z.intValue().toString(b) + r;
    };
    // BigInteger.prototype.fromRadix = bnpFromRadix;
    // (protected) convert from radix string
    BigInteger.prototype.fromRadix = function (s, b) {
        this.fromInt(0);
        if (b == null) {
            b = 10;
        }
        var cs = this.chunkSize(b);
        var d = Math.pow(b, cs);
        var mi = false;
        var j = 0;
        var w = 0;
        for (var i = 0; i < s.length; ++i) {
            var x = intAt(s, i);
            if (x < 0) {
                if (s.charAt(i) == "-" && this.signum() == 0) {
                    mi = true;
                }
                continue;
            }
            w = b * w + x;
            if (++j >= cs) {
                this.dMultiply(d);
                this.dAddOffset(w, 0);
                j = 0;
                w = 0;
            }
        }
        if (j > 0) {
            this.dMultiply(Math.pow(b, j));
            this.dAddOffset(w, 0);
        }
        if (mi) {
            BigInteger.ZERO.subTo(this, this);
        }
    };
    // BigInteger.prototype.fromNumber = bnpFromNumber;
    // (protected) alternate constructor
    BigInteger.prototype.fromNumber = function (a, b, c) {
        if ("number" == typeof b) {
            // new BigInteger(int,int,RNG)
            if (a < 2) {
                this.fromInt(1);
            }
            else {
                this.fromNumber(a, c);
                if (!this.testBit(a - 1)) {
                    // force MSB set
                    this.bitwiseTo(BigInteger.ONE.shiftLeft(a - 1), _util__WEBPACK_IMPORTED_MODULE_0__["op_or"], this);
                }
                if (this.isEven()) {
                    this.dAddOffset(1, 0);
                } // force odd
                while (!this.isProbablePrime(b)) {
                    this.dAddOffset(2, 0);
                    if (this.bitLength() > a) {
                        this.subTo(BigInteger.ONE.shiftLeft(a - 1), this);
                    }
                }
            }
        }
        else {
            // new BigInteger(int,RNG)
            var x = [];
            var t = a & 7;
            x.length = (a >> 3) + 1;
            b.nextBytes(x);
            if (t > 0) {
                x[0] &= ((1 << t) - 1);
            }
            else {
                x[0] = 0;
            }
            this.fromString(x, 256);
        }
    };
    // BigInteger.prototype.bitwiseTo = bnpBitwiseTo;
    // (protected) r = this op a (bitwise)
    BigInteger.prototype.bitwiseTo = function (a, op, r) {
        var i;
        var f;
        var m = Math.min(a.t, this.t);
        for (i = 0; i < m; ++i) {
            r[i] = op(this[i], a[i]);
        }
        if (a.t < this.t) {
            f = a.s & this.DM;
            for (i = m; i < this.t; ++i) {
                r[i] = op(this[i], f);
            }
            r.t = this.t;
        }
        else {
            f = this.s & this.DM;
            for (i = m; i < a.t; ++i) {
                r[i] = op(f, a[i]);
            }
            r.t = a.t;
        }
        r.s = op(this.s, a.s);
        r.clamp();
    };
    // BigInteger.prototype.changeBit = bnpChangeBit;
    // (protected) this op (1<<n)
    BigInteger.prototype.changeBit = function (n, op) {
        var r = BigInteger.ONE.shiftLeft(n);
        this.bitwiseTo(r, op, r);
        return r;
    };
    // BigInteger.prototype.addTo = bnpAddTo;
    // (protected) r = this + a
    BigInteger.prototype.addTo = function (a, r) {
        var i = 0;
        var c = 0;
        var m = Math.min(a.t, this.t);
        while (i < m) {
            c += this[i] + a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        if (a.t < this.t) {
            c += a.s;
            while (i < this.t) {
                c += this[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += this.s;
        }
        else {
            c += this.s;
            while (i < a.t) {
                c += a[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += a.s;
        }
        r.s = (c < 0) ? -1 : 0;
        if (c > 0) {
            r[i++] = c;
        }
        else if (c < -1) {
            r[i++] = this.DV + c;
        }
        r.t = i;
        r.clamp();
    };
    // BigInteger.prototype.dMultiply = bnpDMultiply;
    // (protected) this *= n, this >= 0, 1 < n < DV
    BigInteger.prototype.dMultiply = function (n) {
        this[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
        ++this.t;
        this.clamp();
    };
    // BigInteger.prototype.dAddOffset = bnpDAddOffset;
    // (protected) this += n << w words, this >= 0
    BigInteger.prototype.dAddOffset = function (n, w) {
        if (n == 0) {
            return;
        }
        while (this.t <= w) {
            this[this.t++] = 0;
        }
        this[w] += n;
        while (this[w] >= this.DV) {
            this[w] -= this.DV;
            if (++w >= this.t) {
                this[this.t++] = 0;
            }
            ++this[w];
        }
    };
    // BigInteger.prototype.multiplyLowerTo = bnpMultiplyLowerTo;
    // (protected) r = lower n words of "this * a", a.t <= n
    // "this" should be the larger one if appropriate.
    BigInteger.prototype.multiplyLowerTo = function (a, n, r) {
        var i = Math.min(this.t + a.t, n);
        r.s = 0; // assumes a,this >= 0
        r.t = i;
        while (i > 0) {
            r[--i] = 0;
        }
        for (var j = r.t - this.t; i < j; ++i) {
            r[i + this.t] = this.am(0, a[i], r, i, 0, this.t);
        }
        for (var j = Math.min(a.t, n); i < j; ++i) {
            this.am(0, a[i], r, i, 0, n - i);
        }
        r.clamp();
    };
    // BigInteger.prototype.multiplyUpperTo = bnpMultiplyUpperTo;
    // (protected) r = "this * a" without lower n words, n > 0
    // "this" should be the larger one if appropriate.
    BigInteger.prototype.multiplyUpperTo = function (a, n, r) {
        --n;
        var i = r.t = this.t + a.t - n;
        r.s = 0; // assumes a,this >= 0
        while (--i >= 0) {
            r[i] = 0;
        }
        for (i = Math.max(n - this.t, 0); i < a.t; ++i) {
            r[this.t + i - n] = this.am(n - i, a[i], r, 0, 0, this.t + i - n);
        }
        r.clamp();
        r.drShiftTo(1, r);
    };
    // BigInteger.prototype.modInt = bnpModInt;
    // (protected) this % n, n < 2^26
    BigInteger.prototype.modInt = function (n) {
        if (n <= 0) {
            return 0;
        }
        var d = this.DV % n;
        var r = (this.s < 0) ? n - 1 : 0;
        if (this.t > 0) {
            if (d == 0) {
                r = this[0] % n;
            }
            else {
                for (var i = this.t - 1; i >= 0; --i) {
                    r = (d * r + this[i]) % n;
                }
            }
        }
        return r;
    };
    // BigInteger.prototype.millerRabin = bnpMillerRabin;
    // (protected) true if probably prime (HAC 4.24, Miller-Rabin)
    BigInteger.prototype.millerRabin = function (t) {
        var n1 = this.subtract(BigInteger.ONE);
        var k = n1.getLowestSetBit();
        if (k <= 0) {
            return false;
        }
        var r = n1.shiftRight(k);
        t = (t + 1) >> 1;
        if (t > lowprimes.length) {
            t = lowprimes.length;
        }
        var a = nbi();
        for (var i = 0; i < t; ++i) {
            // Pick bases at random, instead of starting at 2
            a.fromInt(lowprimes[Math.floor(Math.random() * lowprimes.length)]);
            var y = a.modPow(r, this);
            if (y.compareTo(BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
                var j = 1;
                while (j++ < k && y.compareTo(n1) != 0) {
                    y = y.modPowInt(2, this);
                    if (y.compareTo(BigInteger.ONE) == 0) {
                        return false;
                    }
                }
                if (y.compareTo(n1) != 0) {
                    return false;
                }
            }
        }
        return true;
    };
    // BigInteger.prototype.square = bnSquare;
    // (public) this^2
    BigInteger.prototype.square = function () {
        var r = nbi();
        this.squareTo(r);
        return r;
    };
    //#region ASYNC
    // Public API method
    BigInteger.prototype.gcda = function (a, callback) {
        var x = (this.s < 0) ? this.negate() : this.clone();
        var y = (a.s < 0) ? a.negate() : a.clone();
        if (x.compareTo(y) < 0) {
            var t = x;
            x = y;
            y = t;
        }
        var i = x.getLowestSetBit();
        var g = y.getLowestSetBit();
        if (g < 0) {
            callback(x);
            return;
        }
        if (i < g) {
            g = i;
        }
        if (g > 0) {
            x.rShiftTo(g, x);
            y.rShiftTo(g, y);
        }
        // Workhorse of the algorithm, gets called 200 - 800 times per 512 bit keygen.
        var gcda1 = function () {
            if ((i = x.getLowestSetBit()) > 0) {
                x.rShiftTo(i, x);
            }
            if ((i = y.getLowestSetBit()) > 0) {
                y.rShiftTo(i, y);
            }
            if (x.compareTo(y) >= 0) {
                x.subTo(y, x);
                x.rShiftTo(1, x);
            }
            else {
                y.subTo(x, y);
                y.rShiftTo(1, y);
            }
            if (!(x.signum() > 0)) {
                if (g > 0) {
                    y.lShiftTo(g, y);
                }
                setTimeout(function () { callback(y); }, 0); // escape
            }
            else {
                setTimeout(gcda1, 0);
            }
        };
        setTimeout(gcda1, 10);
    };
    // (protected) alternate constructor
    BigInteger.prototype.fromNumberAsync = function (a, b, c, callback) {
        if ("number" == typeof b) {
            if (a < 2) {
                this.fromInt(1);
            }
            else {
                this.fromNumber(a, c);
                if (!this.testBit(a - 1)) {
                    this.bitwiseTo(BigInteger.ONE.shiftLeft(a - 1), _util__WEBPACK_IMPORTED_MODULE_0__["op_or"], this);
                }
                if (this.isEven()) {
                    this.dAddOffset(1, 0);
                }
                var bnp_1 = this;
                var bnpfn1_1 = function () {
                    bnp_1.dAddOffset(2, 0);
                    if (bnp_1.bitLength() > a) {
                        bnp_1.subTo(BigInteger.ONE.shiftLeft(a - 1), bnp_1);
                    }
                    if (bnp_1.isProbablePrime(b)) {
                        setTimeout(function () { callback(); }, 0); // escape
                    }
                    else {
                        setTimeout(bnpfn1_1, 0);
                    }
                };
                setTimeout(bnpfn1_1, 0);
            }
        }
        else {
            var x = [];
            var t = a & 7;
            x.length = (a >> 3) + 1;
            b.nextBytes(x);
            if (t > 0) {
                x[0] &= ((1 << t) - 1);
            }
            else {
                x[0] = 0;
            }
            this.fromString(x, 256);
        }
    };
    return BigInteger;
}());

//#region REDUCERS
//#region NullExp
var NullExp = /** @class */ (function () {
    function NullExp() {
    }
    // NullExp.prototype.convert = nNop;
    NullExp.prototype.convert = function (x) {
        return x;
    };
    // NullExp.prototype.revert = nNop;
    NullExp.prototype.revert = function (x) {
        return x;
    };
    // NullExp.prototype.mulTo = nMulTo;
    NullExp.prototype.mulTo = function (x, y, r) {
        x.multiplyTo(y, r);
    };
    // NullExp.prototype.sqrTo = nSqrTo;
    NullExp.prototype.sqrTo = function (x, r) {
        x.squareTo(r);
    };
    return NullExp;
}());
// Modular reduction using "classic" algorithm
var Classic = /** @class */ (function () {
    function Classic(m) {
        this.m = m;
    }
    // Classic.prototype.convert = cConvert;
    Classic.prototype.convert = function (x) {
        if (x.s < 0 || x.compareTo(this.m) >= 0) {
            return x.mod(this.m);
        }
        else {
            return x;
        }
    };
    // Classic.prototype.revert = cRevert;
    Classic.prototype.revert = function (x) {
        return x;
    };
    // Classic.prototype.reduce = cReduce;
    Classic.prototype.reduce = function (x) {
        x.divRemTo(this.m, null, x);
    };
    // Classic.prototype.mulTo = cMulTo;
    Classic.prototype.mulTo = function (x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    };
    // Classic.prototype.sqrTo = cSqrTo;
    Classic.prototype.sqrTo = function (x, r) {
        x.squareTo(r);
        this.reduce(r);
    };
    return Classic;
}());
//#endregion
//#region Montgomery
// Montgomery reduction
var Montgomery = /** @class */ (function () {
    function Montgomery(m) {
        this.m = m;
        this.mp = m.invDigit();
        this.mpl = this.mp & 0x7fff;
        this.mph = this.mp >> 15;
        this.um = (1 << (m.DB - 15)) - 1;
        this.mt2 = 2 * m.t;
    }
    // Montgomery.prototype.convert = montConvert;
    // xR mod m
    Montgomery.prototype.convert = function (x) {
        var r = nbi();
        x.abs().dlShiftTo(this.m.t, r);
        r.divRemTo(this.m, null, r);
        if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) {
            this.m.subTo(r, r);
        }
        return r;
    };
    // Montgomery.prototype.revert = montRevert;
    // x/R mod m
    Montgomery.prototype.revert = function (x) {
        var r = nbi();
        x.copyTo(r);
        this.reduce(r);
        return r;
    };
    // Montgomery.prototype.reduce = montReduce;
    // x = x/R mod m (HAC 14.32)
    Montgomery.prototype.reduce = function (x) {
        while (x.t <= this.mt2) {
            // pad x so am has enough room later
            x[x.t++] = 0;
        }
        for (var i = 0; i < this.m.t; ++i) {
            // faster way of calculating u0 = x[i]*mp mod DV
            var j = x[i] & 0x7fff;
            var u0 = (j * this.mpl + (((j * this.mph + (x[i] >> 15) * this.mpl) & this.um) << 15)) & x.DM;
            // use am to combine the multiply-shift-add into one call
            j = i + this.m.t;
            x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
            // propagate carry
            while (x[j] >= x.DV) {
                x[j] -= x.DV;
                x[++j]++;
            }
        }
        x.clamp();
        x.drShiftTo(this.m.t, x);
        if (x.compareTo(this.m) >= 0) {
            x.subTo(this.m, x);
        }
    };
    // Montgomery.prototype.mulTo = montMulTo;
    // r = "xy/R mod m"; x,y != r
    Montgomery.prototype.mulTo = function (x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    };
    // Montgomery.prototype.sqrTo = montSqrTo;
    // r = "x^2/R mod m"; x != r
    Montgomery.prototype.sqrTo = function (x, r) {
        x.squareTo(r);
        this.reduce(r);
    };
    return Montgomery;
}());
//#endregion Montgomery
//#region Barrett
// Barrett modular reduction
var Barrett = /** @class */ (function () {
    function Barrett(m) {
        this.m = m;
        // setup Barrett
        this.r2 = nbi();
        this.q3 = nbi();
        BigInteger.ONE.dlShiftTo(2 * m.t, this.r2);
        this.mu = this.r2.divide(m);
    }
    // Barrett.prototype.convert = barrettConvert;
    Barrett.prototype.convert = function (x) {
        if (x.s < 0 || x.t > 2 * this.m.t) {
            return x.mod(this.m);
        }
        else if (x.compareTo(this.m) < 0) {
            return x;
        }
        else {
            var r = nbi();
            x.copyTo(r);
            this.reduce(r);
            return r;
        }
    };
    // Barrett.prototype.revert = barrettRevert;
    Barrett.prototype.revert = function (x) {
        return x;
    };
    // Barrett.prototype.reduce = barrettReduce;
    // x = x mod m (HAC 14.42)
    Barrett.prototype.reduce = function (x) {
        x.drShiftTo(this.m.t - 1, this.r2);
        if (x.t > this.m.t + 1) {
            x.t = this.m.t + 1;
            x.clamp();
        }
        this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
        this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);
        while (x.compareTo(this.r2) < 0) {
            x.dAddOffset(1, this.m.t + 1);
        }
        x.subTo(this.r2, x);
        while (x.compareTo(this.m) >= 0) {
            x.subTo(this.m, x);
        }
    };
    // Barrett.prototype.mulTo = barrettMulTo;
    // r = x*y mod m; x,y != r
    Barrett.prototype.mulTo = function (x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    };
    // Barrett.prototype.sqrTo = barrettSqrTo;
    // r = x^2 mod m; x != r
    Barrett.prototype.sqrTo = function (x, r) {
        x.squareTo(r);
        this.reduce(r);
    };
    return Barrett;
}());
//#endregion
//#endregion REDUCERS
// return new, unset BigInteger
function nbi() { return new BigInteger(null); }
function parseBigInt(str, r) {
    return new BigInteger(str, r);
}
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
var inBrowser = typeof navigator !== "undefined";
if (inBrowser && j_lm && (navigator.appName == "Microsoft Internet Explorer")) {
    // am2 avoids a big mult-and-extract completely.
    // Max digit bits should be <= 30 because we do bitwise ops
    // on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
    BigInteger.prototype.am = function am2(i, x, w, j, c, n) {
        var xl = x & 0x7fff;
        var xh = x >> 15;
        while (--n >= 0) {
            var l = this[i] & 0x7fff;
            var h = this[i++] >> 15;
            var m = xh * l + h * xl;
            l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
            c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
            w[j++] = l & 0x3fffffff;
        }
        return c;
    };
    dbits = 30;
}
else if (inBrowser && j_lm && (navigator.appName != "Netscape")) {
    // am1: use a single mult and divide to get the high bits,
    // max digit bits should be 26 because
    // max internal value = 2*dvalue^2-2*dvalue (< 2^53)
    BigInteger.prototype.am = function am1(i, x, w, j, c, n) {
        while (--n >= 0) {
            var v = x * this[i++] + w[j] + c;
            c = Math.floor(v / 0x4000000);
            w[j++] = v & 0x3ffffff;
        }
        return c;
    };
    dbits = 26;
}
else { // Mozilla/Netscape seems to prefer am3
    // Alternately, set max digit bits to 28 since some
    // browsers slow down when dealing with 32-bit numbers.
    BigInteger.prototype.am = function am3(i, x, w, j, c, n) {
        var xl = x & 0x3fff;
        var xh = x >> 14;
        while (--n >= 0) {
            var l = this[i] & 0x3fff;
            var h = this[i++] >> 14;
            var m = xh * l + h * xl;
            l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
            c = (l >> 28) + (m >> 14) + xh * h;
            w[j++] = l & 0xfffffff;
        }
        return c;
    };
    dbits = 28;
}
BigInteger.prototype.DB = dbits;
BigInteger.prototype.DM = ((1 << dbits) - 1);
BigInteger.prototype.DV = (1 << dbits);
var BI_FP = 52;
BigInteger.prototype.FV = Math.pow(2, BI_FP);
BigInteger.prototype.F1 = BI_FP - dbits;
BigInteger.prototype.F2 = 2 * dbits - BI_FP;
// Digit conversions
var BI_RC = [];
var rr;
var vv;
rr = "0".charCodeAt(0);
for (vv = 0; vv <= 9; ++vv) {
    BI_RC[rr++] = vv;
}
rr = "a".charCodeAt(0);
for (vv = 10; vv < 36; ++vv) {
    BI_RC[rr++] = vv;
}
rr = "A".charCodeAt(0);
for (vv = 10; vv < 36; ++vv) {
    BI_RC[rr++] = vv;
}
function intAt(s, i) {
    var c = BI_RC[s.charCodeAt(i)];
    return (c == null) ? -1 : c;
}
// return bigint initialized to value
function nbv(i) {
    var r = nbi();
    r.fromInt(i);
    return r;
}
// returns bit length of the integer x
function nbits(x) {
    var r = 1;
    var t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
}
// "constants"
BigInteger.ZERO = nbv(0);
BigInteger.ONE = nbv(1);


/***/ }),

/***/ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsbn/prng4.js":
/*!***********************************************************************!*\
  !*** ./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsbn/prng4.js ***!
  \***********************************************************************/
/*! exports provided: Arcfour, prng_newstate, rng_psize */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Arcfour", function() { return Arcfour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prng_newstate", function() { return prng_newstate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rng_psize", function() { return rng_psize; });
// prng4.js - uses Arcfour as a PRNG
var Arcfour = /** @class */ (function () {
    function Arcfour() {
        this.i = 0;
        this.j = 0;
        this.S = [];
    }
    // Arcfour.prototype.init = ARC4init;
    // Initialize arcfour context from key, an array of ints, each from [0..255]
    Arcfour.prototype.init = function (key) {
        var i;
        var j;
        var t;
        for (i = 0; i < 256; ++i) {
            this.S[i] = i;
        }
        j = 0;
        for (i = 0; i < 256; ++i) {
            j = (j + this.S[i] + key[i % key.length]) & 255;
            t = this.S[i];
            this.S[i] = this.S[j];
            this.S[j] = t;
        }
        this.i = 0;
        this.j = 0;
    };
    // Arcfour.prototype.next = ARC4next;
    Arcfour.prototype.next = function () {
        var t;
        this.i = (this.i + 1) & 255;
        this.j = (this.j + this.S[this.i]) & 255;
        t = this.S[this.i];
        this.S[this.i] = this.S[this.j];
        this.S[this.j] = t;
        return this.S[(t + this.S[this.i]) & 255];
    };
    return Arcfour;
}());

// Plug in your RNG constructor here
function prng_newstate() {
    return new Arcfour();
}
// Pool size must be a multiple of 4 and greater than 32.
// An array of bytes the size of the pool will be passed to init()
var rng_psize = 256;


/***/ }),

/***/ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsbn/rng.js":
/*!*********************************************************************!*\
  !*** ./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsbn/rng.js ***!
  \*********************************************************************/
/*! exports provided: SecureRandom */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SecureRandom", function() { return SecureRandom; });
/* harmony import */ var _prng4__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./prng4 */ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsbn/prng4.js");
// Random number generator - requires a PRNG backend, e.g. prng4.js

var rng_state;
var rng_pool = null;
var rng_pptr;
// Initialize the pool with junk if needed.
if (rng_pool == null) {
    rng_pool = [];
    rng_pptr = 0;
    var t = void 0;
    if (window.crypto && window.crypto.getRandomValues) {
        // Extract entropy (2048 bits) from RNG if available
        var z = new Uint32Array(256);
        window.crypto.getRandomValues(z);
        for (t = 0; t < z.length; ++t) {
            rng_pool[rng_pptr++] = z[t] & 255;
        }
    }
    // Use mouse events for entropy, if we do not have enough entropy by the time
    // we need it, entropy will be generated by Math.random.
    var count = 0;
    var onMouseMoveListener_1 = function (ev) {
        count = count || 0;
        if (count >= 256 || rng_pptr >= _prng4__WEBPACK_IMPORTED_MODULE_0__["rng_psize"]) {
            if (window.removeEventListener) {
                window.removeEventListener("mousemove", onMouseMoveListener_1, false);
            }
            else if (window.detachEvent) {
                window.detachEvent("onmousemove", onMouseMoveListener_1);
            }
            return;
        }
        try {
            var mouseCoordinates = ev.x + ev.y;
            rng_pool[rng_pptr++] = mouseCoordinates & 255;
            count += 1;
        }
        catch (e) {
            // Sometimes Firefox will deny permission to access event properties for some reason. Ignore.
        }
    };
    if (window.addEventListener) {
        window.addEventListener("mousemove", onMouseMoveListener_1, false);
    }
    else if (window.attachEvent) {
        window.attachEvent("onmousemove", onMouseMoveListener_1);
    }
}
function rng_get_byte() {
    if (rng_state == null) {
        rng_state = Object(_prng4__WEBPACK_IMPORTED_MODULE_0__["prng_newstate"])();
        // At this point, we may not have collected enough entropy.  If not, fall back to Math.random
        while (rng_pptr < _prng4__WEBPACK_IMPORTED_MODULE_0__["rng_psize"]) {
            var random = Math.floor(65536 * Math.random());
            rng_pool[rng_pptr++] = random & 255;
        }
        rng_state.init(rng_pool);
        for (rng_pptr = 0; rng_pptr < rng_pool.length; ++rng_pptr) {
            rng_pool[rng_pptr] = 0;
        }
        rng_pptr = 0;
    }
    // TODO: allow reseeding after first request
    return rng_state.next();
}
var SecureRandom = /** @class */ (function () {
    function SecureRandom() {
    }
    SecureRandom.prototype.nextBytes = function (ba) {
        for (var i = 0; i < ba.length; ++i) {
            ba[i] = rng_get_byte();
        }
    };
    return SecureRandom;
}());



/***/ }),

/***/ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsbn/rsa.js":
/*!*********************************************************************!*\
  !*** ./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsbn/rsa.js ***!
  \*********************************************************************/
/*! exports provided: RSAKey */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RSAKey", function() { return RSAKey; });
/* harmony import */ var _jsbn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./jsbn */ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsbn/jsbn.js");
/* harmony import */ var _rng__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./rng */ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsbn/rng.js");
// Depends on jsbn.js and rng.js
// Version 1.1: support utf-8 encoding in pkcs1pad2
// convert a (hex) string to a bignum object


// function linebrk(s,n) {
//   var ret = "";
//   var i = 0;
//   while(i + n < s.length) {
//     ret += s.substring(i,i+n) + "\n";
//     i += n;
//   }
//   return ret + s.substring(i,s.length);
// }
// function byte2Hex(b) {
//   if(b < 0x10)
//     return "0" + b.toString(16);
//   else
//     return b.toString(16);
// }
function pkcs1pad1(s, n) {
    if (n < s.length + 22) {
        console.error("Message too long for RSA");
        return null;
    }
    var len = n - s.length - 6;
    var filler = "";
    for (var f = 0; f < len; f += 2) {
        filler += "ff";
    }
    var m = "0001" + filler + "00" + s;
    return Object(_jsbn__WEBPACK_IMPORTED_MODULE_0__["parseBigInt"])(m, 16);
}
// PKCS#1 (type 2, random) pad input string s to n bytes, and return a bigint
function pkcs1pad2(s, n) {
    if (n < s.length + 11) { // TODO: fix for utf-8
        console.error("Message too long for RSA");
        return null;
    }
    var ba = [];
    var i = s.length - 1;
    while (i >= 0 && n > 0) {
        var c = s.charCodeAt(i--);
        if (c < 128) { // encode using utf-8
            ba[--n] = c;
        }
        else if ((c > 127) && (c < 2048)) {
            ba[--n] = (c & 63) | 128;
            ba[--n] = (c >> 6) | 192;
        }
        else {
            ba[--n] = (c & 63) | 128;
            ba[--n] = ((c >> 6) & 63) | 128;
            ba[--n] = (c >> 12) | 224;
        }
    }
    ba[--n] = 0;
    var rng = new _rng__WEBPACK_IMPORTED_MODULE_1__["SecureRandom"]();
    var x = [];
    while (n > 2) { // random non-zero pad
        x[0] = 0;
        while (x[0] == 0) {
            rng.nextBytes(x);
        }
        ba[--n] = x[0];
    }
    ba[--n] = 2;
    ba[--n] = 0;
    return new _jsbn__WEBPACK_IMPORTED_MODULE_0__["BigInteger"](ba);
}
// "empty" RSA key constructor
var RSAKey = /** @class */ (function () {
    function RSAKey() {
        this.n = null;
        this.e = 0;
        this.d = null;
        this.p = null;
        this.q = null;
        this.dmp1 = null;
        this.dmq1 = null;
        this.coeff = null;
    }
    //#region PROTECTED
    // protected
    // RSAKey.prototype.doPublic = RSADoPublic;
    // Perform raw public operation on "x": return x^e (mod n)
    RSAKey.prototype.doPublic = function (x) {
        return x.modPowInt(this.e, this.n);
    };
    // RSAKey.prototype.doPrivate = RSADoPrivate;
    // Perform raw private operation on "x": return x^d (mod n)
    RSAKey.prototype.doPrivate = function (x) {
        if (this.p == null || this.q == null) {
            return x.modPow(this.d, this.n);
        }
        // TODO: re-calculate any missing CRT params
        var xp = x.mod(this.p).modPow(this.dmp1, this.p);
        var xq = x.mod(this.q).modPow(this.dmq1, this.q);
        while (xp.compareTo(xq) < 0) {
            xp = xp.add(this.p);
        }
        return xp.subtract(xq).multiply(this.coeff).mod(this.p).multiply(this.q).add(xq);
    };
    //#endregion PROTECTED
    //#region PUBLIC
    // RSAKey.prototype.setPublic = RSASetPublic;
    // Set the public key fields N and e from hex strings
    RSAKey.prototype.setPublic = function (N, E) {
        if (N != null && E != null && N.length > 0 && E.length > 0) {
            this.n = Object(_jsbn__WEBPACK_IMPORTED_MODULE_0__["parseBigInt"])(N, 16);
            this.e = parseInt(E, 16);
        }
        else {
            console.error("Invalid RSA public key");
        }
    };
    // RSAKey.prototype.encrypt = RSAEncrypt;
    // Return the PKCS#1 RSA encryption of "text" as an even-length hex string
    RSAKey.prototype.encrypt = function (text) {
        var maxLength = (this.n.bitLength() + 7) >> 3;
        var m = pkcs1pad2(text, maxLength);
        if (m == null) {
            return null;
        }
        var c = this.doPublic(m);
        if (c == null) {
            return null;
        }
        var h = c.toString(16);
        var length = h.length;
        // fix zero before result
        for (var i = 0; i < maxLength * 2 - length; i++) {
            h = "0" + h;
        }
        return h;
    };
    // RSAKey.prototype.setPrivate = RSASetPrivate;
    // Set the private key fields N, e, and d from hex strings
    RSAKey.prototype.setPrivate = function (N, E, D) {
        if (N != null && E != null && N.length > 0 && E.length > 0) {
            this.n = Object(_jsbn__WEBPACK_IMPORTED_MODULE_0__["parseBigInt"])(N, 16);
            this.e = parseInt(E, 16);
            this.d = Object(_jsbn__WEBPACK_IMPORTED_MODULE_0__["parseBigInt"])(D, 16);
        }
        else {
            console.error("Invalid RSA private key");
        }
    };
    // RSAKey.prototype.setPrivateEx = RSASetPrivateEx;
    // Set the private key fields N, e, d and CRT params from hex strings
    RSAKey.prototype.setPrivateEx = function (N, E, D, P, Q, DP, DQ, C) {
        if (N != null && E != null && N.length > 0 && E.length > 0) {
            this.n = Object(_jsbn__WEBPACK_IMPORTED_MODULE_0__["parseBigInt"])(N, 16);
            this.e = parseInt(E, 16);
            this.d = Object(_jsbn__WEBPACK_IMPORTED_MODULE_0__["parseBigInt"])(D, 16);
            this.p = Object(_jsbn__WEBPACK_IMPORTED_MODULE_0__["parseBigInt"])(P, 16);
            this.q = Object(_jsbn__WEBPACK_IMPORTED_MODULE_0__["parseBigInt"])(Q, 16);
            this.dmp1 = Object(_jsbn__WEBPACK_IMPORTED_MODULE_0__["parseBigInt"])(DP, 16);
            this.dmq1 = Object(_jsbn__WEBPACK_IMPORTED_MODULE_0__["parseBigInt"])(DQ, 16);
            this.coeff = Object(_jsbn__WEBPACK_IMPORTED_MODULE_0__["parseBigInt"])(C, 16);
        }
        else {
            console.error("Invalid RSA private key");
        }
    };
    // RSAKey.prototype.generate = RSAGenerate;
    // Generate a new random private key B bits long, using public expt E
    RSAKey.prototype.generate = function (B, E) {
        var rng = new _rng__WEBPACK_IMPORTED_MODULE_1__["SecureRandom"]();
        var qs = B >> 1;
        this.e = parseInt(E, 16);
        var ee = new _jsbn__WEBPACK_IMPORTED_MODULE_0__["BigInteger"](E, 16);
        for (;;) {
            for (;;) {
                this.p = new _jsbn__WEBPACK_IMPORTED_MODULE_0__["BigInteger"](B - qs, 1, rng);
                if (this.p.subtract(_jsbn__WEBPACK_IMPORTED_MODULE_0__["BigInteger"].ONE).gcd(ee).compareTo(_jsbn__WEBPACK_IMPORTED_MODULE_0__["BigInteger"].ONE) == 0 && this.p.isProbablePrime(10)) {
                    break;
                }
            }
            for (;;) {
                this.q = new _jsbn__WEBPACK_IMPORTED_MODULE_0__["BigInteger"](qs, 1, rng);
                if (this.q.subtract(_jsbn__WEBPACK_IMPORTED_MODULE_0__["BigInteger"].ONE).gcd(ee).compareTo(_jsbn__WEBPACK_IMPORTED_MODULE_0__["BigInteger"].ONE) == 0 && this.q.isProbablePrime(10)) {
                    break;
                }
            }
            if (this.p.compareTo(this.q) <= 0) {
                var t = this.p;
                this.p = this.q;
                this.q = t;
            }
            var p1 = this.p.subtract(_jsbn__WEBPACK_IMPORTED_MODULE_0__["BigInteger"].ONE);
            var q1 = this.q.subtract(_jsbn__WEBPACK_IMPORTED_MODULE_0__["BigInteger"].ONE);
            var phi = p1.multiply(q1);
            if (phi.gcd(ee).compareTo(_jsbn__WEBPACK_IMPORTED_MODULE_0__["BigInteger"].ONE) == 0) {
                this.n = this.p.multiply(this.q);
                this.d = ee.modInverse(phi);
                this.dmp1 = this.d.mod(p1);
                this.dmq1 = this.d.mod(q1);
                this.coeff = this.q.modInverse(this.p);
                break;
            }
        }
    };
    // RSAKey.prototype.decrypt = RSADecrypt;
    // Return the PKCS#1 RSA decryption of "ctext".
    // "ctext" is an even-length hex string and the output is a plain string.
    RSAKey.prototype.decrypt = function (ctext) {
        var c = Object(_jsbn__WEBPACK_IMPORTED_MODULE_0__["parseBigInt"])(ctext, 16);
        var m = this.doPrivate(c);
        if (m == null) {
            return null;
        }
        return pkcs1unpad2(m, (this.n.bitLength() + 7) >> 3);
    };
    // Generate a new random private key B bits long, using public expt E
    RSAKey.prototype.generateAsync = function (B, E, callback) {
        var rng = new _rng__WEBPACK_IMPORTED_MODULE_1__["SecureRandom"]();
        var qs = B >> 1;
        this.e = parseInt(E, 16);
        var ee = new _jsbn__WEBPACK_IMPORTED_MODULE_0__["BigInteger"](E, 16);
        var rsa = this;
        // These functions have non-descript names because they were originally for(;;) loops.
        // I don't know about cryptography to give them better names than loop1-4.
        var loop1 = function () {
            var loop4 = function () {
                if (rsa.p.compareTo(rsa.q) <= 0) {
                    var t = rsa.p;
                    rsa.p = rsa.q;
                    rsa.q = t;
                }
                var p1 = rsa.p.subtract(_jsbn__WEBPACK_IMPORTED_MODULE_0__["BigInteger"].ONE);
                var q1 = rsa.q.subtract(_jsbn__WEBPACK_IMPORTED_MODULE_0__["BigInteger"].ONE);
                var phi = p1.multiply(q1);
                if (phi.gcd(ee).compareTo(_jsbn__WEBPACK_IMPORTED_MODULE_0__["BigInteger"].ONE) == 0) {
                    rsa.n = rsa.p.multiply(rsa.q);
                    rsa.d = ee.modInverse(phi);
                    rsa.dmp1 = rsa.d.mod(p1);
                    rsa.dmq1 = rsa.d.mod(q1);
                    rsa.coeff = rsa.q.modInverse(rsa.p);
                    setTimeout(function () { callback(); }, 0); // escape
                }
                else {
                    setTimeout(loop1, 0);
                }
            };
            var loop3 = function () {
                rsa.q = Object(_jsbn__WEBPACK_IMPORTED_MODULE_0__["nbi"])();
                rsa.q.fromNumberAsync(qs, 1, rng, function () {
                    rsa.q.subtract(_jsbn__WEBPACK_IMPORTED_MODULE_0__["BigInteger"].ONE).gcda(ee, function (r) {
                        if (r.compareTo(_jsbn__WEBPACK_IMPORTED_MODULE_0__["BigInteger"].ONE) == 0 && rsa.q.isProbablePrime(10)) {
                            setTimeout(loop4, 0);
                        }
                        else {
                            setTimeout(loop3, 0);
                        }
                    });
                });
            };
            var loop2 = function () {
                rsa.p = Object(_jsbn__WEBPACK_IMPORTED_MODULE_0__["nbi"])();
                rsa.p.fromNumberAsync(B - qs, 1, rng, function () {
                    rsa.p.subtract(_jsbn__WEBPACK_IMPORTED_MODULE_0__["BigInteger"].ONE).gcda(ee, function (r) {
                        if (r.compareTo(_jsbn__WEBPACK_IMPORTED_MODULE_0__["BigInteger"].ONE) == 0 && rsa.p.isProbablePrime(10)) {
                            setTimeout(loop3, 0);
                        }
                        else {
                            setTimeout(loop2, 0);
                        }
                    });
                });
            };
            setTimeout(loop2, 0);
        };
        setTimeout(loop1, 0);
    };
    RSAKey.prototype.sign = function (text, digestMethod, digestName) {
        var header = getDigestHeader(digestName);
        var digest = header + digestMethod(text).toString();
        var m = pkcs1pad1(digest, this.n.bitLength() / 4);
        if (m == null) {
            return null;
        }
        var c = this.doPrivate(m);
        if (c == null) {
            return null;
        }
        var h = c.toString(16);
        if ((h.length & 1) == 0) {
            return h;
        }
        else {
            return "0" + h;
        }
    };
    RSAKey.prototype.verify = function (text, signature, digestMethod) {
        var c = Object(_jsbn__WEBPACK_IMPORTED_MODULE_0__["parseBigInt"])(signature, 16);
        var m = this.doPublic(c);
        if (m == null) {
            return null;
        }
        var unpadded = m.toString(16).replace(/^1f+00/, "");
        var digest = removeDigestHeader(unpadded);
        return digest == digestMethod(text).toString();
    };
    return RSAKey;
}());

// Undo PKCS#1 (type 2, random) padding and, if valid, return the plaintext
function pkcs1unpad2(d, n) {
    var b = d.toByteArray();
    var i = 0;
    while (i < b.length && b[i] == 0) {
        ++i;
    }
    if (b.length - i != n - 1 || b[i] != 2) {
        return null;
    }
    ++i;
    while (b[i] != 0) {
        if (++i >= b.length) {
            return null;
        }
    }
    var ret = "";
    while (++i < b.length) {
        var c = b[i] & 255;
        if (c < 128) { // utf-8 decode
            ret += String.fromCharCode(c);
        }
        else if ((c > 191) && (c < 224)) {
            ret += String.fromCharCode(((c & 31) << 6) | (b[i + 1] & 63));
            ++i;
        }
        else {
            ret += String.fromCharCode(((c & 15) << 12) | ((b[i + 1] & 63) << 6) | (b[i + 2] & 63));
            i += 2;
        }
    }
    return ret;
}
// https://tools.ietf.org/html/rfc3447#page-43
var DIGEST_HEADERS = {
    md2: "3020300c06082a864886f70d020205000410",
    md5: "3020300c06082a864886f70d020505000410",
    sha1: "3021300906052b0e03021a05000414",
    sha224: "302d300d06096086480165030402040500041c",
    sha256: "3031300d060960864801650304020105000420",
    sha384: "3041300d060960864801650304020205000430",
    sha512: "3051300d060960864801650304020305000440",
    ripemd160: "3021300906052b2403020105000414"
};
function getDigestHeader(name) {
    return DIGEST_HEADERS[name] || "";
}
function removeDigestHeader(str) {
    for (var name_1 in DIGEST_HEADERS) {
        if (DIGEST_HEADERS.hasOwnProperty(name_1)) {
            var header = DIGEST_HEADERS[name_1];
            var len = header.length;
            if (str.substr(0, len) == header) {
                return str.substr(len);
            }
        }
    }
    return str;
}
// Return the PKCS#1 RSA encryption of "text" as a Base64-encoded string
// function RSAEncryptB64(text) {
//  var h = this.encrypt(text);
//  if(h) return hex2b64(h); else return null;
// }
// public
// RSAKey.prototype.encrypt_b64 = RSAEncryptB64;


/***/ }),

/***/ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsbn/util.js":
/*!**********************************************************************!*\
  !*** ./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsbn/util.js ***!
  \**********************************************************************/
/*! exports provided: int2char, op_and, op_or, op_xor, op_andnot, lbit, cbit */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "int2char", function() { return int2char; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "op_and", function() { return op_and; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "op_or", function() { return op_or; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "op_xor", function() { return op_xor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "op_andnot", function() { return op_andnot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lbit", function() { return lbit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cbit", function() { return cbit; });
var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
function int2char(n) {
    return BI_RM.charAt(n);
}
//#region BIT_OPERATIONS
// (public) this & a
function op_and(x, y) {
    return x & y;
}
// (public) this | a
function op_or(x, y) {
    return x | y;
}
// (public) this ^ a
function op_xor(x, y) {
    return x ^ y;
}
// (public) this & ~a
function op_andnot(x, y) {
    return x & ~y;
}
// return index of lowest 1-bit in x, x < 2^31
function lbit(x) {
    if (x == 0) {
        return -1;
    }
    var r = 0;
    if ((x & 0xffff) == 0) {
        x >>= 16;
        r += 16;
    }
    if ((x & 0xff) == 0) {
        x >>= 8;
        r += 8;
    }
    if ((x & 0xf) == 0) {
        x >>= 4;
        r += 4;
    }
    if ((x & 3) == 0) {
        x >>= 2;
        r += 2;
    }
    if ((x & 1) == 0) {
        ++r;
    }
    return r;
}
// return number of 1 bits in x
function cbit(x) {
    var r = 0;
    while (x != 0) {
        x &= x - 1;
        ++r;
    }
    return r;
}
//#endregion BIT_OPERATIONS


/***/ }),

/***/ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsrsasign/asn1-1.0.js":
/*!*******************************************************************************!*\
  !*** ./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsrsasign/asn1-1.0.js ***!
  \*******************************************************************************/
/*! exports provided: KJUR */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KJUR", function() { return KJUR; });
/* harmony import */ var _jsbn_jsbn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../jsbn/jsbn */ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsbn/jsbn.js");
/* harmony import */ var _yahoo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./yahoo */ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsrsasign/yahoo.js");
/* asn1-1.0.13.js (c) 2013-2017 Kenji Urushima | kjur.github.com/jsrsasign/license
 */
/*
 * asn1.js - ASN.1 DER encoder classes
 *
 * Copyright (c) 2013-2017 Kenji Urushima (kenji.urushima@gmail.com)
 *
 * This software is licensed under the terms of the MIT License.
 * https://kjur.github.io/jsrsasign/license
 *
 * The above copyright and license notice shall be
 * included in all copies or substantial portions of the Software.
 */


/**
 * @fileOverview
 * @name asn1-1.0.js
 * @author Kenji Urushima kenji.urushima@gmail.com
 * @version asn1 1.0.13 (2017-Jun-02)
 * @since jsrsasign 2.1
 * @license <a href="https://kjur.github.io/jsrsasign/license/">MIT License</a>
 */
/**
 * kjur's class library name space
 * <p>
 * This name space provides following name spaces:
 * <ul>
 * <li>{@link KJUR.asn1} - ASN.1 primitive hexadecimal encoder</li>
 * <li>{@link KJUR.asn1.x509} - ASN.1 structure for X.509 certificate and CRL</li>
 * <li>{@link KJUR.crypto} - Java Cryptographic Extension(JCE) style MessageDigest/Signature
 * class and utilities</li>
 * </ul>
 * </p>
 * NOTE: Please ignore method summary and document of this namespace. This caused by a bug of jsdoc2.
 * @name KJUR
 * @namespace kjur's class library name space
 */
var KJUR = {};
/**
 * kjur's ASN.1 class library name space
 * <p>
 * This is ITU-T X.690 ASN.1 DER encoder class library and
 * class structure and methods is very similar to
 * org.bouncycastle.asn1 package of
 * well known BouncyCaslte Cryptography Library.
 * <h4>PROVIDING ASN.1 PRIMITIVES</h4>
 * Here are ASN.1 DER primitive classes.
 * <ul>
 * <li>0x01 {@link KJUR.asn1.DERBoolean}</li>
 * <li>0x02 {@link KJUR.asn1.DERInteger}</li>
 * <li>0x03 {@link KJUR.asn1.DERBitString}</li>
 * <li>0x04 {@link KJUR.asn1.DEROctetString}</li>
 * <li>0x05 {@link KJUR.asn1.DERNull}</li>
 * <li>0x06 {@link KJUR.asn1.DERObjectIdentifier}</li>
 * <li>0x0a {@link KJUR.asn1.DEREnumerated}</li>
 * <li>0x0c {@link KJUR.asn1.DERUTF8String}</li>
 * <li>0x12 {@link KJUR.asn1.DERNumericString}</li>
 * <li>0x13 {@link KJUR.asn1.DERPrintableString}</li>
 * <li>0x14 {@link KJUR.asn1.DERTeletexString}</li>
 * <li>0x16 {@link KJUR.asn1.DERIA5String}</li>
 * <li>0x17 {@link KJUR.asn1.DERUTCTime}</li>
 * <li>0x18 {@link KJUR.asn1.DERGeneralizedTime}</li>
 * <li>0x30 {@link KJUR.asn1.DERSequence}</li>
 * <li>0x31 {@link KJUR.asn1.DERSet}</li>
 * </ul>
 * <h4>OTHER ASN.1 CLASSES</h4>
 * <ul>
 * <li>{@link KJUR.asn1.ASN1Object}</li>
 * <li>{@link KJUR.asn1.DERAbstractString}</li>
 * <li>{@link KJUR.asn1.DERAbstractTime}</li>
 * <li>{@link KJUR.asn1.DERAbstractStructured}</li>
 * <li>{@link KJUR.asn1.DERTaggedObject}</li>
 * </ul>
 * <h4>SUB NAME SPACES</h4>
 * <ul>
 * <li>{@link KJUR.asn1.cades} - CAdES long term signature format</li>
 * <li>{@link KJUR.asn1.cms} - Cryptographic Message Syntax</li>
 * <li>{@link KJUR.asn1.csr} - Certificate Signing Request (CSR/PKCS#10)</li>
 * <li>{@link KJUR.asn1.tsp} - RFC 3161 Timestamping Protocol Format</li>
 * <li>{@link KJUR.asn1.x509} - RFC 5280 X.509 certificate and CRL</li>
 * </ul>
 * </p>
 * NOTE: Please ignore method summary and document of this namespace.
 * This caused by a bug of jsdoc2.
 * @name KJUR.asn1
 * @namespace
 */
if (typeof KJUR.asn1 == "undefined" || !KJUR.asn1)
    KJUR.asn1 = {};
/**
 * ASN1 utilities class
 * @name KJUR.asn1.ASN1Util
 * @class ASN1 utilities class
 * @since asn1 1.0.2
 */
KJUR.asn1.ASN1Util = new function () {
    this.integerToByteHex = function (i) {
        var h = i.toString(16);
        if ((h.length % 2) == 1)
            h = '0' + h;
        return h;
    };
    this.bigIntToMinTwosComplementsHex = function (bigIntegerValue) {
        var h = bigIntegerValue.toString(16);
        if (h.substr(0, 1) != '-') {
            if (h.length % 2 == 1) {
                h = '0' + h;
            }
            else {
                if (!h.match(/^[0-7]/)) {
                    h = '00' + h;
                }
            }
        }
        else {
            var hPos = h.substr(1);
            var xorLen = hPos.length;
            if (xorLen % 2 == 1) {
                xorLen += 1;
            }
            else {
                if (!h.match(/^[0-7]/)) {
                    xorLen += 2;
                }
            }
            var hMask = '';
            for (var i = 0; i < xorLen; i++) {
                hMask += 'f';
            }
            var biMask = new _jsbn_jsbn__WEBPACK_IMPORTED_MODULE_0__["BigInteger"](hMask, 16);
            var biNeg = biMask.xor(bigIntegerValue).add(_jsbn_jsbn__WEBPACK_IMPORTED_MODULE_0__["BigInteger"].ONE);
            h = biNeg.toString(16).replace(/^-/, '');
        }
        return h;
    };
    /**
     * get PEM string from hexadecimal data and header string
     * @name getPEMStringFromHex
     * @memberOf KJUR.asn1.ASN1Util
     * @function
     * @param {String} dataHex hexadecimal string of PEM body
     * @param {String} pemHeader PEM header string (ex. 'RSA PRIVATE KEY')
     * @return {String} PEM formatted string of input data
     * @description
     * This method converts a hexadecimal string to a PEM string with
     * a specified header. Its line break will be CRLF("\r\n").
     * @example
     * var pem  = KJUR.asn1.ASN1Util.getPEMStringFromHex('616161', 'RSA PRIVATE KEY');
     * // value of pem will be:
     * -----BEGIN PRIVATE KEY-----
     * YWFh
     * -----END PRIVATE KEY-----
     */
    this.getPEMStringFromHex = function (dataHex, pemHeader) {
        return hextopem(dataHex, pemHeader);
    };
    /**
     * generate ASN1Object specifed by JSON parameters
     * @name newObject
     * @memberOf KJUR.asn1.ASN1Util
     * @function
     * @param {Array} param JSON parameter to generate ASN1Object
     * @return {KJUR.asn1.ASN1Object} generated object
     * @since asn1 1.0.3
     * @description
     * generate any ASN1Object specified by JSON param
     * including ASN.1 primitive or structured.
     * Generally 'param' can be described as follows:
     * <blockquote>
     * {TYPE-OF-ASNOBJ: ASN1OBJ-PARAMETER}
     * </blockquote>
     * 'TYPE-OF-ASN1OBJ' can be one of following symbols:
     * <ul>
     * <li>'bool' - DERBoolean</li>
     * <li>'int' - DERInteger</li>
     * <li>'bitstr' - DERBitString</li>
     * <li>'octstr' - DEROctetString</li>
     * <li>'null' - DERNull</li>
     * <li>'oid' - DERObjectIdentifier</li>
     * <li>'enum' - DEREnumerated</li>
     * <li>'utf8str' - DERUTF8String</li>
     * <li>'numstr' - DERNumericString</li>
     * <li>'prnstr' - DERPrintableString</li>
     * <li>'telstr' - DERTeletexString</li>
     * <li>'ia5str' - DERIA5String</li>
     * <li>'utctime' - DERUTCTime</li>
     * <li>'gentime' - DERGeneralizedTime</li>
     * <li>'seq' - DERSequence</li>
     * <li>'set' - DERSet</li>
     * <li>'tag' - DERTaggedObject</li>
     * </ul>
     * @example
     * newObject({'prnstr': 'aaa'});
     * newObject({'seq': [{'int': 3}, {'prnstr': 'aaa'}]})
     * // ASN.1 Tagged Object
     * newObject({'tag': {'tag': 'a1',
     *                    'explicit': true,
     *                    'obj': {'seq': [{'int': 3}, {'prnstr': 'aaa'}]}}});
     * // more simple representation of ASN.1 Tagged Object
     * newObject({'tag': ['a1',
     *                    true,
     *                    {'seq': [
     *                      {'int': 3},
     *                      {'prnstr': 'aaa'}]}
     *                   ]});
     */
    this.newObject = function (param) {
        var _KJUR = KJUR, _KJUR_asn1 = _KJUR.asn1, _DERBoolean = _KJUR_asn1.DERBoolean, _DERInteger = _KJUR_asn1.DERInteger, _DERBitString = _KJUR_asn1.DERBitString, _DEROctetString = _KJUR_asn1.DEROctetString, _DERNull = _KJUR_asn1.DERNull, _DERObjectIdentifier = _KJUR_asn1.DERObjectIdentifier, _DEREnumerated = _KJUR_asn1.DEREnumerated, _DERUTF8String = _KJUR_asn1.DERUTF8String, _DERNumericString = _KJUR_asn1.DERNumericString, _DERPrintableString = _KJUR_asn1.DERPrintableString, _DERTeletexString = _KJUR_asn1.DERTeletexString, _DERIA5String = _KJUR_asn1.DERIA5String, _DERUTCTime = _KJUR_asn1.DERUTCTime, _DERGeneralizedTime = _KJUR_asn1.DERGeneralizedTime, _DERSequence = _KJUR_asn1.DERSequence, _DERSet = _KJUR_asn1.DERSet, _DERTaggedObject = _KJUR_asn1.DERTaggedObject, _newObject = _KJUR_asn1.ASN1Util.newObject;
        var keys = Object.keys(param);
        if (keys.length != 1)
            throw "key of param shall be only one.";
        var key = keys[0];
        if (":bool:int:bitstr:octstr:null:oid:enum:utf8str:numstr:prnstr:telstr:ia5str:utctime:gentime:seq:set:tag:".indexOf(":" + key + ":") == -1)
            throw "undefined key: " + key;
        if (key == "bool")
            return new _DERBoolean(param[key]);
        if (key == "int")
            return new _DERInteger(param[key]);
        if (key == "bitstr")
            return new _DERBitString(param[key]);
        if (key == "octstr")
            return new _DEROctetString(param[key]);
        if (key == "null")
            return new _DERNull(param[key]);
        if (key == "oid")
            return new _DERObjectIdentifier(param[key]);
        if (key == "enum")
            return new _DEREnumerated(param[key]);
        if (key == "utf8str")
            return new _DERUTF8String(param[key]);
        if (key == "numstr")
            return new _DERNumericString(param[key]);
        if (key == "prnstr")
            return new _DERPrintableString(param[key]);
        if (key == "telstr")
            return new _DERTeletexString(param[key]);
        if (key == "ia5str")
            return new _DERIA5String(param[key]);
        if (key == "utctime")
            return new _DERUTCTime(param[key]);
        if (key == "gentime")
            return new _DERGeneralizedTime(param[key]);
        if (key == "seq") {
            var paramList = param[key];
            var a = [];
            for (var i = 0; i < paramList.length; i++) {
                var asn1Obj = _newObject(paramList[i]);
                a.push(asn1Obj);
            }
            return new _DERSequence({ 'array': a });
        }
        if (key == "set") {
            var paramList = param[key];
            var a = [];
            for (var i = 0; i < paramList.length; i++) {
                var asn1Obj = _newObject(paramList[i]);
                a.push(asn1Obj);
            }
            return new _DERSet({ 'array': a });
        }
        if (key == "tag") {
            var tagParam = param[key];
            if (Object.prototype.toString.call(tagParam) === '[object Array]' &&
                tagParam.length == 3) {
                var obj = _newObject(tagParam[2]);
                return new _DERTaggedObject({ tag: tagParam[0],
                    explicit: tagParam[1],
                    obj: obj });
            }
            else {
                var newParam = {};
                if (tagParam.explicit !== undefined)
                    newParam.explicit = tagParam.explicit;
                if (tagParam.tag !== undefined)
                    newParam.tag = tagParam.tag;
                if (tagParam.obj === undefined)
                    throw "obj shall be specified for 'tag'.";
                newParam.obj = _newObject(tagParam.obj);
                return new _DERTaggedObject(newParam);
            }
        }
    };
    /**
     * get encoded hexadecimal string of ASN1Object specifed by JSON parameters
     * @name jsonToASN1HEX
     * @memberOf KJUR.asn1.ASN1Util
     * @function
     * @param {Array} param JSON parameter to generate ASN1Object
     * @return hexadecimal string of ASN1Object
     * @since asn1 1.0.4
     * @description
     * As for ASN.1 object representation of JSON object,
     * please see {@link newObject}.
     * @example
     * jsonToASN1HEX({'prnstr': 'aaa'});
     */
    this.jsonToASN1HEX = function (param) {
        var asn1Obj = this.newObject(param);
        return asn1Obj.getEncodedHex();
    };
};
/**
 * get dot noted oid number string from hexadecimal value of OID
 * @name oidHexToInt
 * @memberOf KJUR.asn1.ASN1Util
 * @function
 * @param {String} hex hexadecimal value of object identifier
 * @return {String} dot noted string of object identifier
 * @since jsrsasign 4.8.3 asn1 1.0.7
 * @description
 * This static method converts from hexadecimal string representation of
 * ASN.1 value of object identifier to oid number string.
 * @example
 * KJUR.asn1.ASN1Util.oidHexToInt('550406') &rarr; "2.5.4.6"
 */
KJUR.asn1.ASN1Util.oidHexToInt = function (hex) {
    var s = "";
    var i01 = parseInt(hex.substr(0, 2), 16);
    var i0 = Math.floor(i01 / 40);
    var i1 = i01 % 40;
    var s = i0 + "." + i1;
    var binbuf = "";
    for (var i = 2; i < hex.length; i += 2) {
        var value = parseInt(hex.substr(i, 2), 16);
        var bin = ("00000000" + value.toString(2)).slice(-8);
        binbuf = binbuf + bin.substr(1, 7);
        if (bin.substr(0, 1) == "0") {
            var bi = new _jsbn_jsbn__WEBPACK_IMPORTED_MODULE_0__["BigInteger"](binbuf, 2);
            s = s + "." + bi.toString(10);
            binbuf = "";
        }
    }
    ;
    return s;
};
/**
 * get hexadecimal value of object identifier from dot noted oid value
 * @name oidIntToHex
 * @memberOf KJUR.asn1.ASN1Util
 * @function
 * @param {String} oidString dot noted string of object identifier
 * @return {String} hexadecimal value of object identifier
 * @since jsrsasign 4.8.3 asn1 1.0.7
 * @description
 * This static method converts from object identifier value string.
 * to hexadecimal string representation of it.
 * @example
 * KJUR.asn1.ASN1Util.oidIntToHex("2.5.4.6") &rarr; "550406"
 */
KJUR.asn1.ASN1Util.oidIntToHex = function (oidString) {
    var itox = function (i) {
        var h = i.toString(16);
        if (h.length == 1)
            h = '0' + h;
        return h;
    };
    var roidtox = function (roid) {
        var h = '';
        var bi = new _jsbn_jsbn__WEBPACK_IMPORTED_MODULE_0__["BigInteger"](roid, 10);
        var b = bi.toString(2);
        var padLen = 7 - b.length % 7;
        if (padLen == 7)
            padLen = 0;
        var bPad = '';
        for (var i = 0; i < padLen; i++)
            bPad += '0';
        b = bPad + b;
        for (var i = 0; i < b.length - 1; i += 7) {
            var b8 = b.substr(i, 7);
            if (i != b.length - 7)
                b8 = '1' + b8;
            h += itox(parseInt(b8, 2));
        }
        return h;
    };
    if (!oidString.match(/^[0-9.]+$/)) {
        throw "malformed oid string: " + oidString;
    }
    var h = '';
    var a = oidString.split('.');
    var i0 = parseInt(a[0]) * 40 + parseInt(a[1]);
    h += itox(i0);
    a.splice(0, 2);
    for (var i = 0; i < a.length; i++) {
        h += roidtox(a[i]);
    }
    return h;
};
// ********************************************************************
//  Abstract ASN.1 Classes
// ********************************************************************
// ********************************************************************
/**
 * base class for ASN.1 DER encoder object
 * @name KJUR.asn1.ASN1Object
 * @class base class for ASN.1 DER encoder object
 * @property {Boolean} isModified flag whether internal data was changed
 * @property {String} hTLV hexadecimal string of ASN.1 TLV
 * @property {String} hT hexadecimal string of ASN.1 TLV tag(T)
 * @property {String} hL hexadecimal string of ASN.1 TLV length(L)
 * @property {String} hV hexadecimal string of ASN.1 TLV value(V)
 * @description
 */
KJUR.asn1.ASN1Object = function () {
    var isModified = true;
    var hTLV = null;
    var hT = '00';
    var hL = '00';
    var hV = '';
    /**
     * get hexadecimal ASN.1 TLV length(L) bytes from TLV value(V)
     * @name getLengthHexFromValue
     * @memberOf KJUR.asn1.ASN1Object#
     * @function
     * @return {String} hexadecimal string of ASN.1 TLV length(L)
     */
    this.getLengthHexFromValue = function () {
        if (typeof this.hV == "undefined" || this.hV == null) {
            throw "this.hV is null or undefined.";
        }
        if (this.hV.length % 2 == 1) {
            throw "value hex must be even length: n=" + hV.length + ",v=" + this.hV;
        }
        var n = this.hV.length / 2;
        var hN = n.toString(16);
        if (hN.length % 2 == 1) {
            hN = "0" + hN;
        }
        if (n < 128) {
            return hN;
        }
        else {
            var hNlen = hN.length / 2;
            if (hNlen > 15) {
                throw "ASN.1 length too long to represent by 8x: n = " + n.toString(16);
            }
            var head = 128 + hNlen;
            return head.toString(16) + hN;
        }
    };
    /**
     * get hexadecimal string of ASN.1 TLV bytes
     * @name getEncodedHex
     * @memberOf KJUR.asn1.ASN1Object#
     * @function
     * @return {String} hexadecimal string of ASN.1 TLV
     */
    this.getEncodedHex = function () {
        if (this.hTLV == null || this.isModified) {
            this.hV = this.getFreshValueHex();
            this.hL = this.getLengthHexFromValue();
            this.hTLV = this.hT + this.hL + this.hV;
            this.isModified = false;
            //alert("first time: " + this.hTLV);
        }
        return this.hTLV;
    };
    /**
     * get hexadecimal string of ASN.1 TLV value(V) bytes
     * @name getValueHex
     * @memberOf KJUR.asn1.ASN1Object#
     * @function
     * @return {String} hexadecimal string of ASN.1 TLV value(V) bytes
     */
    this.getValueHex = function () {
        this.getEncodedHex();
        return this.hV;
    };
    this.getFreshValueHex = function () {
        return '';
    };
};
// == BEGIN DERAbstractString ================================================
/**
 * base class for ASN.1 DER string classes
 * @name KJUR.asn1.DERAbstractString
 * @class base class for ASN.1 DER string classes
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @property {String} s internal string of value
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>str - specify initial ASN.1 value(V) by a string</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 */
KJUR.asn1.DERAbstractString = function (params) {
    KJUR.asn1.DERAbstractString.superclass.constructor.call(this);
    var s = null;
    var hV = null;
    /**
     * get string value of this string object
     * @name getString
     * @memberOf KJUR.asn1.DERAbstractString#
     * @function
     * @return {String} string value of this string object
     */
    this.getString = function () {
        return this.s;
    };
    /**
     * set value by a string
     * @name setString
     * @memberOf KJUR.asn1.DERAbstractString#
     * @function
     * @param {String} newS value by a string to set
     */
    this.setString = function (newS) {
        this.hTLV = null;
        this.isModified = true;
        this.s = newS;
        this.hV = stohex(this.s);
    };
    /**
     * set value by a hexadecimal string
     * @name setStringHex
     * @memberOf KJUR.asn1.DERAbstractString#
     * @function
     * @param {String} newHexString value by a hexadecimal string to set
     */
    this.setStringHex = function (newHexString) {
        this.hTLV = null;
        this.isModified = true;
        this.s = null;
        this.hV = newHexString;
    };
    this.getFreshValueHex = function () {
        return this.hV;
    };
    if (typeof params != "undefined") {
        if (typeof params == "string") {
            this.setString(params);
        }
        else if (typeof params['str'] != "undefined") {
            this.setString(params['str']);
        }
        else if (typeof params['hex'] != "undefined") {
            this.setStringHex(params['hex']);
        }
    }
};
_yahoo__WEBPACK_IMPORTED_MODULE_1__["YAHOO"].lang.extend(KJUR.asn1.DERAbstractString, KJUR.asn1.ASN1Object);
// == END   DERAbstractString ================================================
// == BEGIN DERAbstractTime ==================================================
/**
 * base class for ASN.1 DER Generalized/UTCTime class
 * @name KJUR.asn1.DERAbstractTime
 * @class base class for ASN.1 DER Generalized/UTCTime class
 * @param {Array} params associative array of parameters (ex. {'str': '130430235959Z'})
 * @extends KJUR.asn1.ASN1Object
 * @description
 * @see KJUR.asn1.ASN1Object - superclass
 */
KJUR.asn1.DERAbstractTime = function (params) {
    KJUR.asn1.DERAbstractTime.superclass.constructor.call(this);
    var s = null;
    var date = null;
    // --- PRIVATE METHODS --------------------
    this.localDateToUTC = function (d) {
        utc = d.getTime() + (d.getTimezoneOffset() * 60000);
        var utcDate = new Date(utc);
        return utcDate;
    };
    /*
     * format date string by Data object
     * @name formatDate
     * @memberOf KJUR.asn1.AbstractTime;
     * @param {Date} dateObject
     * @param {string} type 'utc' or 'gen'
     * @param {boolean} withMillis flag for with millisections or not
     * @description
     * 'withMillis' flag is supported from asn1 1.0.6.
     */
    this.formatDate = function (dateObject, type, withMillis) {
        var pad = this.zeroPadding;
        var d = this.localDateToUTC(dateObject);
        var year = String(d.getFullYear());
        if (type == 'utc')
            year = year.substr(2, 2);
        var month = pad(String(d.getMonth() + 1), 2);
        var day = pad(String(d.getDate()), 2);
        var hour = pad(String(d.getHours()), 2);
        var min = pad(String(d.getMinutes()), 2);
        var sec = pad(String(d.getSeconds()), 2);
        var s = year + month + day + hour + min + sec;
        if (withMillis === true) {
            var millis = d.getMilliseconds();
            if (millis != 0) {
                var sMillis = pad(String(millis), 3);
                sMillis = sMillis.replace(/[0]+$/, "");
                s = s + "." + sMillis;
            }
        }
        return s + "Z";
    };
    this.zeroPadding = function (s, len) {
        if (s.length >= len)
            return s;
        return new Array(len - s.length + 1).join('0') + s;
    };
    // --- PUBLIC METHODS --------------------
    /**
     * get string value of this string object
     * @name getString
     * @memberOf KJUR.asn1.DERAbstractTime#
     * @function
     * @return {String} string value of this time object
     */
    this.getString = function () {
        return this.s;
    };
    /**
     * set value by a string
     * @name setString
     * @memberOf KJUR.asn1.DERAbstractTime#
     * @function
     * @param {String} newS value by a string to set such like "130430235959Z"
     */
    this.setString = function (newS) {
        this.hTLV = null;
        this.isModified = true;
        this.s = newS;
        this.hV = stohex(newS);
    };
    /**
     * set value by a Date object
     * @name setByDateValue
     * @memberOf KJUR.asn1.DERAbstractTime#
     * @function
     * @param {Integer} year year of date (ex. 2013)
     * @param {Integer} month month of date between 1 and 12 (ex. 12)
     * @param {Integer} day day of month
     * @param {Integer} hour hours of date
     * @param {Integer} min minutes of date
     * @param {Integer} sec seconds of date
     */
    this.setByDateValue = function (year, month, day, hour, min, sec) {
        var dateObject = new Date(Date.UTC(year, month - 1, day, hour, min, sec, 0));
        this.setByDate(dateObject);
    };
    this.getFreshValueHex = function () {
        return this.hV;
    };
};
_yahoo__WEBPACK_IMPORTED_MODULE_1__["YAHOO"].lang.extend(KJUR.asn1.DERAbstractTime, KJUR.asn1.ASN1Object);
// == END   DERAbstractTime ==================================================
// == BEGIN DERAbstractStructured ============================================
/**
 * base class for ASN.1 DER structured class
 * @name KJUR.asn1.DERAbstractStructured
 * @class base class for ASN.1 DER structured class
 * @property {Array} asn1Array internal array of ASN1Object
 * @extends KJUR.asn1.ASN1Object
 * @description
 * @see KJUR.asn1.ASN1Object - superclass
 */
KJUR.asn1.DERAbstractStructured = function (params) {
    KJUR.asn1.DERAbstractString.superclass.constructor.call(this);
    var asn1Array = null;
    /**
     * set value by array of ASN1Object
     * @name setByASN1ObjectArray
     * @memberOf KJUR.asn1.DERAbstractStructured#
     * @function
     * @param {array} asn1ObjectArray array of ASN1Object to set
     */
    this.setByASN1ObjectArray = function (asn1ObjectArray) {
        this.hTLV = null;
        this.isModified = true;
        this.asn1Array = asn1ObjectArray;
    };
    /**
     * append an ASN1Object to internal array
     * @name appendASN1Object
     * @memberOf KJUR.asn1.DERAbstractStructured#
     * @function
     * @param {ASN1Object} asn1Object to add
     */
    this.appendASN1Object = function (asn1Object) {
        this.hTLV = null;
        this.isModified = true;
        this.asn1Array.push(asn1Object);
    };
    this.asn1Array = new Array();
    if (typeof params != "undefined") {
        if (typeof params['array'] != "undefined") {
            this.asn1Array = params['array'];
        }
    }
};
_yahoo__WEBPACK_IMPORTED_MODULE_1__["YAHOO"].lang.extend(KJUR.asn1.DERAbstractStructured, KJUR.asn1.ASN1Object);
// ********************************************************************
//  ASN.1 Object Classes
// ********************************************************************
// ********************************************************************
/**
 * class for ASN.1 DER Boolean
 * @name KJUR.asn1.DERBoolean
 * @class class for ASN.1 DER Boolean
 * @extends KJUR.asn1.ASN1Object
 * @description
 * @see KJUR.asn1.ASN1Object - superclass
 */
KJUR.asn1.DERBoolean = function () {
    KJUR.asn1.DERBoolean.superclass.constructor.call(this);
    this.hT = "01";
    this.hTLV = "0101ff";
};
_yahoo__WEBPACK_IMPORTED_MODULE_1__["YAHOO"].lang.extend(KJUR.asn1.DERBoolean, KJUR.asn1.ASN1Object);
// ********************************************************************
/**
 * class for ASN.1 DER Integer
 * @name KJUR.asn1.DERInteger
 * @class class for ASN.1 DER Integer
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>int - specify initial ASN.1 value(V) by integer value</li>
 * <li>bigint - specify initial ASN.1 value(V) by BigInteger object</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 */
KJUR.asn1.DERInteger = function (params) {
    KJUR.asn1.DERInteger.superclass.constructor.call(this);
    this.hT = "02";
    /**
     * set value by Tom Wu's BigInteger object
     * @name setByBigInteger
     * @memberOf KJUR.asn1.DERInteger#
     * @function
     * @param {BigInteger} bigIntegerValue to set
     */
    this.setByBigInteger = function (bigIntegerValue) {
        this.hTLV = null;
        this.isModified = true;
        this.hV = KJUR.asn1.ASN1Util.bigIntToMinTwosComplementsHex(bigIntegerValue);
    };
    /**
     * set value by integer value
     * @name setByInteger
     * @memberOf KJUR.asn1.DERInteger
     * @function
     * @param {Integer} integer value to set
     */
    this.setByInteger = function (intValue) {
        var bi = new _jsbn_jsbn__WEBPACK_IMPORTED_MODULE_0__["BigInteger"](String(intValue), 10);
        this.setByBigInteger(bi);
    };
    /**
     * set value by integer value
     * @name setValueHex
     * @memberOf KJUR.asn1.DERInteger#
     * @function
     * @param {String} hexadecimal string of integer value
     * @description
     * <br/>
     * NOTE: Value shall be represented by minimum octet length of
     * two's complement representation.
     * @example
     * new KJUR.asn1.DERInteger(123);
     * new KJUR.asn1.DERInteger({'int': 123});
     * new KJUR.asn1.DERInteger({'hex': '1fad'});
     */
    this.setValueHex = function (newHexString) {
        this.hV = newHexString;
    };
    this.getFreshValueHex = function () {
        return this.hV;
    };
    if (typeof params != "undefined") {
        if (typeof params['bigint'] != "undefined") {
            this.setByBigInteger(params['bigint']);
        }
        else if (typeof params['int'] != "undefined") {
            this.setByInteger(params['int']);
        }
        else if (typeof params == "number") {
            this.setByInteger(params);
        }
        else if (typeof params['hex'] != "undefined") {
            this.setValueHex(params['hex']);
        }
    }
};
_yahoo__WEBPACK_IMPORTED_MODULE_1__["YAHOO"].lang.extend(KJUR.asn1.DERInteger, KJUR.asn1.ASN1Object);
// ********************************************************************
/**
 * class for ASN.1 DER encoded BitString primitive
 * @name KJUR.asn1.DERBitString
 * @class class for ASN.1 DER encoded BitString primitive
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>bin - specify binary string (ex. '10111')</li>
 * <li>array - specify array of boolean (ex. [true,false,true,true])</li>
 * <li>hex - specify hexadecimal string of ASN.1 value(V) including unused bits</li>
 * <li>obj - specify {@link KJUR.asn1.ASN1Util.newObject}
 * argument for "BitString encapsulates" structure.</li>
 * </ul>
 * NOTE1: 'params' can be omitted.<br/>
 * NOTE2: 'obj' parameter have been supported since
 * asn1 1.0.11, jsrsasign 6.1.1 (2016-Sep-25).<br/>
 * @example
 * // default constructor
 * o = new KJUR.asn1.DERBitString();
 * // initialize with binary string
 * o = new KJUR.asn1.DERBitString({bin: "1011"});
 * // initialize with boolean array
 * o = new KJUR.asn1.DERBitString({array: [true,false,true,true]});
 * // initialize with hexadecimal string (04 is unused bits)
 * o = new KJUR.asn1.DEROctetString({hex: "04bac0"});
 * // initialize with ASN1Util.newObject argument for encapsulated
 * o = new KJUR.asn1.DERBitString({obj: {seq: [{int: 3}, {prnstr: 'aaa'}]}});
 * // above generates a ASN.1 data like this:
 * // BIT STRING, encapsulates {
 * //   SEQUENCE {
 * //     INTEGER 3
 * //     PrintableString 'aaa'
 * //     }
 * //   }
 */
KJUR.asn1.DERBitString = function (params) {
    if (params !== undefined && typeof params.obj !== "undefined") {
        var o = KJUR.asn1.ASN1Util.newObject(params.obj);
        params.hex = "00" + o.getEncodedHex();
    }
    KJUR.asn1.DERBitString.superclass.constructor.call(this);
    this.hT = "03";
    /**
     * set ASN.1 value(V) by a hexadecimal string including unused bits
     * @name setHexValueIncludingUnusedBits
     * @memberOf KJUR.asn1.DERBitString#
     * @function
     * @param {String} newHexStringIncludingUnusedBits
     */
    this.setHexValueIncludingUnusedBits = function (newHexStringIncludingUnusedBits) {
        this.hTLV = null;
        this.isModified = true;
        this.hV = newHexStringIncludingUnusedBits;
    };
    /**
     * set ASN.1 value(V) by unused bit and hexadecimal string of value
     * @name setUnusedBitsAndHexValue
     * @memberOf KJUR.asn1.DERBitString#
     * @function
     * @param {Integer} unusedBits
     * @param {String} hValue
     */
    this.setUnusedBitsAndHexValue = function (unusedBits, hValue) {
        if (unusedBits < 0 || 7 < unusedBits) {
            throw "unused bits shall be from 0 to 7: u = " + unusedBits;
        }
        var hUnusedBits = "0" + unusedBits;
        this.hTLV = null;
        this.isModified = true;
        this.hV = hUnusedBits + hValue;
    };
    /**
     * set ASN.1 DER BitString by binary string<br/>
     * @name setByBinaryString
     * @memberOf KJUR.asn1.DERBitString#
     * @function
     * @param {String} binaryString binary value string (i.e. '10111')
     * @description
     * Its unused bits will be calculated automatically by length of
     * 'binaryValue'. <br/>
     * NOTE: Trailing zeros '0' will be ignored.
     * @example
     * o = new KJUR.asn1.DERBitString();
     * o.setByBooleanArray("01011");
     */
    this.setByBinaryString = function (binaryString) {
        binaryString = binaryString.replace(/0+$/, '');
        var unusedBits = 8 - binaryString.length % 8;
        if (unusedBits == 8)
            unusedBits = 0;
        for (var i = 0; i <= unusedBits; i++) {
            binaryString += '0';
        }
        var h = '';
        for (var i = 0; i < binaryString.length - 1; i += 8) {
            var b = binaryString.substr(i, 8);
            var x = parseInt(b, 2).toString(16);
            if (x.length == 1)
                x = '0' + x;
            h += x;
        }
        this.hTLV = null;
        this.isModified = true;
        this.hV = '0' + unusedBits + h;
    };
    /**
     * set ASN.1 TLV value(V) by an array of boolean<br/>
     * @name setByBooleanArray
     * @memberOf KJUR.asn1.DERBitString#
     * @function
     * @param {array} booleanArray array of boolean (ex. [true, false, true])
     * @description
     * NOTE: Trailing falses will be ignored in the ASN.1 DER Object.
     * @example
     * o = new KJUR.asn1.DERBitString();
     * o.setByBooleanArray([false, true, false, true, true]);
     */
    this.setByBooleanArray = function (booleanArray) {
        var s = '';
        for (var i = 0; i < booleanArray.length; i++) {
            if (booleanArray[i] == true) {
                s += '1';
            }
            else {
                s += '0';
            }
        }
        this.setByBinaryString(s);
    };
    /**
     * generate an array of falses with specified length<br/>
     * @name newFalseArray
     * @memberOf KJUR.asn1.DERBitString
     * @function
     * @param {Integer} nLength length of array to generate
     * @return {array} array of boolean falses
     * @description
     * This static method may be useful to initialize boolean array.
     * @example
     * o = new KJUR.asn1.DERBitString();
     * o.newFalseArray(3) &rarr; [false, false, false]
     */
    this.newFalseArray = function (nLength) {
        var a = new Array(nLength);
        for (var i = 0; i < nLength; i++) {
            a[i] = false;
        }
        return a;
    };
    this.getFreshValueHex = function () {
        return this.hV;
    };
    if (typeof params != "undefined") {
        if (typeof params == "string" && params.toLowerCase().match(/^[0-9a-f]+$/)) {
            this.setHexValueIncludingUnusedBits(params);
        }
        else if (typeof params['hex'] != "undefined") {
            this.setHexValueIncludingUnusedBits(params['hex']);
        }
        else if (typeof params['bin'] != "undefined") {
            this.setByBinaryString(params['bin']);
        }
        else if (typeof params['array'] != "undefined") {
            this.setByBooleanArray(params['array']);
        }
    }
};
_yahoo__WEBPACK_IMPORTED_MODULE_1__["YAHOO"].lang.extend(KJUR.asn1.DERBitString, KJUR.asn1.ASN1Object);
// ********************************************************************
/**
 * class for ASN.1 DER OctetString<br/>
 * @name KJUR.asn1.DEROctetString
 * @class class for ASN.1 DER OctetString
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * This class provides ASN.1 OctetString simple type.<br/>
 * Supported "params" attributes are:
 * <ul>
 * <li>str - to set a string as a value</li>
 * <li>hex - to set a hexadecimal string as a value</li>
 * <li>obj - to set a encapsulated ASN.1 value by JSON object
 * which is defined in {@link KJUR.asn1.ASN1Util.newObject}</li>
 * </ul>
 * NOTE: A parameter 'obj' have been supported
 * for "OCTET STRING, encapsulates" structure.
 * since asn1 1.0.11, jsrsasign 6.1.1 (2016-Sep-25).
 * @see KJUR.asn1.DERAbstractString - superclass
 * @example
 * // default constructor
 * o = new KJUR.asn1.DEROctetString();
 * // initialize with string
 * o = new KJUR.asn1.DEROctetString({str: "aaa"});
 * // initialize with hexadecimal string
 * o = new KJUR.asn1.DEROctetString({hex: "616161"});
 * // initialize with ASN1Util.newObject argument
 * o = new KJUR.asn1.DEROctetString({obj: {seq: [{int: 3}, {prnstr: 'aaa'}]}});
 * // above generates a ASN.1 data like this:
 * // OCTET STRING, encapsulates {
 * //   SEQUENCE {
 * //     INTEGER 3
 * //     PrintableString 'aaa'
 * //     }
 * //   }
 */
KJUR.asn1.DEROctetString = function (params) {
    if (params !== undefined && typeof params.obj !== "undefined") {
        var o = KJUR.asn1.ASN1Util.newObject(params.obj);
        params.hex = o.getEncodedHex();
    }
    KJUR.asn1.DEROctetString.superclass.constructor.call(this, params);
    this.hT = "04";
};
_yahoo__WEBPACK_IMPORTED_MODULE_1__["YAHOO"].lang.extend(KJUR.asn1.DEROctetString, KJUR.asn1.DERAbstractString);
// ********************************************************************
/**
 * class for ASN.1 DER Null
 * @name KJUR.asn1.DERNull
 * @class class for ASN.1 DER Null
 * @extends KJUR.asn1.ASN1Object
 * @description
 * @see KJUR.asn1.ASN1Object - superclass
 */
KJUR.asn1.DERNull = function () {
    KJUR.asn1.DERNull.superclass.constructor.call(this);
    this.hT = "05";
    this.hTLV = "0500";
};
_yahoo__WEBPACK_IMPORTED_MODULE_1__["YAHOO"].lang.extend(KJUR.asn1.DERNull, KJUR.asn1.ASN1Object);
// ********************************************************************
/**
 * class for ASN.1 DER ObjectIdentifier
 * @name KJUR.asn1.DERObjectIdentifier
 * @class class for ASN.1 DER ObjectIdentifier
 * @param {Array} params associative array of parameters (ex. {'oid': '2.5.4.5'})
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>oid - specify initial ASN.1 value(V) by a oid string (ex. 2.5.4.13)</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 */
KJUR.asn1.DERObjectIdentifier = function (params) {
    var itox = function (i) {
        var h = i.toString(16);
        if (h.length == 1)
            h = '0' + h;
        return h;
    };
    var roidtox = function (roid) {
        var h = '';
        var bi = new _jsbn_jsbn__WEBPACK_IMPORTED_MODULE_0__["BigInteger"](roid, 10);
        var b = bi.toString(2);
        var padLen = 7 - b.length % 7;
        if (padLen == 7)
            padLen = 0;
        var bPad = '';
        for (var i = 0; i < padLen; i++)
            bPad += '0';
        b = bPad + b;
        for (var i = 0; i < b.length - 1; i += 7) {
            var b8 = b.substr(i, 7);
            if (i != b.length - 7)
                b8 = '1' + b8;
            h += itox(parseInt(b8, 2));
        }
        return h;
    };
    KJUR.asn1.DERObjectIdentifier.superclass.constructor.call(this);
    this.hT = "06";
    /**
     * set value by a hexadecimal string
     * @name setValueHex
     * @memberOf KJUR.asn1.DERObjectIdentifier#
     * @function
     * @param {String} newHexString hexadecimal value of OID bytes
     */
    this.setValueHex = function (newHexString) {
        this.hTLV = null;
        this.isModified = true;
        this.s = null;
        this.hV = newHexString;
    };
    /**
     * set value by a OID string<br/>
     * @name setValueOidString
     * @memberOf KJUR.asn1.DERObjectIdentifier#
     * @function
     * @param {String} oidString OID string (ex. 2.5.4.13)
     * @example
     * o = new KJUR.asn1.DERObjectIdentifier();
     * o.setValueOidString("2.5.4.13");
     */
    this.setValueOidString = function (oidString) {
        if (!oidString.match(/^[0-9.]+$/)) {
            throw "malformed oid string: " + oidString;
        }
        var h = '';
        var a = oidString.split('.');
        var i0 = parseInt(a[0]) * 40 + parseInt(a[1]);
        h += itox(i0);
        a.splice(0, 2);
        for (var i = 0; i < a.length; i++) {
            h += roidtox(a[i]);
        }
        this.hTLV = null;
        this.isModified = true;
        this.s = null;
        this.hV = h;
    };
    /**
     * set value by a OID name
     * @name setValueName
     * @memberOf KJUR.asn1.DERObjectIdentifier#
     * @function
     * @param {String} oidName OID name (ex. 'serverAuth')
     * @since 1.0.1
     * @description
     * OID name shall be defined in 'KJUR.asn1.x509.OID.name2oidList'.
     * Otherwise raise error.
     * @example
     * o = new KJUR.asn1.DERObjectIdentifier();
     * o.setValueName("serverAuth");
     */
    this.setValueName = function (oidName) {
        var oid = KJUR.asn1.x509.OID.name2oid(oidName);
        if (oid !== '') {
            this.setValueOidString(oid);
        }
        else {
            throw "DERObjectIdentifier oidName undefined: " + oidName;
        }
    };
    this.getFreshValueHex = function () {
        return this.hV;
    };
    if (params !== undefined) {
        if (typeof params === "string") {
            if (params.match(/^[0-2].[0-9.]+$/)) {
                this.setValueOidString(params);
            }
            else {
                this.setValueName(params);
            }
        }
        else if (params.oid !== undefined) {
            this.setValueOidString(params.oid);
        }
        else if (params.hex !== undefined) {
            this.setValueHex(params.hex);
        }
        else if (params.name !== undefined) {
            this.setValueName(params.name);
        }
    }
};
_yahoo__WEBPACK_IMPORTED_MODULE_1__["YAHOO"].lang.extend(KJUR.asn1.DERObjectIdentifier, KJUR.asn1.ASN1Object);
// ********************************************************************
/**
 * class for ASN.1 DER Enumerated
 * @name KJUR.asn1.DEREnumerated
 * @class class for ASN.1 DER Enumerated
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>int - specify initial ASN.1 value(V) by integer value</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 * @example
 * new KJUR.asn1.DEREnumerated(123);
 * new KJUR.asn1.DEREnumerated({int: 123});
 * new KJUR.asn1.DEREnumerated({hex: '1fad'});
 */
KJUR.asn1.DEREnumerated = function (params) {
    KJUR.asn1.DEREnumerated.superclass.constructor.call(this);
    this.hT = "0a";
    /**
     * set value by Tom Wu's BigInteger object
     * @name setByBigInteger
     * @memberOf KJUR.asn1.DEREnumerated#
     * @function
     * @param {BigInteger} bigIntegerValue to set
     */
    this.setByBigInteger = function (bigIntegerValue) {
        this.hTLV = null;
        this.isModified = true;
        this.hV = KJUR.asn1.ASN1Util.bigIntToMinTwosComplementsHex(bigIntegerValue);
    };
    /**
     * set value by integer value
     * @name setByInteger
     * @memberOf KJUR.asn1.DEREnumerated#
     * @function
     * @param {Integer} integer value to set
     */
    this.setByInteger = function (intValue) {
        var bi = new _jsbn_jsbn__WEBPACK_IMPORTED_MODULE_0__["BigInteger"](String(intValue), 10);
        this.setByBigInteger(bi);
    };
    /**
     * set value by integer value
     * @name setValueHex
     * @memberOf KJUR.asn1.DEREnumerated#
     * @function
     * @param {String} hexadecimal string of integer value
     * @description
     * <br/>
     * NOTE: Value shall be represented by minimum octet length of
     * two's complement representation.
     */
    this.setValueHex = function (newHexString) {
        this.hV = newHexString;
    };
    this.getFreshValueHex = function () {
        return this.hV;
    };
    if (typeof params != "undefined") {
        if (typeof params['int'] != "undefined") {
            this.setByInteger(params['int']);
        }
        else if (typeof params == "number") {
            this.setByInteger(params);
        }
        else if (typeof params['hex'] != "undefined") {
            this.setValueHex(params['hex']);
        }
    }
};
_yahoo__WEBPACK_IMPORTED_MODULE_1__["YAHOO"].lang.extend(KJUR.asn1.DEREnumerated, KJUR.asn1.ASN1Object);
// ********************************************************************
/**
 * class for ASN.1 DER UTF8String
 * @name KJUR.asn1.DERUTF8String
 * @class class for ASN.1 DER UTF8String
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * @see KJUR.asn1.DERAbstractString - superclass
 */
KJUR.asn1.DERUTF8String = function (params) {
    KJUR.asn1.DERUTF8String.superclass.constructor.call(this, params);
    this.hT = "0c";
};
_yahoo__WEBPACK_IMPORTED_MODULE_1__["YAHOO"].lang.extend(KJUR.asn1.DERUTF8String, KJUR.asn1.DERAbstractString);
// ********************************************************************
/**
 * class for ASN.1 DER NumericString
 * @name KJUR.asn1.DERNumericString
 * @class class for ASN.1 DER NumericString
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * @see KJUR.asn1.DERAbstractString - superclass
 */
KJUR.asn1.DERNumericString = function (params) {
    KJUR.asn1.DERNumericString.superclass.constructor.call(this, params);
    this.hT = "12";
};
_yahoo__WEBPACK_IMPORTED_MODULE_1__["YAHOO"].lang.extend(KJUR.asn1.DERNumericString, KJUR.asn1.DERAbstractString);
// ********************************************************************
/**
 * class for ASN.1 DER PrintableString
 * @name KJUR.asn1.DERPrintableString
 * @class class for ASN.1 DER PrintableString
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * @see KJUR.asn1.DERAbstractString - superclass
 */
KJUR.asn1.DERPrintableString = function (params) {
    KJUR.asn1.DERPrintableString.superclass.constructor.call(this, params);
    this.hT = "13";
};
_yahoo__WEBPACK_IMPORTED_MODULE_1__["YAHOO"].lang.extend(KJUR.asn1.DERPrintableString, KJUR.asn1.DERAbstractString);
// ********************************************************************
/**
 * class for ASN.1 DER TeletexString
 * @name KJUR.asn1.DERTeletexString
 * @class class for ASN.1 DER TeletexString
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * @see KJUR.asn1.DERAbstractString - superclass
 */
KJUR.asn1.DERTeletexString = function (params) {
    KJUR.asn1.DERTeletexString.superclass.constructor.call(this, params);
    this.hT = "14";
};
_yahoo__WEBPACK_IMPORTED_MODULE_1__["YAHOO"].lang.extend(KJUR.asn1.DERTeletexString, KJUR.asn1.DERAbstractString);
// ********************************************************************
/**
 * class for ASN.1 DER IA5String
 * @name KJUR.asn1.DERIA5String
 * @class class for ASN.1 DER IA5String
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * @see KJUR.asn1.DERAbstractString - superclass
 */
KJUR.asn1.DERIA5String = function (params) {
    KJUR.asn1.DERIA5String.superclass.constructor.call(this, params);
    this.hT = "16";
};
_yahoo__WEBPACK_IMPORTED_MODULE_1__["YAHOO"].lang.extend(KJUR.asn1.DERIA5String, KJUR.asn1.DERAbstractString);
// ********************************************************************
/**
 * class for ASN.1 DER UTCTime
 * @name KJUR.asn1.DERUTCTime
 * @class class for ASN.1 DER UTCTime
 * @param {Array} params associative array of parameters (ex. {'str': '130430235959Z'})
 * @extends KJUR.asn1.DERAbstractTime
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>str - specify initial ASN.1 value(V) by a string (ex.'130430235959Z')</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * <li>date - specify Date object.</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 * <h4>EXAMPLES</h4>
 * @example
 * d1 = new KJUR.asn1.DERUTCTime();
 * d1.setString('130430125959Z');
 *
 * d2 = new KJUR.asn1.DERUTCTime({'str': '130430125959Z'});
 * d3 = new KJUR.asn1.DERUTCTime({'date': new Date(Date.UTC(2015, 0, 31, 0, 0, 0, 0))});
 * d4 = new KJUR.asn1.DERUTCTime('130430125959Z');
 */
KJUR.asn1.DERUTCTime = function (params) {
    KJUR.asn1.DERUTCTime.superclass.constructor.call(this, params);
    this.hT = "17";
    /**
     * set value by a Date object<br/>
     * @name setByDate
     * @memberOf KJUR.asn1.DERUTCTime#
     * @function
     * @param {Date} dateObject Date object to set ASN.1 value(V)
     * @example
     * o = new KJUR.asn1.DERUTCTime();
     * o.setByDate(new Date("2016/12/31"));
     */
    this.setByDate = function (dateObject) {
        this.hTLV = null;
        this.isModified = true;
        this.date = dateObject;
        this.s = this.formatDate(this.date, 'utc');
        this.hV = stohex(this.s);
    };
    this.getFreshValueHex = function () {
        if (typeof this.date == "undefined" && typeof this.s == "undefined") {
            this.date = new Date();
            this.s = this.formatDate(this.date, 'utc');
            this.hV = stohex(this.s);
        }
        return this.hV;
    };
    if (params !== undefined) {
        if (params.str !== undefined) {
            this.setString(params.str);
        }
        else if (typeof params == "string" && params.match(/^[0-9]{12}Z$/)) {
            this.setString(params);
        }
        else if (params.hex !== undefined) {
            this.setStringHex(params.hex);
        }
        else if (params.date !== undefined) {
            this.setByDate(params.date);
        }
    }
};
_yahoo__WEBPACK_IMPORTED_MODULE_1__["YAHOO"].lang.extend(KJUR.asn1.DERUTCTime, KJUR.asn1.DERAbstractTime);
// ********************************************************************
/**
 * class for ASN.1 DER GeneralizedTime
 * @name KJUR.asn1.DERGeneralizedTime
 * @class class for ASN.1 DER GeneralizedTime
 * @param {Array} params associative array of parameters (ex. {'str': '20130430235959Z'})
 * @property {Boolean} withMillis flag to show milliseconds or not
 * @extends KJUR.asn1.DERAbstractTime
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>str - specify initial ASN.1 value(V) by a string (ex.'20130430235959Z')</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * <li>date - specify Date object.</li>
 * <li>millis - specify flag to show milliseconds (from 1.0.6)</li>
 * </ul>
 * NOTE1: 'params' can be omitted.
 * NOTE2: 'withMillis' property is supported from asn1 1.0.6.
 */
KJUR.asn1.DERGeneralizedTime = function (params) {
    KJUR.asn1.DERGeneralizedTime.superclass.constructor.call(this, params);
    this.hT = "18";
    this.withMillis = false;
    /**
     * set value by a Date object
     * @name setByDate
     * @memberOf KJUR.asn1.DERGeneralizedTime#
     * @function
     * @param {Date} dateObject Date object to set ASN.1 value(V)
     * @example
     * When you specify UTC time, use 'Date.UTC' method like this:<br/>
     * o1 = new DERUTCTime();
     * o1.setByDate(date);
     *
     * date = new Date(Date.UTC(2015, 0, 31, 23, 59, 59, 0)); #2015JAN31 23:59:59
     */
    this.setByDate = function (dateObject) {
        this.hTLV = null;
        this.isModified = true;
        this.date = dateObject;
        this.s = this.formatDate(this.date, 'gen', this.withMillis);
        this.hV = stohex(this.s);
    };
    this.getFreshValueHex = function () {
        if (this.date === undefined && this.s === undefined) {
            this.date = new Date();
            this.s = this.formatDate(this.date, 'gen', this.withMillis);
            this.hV = stohex(this.s);
        }
        return this.hV;
    };
    if (params !== undefined) {
        if (params.str !== undefined) {
            this.setString(params.str);
        }
        else if (typeof params == "string" && params.match(/^[0-9]{14}Z$/)) {
            this.setString(params);
        }
        else if (params.hex !== undefined) {
            this.setStringHex(params.hex);
        }
        else if (params.date !== undefined) {
            this.setByDate(params.date);
        }
        if (params.millis === true) {
            this.withMillis = true;
        }
    }
};
_yahoo__WEBPACK_IMPORTED_MODULE_1__["YAHOO"].lang.extend(KJUR.asn1.DERGeneralizedTime, KJUR.asn1.DERAbstractTime);
// ********************************************************************
/**
 * class for ASN.1 DER Sequence
 * @name KJUR.asn1.DERSequence
 * @class class for ASN.1 DER Sequence
 * @extends KJUR.asn1.DERAbstractStructured
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>array - specify array of ASN1Object to set elements of content</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 */
KJUR.asn1.DERSequence = function (params) {
    KJUR.asn1.DERSequence.superclass.constructor.call(this, params);
    this.hT = "30";
    this.getFreshValueHex = function () {
        var h = '';
        for (var i = 0; i < this.asn1Array.length; i++) {
            var asn1Obj = this.asn1Array[i];
            h += asn1Obj.getEncodedHex();
        }
        this.hV = h;
        return this.hV;
    };
};
_yahoo__WEBPACK_IMPORTED_MODULE_1__["YAHOO"].lang.extend(KJUR.asn1.DERSequence, KJUR.asn1.DERAbstractStructured);
// ********************************************************************
/**
 * class for ASN.1 DER Set
 * @name KJUR.asn1.DERSet
 * @class class for ASN.1 DER Set
 * @extends KJUR.asn1.DERAbstractStructured
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>array - specify array of ASN1Object to set elements of content</li>
 * <li>sortflag - flag for sort (default: true). ASN.1 BER is not sorted in 'SET OF'.</li>
 * </ul>
 * NOTE1: 'params' can be omitted.<br/>
 * NOTE2: sortflag is supported since 1.0.5.
 */
KJUR.asn1.DERSet = function (params) {
    KJUR.asn1.DERSet.superclass.constructor.call(this, params);
    this.hT = "31";
    this.sortFlag = true; // item shall be sorted only in ASN.1 DER
    this.getFreshValueHex = function () {
        var a = new Array();
        for (var i = 0; i < this.asn1Array.length; i++) {
            var asn1Obj = this.asn1Array[i];
            a.push(asn1Obj.getEncodedHex());
        }
        if (this.sortFlag == true)
            a.sort();
        this.hV = a.join('');
        return this.hV;
    };
    if (typeof params != "undefined") {
        if (typeof params.sortflag != "undefined" &&
            params.sortflag == false)
            this.sortFlag = false;
    }
};
_yahoo__WEBPACK_IMPORTED_MODULE_1__["YAHOO"].lang.extend(KJUR.asn1.DERSet, KJUR.asn1.DERAbstractStructured);
// ********************************************************************
/**
 * class for ASN.1 DER TaggedObject
 * @name KJUR.asn1.DERTaggedObject
 * @class class for ASN.1 DER TaggedObject
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * Parameter 'tagNoNex' is ASN.1 tag(T) value for this object.
 * For example, if you find '[1]' tag in a ASN.1 dump,
 * 'tagNoHex' will be 'a1'.
 * <br/>
 * As for optional argument 'params' for constructor, you can specify *ANY* of
 * following properties:
 * <ul>
 * <li>explicit - specify true if this is explicit tag otherwise false
 *     (default is 'true').</li>
 * <li>tag - specify tag (default is 'a0' which means [0])</li>
 * <li>obj - specify ASN1Object which is tagged</li>
 * </ul>
 * @example
 * d1 = new KJUR.asn1.DERUTF8String({'str':'a'});
 * d2 = new KJUR.asn1.DERTaggedObject({'obj': d1});
 * hex = d2.getEncodedHex();
 */
KJUR.asn1.DERTaggedObject = function (params) {
    KJUR.asn1.DERTaggedObject.superclass.constructor.call(this);
    this.hT = "a0";
    this.hV = '';
    this.isExplicit = true;
    this.asn1Object = null;
    /**
     * set value by an ASN1Object
     * @name setString
     * @memberOf KJUR.asn1.DERTaggedObject#
     * @function
     * @param {Boolean} isExplicitFlag flag for explicit/implicit tag
     * @param {Integer} tagNoHex hexadecimal string of ASN.1 tag
     * @param {ASN1Object} asn1Object ASN.1 to encapsulate
     */
    this.setASN1Object = function (isExplicitFlag, tagNoHex, asn1Object) {
        this.hT = tagNoHex;
        this.isExplicit = isExplicitFlag;
        this.asn1Object = asn1Object;
        if (this.isExplicit) {
            this.hV = this.asn1Object.getEncodedHex();
            this.hTLV = null;
            this.isModified = true;
        }
        else {
            this.hV = null;
            this.hTLV = asn1Object.getEncodedHex();
            this.hTLV = this.hTLV.replace(/^../, tagNoHex);
            this.isModified = false;
        }
    };
    this.getFreshValueHex = function () {
        return this.hV;
    };
    if (typeof params != "undefined") {
        if (typeof params['tag'] != "undefined") {
            this.hT = params['tag'];
        }
        if (typeof params['explicit'] != "undefined") {
            this.isExplicit = params['explicit'];
        }
        if (typeof params['obj'] != "undefined") {
            this.asn1Object = params['obj'];
            this.setASN1Object(this.isExplicit, this.hT, this.asn1Object);
        }
    }
};
_yahoo__WEBPACK_IMPORTED_MODULE_1__["YAHOO"].lang.extend(KJUR.asn1.DERTaggedObject, KJUR.asn1.ASN1Object);


/***/ }),

/***/ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsrsasign/yahoo.js":
/*!****************************************************************************!*\
  !*** ./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/lib/jsrsasign/yahoo.js ***!
  \****************************************************************************/
/*! exports provided: YAHOO */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "YAHOO", function() { return YAHOO; });
/*!
Copyright (c) 2011, Yahoo! Inc. All rights reserved.
Code licensed under the BSD License:
http://developer.yahoo.com/yui/license.html
version: 2.9.0
*/
var YAHOO = {};
YAHOO.lang = {
    /**
     * Utility to set up the prototype, constructor and superclass properties to
     * support an inheritance strategy that can chain constructors and methods.
     * Static members will not be inherited.
     *
     * @method extend
     * @static
     * @param {Function} subc   the object to modify
     * @param {Function} superc the object to inherit
     * @param {Object} overrides  additional properties/methods to add to the
     *                              subclass prototype.  These will override the
     *                              matching items obtained from the superclass
     *                              if present.
     */
    extend: function (subc, superc, overrides) {
        if (!superc || !subc) {
            throw new Error("YAHOO.lang.extend failed, please check that " +
                "all dependencies are included.");
        }
        var F = function () { };
        F.prototype = superc.prototype;
        subc.prototype = new F();
        subc.prototype.constructor = subc;
        subc.superclass = superc.prototype;
        if (superc.prototype.constructor == Object.prototype.constructor) {
            superc.prototype.constructor = superc;
        }
        if (overrides) {
            var i;
            for (i in overrides) {
                subc.prototype[i] = overrides[i];
            }
            /*
             * IE will not enumerate native functions in a derived object even if the
             * function was overridden.  This is a workaround for specific functions
             * we care about on the Object prototype.
             * @property _IEEnumFix
             * @param {Function} r  the object to receive the augmentation
             * @param {Function} s  the object that supplies the properties to augment
             * @static
             * @private
             */
            var _IEEnumFix = function () { }, ADD = ["toString", "valueOf"];
            try {
                if (/MSIE/.test(navigator.userAgent)) {
                    _IEEnumFix = function (r, s) {
                        for (i = 0; i < ADD.length; i = i + 1) {
                            var fname = ADD[i], f = s[fname];
                            if (typeof f === 'function' && f != Object.prototype[fname]) {
                                r[fname] = f;
                            }
                        }
                    };
                }
            }
            catch (ex) { }
            ;
            _IEEnumFix(subc.prototype, overrides);
        }
    }
};


/***/ }),

/***/ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/version.json":
/*!******************************************************************!*\
  !*** ./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/version.json ***!
  \******************************************************************/
/*! exports provided: version, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"version\":\"3.2.0\"}");

/***/ }),

/***/ "./node_modules/_process@0.11.10@process/browser.js":
/*!**********************************************************!*\
  !*** ./node_modules/_process@0.11.10@process/browser.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "./node_modules/_ua-parser-js@0.7.28@ua-parser-js/src/ua-parser.js":
/*!*************************************************************************!*\
  !*** ./node_modules/_ua-parser-js@0.7.28@ua-parser-js/src/ua-parser.js ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!@license
 * UAParser.js v0.7.28
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
 * Licensed under MIT License
 */

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '0.7.28',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major', // deprecated
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded',
        UA_MAX_LENGTH = 255;


    ///////////
    // Helper
    //////////


    var util = {
        extend : function (regexes, extensions) {
            var mergedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    mergedRegexes[i] = regexes[i];
                }
            }
            return mergedRegexes;
        },
        has : function (str1, str2) {
            return typeof str1 === STR_TYPE ? str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1 : false;
        },
        lowerize : function (str) {
            return str.toLowerCase();
        },
        major : function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g,'').split(".")[0] : undefined;
        },
        trim : function (str, len) {
            str = str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
            return typeof(len) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };


    ///////////////
    // Map helper
    //////////////


    var mapper = {

        rgx : function (ua, arrays) {

            var i = 0, j, k, p, q, matches, match;

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length == 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length == 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length == 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
        },

        str : function (str, map) {

            for (var i in map) {
                // check if array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (util.has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (util.has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
        }
    };


    ///////////////
    // String map
    //////////////


    var maps = {

        browser : {
            // Safari < 3.0
            oldSafari : {
                version : {
                    '1.0'   : '/8',
                    '1.2'   : '/1',
                    '1.3'   : '/3',
                    '2.0'   : '/412',
                    '2.0.2' : '/416',
                    '2.0.3' : '/417',
                    '2.0.4' : '/419',
                    '?'     : '/'
                }
            },
            oldEdge : {
                version : {
                    '0.1'   : '12.',
                    '21'    : '13.',
                    '31'    : '14.',
                    '39'    : '15.',
                    '41'    : '16.',
                    '42'    : '17.',
                    '44'    : '18.'
                }
            }
        },

        os : {
            windows : {
                version : {
                    'ME'        : '4.90',
                    'NT 3.11'   : 'NT3.51',
                    'NT 4.0'    : 'NT4.0',
                    '2000'      : 'NT 5.0',
                    'XP'        : ['NT 5.1', 'NT 5.2'],
                    'Vista'     : 'NT 6.0',
                    '7'         : 'NT 6.1',
                    '8'         : 'NT 6.2',
                    '8.1'       : 'NT 6.3',
                    '10'        : ['NT 6.4', 'NT 10.0'],
                    'RT'        : 'ARM'
                }
            }
        }
    };


    //////////////
    // Regex map
    /////////////


    var regexes = {

        browser : [[

            /\b(?:crmo|crios)\/([\w\.]+)/i                                      // Chrome for Android/iOS
            ], [VERSION, [NAME, 'Chrome']], [
            /edg(?:e|ios|a)?\/([\w\.]+)/i                                       // Microsoft Edge
            ], [VERSION, [NAME, 'Edge']], [
            // breaking change (reserved for next major release):
            ///edge\/([\w\.]+)/i                                                  // Old Edge (Trident)
            //], [[VERSION, mapper.str, maps.browser.oldEdge.version], [NAME, 'Edge']], [

            // Presto based
            /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
            /(opera\s[mobiletab]{3,6})\b.+version\/([\w\.-]+)/i,                // Opera Mobi/Tablet
            /(opera)(?:.+version\/|[\/\s]+)([\w\.]+)/i,                         // Opera
            ], [NAME, VERSION], [
            /opios[\/\s]+([\w\.]+)/i                                            // Opera mini on iphone >= 8.0
            ], [VERSION, [NAME, 'Opera Mini']], [
            /\sopr\/([\w\.]+)/i                                                 // Opera Webkit
            ], [VERSION, [NAME, 'Opera']], [

            // Mixed
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,     // Lunascape/Maxthon/Netfront/Jasmine/Blazer
            // Trident based
            /(avant\s|iemobile|slim)(?:browser)?[\/\s]?([\w\.]*)/i,             // Avant/IEMobile/SlimBrowser
            /(ba?idubrowser)[\/\s]?([\w\.]+)/i,                                 // Baidu Browser
            /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer

            // Webkit/KHTML based
            /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i,
                                                                                // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([\w\.]+)/i,         // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
            /(weibo)__([\d\.]+)/i                                               // Weibo
            ], [NAME, VERSION], [
            /(?:[\s\/]uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i           // UCBrowser
            ], [VERSION, [NAME, 'UCBrowser']], [
            /(?:windowswechat)?\sqbcore\/([\w\.]+)\b.*(?:windowswechat)?/i      // WeChat Desktop for Windows Built-in Browser
            ], [VERSION, [NAME, 'WeChat(Win) Desktop']], [
            /micromessenger\/([\w\.]+)/i                                        // WeChat
            ], [VERSION, [NAME, 'WeChat']], [
            /konqueror\/([\w\.]+)/i                                             // Konqueror
            ], [VERSION, [NAME, 'Konqueror']], [
            /trident.+rv[:\s]([\w\.]{1,9})\b.+like\sgecko/i                     // IE11
            ], [VERSION, [NAME, 'IE']], [
            /yabrowser\/([\w\.]+)/i                                             // Yandex
            ], [VERSION, [NAME, 'Yandex']], [
            /(avast|avg)\/([\w\.]+)/i                                           // Avast/AVG Secure Browser
            ], [[NAME, /(.+)/, '$1 Secure Browser'], VERSION], [
            /focus\/([\w\.]+)/i                                                 // Firefox Focus
            ], [VERSION, [NAME, 'Firefox Focus']], [
            /opt\/([\w\.]+)/i                                                   // Opera Touch
            ], [VERSION, [NAME, 'Opera Touch']], [
            /coc_coc_browser\/([\w\.]+)/i                                       // Coc Coc Browser
            ], [VERSION, [NAME, 'Coc Coc']], [
            /dolfin\/([\w\.]+)/i                                                // Dolphin
            ], [VERSION, [NAME, 'Dolphin']], [
            /coast\/([\w\.]+)/i                                                 // Opera Coast
            ], [VERSION, [NAME, 'Opera Coast']],
            [/xiaomi\/miuibrowser\/([\w\.]+)/i                                  // MIUI Browser
            ], [VERSION, [NAME, 'MIUI Browser']], [
            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, 'Firefox']], [
            /(qihu|qhbrowser|qihoobrowser|360browser)/i                         // 360
            ], [[NAME, '360 Browser']], [
            /(oculus|samsung|sailfish)browser\/([\w\.]+)/i
            ], [[NAME, /(.+)/, '$1 Browser'], VERSION], [                       // Oculus/Samsung/Sailfish Browser
            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [
            /\s(electron)\/([\w\.]+)\ssafari/i,                                 // Electron-based App
            /(tesla)(?:\sqtcarbrowser|\/(20[12]\d\.[\w\.-]+))/i,                // Tesla
            /m?(qqbrowser|baiduboxapp|2345Explorer)[\/\s]?([\w\.]+)/i           // QQBrowser/Baidu App/2345 Browser
            ], [NAME, VERSION], [
            /(MetaSr)[\/\s]?([\w\.]+)/i,                                        // SouGouBrowser
            /(LBBROWSER)/i                                                      // LieBao Browser
            ], [NAME], [

            // WebView
            /;fbav\/([\w\.]+);/i                                                // Facebook App for iOS & Android with version
            ], [VERSION, [NAME, 'Facebook']], [
            /FBAN\/FBIOS|FB_IAB\/FB4A/i                                         // Facebook App for iOS & Android without version
            ], [[NAME, 'Facebook']], [
            /safari\s(line)\/([\w\.]+)/i,                                       // Line App for iOS
            /\b(line)\/([\w\.]+)\/iab/i,                                        // Line App for Android
            /(chromium|instagram)[\/\s]([\w\.-]+)/i                             // Chromium/Instagram
            ], [NAME, VERSION], [
            /\bgsa\/([\w\.]+)\s.*safari\//i                                     // Google Search Appliance on iOS
            ], [VERSION, [NAME, 'GSA']], [

            /headlesschrome(?:\/([\w\.]+)|\s)/i                                 // Chrome Headless
            ], [VERSION, [NAME, 'Chrome Headless']], [

            /\swv\).+(chrome)\/([\w\.]+)/i                                      // Chrome WebView
            ], [[NAME, 'Chrome WebView'], VERSION], [

            /droid.+\sversion\/([\w\.]+)\b.+(?:mobile\ssafari|safari)/i         // Android Browser
            ], [VERSION, [NAME, 'Android Browser']], [

            /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i      // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /version\/([\w\.]+)\s.*mobile\/\w+\s(safari)/i                      // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [
            /version\/([\w\.]+)\s.*(mobile\s?safari|safari)/i                   // Safari & Safari Mobile
            ], [VERSION, NAME], [
            /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
            ], [NAME, [VERSION, mapper.str, maps.browser.oldSafari.version]], [

            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /ile\svr;\srv:([\w\.]+)\).+firefox/i                                // Firefox Reality
            ], [VERSION, [NAME, 'Firefox Reality']], [
            /ekiohf.+(flow)\/([\w\.]+)/i,                                       // Flow
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,
                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)\s[\w\s\-]+\/[\w\.]+$/i,                       // Other Firefox-based
            /(mozilla)\/([\w\.]+)\s.+rv\:.+gecko\/\d+/i,                        // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
            /(links)\s\(([\w\.]+)/i,                                            // Links
            /(gobrowser)\/?([\w\.]*)/i,                                         // GoBrowser
            /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
            /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
            ], [NAME, VERSION]
        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64 (x64)
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, util.lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32 (x86)
            ], [[ARCHITECTURE, 'ia32']], [

            /\b(aarch64|armv?8e?l?)\b/i                                         // ARM64
            ], [[ARCHITECTURE, 'arm64']], [

            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i                                   // ARMHF
            ], [[ARCHITECTURE, 'armhf']], [

            // PocketPC mistakenly identified as PowerPC
            /windows\s(ce|mobile);\sppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
            ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?:64|(?=v(?:[1-7]|[5-7]1)l?|;|eabi))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, util.lowerize]]
        ],

        device : [[

            //////////////////////////
            // MOBILES & TABLETS
            // Ordered by popularity
            /////////////////////////

            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus\s10)/i
            ], [MODEL, [VENDOR, 'Samsung'], [TYPE, TABLET]], [
            /\b((?:s[cgp]h|gt|sm)-\w+|galaxy\snexus)/i,
            /\ssamsung[\s-]([\w-]+)/i,
            /sec-(sgh\w+)/i
            ], [MODEL, [VENDOR, 'Samsung'], [TYPE, MOBILE]], [

            // Apple
            /\((ip(?:hone|od)[\s\w]*);/i                                        // iPod/iPhone
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [
            /\((ipad);[\w\s\),;-]+apple/i,                                      // iPad
            /applecoremedia\/[\w\.]+\s\((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [

            // Huawei
            /\b((?:agr|ags[23]|bah2?|sht?)-a?[lw]\d{2})/i,
            ], [MODEL, [VENDOR, 'Huawei'], [TYPE, TABLET]], [
            /d\/huawei([\w\s-]+)[;\)]/i,
            /\b(nexus\s6p|vog-[at]?l\d\d|ane-[at]?l[x\d]\d|eml-a?l\d\da?|lya-[at]?l\d[\dc]|clt-a?l\d\di?|ele-l\d\d)/i,
            /\b(\w{2,4}-[atu][ln][01259][019])[;\)\s]/i
            ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [

            // Xiaomi
            /\b(poco[\s\w]+)(?:\sbuild|\))/i,                                   // Xiaomi POCO
            /\b;\s(\w+)\sbuild\/hm\1/i,                                         // Xiaomi Hongmi 'numeric' models
            /\b(hm[\s\-_]?note?[\s_]?(?:\d\w)?)\sbuild/i,                       // Xiaomi Hongmi
            /\b(redmi[\s\-_]?(?:note|k)?[\w\s_]+)(?:\sbuild|\))/i,              // Xiaomi Redmi
            /\b(mi[\s\-_]?(?:a\d|one|one[\s_]plus|note lte)?[\s_]?(?:\d?\w?)[\s_]?(?:plus)?)\sbuild/i  // Xiaomi Mi
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
            /\b(mi[\s\-_]?(?:pad)(?:[\w\s_]+))(?:\sbuild|\))/i                  // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [

            // OPPO
            /;\s(\w+)\sbuild.+\soppo/i,
            /\s(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007)\b/i
            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [

            // Vivo
            /\svivo\s(\w+)(?:\sbuild|\))/i,
            /\s(v[12]\d{3}\w?[at])(?:\sbuild|;)/i
            ], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [

            // Realme
            /\s(rmx[12]\d{3})(?:\sbuild|;)/i
            ], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [

            // Motorola
            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)\b[\w\s]+build\//i,
            /\smot(?:orola)?[\s-](\w*)/i,
            /((?:moto[\s\w\(\)]+|xt\d{3,4}|nexus\s6)(?=\sbuild|\)))/i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
            /\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [

            // LG
            /((?=lg)?[vl]k\-?\d{3})\sbuild|\s3\.[\s\w;-]{10}lg?-([06cv9]{3,4})/i
            ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [
            /(lm-?f100[nv]?|nexus\s[45])/i,
            /lg[e;\s\/-]+((?!browser|netcast)\w+)/i,
            /\blg(\-?[\d\w]+)\sbuild/i
            ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [

            // Lenovo
            /(ideatab[\w\-\s]+)/i,
            /lenovo\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+)|yt[\d\w-]{6}|tb[\d\w-]{6})/i        // Lenovo tablets
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            // Nokia
            /(?:maemo|nokia).*(n900|lumia\s\d+)/i,
            /nokia[\s_-]?([\w\.-]*)/i
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [

            // Google
            /droid.+;\s(pixel\sc)[\s)]/i                                        // Google Pixel C
            ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [
            /droid.+;\s(pixel[\s\daxl]{0,6})(?:\sbuild|\))/i                    // Google Pixel
            ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [

            // Sony
            /droid.+\s([c-g]\d{4}|so[-l]\w+|xq-a\w[4-7][12])(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [
            /sony\stablet\s[ps]\sbuild\//i,
            /(?:sony)?sgp\w+(?:\sbuild\/|\))/i
            ], [[MODEL, 'Xperia Tablet'], [VENDOR, 'Sony'], [TYPE, TABLET]], [

            // OnePlus
            /\s(kb2005|in20[12]5|be20[12][59])\b/i,
            /\ba000(1)\sbuild/i,                                                // OnePlus
            /\boneplus\s(a\d{4})[\s)]/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi)(\sbuild\/|\))/i,                                    // Kindle Fire without Silk
            /(kf[a-z]+)(\sbuild\/|\)).+silk\//i                                 // Kindle Fire HD
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
            /(sd|kf)[0349hijorstuw]+(\sbuild\/|\)).+silk\//i                    // Fire Phone
            ], [[MODEL, 'Fire Phone'], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [

            // BlackBerry
            /\((playbook);[\w\s\),;-]+(rim)/i                                   // BlackBerry PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [
            /((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
            ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [

            // Asus
            /(?:\b|asus_)(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus\s7|padfone|p00[cj])/i
            ], [MODEL, [VENDOR, 'ASUS'], [TYPE, TABLET]], [
            /\s(z[es]6[027][01][km][ls]|zenfone\s\d\w?)\b/i
            ], [MODEL, [VENDOR, 'ASUS'], [TYPE, MOBILE]], [

            // HTC
            /(nexus\s9)/i                                                       // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
            /(htc)[;_\s-]{1,2}([\w\s]+(?=\)|\sbuild)|\w+)/i,                    // HTC

            // ZTE
            /(zte)-(\w*)/i,
            /(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            // Acer
            /droid[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            // Meizu
            /droid.+;\s(m[1-5]\snote)\sbuild/i,
            /\bmz-([\w-]{2,})/i
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [

            // MIXED
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,
                                                                                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
            /(asus)-?(\w+)/i,                                                   // Asus
            /(microsoft);\s(lumia[\s\w]+)/i,                                    // Microsoft Lumia
            /(lenovo)[_\s-]?([\w-]+)/i,                                         // Lenovo
            /linux;.+(jolla);/i,                                                // Jolla
            /droid.+;\s(oppo)\s?([\w\s]+)\sbuild/i                              // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /(archos)\s(gamepad2?)/i,                                           // Archos
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,                             // HP TouchPad
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
            /(dell)\s(strea[kpr\s\d]*[\dko])/i,                                 // Dell Streak
            /[;\/]\s?(le[\s\-]+pan)[\s\-]+(\w{1,9})\sbuild/i,                   // Le Pan Tablets
            /[;\/]\s?(trinity)[\-\s]*(t\d{3})\sbuild/i,                         // Trinity Tablets
            /\b(gigaset)[\s\-]+(q\w{1,9})\sbuild/i,                             // Gigaset Tablets
            /\b(vodafone)\s([\w\s]+)(?:\)|\sbuild)/i                            // Vodafone
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /\s(surface\sduo)\s/i                                               // Surface Duo
            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, TABLET]], [
            /droid\s[\d\.]+;\s(fp\du?)\sbuild/i
            ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [
            /\s(u304aa)\sbuild/i                                                // AT&T
            ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [
            /sie-(\w*)/i                                                        // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
            /[;\/]\s?(rct\w+)\sbuild/i                                          // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
            /[;\/\s](venue[\d\s]{2,7})\sbuild/i                                 // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
            /[;\/]\s?(q(?:mv|ta)\w+)\sbuild/i                                   // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
            /[;\/]\s(?:barnes[&\s]+noble\s|bn[rt])([\w\s\+]*)\sbuild/i          // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [
            /[;\/]\s(tm\d{3}\w+)\sbuild/i
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
            /;\s(k88)\sbuild/i                                                  // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
            /;\s(nx\d{3}j)\sbuild/i                                             // ZTE Nubia
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
            /[;\/]\s?(gen\d{3})\sbuild.*49h/i                                   // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
            /[;\/]\s?(zur\d{3})\sbuild/i                                        // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
            /[;\/]\s?((zeki)?tb.*\b)\sbuild/i                                   // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
            /[;\/]\s([yr]\d{2})\sbuild/i,
            /[;\/]\s(dragon[\-\s]+touch\s|dt)(\w{5})\sbuild/i                   // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
            /[;\/]\s?(ns-?\w{0,9})\sbuild/i                                     // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
            /[;\/]\s?((nxa|Next)-?\w{0,9})\sbuild/i                             // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
            /[;\/]\s?(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05]))\sbuild/i
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [                    // Voice Xtreme Phones
            /[;\/]\s?(lvtel\-)?(v1[12])\sbuild/i                                // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
            /;\s(ph-1)\s/i
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [                // Essential PH-1
            /[;\/]\s?(v(100md|700na|7011|917g).*\b)\sbuild/i                    // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
            /[;\/]\s?(trio[\s\w\-\.]+)\sbuild/i                                 // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
            /[;\/]\s?tu_(1491)\sbuild/i                                         // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
            /(shield[\w\s]+)\sbuild/i                                           // Nvidia Shield Tablets
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [
            /(sprint)\s(\w+)/i                                                  // Sprint Phones
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [
            /droid\s[\d\.]+;\s(cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i     // Zebra
            ], [MODEL, [VENDOR, 'Zebra'], [TYPE, TABLET]], [
            /droid\s[\d\.]+;\s(ec30|ps20|tc[2-8]\d[kx])\)/i
            ], [MODEL, [VENDOR, 'Zebra'], [TYPE, MOBILE]], [

            ///////////////////
            // CONSOLES
            ///////////////////

            /\s(ouya)\s/i,                                                      // Ouya
            /(nintendo)\s([wids3utch]+)/i                                       // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
            /droid.+;\s(shield)\sbuild/i                                        // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
            /(playstation\s[345portablevi]+)/i                                  // Playstation
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [
            /[\s\(;](xbox(?:\sone)?(?!;\sxbox))[\s\);]/i                        // Microsoft Xbox
            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [

            ///////////////////
            // SMARTTVS
            ///////////////////

            /smart-tv.+(samsung)/i                                              // Samsung
            ], [VENDOR, [TYPE, SMARTTV]], [
            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [
            /(?:linux;\snetcast.+smarttv|lg\snetcast\.tv-201\d)/i,              // LG SmartTV
            ], [[VENDOR, 'LG'], [TYPE, SMARTTV]], [
            /(apple)\s?tv/i                                                     // Apple TV
            ], [VENDOR, [MODEL, 'Apple TV'], [TYPE, SMARTTV]], [
            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, 'Chromecast'], [VENDOR, 'Google'], [TYPE, SMARTTV]], [
            /droid.+aft([\w])(\sbuild\/|\))/i                                   // Fire TV
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, SMARTTV]], [
            /\(dtv[\);].+(aquos)/i                                              // Sharp
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [
            /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i            // HbbTV devices
            ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [
            /[\s\/\(](android\s|smart[-\s]?|opera\s)tv[;\)\s]/i                 // SmartTV from Unidentified Vendors
            ], [[TYPE, SMARTTV]], [

            ///////////////////
            // WEARABLES
            ///////////////////

            /((pebble))app\/[\d\.]+\s/i                                         // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
            /droid.+;\s(glass)\s\d/i                                            // Google Glass
            ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [
            /droid\s[\d\.]+;\s(wt63?0{2,3})\)/i
            ], [MODEL, [VENDOR, 'Zebra'], [TYPE, WEARABLE]], [

            ///////////////////
            // EMBEDDED
            ///////////////////

            /(tesla)(?:\sqtcarbrowser|\/20[12]\d\.[\w\.-]+)/i                   // Tesla
            ], [VENDOR, [TYPE, EMBEDDED]], [

            ////////////////////
            // MIXED (GENERIC)
            ///////////////////

            /droid .+?; ([^;]+?)(?: build|\) applewebkit).+? mobile safari/i    // Android Phones from Unidentified Vendors
            ], [MODEL, [TYPE, MOBILE]], [
            /droid .+?;\s([^;]+?)(?: build|\) applewebkit).+?(?! mobile) safari/i  // Android Tablets from Unidentified Vendors
            ], [MODEL, [TYPE, TABLET]], [
            /\s(tablet|tab)[;\/]/i,                                             // Unidentifiable Tablet
            /\s(mobile)(?:[;\/]|\ssafari)/i                                     // Unidentifiable Mobile
            ], [[TYPE, util.lowerize]], [
            /(android[\w\.\s\-]{0,9});.+build/i                                 // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']], [
            /(phone)/i
            ], [[TYPE, MOBILE]]
        ],

        engine : [[

            /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, 'EdgeHTML']], [

            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
            ], [VERSION, [NAME, 'Blink']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
            /ekioh(flow)\/([\w\.]+)/i,                                          // Flow
            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
            /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9})\b.+(gecko)/i                                     // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows
            /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
            /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,                   // Windows Phone
            /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)(?!.+xbox)/i
            ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [

            // iOS/macOS
            /ip[honead]{2,4}\b(?:.*os\s([\w]+)\slike\smac|;\sopera)/i,          // iOS
            /cfnetwork\/.+darwin/i
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
            /(mac\sos\sx)\s?([\w\s\.]*)/i,
            /(macintosh|mac(?=_powerpc)\s)(?!.+haiku)/i                         // Mac OS
            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

            // Mobile OSes                                                      // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki/Sailfish OS
            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i,
            /(blackberry)\w*\/([\w\.]*)/i,                                      // Blackberry
            /(tizen|kaios)[\/\s]([\w\.]+)/i,                                    // Tizen/KaiOS
            /\((series40);/i                                                    // Series 40
            ], [NAME, VERSION], [
            /\(bb(10);/i                                                        // BlackBerry 10
            ], [VERSION, [NAME, 'BlackBerry']], [
            /(?:symbian\s?os|symbos|s60(?=;)|series60)[\/\s-]?([\w\.]*)/i       // Symbian
            ], [VERSION, [NAME, 'Symbian']], [
            /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
            ], [[NAME, 'Firefox OS']], [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i                              // WebOS
            ], [VERSION, [NAME, 'webOS']], [

            // Google Chromecast
            /crkey\/([\d\.]+)/i                                                 // Google Chromecast
            ], [VERSION, [NAME, 'Chromecast']], [
            /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
            ], [[NAME, 'Chromium OS'], VERSION],[

            // Console
            /(nintendo|playstation)\s([wids345portablevuch]+)/i,                // Nintendo/Playstation
            /(xbox);\s+xbox\s([^\);]+)/i,                                       // Microsoft Xbox (360, One, X, S, Series X, Series S)

            // GNU/Linux based
            /(mint)[\/\s\(\)]?(\w*)/i,                                          // Mint
            /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
            /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?=\slinux)|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus|raspbian)(?:\sgnu\/linux)?(?:\slinux)?[\/\s-]?(?!chrom|package)([\w\.-]*)/i,
                                                                                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
                                                                                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
            /(hurd|linux)\s?([\w\.]*)/i,                                        // Hurd/Linux
            /(gnu)\s?([\w\.]*)/i,                                               // GNU

            // BSD based
            /\s([frentopc-]{0,4}bsd|dragonfly)\s?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,  // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
            /(haiku)\s(\w+)/i                                                   // Haiku
            ], [NAME, VERSION], [

            // Other
            /(sunos)\s?([\w\.\d]*)/i                                            // Solaris
            ], [[NAME, 'Solaris'], VERSION], [
            /((?:open)?solaris)[\/\s-]?([\w\.]*)/i,                             // Solaris
            /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,                                // AIX
            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,  // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS/Fuchsia
            /(unix)\s?([\w\.]*)/i                                               // UNIX
            ], [NAME, VERSION]
        ]
    };


    /////////////////
    // Constructor
    ////////////////
    var UAParser = function (ua, extensions) {

        if (typeof ua === 'object') {
            extensions = ua;
            ua = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(ua, extensions).getResult();
        }

        var _ua = ua || ((typeof window !== 'undefined' && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
        var _rgxmap = extensions ? util.extend(regexes, extensions) : regexes;

        this.getBrowser = function () {
            var _browser = { name: undefined, version: undefined };
            mapper.rgx.call(_browser, _ua, _rgxmap.browser);
            _browser.major = util.major(_browser.version); // deprecated
            return _browser;
        };
        this.getCPU = function () {
            var _cpu = { architecture: undefined };
            mapper.rgx.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function () {
            var _device = { vendor: undefined, model: undefined, type: undefined };
            mapper.rgx.call(_device, _ua, _rgxmap.device);
            return _device;
        };
        this.getEngine = function () {
            var _engine = { name: undefined, version: undefined };
            mapper.rgx.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function () {
            var _os = { name: undefined, version: undefined };
            mapper.rgx.call(_os, _ua, _rgxmap.os);
            return _os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return _ua;
        };
        this.setUA = function (ua) {
            _ua = (typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH) ? util.trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = {
        NAME    : NAME,
        MAJOR   : MAJOR, // deprecated
        VERSION : VERSION
    };
    UAParser.CPU = {
        ARCHITECTURE : ARCHITECTURE
    };
    UAParser.DEVICE = {
        MODEL   : MODEL,
        VENDOR  : VENDOR,
        TYPE    : TYPE,
        CONSOLE : CONSOLE,
        MOBILE  : MOBILE,
        SMARTTV : SMARTTV,
        TABLET  : TABLET,
        WEARABLE: WEARABLE,
        EMBEDDED: EMBEDDED
    };
    UAParser.ENGINE = {
        NAME    : NAME,
        VERSION : VERSION
    };
    UAParser.OS = {
        NAME    : NAME,
        VERSION : VERSION
    };

    ///////////
    // Export
    //////////


    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if (typeof module !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (true) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
                return UAParser;
            }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {}
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window !== 'undefined' && (window.jQuery || window.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (uastring) {
            parser.setUA(uastring);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),

/***/ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/index.js":
/*!*****************************************************************!*\
  !*** ./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/index.js ***!
  \*****************************************************************/
/*! exports provided: v1, v3, v4, v5, NIL, version, validate, stringify, parse */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _v1_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./v1.js */ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/v1.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "v1", function() { return _v1_js__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _v3_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./v3.js */ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/v3.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "v3", function() { return _v3_js__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _v4_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./v4.js */ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/v4.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "v4", function() { return _v4_js__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _v5_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./v5.js */ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/v5.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "v5", function() { return _v5_js__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _nil_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./nil.js */ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/nil.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NIL", function() { return _nil_js__WEBPACK_IMPORTED_MODULE_4__["default"]; });

/* harmony import */ var _version_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./version.js */ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/version.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "version", function() { return _version_js__WEBPACK_IMPORTED_MODULE_5__["default"]; });

/* harmony import */ var _validate_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./validate.js */ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/validate.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "validate", function() { return _validate_js__WEBPACK_IMPORTED_MODULE_6__["default"]; });

/* harmony import */ var _stringify_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./stringify.js */ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/stringify.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "stringify", function() { return _stringify_js__WEBPACK_IMPORTED_MODULE_7__["default"]; });

/* harmony import */ var _parse_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./parse.js */ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/parse.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "parse", function() { return _parse_js__WEBPACK_IMPORTED_MODULE_8__["default"]; });











/***/ }),

/***/ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/md5.js":
/*!***************************************************************!*\
  !*** ./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/md5.js ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
function md5(bytes) {
  if (typeof bytes === 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Uint8Array(msg.length);

    for (var i = 0; i < msg.length; ++i) {
      bytes[i] = msg.charCodeAt(i);
    }
  }

  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */


function md5ToHexEncodedArray(input) {
  var output = [];
  var length32 = input.length * 32;
  var hexTab = '0123456789abcdef';

  for (var i = 0; i < length32; i += 8) {
    var x = input[i >> 5] >>> i % 32 & 0xff;
    var hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
    output.push(hex);
  }

  return output;
}
/**
 * Calculate output length with padding and bit length
 */


function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */


function wordsToMd5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[getOutputLength(len) - 1] = len;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (var i = 0; i < x.length; i += 16) {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }

  return [a, b, c, d];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */


function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }

  var length8 = input.length * 8;
  var output = new Uint32Array(getOutputLength(length8));

  for (var i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
  }

  return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */


function safeAdd(x, y) {
  var lsw = (x & 0xffff) + (y & 0xffff);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */


function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */


function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}

function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}

function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}

function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}

function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

/* harmony default export */ __webpack_exports__["default"] = (md5);

/***/ }),

/***/ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/nil.js":
/*!***************************************************************!*\
  !*** ./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/nil.js ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ('00000000-0000-0000-0000-000000000000');

/***/ }),

/***/ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/parse.js":
/*!*****************************************************************!*\
  !*** ./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/parse.js ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _validate_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./validate.js */ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/validate.js");


function parse(uuid) {
  if (!Object(_validate_js__WEBPACK_IMPORTED_MODULE_0__["default"])(uuid)) {
    throw TypeError('Invalid UUID');
  }

  var v;
  var arr = new Uint8Array(16); // Parse ########-....-....-....-............

  arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
  arr[1] = v >>> 16 & 0xff;
  arr[2] = v >>> 8 & 0xff;
  arr[3] = v & 0xff; // Parse ........-####-....-....-............

  arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
  arr[5] = v & 0xff; // Parse ........-....-####-....-............

  arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
  arr[7] = v & 0xff; // Parse ........-....-....-####-............

  arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
  arr[9] = v & 0xff; // Parse ........-....-....-....-############
  // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)

  arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
  arr[11] = v / 0x100000000 & 0xff;
  arr[12] = v >>> 24 & 0xff;
  arr[13] = v >>> 16 & 0xff;
  arr[14] = v >>> 8 & 0xff;
  arr[15] = v & 0xff;
  return arr;
}

/* harmony default export */ __webpack_exports__["default"] = (parse);

/***/ }),

/***/ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/regex.js":
/*!*****************************************************************!*\
  !*** ./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/regex.js ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);

/***/ }),

/***/ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/rng.js":
/*!***************************************************************!*\
  !*** ./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/rng.js ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return rng; });
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

/***/ }),

/***/ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/sha1.js":
/*!****************************************************************!*\
  !*** ./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/sha1.js ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
function f(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;

    case 1:
      return x ^ y ^ z;

    case 2:
      return x & y ^ x & z ^ y & z;

    case 3:
      return x ^ y ^ z;
  }
}

function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}

function sha1(bytes) {
  var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
  var H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];

  if (typeof bytes === 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = [];

    for (var i = 0; i < msg.length; ++i) {
      bytes.push(msg.charCodeAt(i));
    }
  } else if (!Array.isArray(bytes)) {
    // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
  }

  bytes.push(0x80);
  var l = bytes.length / 4 + 2;
  var N = Math.ceil(l / 16);
  var M = new Array(N);

  for (var _i = 0; _i < N; ++_i) {
    var arr = new Uint32Array(16);

    for (var j = 0; j < 16; ++j) {
      arr[j] = bytes[_i * 64 + j * 4] << 24 | bytes[_i * 64 + j * 4 + 1] << 16 | bytes[_i * 64 + j * 4 + 2] << 8 | bytes[_i * 64 + j * 4 + 3];
    }

    M[_i] = arr;
  }

  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;

  for (var _i2 = 0; _i2 < N; ++_i2) {
    var W = new Uint32Array(80);

    for (var t = 0; t < 16; ++t) {
      W[t] = M[_i2][t];
    }

    for (var _t = 16; _t < 80; ++_t) {
      W[_t] = ROTL(W[_t - 3] ^ W[_t - 8] ^ W[_t - 14] ^ W[_t - 16], 1);
    }

    var a = H[0];
    var b = H[1];
    var c = H[2];
    var d = H[3];
    var e = H[4];

    for (var _t2 = 0; _t2 < 80; ++_t2) {
      var s = Math.floor(_t2 / 20);
      var T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[_t2] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }

    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }

  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
}

/* harmony default export */ __webpack_exports__["default"] = (sha1);

/***/ }),

/***/ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/stringify.js":
/*!*********************************************************************!*\
  !*** ./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/stringify.js ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _validate_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./validate.js */ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/validate.js");

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!Object(_validate_js__WEBPACK_IMPORTED_MODULE_0__["default"])(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ __webpack_exports__["default"] = (stringify);

/***/ }),

/***/ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/v1.js":
/*!**************************************************************!*\
  !*** ./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/v1.js ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _rng_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./rng.js */ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/rng.js");
/* harmony import */ var _stringify_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./stringify.js */ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/stringify.js");

 // **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;

var _clockseq; // Previous uuid creation time


var _lastMSecs = 0;
var _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details

function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || new Array(16);
  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189

  if (node == null || clockseq == null) {
    var seedBytes = options.random || (options.rng || _rng_js__WEBPACK_IMPORTED_MODULE_0__["default"])();

    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }

    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.


  var msecs = options.msecs !== undefined ? options.msecs : Date.now(); // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock

  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)

  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression

  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval


  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  } // Per 4.2.1.2 Throw error if too many uuids are requested


  if (nsecs >= 10000) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch

  msecs += 12219292800000; // `time_low`

  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff; // `time_mid`

  var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff; // `time_high_and_version`

  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version

  b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)

  b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`

  b[i++] = clockseq & 0xff; // `node`

  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf || Object(_stringify_js__WEBPACK_IMPORTED_MODULE_1__["default"])(b);
}

/* harmony default export */ __webpack_exports__["default"] = (v1);

/***/ }),

/***/ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/v3.js":
/*!**************************************************************!*\
  !*** ./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/v3.js ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _v35_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./v35.js */ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/v35.js");
/* harmony import */ var _md5_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./md5.js */ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/md5.js");


var v3 = Object(_v35_js__WEBPACK_IMPORTED_MODULE_0__["default"])('v3', 0x30, _md5_js__WEBPACK_IMPORTED_MODULE_1__["default"]);
/* harmony default export */ __webpack_exports__["default"] = (v3);

/***/ }),

/***/ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/v35.js":
/*!***************************************************************!*\
  !*** ./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/v35.js ***!
  \***************************************************************/
/*! exports provided: DNS, URL, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DNS", function() { return DNS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "URL", function() { return URL; });
/* harmony import */ var _stringify_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./stringify.js */ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/stringify.js");
/* harmony import */ var _parse_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./parse.js */ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/parse.js");



function stringToBytes(str) {
  str = unescape(encodeURIComponent(str)); // UTF8 escape

  var bytes = [];

  for (var i = 0; i < str.length; ++i) {
    bytes.push(str.charCodeAt(i));
  }

  return bytes;
}

var DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
var URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
/* harmony default export */ __webpack_exports__["default"] = (function (name, version, hashfunc) {
  function generateUUID(value, namespace, buf, offset) {
    if (typeof value === 'string') {
      value = stringToBytes(value);
    }

    if (typeof namespace === 'string') {
      namespace = Object(_parse_js__WEBPACK_IMPORTED_MODULE_1__["default"])(namespace);
    }

    if (namespace.length !== 16) {
      throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
    } // Compute hash of namespace and value, Per 4.3
    // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
    // hashfunc([...namespace, ... value])`


    var bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace);
    bytes.set(value, namespace.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 0x0f | version;
    bytes[8] = bytes[8] & 0x3f | 0x80;

    if (buf) {
      offset = offset || 0;

      for (var i = 0; i < 16; ++i) {
        buf[offset + i] = bytes[i];
      }

      return buf;
    }

    return Object(_stringify_js__WEBPACK_IMPORTED_MODULE_0__["default"])(bytes);
  } // Function#name is not settable on some platforms (#270)


  try {
    generateUUID.name = name; // eslint-disable-next-line no-empty
  } catch (err) {} // For CommonJS default export support


  generateUUID.DNS = DNS;
  generateUUID.URL = URL;
  return generateUUID;
});

/***/ }),

/***/ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/v4.js":
/*!**************************************************************!*\
  !*** ./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/v4.js ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _rng_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./rng.js */ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/rng.js");
/* harmony import */ var _stringify_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./stringify.js */ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/stringify.js");



function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || _rng_js__WEBPACK_IMPORTED_MODULE_0__["default"])(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return Object(_stringify_js__WEBPACK_IMPORTED_MODULE_1__["default"])(rnds);
}

/* harmony default export */ __webpack_exports__["default"] = (v4);

/***/ }),

/***/ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/v5.js":
/*!**************************************************************!*\
  !*** ./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/v5.js ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _v35_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./v35.js */ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/v35.js");
/* harmony import */ var _sha1_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./sha1.js */ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/sha1.js");


var v5 = Object(_v35_js__WEBPACK_IMPORTED_MODULE_0__["default"])('v5', 0x50, _sha1_js__WEBPACK_IMPORTED_MODULE_1__["default"]);
/* harmony default export */ __webpack_exports__["default"] = (v5);

/***/ }),

/***/ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/validate.js":
/*!********************************************************************!*\
  !*** ./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/validate.js ***!
  \********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _regex_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./regex.js */ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/regex.js");


function validate(uuid) {
  return typeof uuid === 'string' && _regex_js__WEBPACK_IMPORTED_MODULE_0__["default"].test(uuid);
}

/* harmony default export */ __webpack_exports__["default"] = (validate);

/***/ }),

/***/ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/version.js":
/*!*******************************************************************!*\
  !*** ./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/version.js ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _validate_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./validate.js */ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/validate.js");


function version(uuid) {
  if (!Object(_validate_js__WEBPACK_IMPORTED_MODULE_0__["default"])(uuid)) {
    throw TypeError('Invalid UUID');
  }

  return parseInt(uuid.substr(14, 1), 16);
}

/* harmony default export */ __webpack_exports__["default"] = (version);

/***/ }),

/***/ "./node_modules/_webpack@4.46.0@webpack/buildin/amd-options.js":
/*!****************************************!*\
  !*** (webpack)/buildin/amd-options.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(this, {}))

/***/ }),

/***/ "./node_modules/_webpack@4.46.0@webpack/buildin/global.js":
/*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "./src/CM.ts":
/*!*******************!*\
  !*** ./src/CM.ts ***!
  \*******************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(/*! @/common/common */ "./src/common/common.ts");
var config_1 = __webpack_require__(/*! @/config */ "./src/config.ts");
__webpack_require__(/*! CMJSSDK */ "./static/jssdk_v1.0.0.min.js");
var CM = /** @class */ (function () {
    function CM(phoneServer, debuggerMode) {
        this.debuggerMode = debuggerMode;
        this.phoneServer = phoneServer;
    }
    /**
     * 移动获取的token方法
     * @param {CMOPts} options
     */
    CM.prototype.getToken = function (params, accessToken) {
        return __awaiter(this, void 0, void 0, function () {
            var startTime, isLimit;
            var _this = this;
            return __generator(this, function (_a) {
                startTime = new Date();
                isLimit = config_1.default.checkRequestLimit('ACMLimitConfig', 'authToken', 'CM');
                return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                        var res, res, opts, res;
                        var _this = this;
                        return __generator(this, function (_a) {
                            try {
                                if (isLimit === 1) {
                                    res = {
                                        code: 600013,
                                        msg: '系统升级该功能不可用'
                                    };
                                    this.phoneServer.insertVendorTokenMonitor(startTime, false, res.code, res.msg, 'CM');
                                    reject(res);
                                    return [2 /*return*/];
                                }
                                if (isLimit === 2) {
                                    res = {
                                        code: 600014,
                                        msg: '系统维护升级，该功能已达最大调用次数'
                                    };
                                    this.phoneServer.insertVendorTokenMonitor(startTime, false, res.code, res.msg, 'CM');
                                    reject(res);
                                    return [2 /*return*/];
                                }
                                opts = {
                                    data: params,
                                    success: function (resp) {
                                        var res = common_1.isObject(resp) ? resp : {};
                                        var spToken = {
                                            userInformation: res.userInformation,
                                            spToken: res.token,
                                            accessToken: accessToken,
                                        };
                                        var token = common_1.encryptByDES(JSON.stringify(spToken));
                                        var response = {
                                            code: 600000,
                                            spToken: common_1.baseEncrypt(JSON.stringify(token)),
                                        };
                                        var s = __assign(__assign({}, spToken), { accessCode: spToken.spToken || '', spToken: response.spToken });
                                        _this.phoneServer.insertVendorTokenMonitor(startTime, true, response.code, '', 'CM', false, JSON.stringify(params), '', s);
                                        resolve(response);
                                    },
                                    error: function (error) {
                                        var res = _this.getTokenFailed(startTime, params, accessToken, error);
                                        reject(res);
                                    }
                                };
                                config_1.default.addReqCount('ACMLimitConfig', 'authToken', 'CM');
                                window.YDRZ.getTokenInfo(opts);
                            }
                            catch (err) {
                                res = this.getTokenFailed(startTime, params, accessToken, err);
                                reject(res);
                            }
                            return [2 /*return*/];
                        });
                    }); })];
            });
        });
    };
    /**
     * 获取token失败的处理方法
     * @param startTime
     * @param params
     * @param accessToken
     * @param error
     */
    CM.prototype.getTokenFailed = function (startTime, params, accessToken, error) {
        if (this.debuggerMode) {
            window.console.log('移动获取token失败', error);
        }
        var err = common_1.isObject(error) ? error : { msg: common_1.isString(error) ? error : 'unknown' };
        var res = {
            code: 600011,
            msg: '获取token失败',
            carrier: {
                carrierTraceId: err.msgId || '000',
                carrierSdkCode: err.code || 0,
                carrierRespCode: 0,
                carrierSdkMsg: err.message || ''
            },
            content: error
        };
        var s = { accessToken: accessToken };
        this.phoneServer.insertVendorTokenMonitor(startTime, false, res.code, res.msg, 'CM', false, JSON.stringify(params), '', s, res.carrier);
        return res;
    };
    return CM;
}());
exports.default = CM;


/***/ }),

/***/ "./src/CT.ts":
/*!*******************!*\
  !*** ./src/CT.ts ***!
  \*******************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var API_1 = __webpack_require__(/*! @/utils/API */ "./src/utils/API.ts");
var request_1 = __webpack_require__(/*! @/utils/request */ "./src/utils/request.ts");
var common_1 = __webpack_require__(/*! @/common/common */ "./src/common/common.ts");
var config_1 = __webpack_require__(/*! @/config */ "./src/config.ts");
var CU = /** @class */ (function () {
    function CU(phoneServer, debuggerMode) {
        this.debuggerMode = debuggerMode;
        this.phoneServer = phoneServer;
    }
    /**
     * 电信获取的token方法
     * @param params
     */
    CU.prototype.getToken = function (params, accessToken) {
        return __awaiter(this, void 0, void 0, function () {
            var startTime, isLimit;
            var _this = this;
            return __generator(this, function (_a) {
                startTime = new Date();
                isLimit = config_1.default.checkRequestLimit('ACMLimitConfig', 'authToken', 'CT');
                return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                        var res, res, response, spToken, token, res, s, resp, error_1, resp;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    if (isLimit === 1) {
                                        res = {
                                            code: 600013,
                                            msg: '系统升级该功能不可用',
                                        };
                                        this.phoneServer.insertVendorTokenMonitor(startTime, false, res.code, res.msg, 'CT');
                                        reject(res);
                                        return [2 /*return*/];
                                    }
                                    if (isLimit === 2) {
                                        res = {
                                            code: 600014,
                                            msg: '运营商维护升级，该功能已达最大调用次数',
                                        };
                                        this.phoneServer.insertVendorTokenMonitor(startTime, false, res.code, res.msg, 'CT');
                                        reject(res);
                                        return [2 /*return*/];
                                    }
                                    config_1.default.addReqCount('ACMLimitConfig', 'authToken', 'CT');
                                    return [4 /*yield*/, request_1.requestJsonp(API_1.default.preGetMobileCT, params, 'callback')];
                                case 1:
                                    response = _a.sent();
                                    if (response.result === 0 || response.result === 1000) {
                                        spToken = {
                                            userInformation: '',
                                            spToken: response.data,
                                            accessToken: accessToken,
                                        };
                                        token = common_1.encryptByDES(JSON.stringify(spToken));
                                        res = {
                                            code: 600000,
                                            spToken: common_1.baseEncrypt(JSON.stringify(token)),
                                        };
                                        s = __assign(__assign({}, spToken), { accessCode: spToken.spToken || '', spToken: response.spToken });
                                        this.phoneServer.insertVendorTokenMonitor(startTime, true, response.code, '', 'CT', false, JSON.stringify(params), '', s);
                                        resolve(res);
                                        return [2 /*return*/];
                                    }
                                    resp = this.getTokenFailed(startTime, params, accessToken, response);
                                    reject(resp);
                                    return [3 /*break*/, 3];
                                case 2:
                                    error_1 = _a.sent();
                                    resp = this.getTokenFailed(startTime, params, accessToken, error_1);
                                    reject(resp);
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    /**
     * 获取token失败的处理方法
     * @param startTime
     * @param params
     * @param accessToken
     * @param error
     */
    CU.prototype.getTokenFailed = function (startTime, params, accessToken, error) {
        if (this.debuggerMode) {
            window.console.log('电信获取token失败', error);
        }
        var err = common_1.isObject(error) ? error : { msg: common_1.isString(error) ? error : 'unknown' };
        var resp = {
            code: 600011,
            msg: '获取token失败',
            carrier: {
                carrierTraceId: err.data || '000',
                carrierSdkCode: err.result || 0,
                carrierRespCode: 0,
                carrierSdkMsg: err.msg || 'unknown',
            },
            content: error,
        };
        var s = { accessToken: accessToken };
        this.phoneServer.insertVendorTokenMonitor(startTime, false, resp.code, resp.msg, 'CT', false, JSON.stringify(params), JSON.stringify(err), s, resp.carrier);
        return resp;
    };
    return CU;
}());
exports.default = CU;


/***/ }),

/***/ "./src/CU.ts":
/*!*******************!*\
  !*** ./src/CU.ts ***!
  \*******************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(/*! @/common/common */ "./src/common/common.ts");
var config_1 = __webpack_require__(/*! @/config */ "./src/config.ts");
__webpack_require__(/*! CUJSSDK */ "./static/verify_mobile_sdk-1.3.0.js");
var CU = /** @class */ (function () {
    function CU(phoneServer, debuggerMode) {
        this.debuggerMode = debuggerMode;
        this.phoneServer = phoneServer;
    }
    /**
     * 获取联通的token方法
     * @param {CUOPts} options
     */
    CU.prototype.getToken = function (params, accessToken) {
        return __awaiter(this, void 0, void 0, function () {
            var startTime, isLimit;
            var _this = this;
            return __generator(this, function (_a) {
                startTime = new Date();
                isLimit = config_1.default.checkRequestLimit('ACMLimitConfig', 'authToken', 'CU');
                return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                        var limitRes, remoteRes, response, authResp, res, spToken, token, successResp, secret, verifyResult, error_1, resp;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 3, , 4]);
                                    if (isLimit === 1) {
                                        limitRes = {
                                            code: 600013,
                                            msg: '系统升级该功能不可用',
                                        };
                                        this.phoneServer.insertVendorTokenMonitor(startTime, false, limitRes.code, limitRes.msg, 'CU');
                                        reject(limitRes);
                                        return [2 /*return*/];
                                    }
                                    if (isLimit === 2) {
                                        remoteRes = {
                                            code: 600014,
                                            msg: '运营商维护升级，该功能已达最大调用次数',
                                        };
                                        this.phoneServer.insertVendorTokenMonitor(startTime, false, remoteRes.code, remoteRes.msg, 'CU');
                                        reject(remoteRes);
                                        return [2 /*return*/];
                                    }
                                    config_1.default.addReqCount('ACMLimitConfig', 'authToken', 'CU');
                                    return [4 /*yield*/, window.JWuSDK.initWithAuth(params)];
                                case 1:
                                    response = _a.sent();
                                    console.log('success', response);
                                    if (response.code !== '000000') {
                                        authResp = this.getTokenFailed(startTime, params, accessToken, response, true);
                                        reject(authResp);
                                        return [2 /*return*/];
                                    }
                                    return [4 /*yield*/, window.JWuSDK.verifyMobile()];
                                case 2:
                                    res = _a.sent();
                                    console.log('verifySuccess', response);
                                    if (res.code === '000000') {
                                        spToken = {
                                            userInformation: '',
                                            spToken: res.data && res.data.accessToken,
                                            accessToken: accessToken,
                                        };
                                        token = common_1.encryptByDES(JSON.stringify(spToken));
                                        successResp = {
                                            code: 600000,
                                            spToken: common_1.baseEncrypt(JSON.stringify(token)),
                                        };
                                        secret = __assign(__assign({}, spToken), { accessCode: spToken.spToken || '', spToken: response.spToken });
                                        this.phoneServer.insertVendorTokenMonitor(startTime, true, response.code, '', 'CU', false, JSON.stringify(params), '', secret);
                                        resolve(successResp);
                                        return [2 /*return*/];
                                    }
                                    verifyResult = this.getTokenFailed(startTime, params, accessToken, res, false);
                                    reject(verifyResult);
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_1 = _a.sent();
                                    resp = this.getTokenFailed(startTime, params, accessToken, error_1);
                                    reject(resp);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    /**
     * 获取token失败的处理方法
     * @param startTime
     * @param params
     * @param accessToken
     * @param error
     */
    CU.prototype.getTokenFailed = function (startTime, params, accessToken, error, isAuthFailed) {
        console.log('err', error);
        if (this.debuggerMode) {
            window.console.log('获取token失败', error);
        }
        var err = common_1.isObject(error) ? error : { msg: common_1.isString(error) ? error : 'unknown' };
        var resp = {
            code: 600011,
            msg: '获取token失败',
            carrier: {
                carrierTraceId: err.errorUrl || '000',
                carrierSdkCode: err.code || 0,
                carrierRespCode: err.respCode || 0,
                carrierSdkMsg: err.msg || '',
            },
            content: error,
        };
        var s = { accessToken: accessToken };
        var errorUrl = err.errorUrl || '';
        var reg = RegExp(/authentication/g);
        var isAuth = isAuthFailed || !!errorUrl.match(reg);
        this.phoneServer.insertVendorTokenMonitor(
        // tslint:disable-next-line:max-line-length
        startTime, false, resp.code, resp.msg, 'CU', isAuth, JSON.stringify(params), JSON.stringify(err), s, resp.carrier);
        return resp;
    };
    return CU;
}());
exports.default = CU;


/***/ }),

/***/ "./src/common/common.ts":
/*!******************************!*\
  !*** ./src/common/common.ts ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.checkAuthResp = exports.checkParams = exports.isNumber = exports.isFun = exports.isBoolean = exports.isString = exports.isObject = exports.isEmptyObject = exports.createUuid = exports.encryptByDES = exports.baseEncrypt = exports.EncryptRSA = exports.createMd5 = exports.isWifi = exports.osIsPc = exports.findIndex = exports.jsLoader = exports.createAESKey = void 0;
var MD5 = __webpack_require__(/*! js-md5 */ "./node_modules/_js-md5@0.7.3@js-md5/src/md5.js");
var CryptoJS = __webpack_require__(/*! crypto-js */ "./node_modules/_crypto-js@3.3.0@crypto-js/index.js");
var jsencrypt_1 = __webpack_require__(/*! jsencrypt */ "./node_modules/_jsencrypt@3.2.0@jsencrypt/lib/index.js");
var uuid_1 = __webpack_require__(/*! uuid */ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/index.js");
function createAESKey(n) {
    if (n === void 0) { n = 16; }
    // tslint:disable-next-line:max-line-length
    var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    var aesKey = '';
    for (var i = 0; i < n; i++) {
        var id = Math.ceil(Math.random() * 35);
        aesKey += chars[id];
    }
    return aesKey;
}
exports.createAESKey = createAESKey;
/**
 * jsLoader加载器
 * @param {string} url
 * @param {IjsLoaderCallback} callback
 * @param {SPOpts | IpreSign} data
 * @param {boolean} isNotRemove
 */
function jsLoader(url, isCM) {
    if (isCM === void 0) { isCM = false; }
    // if(!isCM && !(window as any).YDRZ){
    //
    // }
    return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.onload = function () {
            resolve();
        };
        script.addEventListener('error', function () {
            reject(url + "script\u8D44\u6E90\u52A0\u8F7D\u5931\u8D25");
            document.body.removeChild(script);
        }, false);
        document.head.appendChild(script);
    });
}
exports.jsLoader = jsLoader;
/**
 * 判断元素是否在数组中
 * @param {{[p: string]: any}[]} array
 * @param {string} val
 * @returns {boolean}
 */
function findIndex(array, val) {
    var index = array.findIndex(function (value) {
        return value.id === val;
    });
    return index;
}
exports.findIndex = findIndex;
function osIsPc() {
    var userAgentInfo = navigator.userAgent;
    var agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPod', 'iPad'];
    var flag = true;
    for (var i = 0; i < agents.length; i++) {
        if (userAgentInfo.indexOf(agents[i]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}
exports.osIsPc = osIsPc;
function isWifi() {
    var navigator = window.navigator;
    var userAgentInfo = navigator.userAgent.toLowerCase();
    var index = userAgentInfo.indexOf('wifi');
    if (index > -1) {
        return true;
    }
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    var connectionType = connection && connection.type;
    if (connectionType === 'wifi') {
        return true;
    }
    return false;
}
exports.isWifi = isWifi;
/**
 * md5加密逻辑
 * @param {string} str
 * @returns {string}
 */
function createMd5(str) {
    return MD5(str);
}
exports.createMd5 = createMd5;
function EncryptRSA(word) {
    var publicKey = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDC/h4YawL1fCVsE8L8jRezZb/b\nX/Q1sQFqUIqtiEh6o2Lppus07FE7/uWq5CCAAawydsagVJDa/gDMTA9Fxt6E/hNj\nMh1fl0Qy5WXHTIUVH2m3XsbKkZSQzvoeGMXqLap6Gi+GNeMPBlFqbiVppjjRvHza\nOSlnDoNXhu4N9LgxJQIDAQAB";
    var encrypt = new jsencrypt_1.default({});
    encrypt.setPublicKey(publicKey);
    return encrypt.encrypt(word);
}
exports.EncryptRSA = EncryptRSA;
/**
 * base64加密算法
 * @param word
 * @returns {string}
 * @constructor
 */
function baseEncrypt(word) {
    var encryptedHexStr = CryptoJS.enc.Utf8.parse(word);
    return CryptoJS.enc.Base64.stringify(encryptedHexStr);
}
exports.baseEncrypt = baseEncrypt;
/**
 * des 加密
 * @param value
 * @param key
 * @returns {string}
 */
function encryptByDES(word) {
    var key = createAESKey();
    var keyHash = CryptoJS.enc.Utf8.parse(key);
    var srcs = CryptoJS.enc.Utf8.parse(word);
    var iv = CryptoJS.enc.Utf8.parse('0000000000000000');
    var aesKey = EncryptRSA(key);
    var encrypted = CryptoJS.AES.encrypt(srcs, keyHash, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return {
        spToken: encrypted.ciphertext.toString(),
        aesKey: aesKey
    };
}
exports.encryptByDES = encryptByDES;
/**
 * 生成一个uuid
 */
function createUuid() {
    return uuid_1.v4();
}
exports.createUuid = createUuid;
/**
 * 判断对象是否为空
 * @param obj
 */
function isEmptyObject(obj) {
    return JSON.stringify(obj) === '{}';
}
exports.isEmptyObject = isEmptyObject;
/**
 * 判断是不是对象
 * @param obj
 */
function isObject(obj) {
    return Object.prototype.toString.call(obj).slice(8, -1) === 'Object';
}
exports.isObject = isObject;
/**
 * 判断是不是字符串
 * @param obj
 */
function isString(obj) {
    return Object.prototype.toString.call(obj).slice(8, -1) === 'String';
}
exports.isString = isString;
/**
 * 判断是不是布尔值
 * @param obj
 */
function isBoolean(obj) {
    return Object.prototype.toString.call(obj).slice(8, -1) === 'Boolean';
}
exports.isBoolean = isBoolean;
/**
 * 判断是不是字符串
 * @param obj
 */
function isFun(obj) {
    return Object.prototype.toString.call(obj).slice(8, -1) === 'Function';
}
exports.isFun = isFun;
/**
 * 判断是不是字符串
 * @param obj
 */
function isNumber(obj) {
    return Object.prototype.toString.call(obj).slice(8, -1) === 'Number';
}
exports.isNumber = isNumber;
// 检查checkAuth接口入参
function checkParams(opts) {
    if (!isObject(opts)) {
        return false;
    }
    if (!opts.accessToken || !opts.jwtToken || !opts.error || !opts.success) {
        return false;
    }
    if (!isFun(opts.error) || !isFun(opts.success)) {
        return false;
    }
    return true;
}
exports.checkParams = checkParams;
// 检查checkAuth接口入参
function checkAuthResp(data) {
    if (!data.appId || !data.sign) {
        return {
            isSuccess: false,
            code: 600004,
            msg: '方案号不存在'
        };
    }
    if (!data.vender) {
        return {
            isSuccess: false,
            code: 600009,
            msg: '无法判断运营商'
        };
    }
    return {
        isSuccess: true
    };
}
exports.checkAuthResp = checkAuthResp;


/***/ }),

/***/ "./src/common/jsonp.ts":
/*!*****************************!*\
  !*** ./src/common/jsonp.ts ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * url拼接方法
 * @param data
 * @returns {string}
 */
function param(data) {
    var url = '';
    for (var k in data) {
        var value = data[k] !== undefined ? data[k] : '';
        url += "&" + k + "=" + encodeURIComponent(value);
    }
    return url ? url.substring(1) : '';
}
/**JSONP 请求
 *
 * @param url
 * @param {{[p: string]: any}} data data
 * @param {string} callbackName
 * @returns {Promise}
 */
function fetchJSONP(url, data, callbackName) {
    if (callbackName === void 0) { callbackName = 'callback'; }
    return new Promise(function (resolve, reject) {
        try {
            // 根据url是否带有参数决定参数前缀符
            var paramFlag = url.indexOf('?') === -1 ? '?' : '&';
            var timer_1;
            // 组装带回调函数和请求参数的url
            url += (url.indexOf('?') < 0 ? '?' : '&') + param(data);
            // 动态创建script标签 在回调函数中需要对该动态创建的标签进行删除
            var script_1 = document.createElement('script');
            timer_1 = setTimeout(function () {
                if (timer_1) {
                    clearTimeout(timer_1);
                }
                if (script_1.parentNode) {
                    document.body.removeChild(script_1);
                }
                reject('接口请求超时');
            }, 4000);
            script_1.src = url;
            // jsonp返回数据到回调函数 需要注意 回调函数必须绑定在window上 且接受数据完毕后要进行回调函数的删除
            window[callbackName] = function (res) {
                // 删除动态创建的script标签
                if (script_1.parentNode) {
                    document.body.removeChild(script_1);
                }
                if (timer_1) {
                    clearTimeout(timer_1);
                }
                if (res) {
                    resolve(res);
                }
                else {
                    reject('没有返回数据');
                }
            };
            // 处理动态加载script标签异常的情况
            script_1.addEventListener('error', function () {
                if (script_1.parentNode) {
                    document.body.removeChild(script_1);
                }
                if (timer_1) {
                    clearTimeout(timer_1);
                }
                reject('script资源加载失败');
            }, false);
            // 添加js节点到document上，开始请求
            document.body.appendChild(script_1);
        }
        catch (e) {
            reject(e);
        }
    });
}
exports.default = fetchJSONP;


/***/ }),

/***/ "./src/config.ts":
/*!***********************!*\
  !*** ./src/config.ts ***!
  \***********************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var request_1 = __webpack_require__(/*! @/utils/request */ "./src/utils/request.ts");
var API_1 = __webpack_require__(/*! @/utils/API */ "./src/utils/API.ts");
var common_1 = __webpack_require__(/*! @/common/common */ "./src/common/common.ts");
var moment_1 = __webpack_require__(/*! @/moment */ "./src/moment.ts");
var constants_1 = __webpack_require__(/*! @/./constants */ "./src/constants.ts");
var ACTION_GET_CONFIG = 'sdk.config';
var ACTION_GET_VENDOR_CONFIG = 'sdk.vendorConfig';
var BROWSER_NAME = constants_1.Constants.BROWSER_NAME;
var BROWSER_VERSION = constants_1.Constants.BROWSER_VERSION;
var OS_NAME = constants_1.Constants.OS_NAME;
var OS_VERSION = constants_1.Constants.OS_VERSION;
var getFullYear = moment_1.default.getFullYear, getMonth = moment_1.default.getMonth, getHours = moment_1.default.getHours, getDay = moment_1.default.getDay;
var Config = /** @class */ (function () {
    function Config(phoneServer) {
        this.phoneServer = phoneServer;
    }
    /**
     * 设置降级限流
     * @param config
     */
    Config.setLimitConfig = function (config, carrierType) {
        // is_limited
        var limit = common_1.isObject(config.limit) ? config.limit : {};
        var configData = this.getLimitConfig('ACMLimitConfig');
        // 拉取供应商配置和拉取其他配置的时候都要更新config的信息
        // 如果未配置降级限流配置则不降级限流 如果配置的格式不正确则按上次拉取的降级限流规则
        if (!Config.checkConfig(limit.config)) {
            limit.config = Config.buildConfigData(limit.config, configData.config || {});
        }
        // config 默认不降级
        configData.config = this.updateLimitConfig(limit.config, 'ACMLimitConfig', 'config');
        // 如果carrierType存在，只更新供应商纬度配置信息
        if (carrierType) {
            if (!Config.checkConfig(limit.authToken)) {
                var oldTokenLimit = configData.authToken || {};
                var oldTokenConfig = oldTokenLimit[carrierType] || {};
                limit.authToken = Config.buildConfigData(limit.authToken, oldTokenConfig);
            }
            if (!configData.authToken) {
                configData.authToken = {};
            }
            configData.authToken[carrierType] = this.updateLimitConfig(__assign({ isDemoted: !!config.isDemoted || !!config.isAuthDemoted }, limit.authToken), 'ACMLimitConfig', 'authToken', carrierType);
            this.storeLimitConfig(configData, 'ACMLimitConfig');
            return;
        }
        configData.isDemoted = !!config.isDemoted;
        if (!Config.checkConfig(limit.authCheck)) {
            limit.authCheck = Config.buildConfigData(limit.authCheck, configData.authCheck);
        }
        var data = __assign(__assign({}, limit.authCheck), { isDemoted: !!config.isDemoted || !!config.isAuthDemoted });
        configData.authCheck = this.updateLimitConfig(data, 'ACMLimitConfig', 'authCheck');
        this.storeLimitConfig(configData, 'ACMLimitConfig');
    };
    /**
     * 检查降级限流配置格式
     * @param config
     */
    Config.checkConfig = function (config) {
        if (!common_1.isObject(config)) {
            return false;
        }
        if (common_1.isEmptyObject(config)) {
            return false;
        }
        if (!common_1.isBoolean(config.is_limited)) {
            return false;
        }
        if (!common_1.isNumber(config.limitTime)) {
            return false;
        }
        if (!common_1.isNumber(config.limitCount)) {
            return false;
        }
        return true;
    };
    /**
     * 如果未配置降级限流配置则不降级限流 如果配置的格式不正确则按上次拉取的降级限流规则
     * @param config  新的降级限流规则
     * @param oldLimit 旧的降级限流规则
     */
    Config.buildConfigData = function (config, oldLimit) {
        if (!common_1.isObject(config) || common_1.isEmptyObject(config)) {
            return {
                is_limited: false,
                limitTime: 0,
                limitCount: 0
            };
        }
        return oldLimit;
    };
    /**
     * 检查降级限流配置
     * return 1 降级 2 限流 0不降级不限流
     */
    Config.checkRequestLimit = function (storeName, configKey, carrierType) {
        var config = this.getLimitConfig(storeName);
        var limit = config[configKey] || {};
        var limitConfig = carrierType ? (limit[carrierType] || {}) : limit;
        var currentTime = Date.now();
        // 还未拉取降级限流配置之前默认不降级限流
        if (common_1.isEmptyObject(limitConfig)) {
            return 0;
        }
        // config 只有限流无降级
        if (configKey !== 'config' && limitConfig.isDemoted) {
            return 1;
        }
        // 对不限流且需重置次数的逻辑进行封装
        var isLimit = this.checkConfigLimit(limitConfig, currentTime);
        if (!isLimit) {
            return 0;
        }
        // 当前请求次数小于最大请求次数，不限流
        if (limitConfig.reqCount < limitConfig.limitCount) {
            return 0;
        }
        return 2;
    };
    /**
     * 设置降级限流方案
     */
    Config.updateLimitConfig = function (limitConfig, storeName, configKey, carrierType) {
        var currentTime = Date.now();
        var oldConfig = this.getLimitConfig(storeName);
        var oldLimit = oldConfig[configKey] || {};
        var oldLimitConfig = carrierType ? (oldLimit[carrierType] || {}) : oldLimit;
        var newLimitConfig = {
            isDemoted: !!limitConfig.isDemoted,
            isLimited: !!limitConfig.is_limited,
            msg: limitConfig.msg || '',
            limitTime: limitConfig.limitTime,
            limitCount: limitConfig.limitCount,
            reqCount: oldLimitConfig.reqCount || 0,
            lastReqTime: oldLimitConfig.lastReqTime || currentTime
        };
        var isLimit = this.checkConfigLimit(newLimitConfig, currentTime);
        // 重置次数逻辑
        if (newLimitConfig.isDemoted || !isLimit) {
            newLimitConfig.reqCount = 0;
            newLimitConfig.lastReqTime = currentTime;
        }
        return newLimitConfig;
    };
    // 获取降级限流配置
    Config.getLimitConfig = function (storeName) {
        var limitConfig = localStorage.getItem(storeName);
        return limitConfig ? JSON.parse(limitConfig) : {};
    };
    /**
     * storeLimitConfig 把limit配置存储在磁盘
     * @param limitConfig
     */
    Config.storeLimitConfig = function (limitConfig, storeName) {
        localStorage.setItem(storeName, JSON.stringify(limitConfig));
    };
    // 增加次数
    Config.addReqCount = function (storeName, configKey, carrierType) {
        var config = this.getLimitConfig(storeName);
        var limit = config[configKey] || {};
        var limitConfig = carrierType ? (limit[carrierType] || {}) : limit;
        var currentTime = Date.now();
        if (!config[configKey]) {
            return;
        }
        var isLimit = this.checkConfigLimit(limitConfig, currentTime);
        if (isLimit) {
            limitConfig.reqCount = ++limitConfig.reqCount;
            limitConfig.lastReqTime = currentTime;
        }
        if (carrierType) {
            config[configKey][carrierType] = limitConfig;
        }
        else {
            config[configKey] = limitConfig;
        }
        this.storeLimitConfig(config, storeName);
    };
    /**
     * 对可重置的限流逻辑进行检查封装
     * @param limitConfig
     * @param currentTime
     */
    Config.checkConfigLimit = function (limitConfig, currentTime) {
        var isLimitTimeNumber = common_1.isNumber(limitConfig.limitTime);
        // 如果isLimited为false，则不限流
        if (!limitConfig.isLimited) {
            return false;
        }
        // limitTime 小于等于0或者不能被24整除，不限流
        if (!isLimitTimeNumber || limitConfig.limitTime <= 0 || 24 % limitConfig.limitTime !== 0) {
            return false;
        }
        if (!limitConfig.lastReqTime) {
            return false;
        }
        var oldPeriod = getHours(limitConfig.lastReqTime) / limitConfig.limitTime;
        var currentPeriod = getHours(currentTime) / limitConfig.limitTime;
        // 新的请求和老的请求不在同一天且不在同一个区间，不限流
        if (getFullYear(limitConfig.lastReqTime) !== getFullYear(currentTime) ||
            getMonth(limitConfig.lastReqTime) !== getMonth(currentTime) ||
            getDay(limitConfig.lastReqTime) !== getDay(currentTime) ||
            parseInt(String(oldPeriod)) !== parseInt(String(currentPeriod)) // parseInt第一个参数为字符串
        ) {
            return false;
        }
        return true;
    };
    Config.prototype.getConfig = function (jwtToken, accessToken, sdkVersion, carrierType) {
        return __awaiter(this, void 0, void 0, function () {
            var data, startTime, action;
            var _this = this;
            return __generator(this, function (_a) {
                data = __assign({ sdkVersion: sdkVersion, osType: 'WEB', originId: window.location.host, businessType: 'dypns', browserId: BROWSER_NAME, browserVersion: BROWSER_VERSION, osId: OS_NAME, osVersion: OS_VERSION }, (carrierType
                    ? {
                        vendorId: carrierType
                    }
                    : {}));
                startTime = new Date();
                action = carrierType ? ACTION_GET_VENDOR_CONFIG : ACTION_GET_CONFIG;
                return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                        var configResult, res, resp, model, config, message, info, msg, err_1, msg;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    if (!jwtToken) {
                                        reject('jwtToken不合法');
                                        return [2 /*return*/];
                                    }
                                    return [4 /*yield*/, request_1.request(API_1.default.getConfig, 'post', data, { jwtToken: jwtToken }, { 'Content-Type': 'application/json' })];
                                case 1:
                                    configResult = _a.sent();
                                    res = common_1.isObject(configResult) ? configResult : {};
                                    resp = common_1.isObject(res.data) ? res.data : {};
                                    model = resp.model;
                                    config = common_1.isString(model) ? JSON.parse(model) : {};
                                    if (config && resp.code === 'OK') {
                                        message = '拉取降级限流配置成功';
                                        info = this.phoneServer.createSdkInfo(true, message, 0);
                                        this.phoneServer.insertGetConfigMonitor(action, startTime, info, JSON.stringify(data), JSON.stringify({}), JSON.stringify(config));
                                        resolve(config);
                                        return [2 /*return*/];
                                    }
                                    msg = '拉取降级限流配置失败';
                                    this.getConfigFailed(action, startTime, false, msg, 0, data, config);
                                    reject();
                                    return [3 /*break*/, 3];
                                case 2:
                                    err_1 = _a.sent();
                                    msg = '拉取降级限流配置失败';
                                    this.getConfigFailed(action, startTime, false, msg, 0, data, err_1);
                                    reject(err_1);
                                    return [3 /*break*/, 3];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    Config.prototype.getConfigFailed = function (action, startTime, isSuccess, msg, authSdkCode, data, error) {
        var err = common_1.isObject(error) ? error : { msg: common_1.isString(error) ? error : 'unknown' };
        var info = this.phoneServer.createSdkInfo(isSuccess, msg, authSdkCode);
        var carrierFailedResultData = JSON.stringify(err);
        this.phoneServer.insertGetConfigMonitor(action, startTime, info, JSON.stringify(data), carrierFailedResultData, '{}');
    };
    return Config;
}());
exports.default = Config;


/***/ }),

/***/ "./src/constants.ts":
/*!**************************!*\
  !*** ./src/constants.ts ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Constants = exports.Errors = void 0;
var ua_parser_js_1 = __webpack_require__(/*! ua-parser-js */ "./node_modules/_ua-parser-js@0.7.28@ua-parser-js/src/ua-parser.js");
var Errors;
(function (Errors) {
    /**
     * 未知异常
     */
    Errors.ERROR_UNKNOW = 600010;
    /**
     * 校验接入方身份信息失败
     */
    Errors.ERROR_CHECK_AUTH = 600025;
    /**
     * 环境检测错误
     */
    Errors.ERROR_CHECK_ENV = 600008;
    /**
     * 获取token失败
     */
    Errors.ERROR_GET_TOKEN = 600011;
    /**
     * 运营商维护升级，该功能不可用
     */
    Errors.ERROR_UNAVAILABLE = 600013;
    /**
     * 运营商维护升级，该功能已达最大调用次数
     */
    Errors.ERROR_MAX_TIME = 600014;
    /**
     * 接口超时

     */
    Errors.ERROR_TIMEOUT = 600015;
})(Errors = exports.Errors || (exports.Errors = {}));
var Constants;
(function (Constants) {
    var parser = new ua_parser_js_1.UAParser(window.navigator.userAgent.toLowerCase());
    var osInfo = parser.getOS();
    var browser = parser.getBrowser();
    Constants.BROWSER_NAME = browser.name;
    Constants.BROWSER_VERSION = browser.version;
    Constants.OS_VERSION = osInfo.version;
    Constants.OS_NAME = osInfo.name;
})(Constants = exports.Constants || (exports.Constants = {}));
;


/***/ }),

/***/ "./src/getToken.ts":
/*!*************************!*\
  !*** ./src/getToken.ts ***!
  \*************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var CM_1 = __webpack_require__(/*! ./CM */ "./src/CM.ts");
var CU_1 = __webpack_require__(/*! ./CU */ "./src/CU.ts");
var CT_1 = __webpack_require__(/*! ./CT */ "./src/CT.ts");
var GetToken = /** @class */ (function () {
    function GetToken(phoneServer, debuggerMode, currentNetType, tokenParams, phoneNumber) {
        if (!currentNetType) {
            this.phoneServer = phoneServer;
            this.debuggerMode = debuggerMode;
            this.tokenParams = tokenParams;
        }
        else {
            switch (currentNetType) {
                case 'CM':
                    this.spServer = new CM_1.default(phoneServer, debuggerMode);
                    this.options = this.getCMParams(tokenParams);
                    break;
                case 'CU':
                    this.options = this.getCUParams(tokenParams);
                    this.spServer = new CU_1.default(phoneServer, debuggerMode);
                    break;
                case 'CT':
                    this.options = this.getCTParams(tokenParams);
                    this.spServer = new CT_1.default(phoneServer, debuggerMode);
                    break;
                default:
                    break;
            }
        }
    }
    GetToken.prototype.getToken = function (accessToken) {
        return __awaiter(this, void 0, void 0, function () {
            var options;
            return __generator(this, function (_a) {
                options = this.options;
                return [2 /*return*/, this.spServer.getToken(options, accessToken)];
            });
        });
    };
    GetToken.prototype.getAllVendorToken = function (accessToken) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, phoneServer, debuggerMode, tokenParams;
            var _this = this;
            return __generator(this, function (_b) {
                _a = this, phoneServer = _a.phoneServer, debuggerMode = _a.debuggerMode, tokenParams = _a.tokenParams;
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var result = [];
                        var venderNum = tokenParams.length;
                        var errCount = 0; // 失败次数统计
                        var doneCount = 0;
                        // 处理供应商返回的结果
                        var handleCallback = function (data, i, isSuccess, apiParams) {
                            doneCount = doneCount + 1;
                            if (!isSuccess) {
                                errCount = errCount + 1;
                            }
                            if (_this.debuggerMode) {
                                window.console.log('doneCount:', doneCount, '   errCount:', errCount);
                            }
                            data.isSuccess = isSuccess;
                            data.vender = i === 0 ? 'CM' : (i === 1 ? 'CU' : 'CT');
                            data.apiParams = isSuccess ? apiParams : undefined;
                            result[i] = data;
                            if (doneCount < venderNum) {
                                return;
                            }
                            if (errCount === venderNum) {
                                reject(result);
                            }
                            else {
                                resolve(result);
                            }
                        };
                        tokenParams.forEach(function (vendorItem, index) {
                            switch (vendorItem.vender) {
                                case 'CM':
                                    var cmOptions_1 = _this.getCMParams(vendorItem);
                                    var cmServer = new CM_1.default(phoneServer, debuggerMode);
                                    cmServer.getToken(cmOptions_1, accessToken).then(function (res) {
                                        handleCallback(res, index, true, cmOptions_1);
                                    }, function (err) {
                                        handleCallback(err, index, false);
                                    });
                                    break;
                                case 'CU':
                                    var cuOptions_1 = _this.getCUParams(vendorItem);
                                    var cuServer = new CU_1.default(phoneServer, debuggerMode);
                                    cuServer.getToken(cuOptions_1, accessToken).then(function (res) {
                                        handleCallback(res, index, true, cuOptions_1);
                                    }, function (err) {
                                        handleCallback(err, index, false);
                                    });
                                    break;
                                case 'CT':
                                    var ctOptions_1 = _this.getCTParams(vendorItem);
                                    var ctServer = new CT_1.default(phoneServer, debuggerMode);
                                    ctServer.getToken(ctOptions_1, accessToken).then(function (res) {
                                        handleCallback(res, index, true, ctOptions_1);
                                    }, function (err) {
                                        handleCallback(err, index, false);
                                    });
                                    break;
                                default:
                            }
                        });
                    })];
            });
        });
    };
    /**
     * 获取移动的入参
     * @returns {CMParams}
     */
    GetToken.prototype.getCMParams = function (tokenParams) {
        var paramsCM = tokenParams;
        var isTest = '1';
        var cmParams = {
            version: '1.0',
            appId: paramsCM.appId,
            traceId: paramsCM.msgId,
            sign: paramsCM.sign,
            timestamp: paramsCM.reqTimeStamp,
            openType: '0',
            // expandParams, //扩展参数  格式：参数名=值  多个时使用 | 分割（选填，联调环境只能模拟取号，联调时需填写phoneNum=188185*****  手机号可以随便填写，生产可不填）
            isTest: isTest,
        };
        return cmParams;
    };
    /**
     * 获取联通的入参
     * @returns {CUParams}
     */
    GetToken.prototype.getCUParams = function (tokenParams) {
        var paramsCU = tokenParams;
        var cuParams = {
            reqTimeStamp: paramsCU.reqTimeStamp,
            clientId: paramsCU.appId,
            authorization: paramsCU.sign,
        };
        return cuParams;
    };
    /**
     * 获取电信的入参
     * @returns {CTParams}
     */
    GetToken.prototype.getCTParams = function (tokenParams) {
        var paramsCT = tokenParams;
        var ctParams = {
            appId: paramsCT.appId,
            clientType: 'H5-20200',
            format: 'jsonp',
            sign: paramsCT.sign,
            version: '1.5',
            paramKey: paramsCT.paramKey,
            paramStr: paramsCT.paramStr //不公开请求的参数
        };
        return ctParams;
    };
    return GetToken;
}());
exports.default = GetToken;


/***/ }),

/***/ "./src/index.ts":
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Errors = exports.PhoneNumberServer = void 0;
var phoneNumberServer_1 = __webpack_require__(/*! @/phoneNumberServer */ "./src/phoneNumberServer.ts");
exports.PhoneNumberServer = phoneNumberServer_1.default;
var constants_1 = __webpack_require__(/*! @/constants */ "./src/constants.ts");
Object.defineProperty(exports, "Errors", { enumerable: true, get: function () { return constants_1.Errors; } });


/***/ }),

/***/ "./src/moment.ts":
/*!***********************!*\
  !*** ./src/moment.ts ***!
  \***********************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Moment = /** @class */ (function () {
    function Moment() {
    }
    /**
     *
     * @param timestamp
     */
    Moment.getFullYear = function (timestamp) {
        var date = new Date(timestamp);
        return date.getFullYear();
    };
    /**
     * 获取传入时间在哪一月
     * @param timestamp
     */
    Moment.getMonth = function (timestamp) {
        var date = new Date(timestamp);
        return date.getMonth();
    };
    /**
     * 获取传入时间在哪一天
     * @param timestamp
     */
    Moment.getDay = function (timestamp) {
        var date = new Date(timestamp);
        return date.getDay();
    };
    /**
     * 获取传入时间在一天的哪个小时
     * @param timestamp
     */
    Moment.getHours = function (timestamp) {
        var date = new Date(timestamp);
        return date.getHours();
    };
    return Moment;
}());
exports.default = Moment;


/***/ }),

/***/ "./src/phoneNumberServer.ts":
/*!**********************************!*\
  !*** ./src/phoneNumberServer.ts ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var API_1 = __webpack_require__(/*! @/utils/API */ "./src/utils/API.ts");
var request_1 = __webpack_require__(/*! @/utils/request */ "./src/utils/request.ts");
var utils_1 = __webpack_require__(/*! @/utils/utils */ "./src/utils/utils.ts");
var common_1 = __webpack_require__(/*! @/common/common */ "./src/common/common.ts");
var getToken_1 = __webpack_require__(/*! @/getToken */ "./src/getToken.ts");
var config_1 = __webpack_require__(/*! @/config */ "./src/config.ts");
var index_1 = __webpack_require__(/*! @/report/index */ "./src/report/index.ts");
var monitorUtil_1 = __webpack_require__(/*! @/report/monitorUtil */ "./src/report/monitorUtil.ts");
var delay = utils_1.Utilities.delay;
var defaultAuthTime = 10; //checkAuthAvailable接口默认超时时间，单位秒
var defaultTokenTime = 25; //getVerifyToken接口默认超时时间，单位秒 为兼容联通超时时间20s设置
var PhoneNumberServer = /** @class */ (function () {
    function PhoneNumberServer() {
        var _this = this;
        /**
         * 校验接入方身份信息
         * @param opts
         */
        this.checkAuthAvailable = function (opts) {
            var callTimeout = opts.timeout || defaultAuthTime;
            _this.startAuthTime = new Date();
            _this.sessionId = common_1.createUuid();
            _this.authRequestId = common_1.createUuid();
            _this.accessToken = opts.accessToken;
            _this.jwtToken = opts.jwtToken;
            _this.isAllVendor = opts.phoneNumber ? false : true;
            var secretInfo = {
                accessToken: opts.accessToken,
                phoneNumber: _this.isAllVendor ? undefined : opts.phoneNumber,
                jwtToken: opts.jwtToken
            };
            _this.secretInfo = secretInfo;
            var params = __assign({}, secretInfo);
            _this.authTask = delay(callTimeout * 1000, function () { _this.authTaskEntity(opts, params); });
            _this.authTask.start(); // 启用鉴权超时任务
            _this.checkAuthLimit(opts, params);
        };
        this.getVerifyToken = function (opts) {
            var timeout = opts.timeout || defaultTokenTime;
            _this.startTokenTime = new Date();
            _this.verifyTokenTask = delay(timeout * 1000, function () { _this.getTokenTaskEntity(opts); });
            _this.verifyTokenTask.start();
            if (!_this.isAuthSuccess) {
                var msg = '身份校验失败';
                _this.getVerifyTokenFailed(opts, 600025, msg);
                return;
            }
            if (!_this.isAllVendor) {
                var currentNetType = _this.tokenParams && _this.tokenParams.vender;
                _this.getToken = new getToken_1.default(_this, _this.isLoggerEnable, currentNetType, _this.tokenParams, _this.phoneNumber);
                _this.getVendorConfig(opts, currentNetType);
            }
            else {
                _this.getToken = new getToken_1.default(_this, _this.isLoggerEnable, "", _this.tokenParams, "");
                _this.getAllVendorToken(opts);
            }
        };
        this.uploadMonitor = function (data) {
            if (!_this.jwtToken) {
                return;
            }
            var records = data.map(function (item) { return item.content; });
            return new Promise(function (resolve, reject) {
                request_1.request(API_1.default.upLoadInfo, 'post', { uploadMonitorDTOList: records }, { jwtToken: _this.jwtToken }).then(function (res) {
                    if (res.data && res.data.success) {
                        resolve();
                    }
                    else {
                        reject();
                    }
                }).catch(function () {
                    reject();
                });
            });
        };
        this.sign = {};
        this.getToken = null;
        this.phoneNumber = '';
        this.preSign = '';
        this.isAuthSuccess = false;
        this.isLoggerEnable = true;
        this.isUploadEnable = true;
        this.traceId = common_1.createUuid();
        this.configCount = 0;
        this.vendorConfigCount = {
            CM: 0,
            CU: 0,
            CT: 0
        };
        this.tokenParams = {
            appId: '',
            vender: 'CM',
            sign: '',
        };
        this.monitor = new index_1.PNSMonitor();
        this.monitor.setUploadDelegate({
            uploadMonitors: this.uploadMonitor,
        });
        this.config = new config_1.default(this);
    }
    /**
     * 设置日志是否打印更多信息  调试时开启上线关闭
     * @param isEnable
     */
    PhoneNumberServer.prototype.setLoggerEnable = function (isEnable) {
        this.isLoggerEnable = isEnable;
    };
    /**
     * 是否上传日志 默认上传
     * @param isEnable
     */
    PhoneNumberServer.prototype.setUploadEnable = function (isEnable) {
        this.isUploadEnable = isEnable;
    };
    // 获取sdk版本号
    PhoneNumberServer.prototype.getVersion = function () {
        return "1.1.1";
    };
    /**
     * 利用鉴权接口（authPnsWeb、authPnsWebAllVendor）进行鉴权
     * @param {IcheckAuthOpts} opts
     * @param data
     */
    PhoneNumberServer.prototype.checkAuth = function (opts, params) {
        var isLimit = config_1.default.checkRequestLimit('ACMLimitConfig', 'authCheck');
        if (isLimit === 1) {
            var msg = '系统升级该功能不可用';
            var code = 600013;
            if (this.isLoggerEnable) {
                window.console.log('鉴权失败', msg);
            }
            this.checkAuthFailed(opts, params, code, msg);
            return;
        }
        if (isLimit === 2) {
            var msg = '运营商维护升级，该功能已达最大调用次数';
            var code = 600014;
            if (this.isLoggerEnable) {
                window.console.log('鉴权失败', msg);
            }
            this.checkAuthFailed(opts, params, code, msg);
            return;
        }
        var isCheckParams = common_1.checkParams(opts);
        if (!isCheckParams) {
            var msg = '入参错误';
            var code = 600028;
            this.checkAuthFailed(opts, params, code, msg);
            return;
        }
        var isEnvAvailable = this.checkEnvAvailable();
        if (isEnvAvailable) {
            var msg = '环境检测失败';
            var code = 600008;
            this.checkAuthFailed(opts, params, code, msg);
            return;
        }
        config_1.default.addReqCount('ACMLimitConfig', 'authCheck');
        if (!this.isAllVendor) {
            this.authPnsWeb(opts, params);
        }
        else {
            this.authPnsWebAllVendor(opts, params);
        }
    };
    /**
     * 用户输入手机号 利用鉴权接口（authPnsWeb）进行鉴权
     * @param {IcheckAuthOpts} opts
     * @param {IcheckAuthParams} params
     */
    PhoneNumberServer.prototype.authPnsWeb = function (opts, params) {
        var _this = this;
        var apiParams = __assign(__assign({}, params), { timeout: opts.timeout || defaultAuthTime });
        var response = request_1.request(API_1.default.authPnsWeb, 'get', {}, params, {
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        this.phoneNumber = opts.phoneNumber;
        /**
         * 校验身份及三网信息
         */
        response.then(function (res) {
            if (_this.authStop) {
                return;
            }
            // Config.addReqCount('ACMLimitConfig', 'authCheck' );
            var resp = res && res.data || {};
            var serverInfo = __assign({ isSuccess: resp.code === 'OK' ? true : false, topTraceId: resp.requestId }, (resp.code !== 'OK'
                ? {
                    carrierSdkCode: resp.code,
                    carrierSdkMsg: resp.message,
                    carrierFailedResultData: JSON.stringify(resp)
                }
                : {}));
            if (resp && resp.module && resp.code === 'OK') {
                var data = resp.module;
                var checkResult = common_1.checkAuthResp(data);
                if (!checkResult.isSuccess) {
                    _this.checkAuthFailed(opts, params, checkResult.code, checkResult.msg, data.vender, serverInfo);
                    return;
                }
                var msg = '鉴权成功';
                _this.tokenParams = data;
                _this.isAuthSuccess = true;
                _this.authTask.stop(); //结束超时任务
                if (_this.isLoggerEnable) {
                    window.console.log('鉴权成功', res.data);
                }
                var sdkInfo = _this.createSdkInfo(true, msg, 600000, data.vender);
                opts.success({
                    code: 600000,
                    msg: msg,
                    requestId: sdkInfo.requestId
                });
                _this.insertCheckAuthMonitor(sdkInfo, JSON.stringify(apiParams), serverInfo);
                return;
            }
            else {
                var msg = '接入方身份信息校验失败';
                if (_this.isLoggerEnable) {
                    window.console.log('鉴权失败', res.data);
                }
                _this.checkAuthFailed(opts, params, 600025, msg, '', serverInfo);
            }
        }).catch(function (err) {
            if (_this.authStop) {
                return;
            }
            var msg = '未知异常';
            var error = common_1.isObject(err) ? err : { msg: err };
            if (_this.isLoggerEnable) {
                window.console.log('鉴权失败', err);
            }
            var serverInfo = { isSuccess: false, failRet: msg, carrierFailedResultData: JSON.stringify(error) };
            _this.checkAuthFailed(opts, params, 600010, msg, '', serverInfo);
        });
    };
    ;
    /**
     * 用户没有输入手机号 利用鉴权接口（authPnsWebAllVendor）进行鉴权
     * @param {IcheckAuthOpts} opts
     * @param {IcheckAuthParams} params
     */
    PhoneNumberServer.prototype.authPnsWebAllVendor = function (opts, params) {
        var _this = this;
        var apiParams = __assign(__assign({}, params), { timeout: opts.timeout || defaultAuthTime });
        var response = request_1.request(API_1.default.authPnsWebAllVendor, 'post', {}, params, {
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        /**
         * 校验身份及三网信息
         */
        response.then(function (res) {
            if (_this.authStop) {
                return;
            }
            var resp = res && res.data || {};
            var serverInfo = __assign({ isSuccess: resp.code === 'OK' ? true : false, topTraceId: resp.requestId }, (resp.code !== 'OK'
                ? {
                    carrierSdkCode: resp.code,
                    carrierSdkMsg: resp.message,
                    carrierFailedResultData: JSON.stringify(resp)
                }
                : {}));
            if (resp && resp.module && resp.code === 'OK') {
                var data = resp.module;
                var msg = '鉴权成功';
                _this.tokenParams = data;
                _this.isAuthSuccess = true;
                _this.authTask.stop(); //结束超时任务
                if (_this.isLoggerEnable) {
                    window.console.log('鉴权成功', res.data);
                }
                var sdkInfo = _this.createSdkInfo(true, msg, 600000);
                opts.success({
                    code: 600000,
                    msg: msg,
                    requestId: sdkInfo.requestId
                });
                _this.insertCheckAuthMonitor(sdkInfo, JSON.stringify(apiParams), serverInfo);
                return;
            }
            else {
                var msg = '接入方身份信息校验失败';
                if (_this.isLoggerEnable) {
                    window.console.log('鉴权失败', res.data);
                }
                _this.checkAuthFailed(opts, params, 600025, msg, null, serverInfo);
            }
        }).catch(function (err) {
            if (_this.authStop) {
                return;
            }
            var msg = '未知异常';
            var error = common_1.isObject(err) ? err : { msg: err };
            if (_this.isLoggerEnable) {
                window.console.log('鉴权失败', err);
            }
            var serverInfo = { isSuccess: false, failRet: msg, carrierFailedResultData: JSON.stringify(error) };
            _this.checkAuthFailed(opts, params, 600010, msg, null, serverInfo);
        });
    };
    /**
     * 获取运营商token
     * @param opts
     */
    PhoneNumberServer.prototype.getVendorToken = function (opts) {
        var _this = this;
        var netType = this.tokenParams && this.tokenParams.vender;
        var isLimit = config_1.default.checkRequestLimit('ACMLimitConfig', 'authToken', netType);
        if (isLimit === 1) {
            var msg = '系统升级该功能不可用';
            var code = 600013;
            if (this.isLoggerEnable) {
                window.console.log('获取token失败', msg);
            }
            this.getVerifyTokenFailed(opts, code, msg);
            return;
        }
        if (isLimit === 2) {
            var msg = '运营商维护升级，该功能已达最大调用次数';
            var code = 600014;
            if (this.isLoggerEnable) {
                window.console.log('获取token失败', msg);
            }
            this.getVerifyTokenFailed(opts, code, msg);
            return;
        }
        this.getToken.getToken(this.accessToken).then(function (res) {
            if (_this.verifyStop) {
                return;
            }
            _this.verifyTokenTask.stop(); //结束getVerifyToken超时逻辑
            var msg = '获取spToken成功';
            var sdkInfo = _this.createSdkInfo(true, msg, 600000, netType);
            _this.insertGetTokenMonitor(sdkInfo);
            opts.success(__assign(__assign({}, res), { requestId: sdkInfo.requestId }));
            if (_this.jwtToken) {
                _this.monitor.uploadMonitorByManual();
            }
        }).catch(function (error) {
            if (_this.verifyStop) {
                return;
            }
            _this.verifyTokenTask.stop(); //结束getVerifyToken超时逻辑
            var err = common_1.isObject(error) ? error : {};
            var errMsg = common_1.isString(error) ? err : '';
            var carrier = err.carrier || {};
            var sdkInfo = _this.createSdkInfo(false, err.msg || errMsg, err.code || 600010, netType);
            _this.insertGetTokenMonitor(sdkInfo, __assign({ carrierFailedResultData: JSON.stringify(err.content || {}) }, carrier));
            opts.error({
                code: err.code || 600010,
                msg: err.msg || '未知异常',
                content: err.content || {},
                requestId: sdkInfo.requestId
            });
            if (_this.jwtToken) {
                _this.monitor.uploadMonitorByManual();
            }
        });
    };
    /**
     * 三网轮询，获取token
     * @param opts
     */
    PhoneNumberServer.prototype.getAllVendorToken = function (opts) {
        var _this = this;
        this.getToken.getAllVendorToken(this.accessToken).then(function (res) {
            if (_this.verifyStop) { // getVerifyToken 请求超时
                return;
            }
            _this.verifyTokenTask.stop(); //结束getVerifyToken超时逻辑
            var result, allVendorCarrierInfo;
            res.forEach(function (vendorItem) {
                if (vendorItem.isSuccess) {
                    result = vendorItem;
                }
                else {
                    allVendorCarrierInfo = _this.createAllVenderInfo(vendorItem, allVendorCarrierInfo);
                }
            });
            var msg = '获取spToken成功';
            var sdkInfo = _this.createSdkInfo(true, msg, 600000);
            _this.insertAllVendorGetTokenMonitor(sdkInfo, allVendorCarrierInfo, JSON.stringify(result.apiParams));
            delete result.apiParams;
            opts.success(__assign(__assign({}, result), { requestId: sdkInfo.requestId }));
            if (_this.jwtToken) {
                _this.monitor.uploadMonitorByManual();
            }
        }).catch(function (error) {
            if (_this.verifyStop) {
                return;
            }
            _this.verifyTokenTask.stop(); //结束getVerifyToken超时逻辑
            var allVendorCarrierInfo;
            error.forEach(function (vendorItem) {
                allVendorCarrierInfo = _this.createAllVenderInfo(vendorItem, allVendorCarrierInfo);
            });
            var sdkInfo = _this.createSdkInfo(false, '未知异常', 600010);
            _this.insertAllVendorGetTokenMonitor(sdkInfo, allVendorCarrierInfo);
            opts.error({
                code: 600010,
                msg: '未知异常',
                content: error,
                requestId: sdkInfo.requestId
            });
            if (_this.jwtToken) {
                _this.monitor.uploadMonitorByManual();
            }
        });
    };
    // 获取整体降级限流配置
    PhoneNumberServer.prototype.checkAuthLimit = function (opts, params) {
        var _this = this;
        var isLimit = config_1.default.checkRequestLimit('ACMLimitConfig', 'config');
        if (this.configCount > 0) {
            this.checkAuth(opts, params);
            return;
        }
        if (isLimit === 2) {
            this.checkAuth(opts, params);
            return;
        }
        this.config.getConfig(opts.jwtToken, opts.accessToken, this.getVersion()).then(function (res) {
            _this.configCount++;
            var config = common_1.isObject(res) ? res : {};
            var limit = common_1.isObject(config.limit) ? config.limit : {};
            // sls降级
            if (config.isSlsDemoted || config.isDemoted) {
                _this.monitor.setInsertEnable(false);
                _this.monitor.setUploadEnable(false);
            }
            // sls限流
            if (!config_1.default.checkConfig(limit.sls)) {
                var slsConfig = config_1.default.getLimitConfig('ACMSlsLimitConfig');
                limit.sls = config_1.default.buildConfigData(limit.sls, slsConfig);
            }
            _this.monitor.setLimitConfig(__assign(__assign({}, limit.sls), { isLimited: !!limit.sls.is_limited }));
            // 其他限流
            config_1.default.setLimitConfig(config);
            config_1.default.addReqCount('ACMLimitConfig', 'config');
            _this.checkAuth(opts, params);
            _this.monitor.uploadFailedData();
        }).catch(function (err) {
            console.log('err', err);
            _this.checkAuth(opts, params);
        });
    };
    // 获取运营商降级限流配置
    PhoneNumberServer.prototype.getVendorConfig = function (opts, currentNetType) {
        var _this = this;
        var isLimit = config_1.default.checkRequestLimit('ACMLimitConfig', 'config');
        if (isLimit === 2) {
            this.getVendorToken(opts);
            return;
        }
        if (this.vendorConfigCount[currentNetType] > 0) {
            var msg = 'sdk生命周期内仅拉取一次';
            this.getVendorToken(opts);
            return;
        }
        // 获取供应商配置
        this.config.getConfig(this.jwtToken, this.accessToken, this.getVersion(), currentNetType).then(function (res) {
            _this.vendorConfigCount[currentNetType]++;
            var config = common_1.isObject(res) ? res : {};
            // 其他限流
            config_1.default.setLimitConfig(config, currentNetType);
            config_1.default.addReqCount('ACMLimitConfig', 'config');
            _this.getVendorToken(opts);
        }).catch(function (err) {
            console.log('err', err);
            config_1.default.addReqCount('ACMLimitConfig', 'config');
            _this.getVendorToken(opts);
            _this.monitor.uploadFailedData();
        });
    };
    // 当超时时
    PhoneNumberServer.prototype.authTaskEntity = function (opts, params) {
        var code = 600015;
        var msg = '接口超时';
        this.authStop = true;
        this.checkAuthFailed(opts, params, code, msg);
    };
    PhoneNumberServer.prototype.getTokenTaskEntity = function (opts) {
        var code = 600015;
        var msg = '接口超时';
        this.verifyStop = true;
        this.getVerifyTokenFailed(opts, code, msg);
    };
    /**
     * 检查环境
     * @returns {boolean}
     */
    PhoneNumberServer.prototype.checkEnvAvailable = function () {
        var isPc = common_1.osIsPc();
        var netTypeIsWifi = common_1.isWifi();
        return isPc || netTypeIsWifi;
    };
    // 鉴权接口埋点
    PhoneNumberServer.prototype.insertCheckAuthMonitor = function (sdkInfo, apiParams, serverInfo) {
        var endTime = new Date();
        var startTime = this.startAuthTime;
        var monitor = monitorUtil_1.default.makeCheckAuthMonitorData(startTime, endTime, __assign(__assign({}, sdkInfo), { apiParams: apiParams }), this.secretInfo, this.isAllVendor, serverInfo);
        this.monitor.monitorData(monitor);
    };
    ;
    // 拉取降级限流配置埋点
    PhoneNumberServer.prototype.insertGetConfigMonitor = function (action, startTime, sdkInfo, apiParams, carrierFailedResultData, config, serverInfo) {
        var endTime = new Date();
        var info = __assign(__assign({}, sdkInfo), { config: config, apiParams: apiParams });
        var monitor = monitorUtil_1.default.makeConfigMonitorData(action, startTime, endTime, info, this.secretInfo, serverInfo);
        this.monitor.monitorData(monitor);
    };
    ;
    // 获取供应商token埋点
    PhoneNumberServer.prototype.insertGetTokenMonitor = function (sdkInfo, carrierInfo) {
        var endTime = new Date();
        var startTime = this.startTokenTime;
        var monitor = monitorUtil_1.default.makeTokenMonitorData(startTime, endTime, sdkInfo, this.secretInfo, carrierInfo);
        this.monitor.monitorData(monitor);
    };
    ;
    // 获取全部供应商token埋点
    PhoneNumberServer.prototype.insertAllVendorGetTokenMonitor = function (sdkInfo, allVendorCarrierInfo, apiParams) {
        var endTime = new Date();
        var startTime = this.startTokenTime;
        var u = __assign(__assign({}, sdkInfo), { apiParams: apiParams });
        var monitor = monitorUtil_1.default.makeAllVendorTokenMonitorData(startTime, endTime, u, this.secretInfo, allVendorCarrierInfo);
        this.monitor.monitorData(monitor);
    };
    ;
    // 鉴权失败
    PhoneNumberServer.prototype.checkAuthFailed = function (opts, params, code, msg, netType, serverInfo) {
        this.authTask.stop(); //结束超时任务
        var apiParams = __assign(__assign({}, params), { timeout: opts.timeout || defaultAuthTime });
        var sdkInfo = this.createSdkInfo(false, msg, code, netType);
        opts.error(__assign({ code: code,
            msg: msg, requestId: sdkInfo.requestId }, (serverInfo
            ? {
                content: __assign(__assign({}, (serverInfo.carrierSdkCode ?
                    {
                        code: serverInfo.carrierSdkCode,
                    } : {})), (serverInfo.carrierSdkMsg ?
                    {
                        msg: serverInfo.carrierSdkMsg,
                    } : {}))
            }
            : {})));
        this.insertCheckAuthMonitor(sdkInfo, JSON.stringify(apiParams), serverInfo);
        if (this.jwtToken) {
            this.monitor.uploadMonitorByManual();
        }
    };
    PhoneNumberServer.prototype.getVerifyTokenFailed = function (opts, code, msg, serverInfo) {
        var netType = this.tokenParams && this.tokenParams.vender;
        var sdkInfo = this.createSdkInfo(false, msg, code, netType);
        this.verifyTokenTask.stop(); //结束getVerifyToken超时逻辑
        this.insertGetTokenMonitor(sdkInfo);
        opts.error({
            code: code,
            msg: msg,
            requestId: sdkInfo.requestId
        });
        if (this.jwtToken) {
            this.monitor.uploadMonitorByManual();
        }
    };
    PhoneNumberServer.prototype.insertVendorTokenMonitor = function (startTime, isSuccess, code, msg, netType, isAuth, apiParams, carrierFailedResultData, s, carrierInfo) {
        var endTime = new Date();
        var sdkInfo = this.createSdkInfo(isSuccess, msg, code, netType);
        var u = __assign(__assign({}, sdkInfo), { apiParams: apiParams, carrierFailedResultData: carrierFailedResultData });
        var secretInfo = __assign(__assign({}, this.secretInfo), s);
        // tslint:disable-next-line:max-line-length
        var monitor = monitorUtil_1.default.makeVendorTokenMonitorData(startTime, endTime, !!isAuth, u, secretInfo, carrierInfo);
        this.monitor.monitorData(monitor);
    };
    PhoneNumberServer.prototype.createSdkInfo = function (isSuccess, failRet, authSdkCode, netType) {
        var requestId = common_1.createUuid();
        return {
            isSuccess: isSuccess,
            failRet: failRet,
            traceId: this.traceId,
            netType: netType,
            requestId: requestId,
            sessionId: this.sessionId,
            authSdkCode: authSdkCode
        };
    };
    PhoneNumberServer.prototype.createAllVenderInfo = function (vendorItem, allVendorCarrierInfo) {
        var vender = vendorItem.vender, carrier = vendorItem.carrier;
        return __assign(__assign({}, allVendorCarrierInfo), (carrier
            ? (vender === 'CM'
                ? {
                    cmccCarrierTraceId: carrier.carrierTraceId || '000',
                    cmccCarrierSdkCode: carrier.carrierSdkCode || 0,
                    cmccCarrierSdkMsg: carrier.carrierSdkMsg || '',
                    cmccCarrierRespCode: carrier.carrierRespCode || 0,
                }
                : (vender === 'CU'
                    ? {
                        cuccCarrierTraceId: carrier.carrierTraceId || '000',
                        cuccCarrierSdkCode: carrier.carrierSdkCode || 0,
                        cuccCarrierSdkMsg: carrier.carrierSdkMsg || '',
                        cuccCarrierRespCode: carrier.carrierRespCode || 0,
                    }
                    : (vender === 'CT'
                        ? {
                            ctccCarrierTraceId: carrier.carrierTraceId || '000',
                            ctccCarrierSdkCode: carrier.carrierSdkCode || 0,
                            ctccCarrierSdkMsg: carrier.carrierSdkMsg || '',
                            ctccCarrierRespCode: carrier.carrierRespCode || 0,
                        }
                        : {})))
            : {}));
    };
    return PhoneNumberServer;
}());
exports.default = PhoneNumberServer;


/***/ }),

/***/ "./src/report/PNSCacheManager.ts":
/*!***************************************!*\
  !*** ./src/report/PNSCacheManager.ts ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PNSDB_1 = __webpack_require__(/*! ./PNSDB */ "./src/report/PNSDB.ts");
var PNSLocalStorage_1 = __webpack_require__(/*! ./PNSLocalStorage */ "./src/report/PNSLocalStorage.ts");
var PNSCacheManager = /** @class */ (function () {
    function PNSCacheManager() {
        if (window.indexedDB) {
            this.store = new PNSDB_1.default();
        }
        else {
            this.store = new PNSLocalStorage_1.default();
        }
    }
    /**
     * cacheMonitor
     * @param RecordData
     */
    PNSCacheManager.prototype.cacheMonitor = function (RecordData) {
        this.store.cacheMonitor(RecordData);
    };
    /**
     * 获取getMonitorRecordsWithStartId
     * @param recordId
     * @param count
     * @param uploadFlag
     */
    PNSCacheManager.prototype.getMonitorRecordsWithStartId = function (recordId, count, uploadFlag) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.store.getAllMonitors(recordId).then(function (monitorAll) {
                var records = [];
                // 筛选uploadFlag为1的数据
                monitorAll.forEach(function (item) {
                    if (item.uploadFlag === uploadFlag) {
                        records.push(item);
                    }
                });
                resolve(records.length ? records.splice(0, count) : []);
            });
        });
    };
    /**
     * getMonitorRecords
     * @param count
     */
    PNSCacheManager.prototype.getMonitorRecords = function (count) {
        var _this = this;
        return new Promise(function (resolve) {
            _this.store.getAllMonitors(0).then(function (monitorAll) {
                var records = [];
                // 筛选uploadFlag为0的数据
                monitorAll.forEach(function (item) {
                    if (item.uploadFlag === 0) {
                        records.push(item);
                    }
                });
                resolve(records.length ? records.splice(0, count) : []);
            }).catch(function () {
                console.log('--------------获取logger失败');
            });
        });
    };
    /**
     * 删除
     * @param records
     */
    PNSCacheManager.prototype.deleteMonitor = function (records) {
        var _this = this;
        if (records && records.length) {
            records.forEach(function (item) {
                _this.store.deleteMonitor(item);
            });
        }
    };
    /**
     * updateMonitor
     * @param records
     */
    PNSCacheManager.prototype.updateMonitor = function (records) {
        var _this = this;
        if (records && records.length) {
            records.forEach(function (item) {
                item.uploadFlag = 1;
                item.uploadCount += 1;
                _this.store.updateMonitor(item);
            });
        }
    };
    /**
     * cacheLog
     * @param record
     */
    PNSCacheManager.prototype.cacheLog = function (record) {
        this.store.cacheLog(record);
    };
    /**
     * getLoggerRecordsWithStartDate
     * @param startDate
     * @param endDate
     * @param count
     * @param levels
     * @param uploadFlag
     */
    PNSCacheManager.prototype.getLoggerRecordsWithStartDate = function (start, end, recordId, count, levels, uploadFlag) {
        var _this = this;
        if (uploadFlag === void 0) { uploadFlag = 0; }
        return new Promise(function (resolve) {
            _this.store.getAllLoggers(recordId).then(function (loggers) {
                var records = [];
                // 筛选uploadFlag为0的数据
                loggers.forEach(function (item) {
                    var itemDate = new Date(item.date).getTime();
                    var index = levels.findIndex(function (it) { return it === item.level; });
                    if (itemDate >= start &&
                        itemDate <= end &&
                        index > -1 && item.uploadFlag === uploadFlag) {
                        records.push(item);
                    }
                });
                resolve(records.length ? records.splice(0, count) : []);
            });
        });
    };
    ;
    PNSCacheManager.prototype.getLoggerRecordsWithStartId = function (recordId, count, uploadFlag) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.store.getAllLoggers(recordId).then(function (monitorAll) {
                var records = [];
                // 筛选uploadFlag为1的数据
                monitorAll.forEach(function (item) {
                    if (item.uploadFlag === uploadFlag) {
                        records.push(item);
                    }
                });
                resolve(records.length ? records.splice(0, count) : []);
            });
        });
    };
    /**
     * deleteLog
     * @param records
     */
    PNSCacheManager.prototype.deleteLog = function (records) {
        var _this = this;
        if (records && records.length) {
            records.forEach(function (item) {
                _this.store.deleteLog(item);
            });
        }
    };
    /**
     * updateLogger
     * @param records
     */
    PNSCacheManager.prototype.updateLogger = function (records) {
        var _this = this;
        if (records && records.length) {
            records.forEach(function (item) {
                item.uploadFlag = 1;
                _this.store.updateLogger(item);
            });
        }
    };
    return PNSCacheManager;
}());
exports.default = PNSCacheManager;


/***/ }),

/***/ "./src/report/PNSDB.ts":
/*!*****************************!*\
  !*** ./src/report/PNSDB.ts ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var LOGGER_LIMIT_SIZE = 5 * 1024 * 1024;
var PNSDB = /** @class */ (function () {
    function PNSDB() {
    }
    /**
     * cacheMonitor
     * @param RecordData
     */
    PNSDB.prototype.cacheMonitor = function (record) {
        this.createDB().then(function (db) {
            var transaction = db.transaction(['monitorStore'], 'readwrite');
            var store = transaction.objectStore('monitorStore');
            store.add(record);
        });
    };
    /**
     * getMonitorRecords
     * @param count
     */
    PNSDB.prototype.getAllMonitors = function (key) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.createDB().then(function (db) {
                var transaction = db.transaction(['monitorStore'], 'readwrite');
                var store = transaction.objectStore('monitorStore');
                var rangeVal = IDBKeyRange.lowerBound(key, true);
                var records = store.getAll ? store.getAll(rangeVal) : store.openCursor(rangeVal);
                if (store.getAll) {
                    records.onsuccess = function () {
                        var result = records.result;
                        if (result) {
                            resolve(result);
                        }
                        else {
                            reject(result);
                        }
                    };
                }
                else {
                    var result_1 = [];
                    records.onsuccess = function (event) {
                        var cursor = event.target.result;
                        if (cursor) {
                            result_1.push(cursor.value);
                            cursor.continue();
                        }
                        else {
                            resolve(result_1);
                        }
                    };
                }
                records.onerror = function (event) {
                    reject(event);
                };
            });
        });
    };
    /**
     * 删除
     * @param records
     */
    PNSDB.prototype.deleteMonitor = function (record) {
        this.createDB().then(function (db) {
            var transaction = db.transaction(['monitorStore'], 'readwrite');
            var store = transaction.objectStore('monitorStore');
            store.delete(record.id);
        });
    };
    /**
     * updateMonitor
     * @param records
     */
    PNSDB.prototype.updateMonitor = function (record) {
        this.createDB().then(function (db) {
            var transaction = db.transaction(['monitorStore'], 'readwrite');
            var store = transaction.objectStore('monitorStore');
            store.put(record);
        });
    };
    /**
     * cacheLog
     * @param record
     */
    PNSDB.prototype.cacheLog = function (record) {
        return __awaiter(this, void 0, void 0, function () {
            var db, logs, allDataStr, size, clearLogs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createDB()];
                    case 1:
                        db = _a.sent();
                        return [4 /*yield*/, this.getAllLogs(db)];
                    case 2:
                        logs = _a.sent();
                        allDataStr = logs.length ? logs.map(function (item) { return JSON.stringify(item); }).join('$$') : '';
                        size = logs.length > 1000 ? this.checkSize(allDataStr) : -1;
                        if (size > LOGGER_LIMIT_SIZE) {
                            clearLogs = logs.splice(0, Math.ceil(logs.length / 2));
                            this.delLogs(db, clearLogs);
                        }
                        this.addLog(db, record);
                        return [2 /*return*/];
                }
            });
        });
    };
    // 获取所有log getAllLoggers
    PNSDB.prototype.getAllLoggers = function (key) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.createDB().then(function (db) {
                var transaction = db.transaction(['loggerStore'], 'readwrite');
                var store = transaction.objectStore('loggerStore');
                var rangeVal = IDBKeyRange.lowerBound(key, true);
                var records = store.getAll ? store.getAll(rangeVal) : store.openCursor(rangeVal);
                if (store.getAll) {
                    records.onsuccess = function () {
                        var result = records.result;
                        if (result) {
                            resolve(result);
                        }
                        else {
                            reject(result);
                        }
                    };
                }
                else {
                    var result_2 = [];
                    records.onsuccess = function (event) {
                        var cursor = event.target.result;
                        if (cursor) {
                            result_2.push(cursor.value);
                            cursor.continue();
                        }
                        else {
                            resolve(result_2);
                        }
                    };
                }
                records.onerror = function (event) {
                    reject(event);
                };
            }).catch(function () {
                reject();
            });
        });
    };
    /**
     * deleteLog
     * @param records
     */
    PNSDB.prototype.deleteLog = function (record) {
        this.createDB().then(function (db) {
            var transaction = db.transaction(['loggerStore'], 'readwrite');
            var store = transaction.objectStore('loggerStore');
            store.delete(record.id);
        });
    };
    /**
     * updateLogger
     * @param records
     */
    PNSDB.prototype.updateLogger = function (record) {
        this.createDB().then(function (db) {
            var transaction = db.transaction(['loggerStore'], 'readwrite');
            var store = transaction.objectStore('loggerStore');
            store.put(record);
        });
    };
    /**
     * 新建数据库
     */
    PNSDB.prototype.createDB = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var request = window.indexedDB.open('ACMLocalDVSMonitor');
            // 该事件仅在较新的浏览器中实现了
            request.onupgradeneeded = function (event) {
                _this.onupgradeneeded(event);
            };
            request.onerror = function (event) {
                var db = event.target.result;
                reject(db);
            };
            request.onsuccess = function (event) {
                var db = event.target.result;
                resolve(db);
            };
        });
    };
    /**
     * indexDB 的事件监听函数
     * @param event
     */
    PNSDB.prototype.onupgradeneeded = function (event) {
        var db = event.target.result;
        var dbColumn = ['id', 'date', 'uploadFlag', 'uploadCount', 'content', 'realTime', 'strategy', 'urgency'];
        // 为该数据库创建一个对象仓库
        if (!db.objectStoreNames.contains('monitorStore')) {
            // 新建一个表
            var monitorStore = db.createObjectStore('monitorStore', { keyPath: 'id', autoIncrement: true });
            this.createDBColumn(monitorStore, dbColumn);
        }
        // 为该数据库创建一个对象仓库
        if (!db.objectStoreNames.contains('loggerStore')) {
            // 新建一个表
            var loggerStore = db.createObjectStore('loggerStore', { keyPath: 'id', autoIncrement: true });
            this.createDBColumn(loggerStore, dbColumn);
        }
    };
    /**
     * 创建索引
     * @param objectStore
     * @param {string[]} data
     */
    PNSDB.prototype.createDBColumn = function (objectStore, data) {
        data.forEach(function (item) {
            objectStore.createIndex(item, item, { unique: false });
        });
    };
    PNSDB.prototype.getAllLogs = function (db) {
        var transaction = db.transaction(['loggerStore'], 'readwrite');
        var store = transaction.objectStore('loggerStore');
        var records = store.getAll();
        return new Promise(function (resolve, reject) {
            records.onsuccess = function (event) {
                var result = records.result;
                if (result) {
                    resolve(result);
                }
                else {
                    reject(result);
                }
            };
            records.onerror = function (event) {
                reject(event);
            };
        });
    };
    PNSDB.prototype.checkSize = function (str) {
        var size = 0;
        if (typeof str === 'string') {
            var len = str.length;
            for (var i = 0; i < len; i++) {
                var charCode = str.charCodeAt(i);
                if (charCode <= 0x007f) {
                    size += 1;
                }
                else if (charCode <= 0x07ff) {
                    size += 2;
                }
                else if (charCode <= 0xffff) {
                    size += 3;
                }
                else {
                    size += 4;
                }
            }
        }
        return size;
    };
    PNSDB.prototype.addLog = function (db, record) {
        var transaction = db.transaction(['loggerStore'], 'readwrite');
        var store = transaction.objectStore('loggerStore');
        store.add(record);
    };
    PNSDB.prototype.delLogs = function (db, logs) {
        logs.forEach(function (record) {
            var transaction = db.transaction(['loggerStore'], 'readwrite');
            var store = transaction.objectStore('loggerStore');
            store.delete(record.id);
        });
    };
    return PNSDB;
}());
exports.default = PNSDB;


/***/ }),

/***/ "./src/report/PNSLocalStorage.ts":
/*!***************************************!*\
  !*** ./src/report/PNSLocalStorage.ts ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var QUOTA_EXCEEDED_ERR_CODE = 22; // localStorage 超过最大限制的报错
var LOGGER_LIMIT_SIZE = 0.4 * 1024 * 1024;
var PNSLocalStorage = /** @class */ (function () {
    function PNSLocalStorage() {
        this.loggerMaxId = 0;
        this.monitorMaxId = 0;
    }
    /**
     * cacheMonitor
     * @param reportData
     */
    PNSLocalStorage.prototype.cacheMonitor = function (record) {
        var monitors = this.getAllMonitor();
        var monitorMaxId = localStorage.getItem('ACMMonitorDVSMaxId');
        this.monitorMaxId = monitorMaxId ? parseInt(monitorMaxId) : 0;
        this.monitorMaxId++;
        monitors.push(__assign(__assign({}, record), { id: this.monitorMaxId }));
        this.setMonitors(monitors);
    };
    // 获取monitors
    PNSLocalStorage.prototype.getAllMonitors = function (key) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var monitorAll = _this.getAllMonitor();
            var index = monitorAll.findIndex(function (it) { return it.id >= key; });
            resolve(monitorAll.length ? monitorAll.slice(index) : []);
        });
    };
    /**
     * 删除Monitor
     * @param records
     */
    PNSLocalStorage.prototype.deleteMonitor = function (record) {
        var monitorAll = this.getAllMonitor();
        var index = monitorAll.findIndex(function (it) { return it.id === record.id; });
        if (index > -1) {
            monitorAll.splice(index, 1);
        }
        this.setMonitors(monitorAll);
    };
    ;
    /**
     * 更新Monitor
     * @param data
     */
    PNSLocalStorage.prototype.updateMonitor = function (record) {
        var monitorAll = this.getAllMonitor();
        var index = monitorAll.findIndex(function (it) { return it.id === record.id; });
        if (index > -1) {
            monitorAll[index].uploadFlag = 1;
            monitorAll[index].uploadFlag = 1;
        }
        this.setMonitors(monitorAll);
    };
    /**
     * 新增Log
     * @param record
     */
    PNSLocalStorage.prototype.cacheLog = function (record) {
        var loggers = this.getAllLogger();
        var loggerMaxId = localStorage.getItem('ACMLoggerDVSMaxId');
        this.loggerMaxId = loggerMaxId ? parseInt(loggerMaxId) : 0;
        this.loggerMaxId++;
        loggers.push(__assign(__assign({}, record), { id: this.loggerMaxId }));
        var allDataStr = loggers.length ? loggers.map(function (item) { return JSON.stringify(item); }).join('$$') : '';
        var size = loggers.length ? this.checkSize(allDataStr) : -1;
        if (size > LOGGER_LIMIT_SIZE) {
            loggers.splice(0, Math.ceil(loggers.length / 2));
        }
        this.setLogger(loggers);
    };
    // 获取monitors
    PNSLocalStorage.prototype.getAllLoggers = function (key) {
        var _this = this;
        if (key === void 0) { key = 0; }
        return new Promise(function (resolve, reject) {
            var loggers = _this.getAllLogger();
            var index = loggers.findIndex(function (it) { return it.id >= key; });
            resolve(loggers.length ? loggers.slice(index) : []);
        });
    };
    /**
     * 删除logs
     */
    PNSLocalStorage.prototype.deleteLog = function (record) {
        var loggers = this.getAllLogger();
        var index = loggers.findIndex(function (it) { return it.id === record.id; });
        if (index > -1) {
            loggers.splice(index, 1);
        }
        this.setLogger(loggers);
    };
    /**
     * 更新records
     */
    PNSLocalStorage.prototype.updateLogger = function (record) {
        var loggers = this.getAllLogger();
        var index = loggers.findIndex(function (it) { return it.id === record.id; });
        if (index > -1) {
            loggers[index].uploadFlag = 1;
        }
        this.setLogger(loggers);
    };
    /**
     * 取出所有的monitors
     */
    PNSLocalStorage.prototype.getAllMonitor = function () {
        var monitorStr = localStorage.getItem('ACMLocalDVSMonitor');
        return monitorStr ? JSON.parse(monitorStr) : [];
    };
    /**
     * 设置monitors
     */
    PNSLocalStorage.prototype.setMonitors = function (monitors) {
        var monitorMaxId = localStorage.getItem('ACMMonitorDVSMaxId');
        var monitorMaxIdP = monitorMaxId ? parseInt(monitorMaxId) : 0;
        monitorMaxIdP++;
        try {
            localStorage.setItem('ACMLocalDVSMonitor', JSON.stringify(monitors));
            localStorage.setItem('ACMMonitorDVSMaxId', monitorMaxIdP.toString());
        }
        catch (e) {
            if (e.code === QUOTA_EXCEEDED_ERR_CODE) {
                var clearMonitor = monitors.splice(0, Math.ceil(monitors.length));
                localStorage.removeItem('ACMLocalDVSMonitor');
                localStorage.removeItem('ACMMonitorDVSMaxId');
                localStorage.setItem('ACMLocalDVSMonitor', JSON.stringify(clearMonitor));
                localStorage.setItem('ACMMonitorDVSMaxId', monitorMaxIdP.toString());
            }
        }
    };
    // 获取logger
    PNSLocalStorage.prototype.getAllLogger = function () {
        var loggerStr = localStorage.getItem('ACMLocalDVSLogger');
        return loggerStr ? JSON.parse(loggerStr) : [];
    };
    // 获取logger
    PNSLocalStorage.prototype.setLogger = function (loggers) {
        try {
            localStorage.setItem('ACMLocalDVSLogger', JSON.stringify(loggers));
            localStorage.setItem('ACMLoggerDVSMaxId', this.loggerMaxId.toString());
        }
        catch (e) {
            if (e.code === QUOTA_EXCEEDED_ERR_CODE) {
                var clearLoggers = loggers.splice(0, Math.ceil(loggers.length));
                localStorage.setItem('ACMLocalDVSLogger', JSON.stringify(clearLoggers));
                localStorage.setItem('ACMLoggerDVSMaxId', this.loggerMaxId.toString());
            }
        }
    };
    // 检查logger最大条数
    PNSLocalStorage.prototype.checkSize = function (str) {
        var size = 0;
        if (typeof str === 'string') {
            var len = str.length;
            for (var i = 0; i < len; i++) {
                var charCode = str.charCodeAt(i);
                if (charCode <= 0x007f) {
                    size += 1;
                }
                else if (charCode <= 0x07ff) {
                    size += 2;
                }
                else if (charCode <= 0xffff) {
                    size += 3;
                }
                else {
                    size += 4;
                }
            }
        }
        return size;
    };
    return PNSLocalStorage;
}());
exports.default = PNSLocalStorage;


/***/ }),

/***/ "./src/report/PNSLogger.ts":
/*!*********************************!*\
  !*** ./src/report/PNSLogger.ts ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PNSCacheManager_1 = __webpack_require__(/*! ./PNSCacheManager */ "./src/report/PNSCacheManager.ts");
var PNSUploadManager_1 = __webpack_require__(/*! ./PNSUploadManager */ "./src/report/PNSUploadManager.ts");
var moment_1 = __webpack_require__(/*! ./moment */ "./src/report/moment.ts");
var dateFormat = moment_1.default.dateFormat;
var PNSLogger = /** @class */ (function () {
    function PNSLogger() {
        this.cacheManage = new PNSCacheManager_1.default();
        this.uploader = new PNSUploadManager_1.default();
        this.insertEnable = true;
    }
    /**
     * 上传level为v的数据
     * @param data
     */
    PNSLogger.prototype.veboseLog = function (data, strategy) {
        if (!this.insertEnable) {
            return;
        }
        var date = dateFormat(new Date());
        var uploadFlag = 0;
        var uploadCount = 0;
        var content = data;
        this.cacheManage.cacheLog({
            date: date,
            uploadFlag: uploadFlag,
            uploadCount: uploadCount,
            content: content,
            level: 1,
            strategy: strategy || 2
        });
    };
    /**
     * 上传level为d的数据
     * @param data
     */
    PNSLogger.prototype.debugLog = function (data, strategy) {
        if (!this.insertEnable) {
            return;
        }
        var date = dateFormat(new Date());
        var uploadFlag = 0;
        var uploadCount = 0;
        var content = data;
        this.cacheManage.cacheLog({
            date: date,
            uploadFlag: uploadFlag,
            uploadCount: uploadCount,
            content: content,
            level: 2,
            strategy: strategy || 2
        });
    };
    /**
     * 上传level为i的数据
     * @param data
     */
    PNSLogger.prototype.infoLog = function (data, strategy) {
        if (!this.insertEnable) {
            return;
        }
        var date = dateFormat(new Date());
        var uploadFlag = 0;
        var uploadCount = 0;
        var content = data;
        this.cacheManage.cacheLog({
            date: date,
            uploadFlag: uploadFlag,
            uploadCount: uploadCount,
            content: content,
            level: 3,
            strategy: strategy || 2
        });
    };
    /**
     * 上传level为w的数据
     * @param data
     */
    PNSLogger.prototype.warnLog = function (data, strategy) {
        if (!this.insertEnable) {
            return;
        }
        var date = dateFormat(new Date());
        var uploadFlag = 0;
        var uploadCount = 0;
        var content = data;
        this.cacheManage.cacheLog({
            date: date,
            uploadFlag: uploadFlag,
            uploadCount: uploadCount,
            content: content,
            level: 4,
            strategy: strategy || 2
        });
    };
    /**
     * 上传level为e的数据
     * @param data
     */
    PNSLogger.prototype.errorLog = function (data, strategy) {
        if (!this.insertEnable) {
            return;
        }
        var date = dateFormat(new Date());
        var uploadFlag = 0;
        var uploadCount = 0;
        var content = data;
        this.cacheManage.cacheLog({
            date: date,
            uploadFlag: uploadFlag,
            uploadCount: uploadCount,
            content: content,
            level: 5,
            strategy: strategy || 2
        });
    };
    /**
     * 设置降级限流配置
     * @param slsLimit
     */
    PNSLogger.prototype.setLimitConfig = function (slsLimit) {
        this.uploader.setLimitConfig(slsLimit);
    };
    /**
     * 日志上传开关
     * @param enable
     */
    PNSLogger.prototype.setUploadEnable = function (enable) {
        this.uploader.setLogUploadEnable(enable);
    };
    /**
     * 日志上传开关
     * @param enable
     */
    PNSLogger.prototype.setInsertEnable = function (enable) {
        this.insertEnable = enable;
    };
    /**
     * 设置埋点上传函数
     * @param uploadDelegate
     */
    PNSLogger.prototype.setUploadDelegate = function (uploadDelegate) {
        this.uploader.setUploadLogDelegate(uploadDelegate);
    };
    /**
     * 上传startDate到endDate的数据
     * @param startDate
     * @param endDate
     * @param levels
     */
    PNSLogger.prototype.uploadLoggerRecordsWithStartDate = function (startDate, endDate, levels) {
        var start = startDate.getTime();
        var end = endDate.getTime();
        this.uploader.uploadLoggerRecordsWithStartDate(start, end, levels);
    };
    /**
     * 上传失败的日志
     */
    PNSLogger.prototype.uploadFailedData = function () {
        this.uploader.uploadFailedLogger();
    };
    return PNSLogger;
}());
exports.default = PNSLogger;


/***/ }),

/***/ "./src/report/PNSMonitor.ts":
/*!**********************************!*\
  !*** ./src/report/PNSMonitor.ts ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PNSCacheManager_1 = __webpack_require__(/*! ./PNSCacheManager */ "./src/report/PNSCacheManager.ts");
var PNSUploadManager_1 = __webpack_require__(/*! ./PNSUploadManager */ "./src/report/PNSUploadManager.ts");
var moment_1 = __webpack_require__(/*! ./moment */ "./src/report/moment.ts");
var dateFormat = moment_1.default.dateFormat;
var PNSMonitor = /** @class */ (function () {
    function PNSMonitor() {
        this.cacheManage = new PNSCacheManager_1.default();
        this.uploader = new PNSUploadManager_1.default();
        this.insertEnable = true;
    }
    /**
     * 插入一条monitor的数据
     * @param data
     */
    PNSMonitor.prototype.monitorData = function (data, realTime, strategy, urgency) {
        if (!this.insertEnable) {
            return;
        }
        var date = dateFormat(new Date());
        var uploadFlag = 0;
        var uploadCount = 0;
        var content = data;
        this.cacheManage.cacheMonitor({
            date: date,
            uploadFlag: uploadFlag,
            uploadCount: uploadCount,
            content: content,
            realTime: realTime || false,
            strategy: strategy || 2,
            urgency: urgency || 2,
        });
    };
    /**
     * 设置降级限流配置
     * @param slsLimit
     */
    PNSMonitor.prototype.setLimitConfig = function (slsLimit) {
        this.uploader.setLimitConfig(slsLimit);
    };
    /**
     * 埋点上传开关
     * @param enable
     */
    PNSMonitor.prototype.setUploadEnable = function (enable) {
        this.uploader.setMonitorUploadEnable(enable);
    };
    /**
     * 埋点入库开关
     * @param enable
     */
    PNSMonitor.prototype.setInsertEnable = function (enable) {
        this.insertEnable = enable;
    };
    /**
     * 设置埋点上传函数
     * @param uploadDelegate
     */
    PNSMonitor.prototype.setUploadDelegate = function (uploadDelegate) {
        this.uploader.setUploadMonitorEnable(uploadDelegate);
    };
    /**
     * 手动上传埋点
     */
    PNSMonitor.prototype.uploadMonitorByManual = function () {
        this.uploader.uploadMonitorByManual();
    };
    /**
     * 上传失败的埋点
     */
    PNSMonitor.prototype.uploadFailedData = function () {
        this.uploader.uploadFailedMonitor();
    };
    return PNSMonitor;
}());
exports.default = PNSMonitor;


/***/ }),

/***/ "./src/report/PNSUploadManager.ts":
/*!****************************************!*\
  !*** ./src/report/PNSUploadManager.ts ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __webpack_require__(/*! ./moment */ "./src/report/moment.ts");
var PNSCacheManager_1 = __webpack_require__(/*! ./PNSCacheManager */ "./src/report/PNSCacheManager.ts");
var constants_1 = __webpack_require__(/*! ./constants */ "./src/report/constants.ts");
var MAX_UPLOAD_COUNT = constants_1.Constants.MAX_UPLOAD_COUNT;
var common_1 = __webpack_require__(/*! @/common/common */ "./src/common/common.ts");
var getFullYear = moment_1.default.getFullYear, getMonth = moment_1.default.getMonth, getDay = moment_1.default.getDay, getHours = moment_1.default.getHours;
var PNSUploadManager = /** @class */ (function () {
    function PNSUploadManager() {
        this.aCMMaxLoggerRecordId = 0;
        this.aCMMaxRecordId = 0;
        this.voipMaxRecordId = 0;
        this.voipMaxLoggerRecordId = 0;
        this.uploadLogEnable = true;
        this.uploadMonitorEnable = true;
        this.cache = new PNSCacheManager_1.default();
    }
    /**
     * setUploadDelegate
     * @param uploadDelegate
     */
    PNSUploadManager.prototype.setUploadLogDelegate = function (uploadDelegate) {
        this.uploadLoggerDelegate = uploadDelegate;
    };
    /**
     * setUploadDelegate
     * @param uploadDelegate
     */
    PNSUploadManager.prototype.setUploadMonitorEnable = function (uploadDelegate) {
        this.uploadMonitorDelegate = uploadDelegate;
    };
    /**
     * 日志上传开关
     * @param enable
     */
    PNSUploadManager.prototype.setLogUploadEnable = function (enable) {
        this.uploadLogEnable = enable;
    };
    /**
     * 埋点上传开关
     * @param enable
     */
    PNSUploadManager.prototype.setMonitorUploadEnable = function (enable) {
        this.uploadMonitorEnable = enable;
    };
    /**
     * 降级限流设置
     * @param info
     */
    PNSUploadManager.prototype.setLimitConfig = function (slsLimit) {
        this.updateLimitConfig(slsLimit);
    };
    /**
     * 手动上传埋点
     */
    PNSUploadManager.prototype.uploadMonitorByManual = function () {
        if (!this.uploadMonitorEnable) {
            return;
        }
        var iSlsLimitEnable = this.checkRequestLimit();
        if (iSlsLimitEnable) {
            return;
        }
        this.uploadMonitors();
    };
    /**
     * 上传失败的数据重新上传 因为需要上传多次,不好区分, 要标记recordId
     * @param records
     */
    PNSUploadManager.prototype.uploadFailedMonitor = function () {
        if (!this.uploadMonitorEnable) {
            return;
        }
        var iSlsLimit = this.checkRequestLimit();
        if (iSlsLimit) {
            return;
        }
        // 循环上传
        this.loopUploadFailedData();
    };
    /**
     * 上传失败的日志
     * @param records
     */
    PNSUploadManager.prototype.uploadFailedLogger = function () {
        if (!this.uploadMonitorEnable) {
            return;
        }
        var iSlsLimit = this.checkRequestLimit();
        if (iSlsLimit) {
            return;
        }
        // 循环上传
        this.loopUploadFailedLogger();
    };
    /**
     * 上传日志
     * @param startDate
     * @param endDate
     * @param levels
     */
    PNSUploadManager.prototype.uploadLoggerRecordsWithStartDate = function (startDate, endDate, levels) {
        if (!this.uploadLogEnable) {
            return;
        }
        this.uploadLoggers(startDate, endDate, levels);
    };
    // 上传失败重试
    PNSUploadManager.prototype.retryUploadData = function (records, isFailed) {
        var _this = this;
        var iSlsLimitEnable = this.checkRequestLimit();
        if (iSlsLimitEnable) {
            return;
        }
        this.addReqCount();
        this.uploadMonitorDelegate.uploadMonitors(records).then(function () {
            _this.cache.deleteMonitor(records);
        }).catch(function (err) {
            console.log('---------', err);
            if (isFailed) {
                _this.cache.deleteMonitor(records);
                return;
            }
            _this.cache.updateMonitor(records);
        });
    };
    /**
     * uploadLoggers 上传日志
     * @param startDate
     * @param endDate
     * @param levels
     */
    PNSUploadManager.prototype.uploadLoggers = function (startDate, endDate, levels) {
        var _this = this;
        var voipMaxLoggerRecordId = this.voipMaxLoggerRecordId;
        this.cache.getLoggerRecordsWithStartDate(startDate, endDate, voipMaxLoggerRecordId, MAX_UPLOAD_COUNT, levels, 0).then(function (records) {
            if (!records || !records.length) {
                return;
            }
            var iSlsLimitEnable = _this.checkRequestLimit();
            if (iSlsLimitEnable) {
                return;
            }
            _this.voipMaxLoggerRecordId = records[records.length - 1].id;
            _this.addReqCount();
            _this.uploadLoggerDelegate.uploadLogs(records).then(function () {
                _this.cache.deleteLog(records);
                _this.uploadLoggers(startDate, endDate, levels);
            }).catch(function (err) {
                _this.retryUploadLogger(records);
                _this.uploadLoggers(startDate, endDate, levels);
            });
        });
    };
    // 日志上传失败重试
    PNSUploadManager.prototype.retryUploadLogger = function (records, isFailed) {
        var _this = this;
        var iSlsLimitEnable = this.checkRequestLimit();
        if (iSlsLimitEnable) {
            return;
        }
        this.addReqCount();
        this.uploadLoggerDelegate.uploadLogs(records).then(function () {
            _this.cache.deleteLog(records);
        }).catch(function (err) {
            console.log('---------', err);
            _this.cache.updateLogger(records);
        });
    };
    /**
     * 检查降级限流配置
     */
    PNSUploadManager.prototype.checkRequestLimit = function () {
        var limitConfig = this.getLimitConfig();
        var currentTime = Date.now();
        // 还未拉取降级限流配置之前默认不降级限流
        if (common_1.isEmptyObject(limitConfig)) {
            return false;
        }
        // 对不限流且需重置次数的逻辑进行封装
        var isLimit = this.checkConfigLimit(limitConfig, currentTime);
        if (!isLimit) {
            return false;
        }
        // 当前请求次数小于最大请求次数，不限流
        if (limitConfig.reqCount < limitConfig.limitCount) {
            return false;
        }
        return true;
    };
    // 上传埋点
    PNSUploadManager.prototype.uploadMonitors = function () {
        var _this = this;
        var voipMaxRecordId = this.voipMaxRecordId;
        this.cache.getMonitorRecordsWithStartId(voipMaxRecordId, MAX_UPLOAD_COUNT, 0).then(function (records) {
            if (!records || !records.length) {
                return;
            }
            var iSlsLimitEnable = _this.checkRequestLimit();
            if (iSlsLimitEnable) {
                return;
            }
            _this.addReqCount();
            _this.voipMaxRecordId = records[records.length - 1].id;
            _this.uploadMonitorDelegate.uploadMonitors(records).then(function () {
                _this.cache.deleteMonitor(records);
                _this.uploadMonitors();
            }).catch(function (err) {
                console.log('---------', err);
                _this.retryUploadData(records);
                _this.uploadMonitors();
            });
        });
    };
    // 上传失败的埋点
    PNSUploadManager.prototype.loopUploadFailedData = function () {
        var _this = this;
        var acmMaxRecordId = this.aCMMaxRecordId;
        this.cache.getMonitorRecordsWithStartId(acmMaxRecordId, MAX_UPLOAD_COUNT, 1).then(function (records) {
            if (!records || !records.length) {
                return;
            }
            var iSlsLimitEnable = _this.checkRequestLimit();
            if (iSlsLimitEnable) {
                return;
            }
            _this.aCMMaxRecordId = records[records.length - 1].id;
            _this.addReqCount();
            _this.uploadMonitorDelegate.uploadMonitors(records).then(function () {
                _this.cache.deleteMonitor(records);
                _this.loopUploadFailedData();
            }).catch(function (err) {
                console.log('---------', '上传失败重试');
                _this.retryUploadData(records, true);
                _this.loopUploadFailedData();
            });
        }).catch(function (err) {
            console.log('err', err);
        });
    };
    /**
     * 上传失败的日志
     */
    PNSUploadManager.prototype.loopUploadFailedLogger = function () {
        var _this = this;
        var ACMMaxLoggerRecordId = this.aCMMaxLoggerRecordId;
        this.cache.getLoggerRecordsWithStartId(ACMMaxLoggerRecordId, MAX_UPLOAD_COUNT, 1).then(function (records) {
            if (!records || !records.length) {
                return;
            }
            var iSlsLimitEnable = _this.checkRequestLimit();
            if (iSlsLimitEnable) {
                return;
            }
            _this.addReqCount();
            _this.aCMMaxLoggerRecordId = records[records.length - 1].id;
            _this.uploadLoggerDelegate.uploadLogs(records).then(function () {
                _this.cache.deleteLog(records);
                _this.loopUploadFailedLogger();
            }).catch(function (err) {
                console.log('---------', '上传失败重试');
                _this.retryUploadLogger(records, true);
                _this.loopUploadFailedLogger();
            });
        }).catch(function (err) {
            console.log('err', err);
        });
    };
    /**
     * 设置降级限流方案
     */
    PNSUploadManager.prototype.updateLimitConfig = function (slsLimitConfig) {
        var oldLimitConfig = this.getLimitConfig();
        var currentTime = Date.now();
        var newLimitConfig = {
            isLimited: !!slsLimitConfig.isLimited,
            msg: slsLimitConfig.msg || '',
            limitTime: slsLimitConfig.limitTime || 0,
            limitCount: slsLimitConfig.limitCount || 0,
            reqCount: oldLimitConfig.reqCount || 0,
            lastReqTime: oldLimitConfig.lastReqTime || currentTime
        };
        var isLimit = this.checkConfigLimit(newLimitConfig, currentTime);
        // 重置次数逻辑
        if (isLimit) {
            newLimitConfig.reqCount = 0;
            newLimitConfig.lastReqTime = currentTime;
        }
        this.storeLimitConfig(newLimitConfig);
    };
    // 获取降级限流配置
    PNSUploadManager.prototype.getLimitConfig = function () {
        var slsLimitConfig = localStorage.getItem('ACMSlsLimitConfig');
        return slsLimitConfig ? JSON.parse(slsLimitConfig) : {};
    };
    /**
     * storeLimitConfig 把limit配置存储在磁盘
     * @param limitConfig
     */
    PNSUploadManager.prototype.storeLimitConfig = function (limitConfig) {
        localStorage.setItem('ACMSlsLimitConfig', JSON.stringify(limitConfig));
    };
    /**
     * 对可重置的限流逻辑进行检查封装
     * @param limitConfig
     * @param currentTime
     */
    PNSUploadManager.prototype.checkConfigLimit = function (limitConfig, currentTime) {
        // 如果isLimited为false，则不限流
        if (!limitConfig.isLimited) {
            return false;
        }
        var isLimitTimeNumber = common_1.isNumber(limitConfig.limitTime || 0);
        // limitTime 小于等于0或者不能被24整除，不限流
        if (!isLimitTimeNumber || limitConfig.limitTime <= 0 || 24 % limitConfig.limitTime !== 0) {
            return false;
        }
        if (!limitConfig.lastReqTime) {
            return false;
        }
        var oldPeriod = getHours(limitConfig.lastReqTime) / limitConfig.limitTime;
        var currentPeriod = getHours(currentTime) / limitConfig.limitTime;
        // 新的请求和老的请求不在同一天且不在同一个区间，不限流
        if (getFullYear(limitConfig.lastReqTime) !== getFullYear(currentTime) ||
            getMonth(limitConfig.lastReqTime) !== getMonth(currentTime) ||
            getDay(limitConfig.lastReqTime) !== getDay(currentTime) ||
            parseInt(String(oldPeriod)) !== parseInt(String(currentPeriod)) // parseInt第一个参数为字符串
        ) {
            return false;
        }
        return true;
    };
    // 增加次数
    PNSUploadManager.prototype.addReqCount = function () {
        var slsLimitConfig = this.getLimitConfig();
        var currentTime = Date.now();
        if (!slsLimitConfig.isLimited) {
            return;
        }
        var isLimit = this.checkConfigLimit(slsLimitConfig, currentTime);
        if (isLimit) {
            slsLimitConfig.reqCount = ++slsLimitConfig.reqCount;
            slsLimitConfig.lastReqTime = currentTime;
        }
        this.storeLimitConfig(slsLimitConfig);
    };
    return PNSUploadManager;
}());
exports.default = PNSUploadManager;


/***/ }),

/***/ "./src/report/constants.ts":
/*!*********************************!*\
  !*** ./src/report/constants.ts ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Constants = void 0;
var ua_parser_js_1 = __webpack_require__(/*! ua-parser-js */ "./node_modules/_ua-parser-js@0.7.28@ua-parser-js/src/ua-parser.js");
var MD5 = __webpack_require__(/*! js-md5 */ "./node_modules/_js-md5@0.7.3@js-md5/src/md5.js");
var uuid_1 = __webpack_require__(/*! uuid */ "./node_modules/_uuid@8.3.2@uuid/dist/esm-browser/index.js");
var Constants;
(function (Constants) {
    var _a;
    Constants.MAX_UPLOAD_COUNT = 20;
    Constants.KEY_SDK_VERSION = 'sdkVersion';
    Constants.KEY_OS_VERSION = 'osVersion';
    Constants.KEY_DEVICE_MODEL = 'deviceModel';
    Constants.KEY_DEVICE_BRAND = 'deviceBrand';
    Constants.KEY_BROWSER_BRAND = 'browserBrand';
    Constants.KEY_DEVICE_ID = 'deviceId';
    Constants.KEY_DEVICE_NAME = 'deviceName';
    Constants.KEY_DEVICE_TYPE = 'deviceType';
    // export const KEY_OS_TYPE = 'osType';
    Constants.KEY_CARRIER_SDK_VERSION = 'carrierSdkVersion';
    Constants.KEY_MONITOR_VERSION = 'monitorVersion';
    Constants.KEY_BROWSER = 'browser';
    Constants.KEY_BROWSER_VERSION = 'browserVersion';
    Constants.KEY_VENDOR_KEY = 'vendorKey';
    Constants.KEY_OS_NAME = 'osName';
    Constants.KEY_ACTION = 'action';
    Constants.KEY_API_LEVEL = 'apiLevel';
    Constants.KEY_OS_TYPE = 'osType';
    Constants.SDK_VERSION = "1.1.1";
    Constants.DEVICE_TYPE = 'web';
    Constants.DEVICE_BRAND = window.navigator.vendor; //浏览器厂商 deviceBrand
    Constants.CARRIER_SDK_VERSION = '1.2.0';
    Constants.MONITOR_VERSION = '2.0';
    Constants.ACTION_CHECK_AUTH_AVAILABLE = 'sdk.check';
    Constants.ACTION_GET_CONFIG = 'sdk.config';
    Constants.ACTION_GET_VENDOR_CONFIG = 'sdk.getVendorConfig';
    Constants.ACTION_GET_CMCC_TOKEN = 'sdk.cmcc.getToken';
    Constants.ACTION_GET_CUCC_TOKEN = 'sdk.cmcc.getToken';
    Constants.ACTION_GET_CTCC_TOKEN = 'sdk.cmcc.getToken';
    Constants.ACTION_GET_ALLVENDOR_TOKEN = 'sdk.cc.getToken';
    var DEVICE_ID = MD5(uuid_1.v4() + window.location.host + new Date().getTime());
    var deviceId = localStorage.getItem('AlicomVoipUniqueId');
    Constants.uniqueId = deviceId || DEVICE_ID;
    if (!deviceId) {
        localStorage.setItem('AlicomVoipUniqueId', DEVICE_ID);
    }
    var parser = new ua_parser_js_1.UAParser(window.navigator.userAgent.toLowerCase());
    var osInfo = parser.getOS();
    var browser = parser.getBrowser();
    var device = parser.getDevice();
    Constants.OS_NAME = osInfo.name;
    Constants.OS_VERSION = osInfo.version;
    Constants.SDK_EXTRA_INFO = (_a = {},
        _a[Constants.KEY_SDK_VERSION] = Constants.SDK_VERSION,
        _a[Constants.KEY_OS_VERSION] = Constants.OS_VERSION,
        _a[Constants.KEY_OS_NAME] = Constants.OS_NAME,
        _a[Constants.KEY_DEVICE_NAME] = device.model,
        _a[Constants.KEY_DEVICE_BRAND] = device.vendor,
        _a[Constants.KEY_DEVICE_TYPE] = device.type,
        _a[Constants.KEY_MONITOR_VERSION] = Constants.MONITOR_VERSION,
        _a[Constants.KEY_BROWSER] = browser.name,
        _a[Constants.KEY_BROWSER_VERSION] = browser.version,
        _a[Constants.KEY_BROWSER_BRAND] = Constants.DEVICE_BRAND,
        _a[Constants.KEY_OS_TYPE] = Constants.DEVICE_TYPE,
        _a);
    var vendorKey;
    (function (vendorKey) {
        vendorKey[vendorKey["CM"] = 1] = "CM";
        vendorKey[vendorKey["CU"] = 2] = "CU";
        vendorKey[vendorKey["CT"] = 3] = "CT";
    })(vendorKey = Constants.vendorKey || (Constants.vendorKey = {}));
})(Constants = exports.Constants || (exports.Constants = {}));


/***/ }),

/***/ "./src/report/index.ts":
/*!*****************************!*\
  !*** ./src/report/index.ts ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PNSLogger = exports.PNSMonitor = void 0;
var PNSMonitor_1 = __webpack_require__(/*! ./PNSMonitor */ "./src/report/PNSMonitor.ts");
exports.PNSMonitor = PNSMonitor_1.default;
var PNSLogger_1 = __webpack_require__(/*! ./PNSLogger */ "./src/report/PNSLogger.ts");
exports.PNSLogger = PNSLogger_1.default;


/***/ }),

/***/ "./src/report/moment.ts":
/*!******************************!*\
  !*** ./src/report/moment.ts ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Moment = /** @class */ (function () {
    function Moment() {
    }
    /**
     *
     * @param timestamp
     */
    Moment.getFullYear = function (timestamp) {
        var date = new Date(timestamp);
        return date.getFullYear();
    };
    /**
     * 获取传入时间在哪一月
     * @param timestamp
     */
    Moment.getMonth = function (timestamp) {
        var date = new Date(timestamp);
        return date.getMonth();
    };
    /**
     * 获取传入时间在哪一天
     * @param timestamp
     */
    Moment.getDay = function (timestamp) {
        var date = new Date(timestamp);
        return date.getDay();
    };
    /**
     * 获取传入时间在一天的哪个小时
     * @param timestamp
     */
    Moment.getHours = function (timestamp) {
        var date = new Date(timestamp);
        return date.getHours();
    };
    Moment.dateFormat = function (date) {
        var seperator1 = '-';
        var seperator2 = ':';
        var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        var strDate = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate
            + ' ' + date.getHours() + seperator2 + date.getMinutes() + seperator2 + date.getSeconds()
            + '.' + date.getMilliseconds();
        return currentdate;
    };
    return Moment;
}());
exports.default = Moment;


/***/ }),

/***/ "./src/report/monitorUtil.ts":
/*!***********************************!*\
  !*** ./src/report/monitorUtil.ts ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(/*! ./constants */ "./src/report/constants.ts");
var moment_1 = __webpack_require__(/*! @/report/moment */ "./src/report/moment.ts");
var dateFormat = moment_1.default.dateFormat;
var SDK_EXTRA_INFO = constants_1.Constants.SDK_EXTRA_INFO;
var KEY_ACTION = constants_1.Constants.KEY_ACTION;
var vendorKey = constants_1.Constants.vendorKey;
var KEY_API_LEVEL = constants_1.Constants.KEY_API_LEVEL;
var KEY_OS_TYPE = constants_1.Constants.KEY_OS_TYPE;
var ACTION_CHECK_AUTH_AVAILABLE = constants_1.Constants.ACTION_CHECK_AUTH_AVAILABLE;
var ACTION_GET_CONFIG = constants_1.Constants.ACTION_GET_CONFIG;
var ACTION_GET_VENDOR_CONFIG = constants_1.Constants.ACTION_GET_VENDOR_CONFIG;
var ACTION_GET_ALLVENDOR_TOKEN = constants_1.Constants.ACTION_GET_ALLVENDOR_TOKEN;
var uniqueId = constants_1.Constants.uniqueId;
var MonitorUtil = /** @class */ (function () {
    function MonitorUtil() {
    }
    MonitorUtil.makeAllVendorClientInfo = function (traceId) {
        return __assign(__assign({}, SDK_EXTRA_INFO), { uniqueId: uniqueId,
            traceId: traceId, domain: location.host, url: location.href });
    };
    ;
    MonitorUtil.makeClientInfo = function (traceId, netType) {
        var carrierSdkVersion = netType === 'CU' ? '1.3.0' : '1.0.0';
        var operatorId = netType === 'CM' ? 1 : (netType === 'CU' ? 2 : 3);
        return __assign(__assign({}, SDK_EXTRA_INFO), { uniqueId: uniqueId, vendorKey: netType, carrierSdkVersion: carrierSdkVersion,
            traceId: traceId,
            operatorId: operatorId, domain: location.host, url: location.href });
    };
    MonitorUtil.makeUserInfo = function (startTime, endTime, sdkInfo, serverInfo, carrierInfo) {
        var whole = ((endTime.getTime() - startTime.getTime()) / 1000).toFixed(2);
        return __assign(__assign(__assign(__assign(__assign({ startTime: dateFormat(startTime), endTime: dateFormat(endTime) }, (sdkInfo
            ? sdkInfo
            : {})), { netType: sdkInfo.netType || 'unknown' }), (serverInfo
            ? serverInfo
            : {})), (carrierInfo
            ? carrierInfo
            : {})), { wholeMS: whole });
    };
    // static makeSecretInfo(
    //   phoneNumber: string,
    //   accessCode?: string,
    //   jwtToken?: string,
    //   accessToken?: string,
    //   spToken?: string
    // ): string {
    //   const secretInfo: ISecretInfo =  {
    //     phoneNumber,
    //     accessCode,
    //     jwtToken,
    //     accessToken,
    //     spToken
    //   };
    //
    //   // return encryptByDES(secretInfo);
    // }
    MonitorUtil.makeCheckAuthMonitorData = function (startTime, endTime, sdkInfo, secretInfo, isAllVendor, serverInfo) {
        var _a;
        var netType = sdkInfo.netType || 'unknown';
        var clientInfo = isAllVendor
            ? this.makeClientInfo(sdkInfo.traceId, netType)
            : this.makeAllVendorClientInfo(sdkInfo.traceId);
        var userInfo = this.makeUserInfo(startTime, endTime, sdkInfo, serverInfo);
        // const s = this.makeSecretInfo(secretInfo);
        isAllVendor && delete userInfo.netType;
        return _a = {},
            _a[KEY_ACTION] = ACTION_CHECK_AUTH_AVAILABLE,
            _a[KEY_API_LEVEL] = '0',
            _a[KEY_OS_TYPE] = 'web',
            _a.c = clientInfo,
            _a.u = __assign(__assign({}, userInfo), secretInfo),
            _a.s = '',
            _a;
    };
    MonitorUtil.makeConfigMonitorData = function (action, startTime, endTime, sdkInfo, secretInfo, serverInfo) {
        var _a;
        var netType = sdkInfo.netType || 'unknown';
        var clientInfo = this.makeClientInfo(sdkInfo.traceId, netType);
        var userInfo = this.makeUserInfo(startTime, endTime, sdkInfo, serverInfo);
        // const s = this.makeSecretInfo(secretInfo);
        return _a = {},
            _a[KEY_ACTION] = action,
            _a[KEY_API_LEVEL] = '1',
            _a[KEY_OS_TYPE] = 'web',
            _a.c = clientInfo,
            _a.u = __assign(__assign({}, userInfo), secretInfo),
            _a.s = '',
            _a;
    };
    MonitorUtil.insertGetVendorConfigMonitor = function (startTime, endTime, sdkInfo, secretInfo, serverInfo) {
        var _a;
        var netType = sdkInfo.netType || 'unknown';
        var clientInfo = this.makeClientInfo(sdkInfo.traceId, netType);
        var userInfo = this.makeUserInfo(startTime, endTime, sdkInfo, serverInfo);
        // const s = this.makeSecretInfo(secretInfo);
        return _a = {},
            _a[KEY_ACTION] = ACTION_GET_VENDOR_CONFIG,
            _a[KEY_API_LEVEL] = '1',
            _a[KEY_OS_TYPE] = 'web',
            _a.c = clientInfo,
            _a.u = __assign(__assign({}, userInfo), secretInfo),
            _a.s = '',
            _a;
    };
    /**
     * 供应商token埋点
     */
    MonitorUtil.makeTokenMonitorData = function (startTime, endTime, sdkInfo, secretInfo, carrierInfo) {
        var _a;
        var clientInfo = this.makeClientInfo(sdkInfo.traceId, sdkInfo.netType);
        var userInfo = this.makeUserInfo(startTime, endTime, sdkInfo, carrierInfo);
        // const s = this.makeSecretInfo( secretInfo.phoneNumber, secretInfo.accessCode,  secretInfo.spToken);
        var action = sdkInfo.netType ? "sdk." + sdkInfo.netType.toLocaleLowerCase() + "cc.getoken" : 'unknown.getoken';
        return _a = {},
            _a[KEY_ACTION] = action,
            _a[KEY_API_LEVEL] = '0',
            _a[KEY_OS_TYPE] = 'web',
            _a.c = clientInfo,
            _a.u = __assign(__assign(__assign({}, userInfo), secretInfo), { accessCode: '' }),
            _a.s = '',
            _a;
    };
    /**
     * 三网供应商token，综合数据埋点
     */
    MonitorUtil.makeAllVendorTokenMonitorData = function (startTime, endTime, sdkInfo, secretInfo, allVendorCarrierInfo) {
        var _a;
        var clientInfo = this.makeAllVendorClientInfo(sdkInfo.traceId);
        var userInfo = this.makeUserInfo(startTime, endTime, sdkInfo, allVendorCarrierInfo);
        delete userInfo.netType;
        var action = ACTION_GET_ALLVENDOR_TOKEN;
        return _a = {},
            _a[KEY_ACTION] = action,
            _a[KEY_API_LEVEL] = '0',
            _a[KEY_OS_TYPE] = 'web',
            _a.c = clientInfo,
            _a.u = __assign(__assign({}, userInfo), secretInfo),
            _a.s = '',
            _a;
    };
    ;
    MonitorUtil.makeVendorTokenMonitorData = function (startTime, endTime, isAuth, sdkInfo, secretInfo, carrierInfo) {
        var _a;
        var clientInfo = this.makeClientInfo(sdkInfo.traceId, sdkInfo.netType);
        var userInfo = this.makeUserInfo(startTime, endTime, sdkInfo, carrierInfo);
        // const s = this.makeSecretInfo( secretInfo.phoneNumber, secretInfo.accessCode,  secretInfo.spToken);
        var authAction = sdkInfo.netType ? sdkInfo.netType.toLocaleLowerCase() + "cc.auth" : 'unknown.auth';
        var action = sdkInfo.netType ? sdkInfo.netType.toLocaleLowerCase() + "cc.getoken" : 'unknown.getoken';
        return _a = {},
            _a[KEY_ACTION] = isAuth ? authAction : action,
            _a[KEY_API_LEVEL] = '0',
            _a[KEY_OS_TYPE] = 'web',
            _a.c = clientInfo,
            _a.u = __assign(__assign({}, userInfo), secretInfo),
            _a.s = '',
            _a;
    };
    return MonitorUtil;
}());
exports.default = MonitorUtil;


/***/ }),

/***/ "./src/utils/API.ts":
/*!**************************!*\
  !*** ./src/utils/API.ts ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var baseUrl = '//dypns.alysm.cn';
var baseCTUrl = 'https://id6.me';
// const mockBaseUrl = '../../mock';
var API = {
    authPnsWeb: baseUrl + "/pns/authPnsWeb",
    authPnsWebAllVendor: baseUrl + "/pns/authPnsWebAllVendor",
    preGetMobileCT: baseCTUrl + "/auth/preauth.do",
    upLoadInfo: baseUrl + "/upLoadInfo",
    getConfig: baseUrl + "/queryAppConfig",
};
exports.default = API;


/***/ }),

/***/ "./src/utils/request.ts":
/*!******************************!*\
  !*** ./src/utils/request.ts ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestJsonp = exports.request = void 0;
var jsonp_1 = __webpack_require__(/*! @/common/jsonp */ "./src/common/jsonp.ts");
var axios_1 = __webpack_require__(/*! axios */ "./node_modules/_axios@0.19.2@axios/index.js");
function request(url, method, data, params, header) {
    if (params === void 0) { params = {}; }
    if (header === void 0) { header = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var opt;
        return __generator(this, function (_a) {
            opt = {
                url: url,
                method: method,
                // baseURL,
                transformResponse: [function (res) {
                        // 对 data 进行任意转换处理
                        var dataJson = JSON.parse(res);
                        return dataJson;
                    }],
                headers: __assign({}, header),
                data: data,
                params: params,
                withCredentials: false,
            };
            axios_1.default.defaults.timeout = 4000;
            return [2 /*return*/, axios_1.default(__assign({}, opt))];
        });
    });
}
exports.request = request;
function requestJsonp(url, data, callbackName) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, jsonp_1.default(url, data, callbackName)];
        });
    });
}
exports.requestJsonp = requestJsonp;


/***/ }),

/***/ "./src/utils/utils.ts":
/*!****************************!*\
  !*** ./src/utils/utils.ts ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Utilities = void 0;
var Utilities;
(function (Utilities) {
    // tslint:disable-next-line:ban-types
    function delay(time, fn) {
        var timer = null;
        return {
            start: function (immediate) {
                if (immediate) {
                    return Promise.resolve(fn(timer));
                }
                if (timer) {
                    return;
                }
                return new Promise(function (resolve) {
                    timer = window.setTimeout(function () {
                        timer = null;
                        resolve(fn(timer));
                    }, time);
                });
            },
            stop: function () {
                if (timer) {
                    window.clearTimeout(timer);
                }
            },
        };
    }
    Utilities.delay = delay;
})(Utilities = exports.Utilities || (exports.Utilities = {}));


/***/ }),

/***/ "./static/jssdk_v1.0.0.min.js":
/*!************************************!*\
  !*** ./static/jssdk_v1.0.0.min.js ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/*
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

/*
 * Configurable variables. You may need to tweak these to be compatible with
 * the server-side, but the defaults work in most cases.
 */
var hexcase = 0;  /* hex output format. 0 - lowercase; 1 - uppercase        */
var b64pad = ""; /* base-64 pad character. "=" for strict RFC compliance   */
var chrsz = 8;  /* bits per input character. 8 - ASCII; 16 - Unicode      */

/*
 * These are the functions you'll usually want to call
 * They take string arguments and return either hex or base-64 encoded strings
 */
function hex_md5(s) { return binl2hex(core_md5(str2binl(s), s.length * chrsz)); }
function b64_md5(s) { return binl2b64(core_md5(str2binl(s), s.length * chrsz)); }
function str_md5(s) { return binl2str(core_md5(str2binl(s), s.length * chrsz)); }
function hex_hmac_md5(key, data) { return binl2hex(core_hmac_md5(key, data)); }
function b64_hmac_md5(key, data) { return binl2b64(core_hmac_md5(key, data)); }
function str_hmac_md5(key, data) { return binl2str(core_hmac_md5(key, data)); }

/*
 * Perform a simple self-test to see if the VM is working
 */
function md5_vm_test() {
  return hex_md5("abc") == "900150983cd24fb0d6963f7d28e17f72";
}

/*
 * Calculate the MD5 of an array of little-endian words, and a bit length
 */
function core_md5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << ((len) % 32);
  x[(((len + 64) >>> 9) << 4) + 14] = len;

  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (var i = 0; i < x.length; i += 16) {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;

    a = md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
    d = md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5_ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);

    a = md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
    a = md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);

    a = md5_hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
    c = md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5_hh(b, c, d, a, x[i + 2], 23, -995338651);

    a = md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
    d = md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5_ii(b, c, d, a, x[i + 9], 21, -343485551);

    a = safe_add(a, olda);
    b = safe_add(b, oldb);
    c = safe_add(c, oldc);
    d = safe_add(d, oldd);
  }
  return Array(a, b, c, d);

}

/*
 * These functions implement the four basic operations the algorithm uses.
 */
function md5_cmn(q, a, b, x, s, t) {
  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
}
function md5_ff(a, b, c, d, x, s, t) {
  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
}
function md5_gg(a, b, c, d, x, s, t) {
  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
}
function md5_hh(a, b, c, d, x, s, t) {
  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5_ii(a, b, c, d, x, s, t) {
  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
}

/*
 * Calculate the HMAC-MD5, of a key and some data
 */
function core_hmac_md5(key, data) {
  var bkey = str2binl(key);
  if (bkey.length > 16) bkey = core_md5(bkey, key.length * chrsz);

  var ipad = Array(16), opad = Array(16);
  for (var i = 0; i < 16; i++) {
    ipad[i] = bkey[i] ^ 0x36363636;
    opad[i] = bkey[i] ^ 0x5C5C5C5C;
  }

  var hash = core_md5(ipad.concat(str2binl(data)), 512 + data.length * chrsz);
  return core_md5(opad.concat(hash), 512 + 128);
}

/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */
function safe_add(x, y) {
  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return (msw << 16) | (lsw & 0xFFFF);
}

/*
 * Bitwise rotate a 32-bit number to the left.
 */
function bit_rol(num, cnt) {
  return (num << cnt) | (num >>> (32 - cnt));
}

/*
 * Convert a string to an array of little-endian words
 * If chrsz is ASCII, characters >255 have their hi-byte silently ignored.
 */
function str2binl(str) {
  var bin = Array();
  var mask = (1 << chrsz) - 1;
  for (var i = 0; i < str.length * chrsz; i += chrsz)
    bin[i >> 5] |= (str.charCodeAt(i / chrsz) & mask) << (i % 32);
  return bin;
}

/*
 * Convert an array of little-endian words to a string
 */
function binl2str(bin) {
  var str = "";
  var mask = (1 << chrsz) - 1;
  for (var i = 0; i < bin.length * 32; i += chrsz)
    str += String.fromCharCode((bin[i >> 5] >>> (i % 32)) & mask);
  return str;
}

/*
 * Convert an array of little-endian words to a hex string.
 */
function binl2hex(binarray) {
  var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
  var str = "";
  for (var i = 0; i < binarray.length * 4; i++) {
    str += hex_tab.charAt((binarray[i >> 2] >> ((i % 4) * 8 + 4)) & 0xF) +
      hex_tab.charAt((binarray[i >> 2] >> ((i % 4) * 8)) & 0xF);
  }
  return str;
}

/*
 * Convert an array of little-endian words to a base-64 string
 */
function binl2b64(binarray) {
  var tab = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  var str = "";
  for (var i = 0; i < binarray.length * 4; i += 3) {
    var triplet = (((binarray[i >> 2] >> 8 * (i % 4)) & 0xFF) << 16)
      | (((binarray[i + 1 >> 2] >> 8 * ((i + 1) % 4)) & 0xFF) << 8)
      | ((binarray[i + 2 >> 2] >> 8 * ((i + 2) % 4)) & 0xFF);
    for (var j = 0; j < 4; j++) {
      if (i * 8 + j * 6 > binarray.length * 32) str += b64pad;
      else str += tab.charAt((triplet >> 6 * (3 - j)) & 0x3F);
    }
  }
  return str;
}
; (function (win, doc) {
  var host = window.location.host === "121.15.167.251:31031" ? "http://120.197.235.102" : "https://www.cmpassport.com"
  var opts = {
    //取号地址
    getMobileUrl: {
      // test01:"https://10.153.99.55:1443/h5/getMobile",
      test01: "https://120.197.235.102:7009/h5/getMobile",
      // test01:" https://10.153.99.56:1443/h5/getMobile",
      // test01:" https://www.cmpassport.com:1443/h5/getMobile",
      // test01:"http://192.168.92.94:1443/h5/getMobile",
      pro: "https://verify.cmpassport.com/h5/getMobile"
    },
    getCTaddress: {
      test01: "http://120.197.235.102/NumberAbility01/h5/getCTaddress.htm",
      // test01:"http://10.153.99.51:8315/NumberAbility/h5/getCTaddress.htm",
      pro: "https://www.cmpassport.com/NumberAbility/h5/getCTaddress.htm"
    },
    getCTCUtoken: {
      test01: "http://120.197.235.102/NumberAbility01/h5/getCTCUtoken.htm",
      // test01:"http://10.153.99.51:8315/NumberAbility/h5/getCTCUtoken.htm",
      pro: "https://www.cmpassport.com/NumberAbility/h5/getCTCUtoken.htm"
    },
    //日志上报
    logReport: {
      pro: "https://log-h5.cmpassport.com:9443/log/logReport"
    },
    CUjssdk: {
      pro: "https://sdk.microwu.com/sdk-deliver/js/verify_mobile_sdk-1.3.0.js"
    },
    optparams: {
      uuid: '',
      msgId: '',
      businessType: '1',
      timestamp: dateFormat(new Date(), "yyyyMMddhhmmssSSS"),
      userInformation: getFingerPrint(),
      isimge: false
    }
  }
  //生成uuid
  function uuid(len, radix) {
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    var uuid = [], i;
    radix = radix || chars.length;

    if (len) {
      for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
    } else {
      var r;

      uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
      uuid[14] = '4';

      for (i = 0; i < 36; i++) {
        if (!uuid[i]) {
          r = 0 | Math.random() * 16;
          uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
        }
      }
    }
    return uuid.join('');
  }
  //获取浏览器指纹并进行base64加密处理以及url编码
  function getFingerPrint() {
    return encodeURIComponent(base64encode(getBrowserInfo()));
  }
  //生成时间戳
  function dateFormat(obj, fmt) {
    var o = {
      "M+": obj.getMonth() + 1, //月份 
      "d+": obj.getDate(), //日 
      "h+": obj.getHours(), //小时 
      "m+": obj.getMinutes(), //分 
      "s+": obj.getSeconds(), //秒 
      "q+": Math.floor((obj.getMonth() + 3) / 3), //季度 
      "S+": obj.getMilliseconds() //毫秒 
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (obj.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
      if (new RegExp("(" + k + ")").test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : ((((RegExp.$1.length == 3 && k == "S+") ? "000" : "00") + o[k]).substr(("" + o[k]).length)));
      }
    }
    return fmt;
  }

  var jsonpFun = function (options) {
    options = options || {};
    if (!options.url || !options.callback) {
      throw new Error("参数不合法");
    }
    //创建 script 标签并加入到页面中
    var oHead = document.getElementsByTagName('head')[0];
    var params = "";
    if (options.data) {
      options.data[options.callback] = options.callback;
      params += formatParams(options.data);
    } else {
      params += options.callback + "=" + options.callback;
    }

    var oS = document.createElement('script');
    oHead.appendChild(oS);

    //创建jsonp回调函数
    window[options.callback] = function (json) {
      oHead.removeChild(oS);
      clearTimeout(oS.timer);
      window[options.callback] = null;
      options.success && options.success(json);
    };

    //发送请求
    //alert(options.oSscrType);
    if (options.oSscrType === 1) {
      var appendLo = (options.url.indexOf('?') < 0) ? '?' : '&';
      oS.src = options.url + appendLo + params;
    } else {
      oS.src = options.url;
    }
    //超时处理
    if (options.time) {
      oS.timer = setTimeout(function () {
        window[options.callback] = null;
        oHead.removeChild(oS);
        options.fail && options.fail({
          message: "超时"
        });
      }, options.time);
    }
  }

  function loadJS(url, callback) {
    var al = document.getElementsByTagName("script");
    var joine = [];
    for(var i = 0; i<al.length; i++){
      joine.push(al[i].getAttribute("src"));
    }
    var ajoine = joine.join(",");
    if(ajoine.indexOf(url)>0) {
      // console.log(al);
      callback.success();
      return;
    }
    var script = document.createElement('script'),
      succFn = callback.success || function () { },
      errorFn = callback.error || function () { };
      script.type = 'text/javascript',
      script.id = 'CU';
    //IE
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState == 'loaded' || script.readyState == 'complete') {
          script.onreadystatechange = null;
          succFn();
        }
      };
    } else {
      //其他浏览器
      script.onload = function () { succFn(); };
    }
    script.onerror = function() {
      errorFn();
      document.getElementById('CU').remove();
    }
    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
  }

  //获取s加密后的sign以及获取token
  win.YDRZ = {

    //获取网络类型
    getConnection: function (appId) {
      if(opts.optparams.msgId == '') {
        opts.optparams.msgId = uuid(32, 32);
      }
      var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection || {
        type: "unknown"
      };

      // var ua = navigator.userAgent;
      // var networkStr = ua.match(/NetType\/\w+/) ? ua.match(/NetType\/\w+/)[0] : 'NetType/other';
      //     networkStr = networkStr.toLowerCase().replace('nettype/', '');
      // //网络类型
      // var cellularType = ['cellular','4g','3g','3gnet','2g'];


      var version = '2.0';
      var str = version + appId + opts.optparams.timestamp + opts.optparams.msgId + '@Fdiwmxy7CBDDQNUI';
      var signMD5 = hex_md5(str);

      var net = {
        appid: appId,
        msgid: opts.optparams.msgId,
        // netType:connection.type || 'unknown',
        netType: connection.type == 'none' ? 'unknown' : connection.type || 'unknown',
        // netType1:cellularType.indexOf(networkStr) != -1 ? 'cellular' : networkStr == 'wifi' ? 'wifi' : 'unknown'
      }
      var param = {
        "header": {
          "sign": signMD5,
          "msgid": opts.optparams.msgId,
          "version": version,
          "appid": appId,
          "systemtime": opts.optparams.timestamp
        },
        "body": {
          "log": {
            "UA": navigator.userAgent,
            "appId": appId,
            "msgid": opts.optparams.msgId,
            "netType": net.netType
          }
        }
      }
      if(navigator.sendBeacon) {
        navigator.sendBeacon(opts.logReport.pro, JSON.stringify(param));
      }
      


      return net;
    },
    
    getTokenInfo: function (opt) {
      opts.optparams.msgId = opt.data.traceId;
      var This = this;
      //判断参数是否正确
      var options = {
        // header: {
        version: opt.data.version,
        timestamp: opt.data.timestamp,
        appId: opt.data.appId,
        businessType: opts.optparams.businessType,
        traceId: opt.data.traceId,
        // },
        // body: {
        sign: opt.data.sign,
        msgId: opt.data.traceId,
        userInformation: opts.optparams.userInformation,
        expandParams: opt.data.expandParams
        // }
      }
      //校验是否启用测试线链接
      var reqUrl = opt.data.isTest === '0' ? opts.getMobileUrl.test01 : opts.getMobileUrl.pro;
      var openType = opt.data.openType;

      try {
        request.ajax({
          request: {
            // headers:options.header,
            url: reqUrl,
            method: "post",
            data: JSON.stringify(options)
          },
          success: function (res) {
            if (res.result.body.resultCode === '103000') {
              var obj = {
                code: res.result.body.resultCode,
                token: res.result.body.token,
                userInformation: opts.optparams.userInformation,
                message: '获取token成功'
              }
              opt.success({
                code: obj.code,
                message: obj.message,
                token: obj.token,
                userInformation: obj.userInformation,
                msgId: opts.optparams.msgId
              })
            } else {
              var obj = {
                code: res.result.body.resultCode,
                message: res.result.body.resultDesc
              }
              if(openType == '0') {
                opt.error({
                  code: obj.code,
                  message: obj.message,
                  msgId: opts.optparams.msgId
                })
                return obj
              }else {
                opt.YDData = obj.message + '|' + obj.code;
                This.getCTInfo(opt);
              }
            }
          },
          error: function (res) {
            var obj = {
              code: "500",
              message: "接口异常，获取token失败"
            }
            if(openType == '0') {
              opt.error({
                code: obj.code,
                message: obj.message,
                msgId: opts.optparams.msgId
              })
              return obj
            }else {
              opt.YDData = obj.message + '|' + obj.code;
              This.getCTInfo(opt);
            }
          }
        });

      } catch (e) {
        throw new Error(e);
      }
    },
    getCTInfo: function (opt) {
      var reqUrl = opt.data.isTest === '0' ? opts.getCTaddress.test01 : opts.getCTaddress.pro,
        version = '1.5',
        msgId = opts.optparams.msgId,
        timestamp = opts.optparams.timestamp,
        appIdCT = '8235229163',
        appid = opt.data.appId,
        format = 'jsonp',
        clientType = '20200',
        appKey = '',
        _self = this,
        MD5_CTStr = hex_md5(appid + appIdCT + clientType + format + msgId + timestamp + version);
      var param = {
        header: {
          version: version,
          msgId: msgId,
          timestamp: timestamp,
          appIdCT: appIdCT,
          appId: appid
        },
        body: {
          format: format,
          clientType: clientType,
          sign: MD5_CTStr
        }
      }
      request.ajax({
        request: {
          url: reqUrl,
          method: "post",
          data: JSON.stringify(param)
        },
        success: function (res) {
          if (res.result.body.resultCode == "000000") {
            var res = res.result.body,
              CTURL = res.reqUrl
                + '?appId=' + appIdCT
                + '&paramKey=' + res.paramKey
                + '&paramStr=' + res.paramStr
                + '&sign=' + res.sign
                + '&version=1.5'
                + '&clientType=' + clientType
                + '&format=' + format;

            jsonpFun({
              url: CTURL,
              callback: "getTelecomPhone",
              time: 3000,
              oSscrType: 0,
              success: function (ds) {
                if (ds.result == '0') {
                  var config = {
                    appid: opt.data.appId,
                    operType: 'CT',
                    data: ds.data,
                    paramKey: res.encryKeyA,
                    error: opt.error,
                    success: opt.success,
                    isTest: opt.data.isTest
                  }
                  _self.getYwToken(config)
                } else {
                  opt.CTData = ds.data + '|' + ds.result;
                  // _self.getCUInfo(opt)
                  loadJS(opts.CUjssdk.pro, {
                    success:function () {
                      _self.getCUInfo(opt)
                    },
                    error: function () {
                      var obj = {
                        code: '504',
                        message: '联通sdk文件加载失败'
                      }
                      opt.error({
                        code: obj.code,
                        message: obj.message,
                        msgId: opts.optparams.msgId,
                        YDData: opt.YDData,
                        CTData: opt.CTData
                      })
                    }
                  });
                }
              },
              fail: function () {
                // alert(111)
                var obj = {
                  code: "502",
                  message: "接口异常，电信取号接口失败"
                }
                opt.CTData = obj.message + '|' + obj.code;
                loadJS(opts.CUjssdk.pro, {
                  success:function () {
                    _self.getCUInfo(opt)
                  },
                  error: function () {
                    var obj = {
                      code: '504',
                      message: '联通sdk文件加载失败'
                    }
                    opt.error({
                      code: obj.code,
                      message: obj.message,
                      msgId: opts.optparams.msgId,
                      YDData: opt.YDData,
                      CTData: opt.CTData
                    })
                  }
                });
                // opt.error({
                //   code: obj.code,
                //   message: obj.message,
                //   msgId: opts.optparams.msgId,
                //   YDData: opt.YDData
                // })
                // return obj

              }
            })


          }
          /*else if (res.result.body.resultCode == "121016") {


            loadJS(opts.CUjssdk.pro, {
              success:function () {
                _self.getCUInfo(opt)
              },
              error: function () {
                var obj = {
                  code: '504',
                  message: '联通sdk文件加载失败'
                }
                opt.error({
                  code: obj.code,
                  message: obj.message,
                  msgId: opts.optparams.msgId,
                  YDData: opt.YDData
                })
              }
            });
            // _self.getCUInfo(opt);
          }*/ 
          else {
            var obj = {
              code: res.result.body.resultCode,
              message: res.result.body.resultDesc
            }
            opt.CTData = obj.message + '|' + obj.code;
            loadJS(opts.CUjssdk.pro, {
              success:function () {
                _self.getCUInfo(opt)
              },
              error: function () {
                var obj = {
                  code: '504',
                  message: '联通sdk文件加载失败'
                }
                opt.error({
                  code: obj.code,
                  message: obj.message,
                  msgId: opts.optparams.msgId,
                  YDData: opt.YDData,
                  CTData: opt.CTData
                })
              }
            });
            return obj
          }

        },
        error: function (res) {
          var obj = {
            code: "501",
            message: "接口异常，电信预取号接口失败"
          }
          
          opt.CTData = obj.message + '|' + obj.code;
            loadJS(opts.CUjssdk.pro, {
              success:function () {
                _self.getCUInfo(opt)
              },
              error: function () {
                var obj = {
                  code: '504',
                  message: '联通sdk文件加载失败'
                }
                opt.error({
                  code: obj.code,
                  message: obj.message,
                  msgId: opts.optparams.msgId,
                  YDData: opt.YDData,
                  CTData: opt.CTData
                })
              }
            });
          return obj
        }
      });

    },
    getYwToken: function (cfg) {
      var reqUrl = cfg.isTest === '0' ? opts.getCTCUtoken.test01 : opts.getCTCUtoken.pro,
        version = '1.0',
        msgId = opts.optparams.msgId,
        timestamp = opts.optparams.timestamp,
        appid = cfg.appid,
        operType = cfg.operType,
        paramKey = cfg.paramKey,
        data = cfg.data,
        appKey = '',
        MD5_tokenStr = hex_md5(appid + appKey + data + msgId + operType + timestamp + version);
      var param = {
        header: {
          version: version,
          msgId: msgId,
          timestamp: timestamp,
          appId: appid
        },
        body: {
          operType: operType,
          paramKey: paramKey,
          data: data,
          sign: MD5_tokenStr
        }
      }
      request.ajax({
        request: {
          url: reqUrl,
          method: "post",
          data: JSON.stringify(param)
        },
        success: function (res) {
          if (res.result.body.resultCode == '000000') {
            var obj = {
              code: res.result.header.resultCode,
              token: res.result.body.token,
              userInformation: opts.optparams.userInformation,
              message: '获取token成功'
            }
            cfg.success({ code: obj.code, message: obj.message, token: obj.token, userInformation: obj.userInformation })

          } else {
            var obj = {
              code: res.result.body.resultCode,
              message: res.result.body.resultDesc
            }
            cfg.error({
              code: obj.code,
              message: obj.message,
              msgId: opts.optparams.msgId
            })
            return obj
          }
        },
        error: function (res) {
          var obj = {
            code: "503",
            message: "接口异常，获取异网token接口失败"
          }
          cfg.error({
            code: obj.code,
            message: obj.message,
            msgId: opts.optparams.msgId
          })
          return obj
        }
      });
    },
    getCUInfo: function (opt) {
      var _self = this,
        clientId = '114231242',
        clientKey = '26orjaVVZ4dikp5S',
        reqTimeStamp = opts.optparams.timestamp,
        clientDomain = 'http://39.104.104.199:7002';
      var MD5_CUStr = hex_md5("$" + clientKey + "$" + clientId + "$" + reqTimeStamp + "$" + clientDomain + "$" + clientKey + "$")
      opt.CUData = MD5_CUStr + '|' + reqTimeStamp;
      window.JWuSDK.initWithAuth({
        "reqTimeStamp": reqTimeStamp,
        "clientId": clientId,
        "authorization": MD5_CUStr
      }).then(function(response) {
        // 初始化成功
        window.JWuSDK.verifyMobile().then(function(response) {
          // 处理response
          var config = {
            appid: opt.data.appId,
            operType: 'CU',
            data: JSON.stringify(response.data),
            paramKey: '',
            error: opt.error,
            success: opt.success,
            isTest: opt.data.isTest
          }
          _self.getYwToken(config);

        }).catch(function(err)  {
          // 处理error情况
          var obj = {
            code: err.code,
            respCode: err.respCode.toString() || '',
            CUData: opt.CUData,
            message: "联通取号失败"
          }
          opt.error({
            code: obj.code,
            respCode: obj.respCode,
            message: obj.message,
            msgId: opts.optparams.msgId,
            CTData: opt.CTData,
            CUData: opt.CUData,
            YDData: opt.YDData
          })
          return obj
        });
      }).catch(function(err) {
        // 初始化失败
        var obj = {
          code: err.code,
          respCode: err.respCode.toString() || '',
          message: "接口异常，联通取号初始化失败"
        }
        opt.error({
          code: obj.code,
          respCode: obj.respCode,
          message: obj.message,
          msgId: opts.optparams.msgId,
          CTData: opt.CTData,
          CUData: opt.CUData,
          YDData: opt.YDData
        })
      });
    }
  }

  //校验参数
  function checkParms(opt) {
    var isflag = true;
    //循环校验参数是否为空
    for (p in opt.data) {
      if (opt.data[p] === '' || opt.data[p] === undefined) {
        opt.error({ code: "500", message: p + "为空，请检查参数是否正确" })
        isflag = false;
        return
      }
    }
    return isflag
  }

  /**
  * 获取最外层窗口浏览器的信息,获取不到就返回为空
  */
  function getBrowserInfo() {
    var obj = {
      "location": ["href"],
      "navigator": ["platform", "userAgent", "appVersion", "cookieEnabled", "cpuClass", "hardwareConcurrency", "language", "plugins"],
      "screen": ["availWidth", "availHeight", "colorDepth"],
      "Date": ["getTimezoneOffset"]
    };
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    var isAndroidOrIOS = isAndroid === true ? "Android" : "IOS";
    var str = top["navigator"]["platform"]
      + "@@" + top["navigator"]["userAgent"]
      + "@@" + top["navigator"]["appVersion"]
      + "@@" + top["navigator"]["cookieEnabled"]
      + "@@" + top["navigator"]["cpuClass"]
      + "@@" + top["navigator"]["hardwareConcurrency"]
      + "@@" + top["navigator"]["language"]
      + "@@" + top["navigator"]["plugins"]
      + "@@" + top["screen"]["availWidth"]
      + "@@" + top["navigator"]["availHeight"]
      + "@@" + top["screen"]["colorDepth"]
      + "@@" + top["Date"]["getTimezoneOffset"]
    var BrowserInfo = top["navigator"]["platform"]
      + "@@" + top["navigator"]["userAgent"]
      + "@@" + hex_md5(str);
    return BrowserInfo
  }

  //Base64加密
  function base64encode(input) {
    var output = "";
    var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;

    input = _utf8_encode(input);
    while (i < input.length) {

      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);

      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;

      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }

      output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);

    }

    return output;
  }
  function _utf8_encode(string) {
    string = string.replace(/\r\n/g, "\n");
    var utftext = "";

    for (var n = 0; n < string.length; n++) {

      var c = string.charCodeAt(n);

      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if ((c > 127) && (c < 2048)) {
        utftext += String.fromCharCode((c >> 6) | 192);
        utftext += String.fromCharCode((c & 63) | 128);
      } else {
        utftext += String.fromCharCode((c >> 12) | 224);
        utftext += String.fromCharCode(((c >> 6) & 63) | 128);
        utftext += String.fromCharCode((c & 63) | 128);
      }

    }
    return utftext;
  }

  /**
     * [ajax]
     */
  var request = {
    /**
     * [兼容老版的]
     */
    utilCreateXHR: function (options) {
      var win = (options && options.window) || window;
      if (win.XMLHttpRequest) {
        return new win.XMLHttpRequest();
      } else {
        var MSXML = ['MSXML2.XMLHTTP.5.0', 'MSXML2.XMLHTTP.4.0', 'MSXML2.XMLHTTP.3.0', 'Microsoft.XMLHTTP'];
        for (var n = 0; n < MSXML.length; n++) {
          try {
            return new win.ActiveXObject(MSXML[n]);
            break;
          }
          catch (e) {
          }
        }
      }
    },
    /**
     * [JSON.parse]
     */
    parseJson: function (text) {
      var obj = false;
      if (!text) {
        obj = {
          "code": "ER_NOBODY",
          "summary": "responseText is empty"
        };
      }

      if (window.JSON && JSON.parse) {
        try {
          obj = JSON.parse(text);
        } catch (ex) {
        }
      }

      if (!obj) {
        try {
          obj = eval("(" + text + ")");
        } catch (ex) {
          obj = {
            "code": "ER_INVALIDJSON",
            "summary": "responseText is invalid json"
          };
        }
      }

      return obj;
    },
    /**
     * [ajax请求]
     */
    ajax: function (args) {
      var This = this;
      var args = args || {};
      var request = args.request || {};
      var xhr = this.utilCreateXHR(args);

      var onsuccess = args.success || new Function();
      var onerror = args.error || new Function();

      var timeout = request.timeout;
      var timer = null;
      if (timeout > 0) {
        timer = setTimeout(function () {
          if (xhr.readyState == 3 && xhr.status == 200) return;
          xhr.abort();
          onerror({
            result: { code: "ER_TIMEOUT", summary: "timeout" }
          });
        }, timeout);
      }

      xhr.onreadystatechange = function (data) {
        //abort()后xhr.status为0
        if (xhr.readyState == 4) {
          clearTimeout(timer);
          if (xhr.status != 0) {
            if (xhr.status == 304 || (xhr.status >= 200 && xhr.status < 300)) {
              onsuccess({
                result: This.parseJson(xhr.responseText),
                text: xhr.responseText,
                status: xhr.status
              });
            } else {
              onerror({
                result: { code: "ER_NETWORK", summary: "network has error" },
                text: xhr.responseText,
                status: xhr.status
              });
            }
          } else {
            onerror({
              result: { code: "ER_STATUS", summary: "status is 0" }
            });
          }
        }
      }
      var method = request.method && request.method.toLowerCase();
      xhr.open(method || "get", request.url, true);

      var data = request.data;

      if (!request.isFormData) {
        //如果到了这里data仍为object类型，则自动转化为urlencoded或JSON.stringify
        if (typeof data == "object") {
          data = [];
          for (var p in request.data) {
            data.push(p + "=" + encodeURIComponent(request.data[p]));
          }
          data = data.join("&");
        }
      }
      if (request.headers) {
        for (var p in request.headers) {
          console.log(xhr)
          xhr.setRequestHeader(p, request.headers[p]);
        }
      }
      if (method != 'post' || !data) {
        data = null;
      }
      //xhr.send仅用于method=post请求
      xhr.send(data);
    }
  }


})(window, document);

/***/ }),

/***/ "./static/verify_mobile_sdk-1.3.0.js":
/*!*******************************************!*\
  !*** ./static/verify_mobile_sdk-1.3.0.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval(function(p,a,c,k,e,r){e=function(c){return(c<62?'':e(parseInt(c/62)))+((c=c%62)>35?String.fromCharCode(c+29):c.toString(36))};if('0'.replace(0,e)==0){while(c--)r[e(c)]=k[c];k=[function(e){return r[e]||e}];e=function(){return'([fjlptvwA-GI-LN-RTVWY]|[\\da]\\w)'};c=1};while(c--)if(k[c])p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c]);return p}('"use strict";l 3O(3k){l 4S(4T,6H){1l 4T<<6H|4T>>>32-6H}l 2l(lX,lY){A 5I,5J,4l,4m,4e;4l=lX&6I;4m=lY&6I;5I=lX&5K;5J=lY&5K;4e=(lX&7w)+(lY&7w);v(5I&5J){1l 4e^6I^4l^4m}v(5I|5J){v(4e&5K){1l 4e^0xC0000000^4l^4m}I{1l 4e^5K^4l^4m}}I{1l 4e^4l^4m}}l 7x(x,y,z){1l x&y|~x&z}l 7y(x,y,z){1l x&z|y&~z}l 7z(x,y,z){1l x^y^z}l 7A(x,y,z){1l y^(x|~z)}l 2I(a,b,c,d,x,s,ac){a=2l(a,2l(2l(7x(b,c,d),x),ac));1l 2l(4S(a,s),b)}l 2J(a,b,c,d,x,s,ac){a=2l(a,2l(2l(7y(b,c,d),x),ac));1l 2l(4S(a,s),b)}l 2K(a,b,c,d,x,s,ac){a=2l(a,2l(2l(7z(b,c,d),x),ac));1l 2l(4S(a,s),b)}l 2L(a,b,c,d,x,s,ac){a=2l(a,2l(2l(7A(b,c,d),x),ac));1l 2l(4S(a,s),b)}l 7B(3k){A 4f;A 4U=3k.33;A 6J=4U+8;A 7C=(6J-6J%64)/64;A 5L=(7C+1)*16;A 3V=7D(5L-1);A 4V=0;A 3F=0;while(3F<4U){4f=(3F-3F%4)/4;4V=3F%4*8;3V[4f]=3V[4f]|3k.7E(3F)<<4V;3F++}4f=(3F-3F%4)/4;4V=3F%4*8;3V[4f]=3V[4f]|0x80<<4V;3V[5L-2]=4U<<3;3V[5L-1]=4U>>>29;1l 3V}l 4W(4T){A 5M="",5N="",6K,4X;3W(4X=0;4X<=3;4X++){6K=4T>>>4X*8&255;5N="0"+6K.toString(16);5M=5M+5N.4g(5N.33-2,2)}1l 5M}l 7F(3k){3k=3k.3z(/\\r\\n/g,"\\n");A 3X="";3W(A n=0;n<3k.33;n++){A c=3k.7E(n);v(c<5O){3X+=4n.4o(c)}I v(c>127&&c<2048){3X+=4n.4o(c>>6|192);3X+=4n.4o(c&63|5O)}I{3X+=4n.4o(c>>12|224);3X+=4n.4o(c>>6&63|5O);3X+=4n.4o(c&63|5O)}}1l 3X}A x=7D();A k,AA,BB,CC,DD,a,b,c,d;A 4Y=7,4Z=12,51=17,52=22;A 53=5,54=9,55=14,56=20;A 57=4,58=11,59=16,5a=23;A 5b=6,5c=10,5d=15,5e=21;3k=7F(3k);x=7B(3k);a=0x67452301;b=0xEFCDAB89;c=0x98BADCFE;d=0x10325476;3W(k=0;k<x.33;k+=16){AA=a;BB=b;CC=c;DD=d;a=2I(a,b,c,d,x[k+0],4Y,0xD76AA478);d=2I(d,a,b,c,x[k+1],4Z,0xE8C7B756);c=2I(c,d,a,b,x[k+2],51,0x242070DB);b=2I(b,c,d,a,x[k+3],52,0xC1BDCEEE);a=2I(a,b,c,d,x[k+4],4Y,0xF57C0FAF);d=2I(d,a,b,c,x[k+5],4Z,0x4787C62A);c=2I(c,d,a,b,x[k+6],51,0xA8304613);b=2I(b,c,d,a,x[k+7],52,0xFD469501);a=2I(a,b,c,d,x[k+8],4Y,0x698098D8);d=2I(d,a,b,c,x[k+9],4Z,0x8B44F7AF);c=2I(c,d,a,b,x[k+10],51,0xFFFF5BB1);b=2I(b,c,d,a,x[k+11],52,0x895CD7BE);a=2I(a,b,c,d,x[k+12],4Y,0x6B901122);d=2I(d,a,b,c,x[k+13],4Z,0xFD987193);c=2I(c,d,a,b,x[k+14],51,0xA679438E);b=2I(b,c,d,a,x[k+15],52,0x49B40821);a=2J(a,b,c,d,x[k+1],53,0xF61E2562);d=2J(d,a,b,c,x[k+6],54,0xC040B340);c=2J(c,d,a,b,x[k+11],55,0x265E5A51);b=2J(b,c,d,a,x[k+0],56,0xE9B6C7AA);a=2J(a,b,c,d,x[k+5],53,0xD62F105D);d=2J(d,a,b,c,x[k+10],54,0x2441453);c=2J(c,d,a,b,x[k+15],55,0xD8A1E681);b=2J(b,c,d,a,x[k+4],56,0xE7D3FBC8);a=2J(a,b,c,d,x[k+9],53,0x21E1CDE6);d=2J(d,a,b,c,x[k+14],54,0xC33707D6);c=2J(c,d,a,b,x[k+3],55,0xF4D50D87);b=2J(b,c,d,a,x[k+8],56,0x455A14ED);a=2J(a,b,c,d,x[k+13],53,0xA9E3E905);d=2J(d,a,b,c,x[k+2],54,0xFCEFA3F8);c=2J(c,d,a,b,x[k+7],55,0x676F02D9);b=2J(b,c,d,a,x[k+12],56,0x8D2A4C8A);a=2K(a,b,c,d,x[k+5],57,0xFFFA3942);d=2K(d,a,b,c,x[k+8],58,0x8771F681);c=2K(c,d,a,b,x[k+11],59,0x6D9D6122);b=2K(b,c,d,a,x[k+14],5a,0xFDE5380C);a=2K(a,b,c,d,x[k+1],57,0xA4BEEA44);d=2K(d,a,b,c,x[k+4],58,0x4BDECFA9);c=2K(c,d,a,b,x[k+7],59,0xF6BB4B60);b=2K(b,c,d,a,x[k+10],5a,0xBEBFBC70);a=2K(a,b,c,d,x[k+13],57,0x289B7EC6);d=2K(d,a,b,c,x[k+0],58,0xEAA127FA);c=2K(c,d,a,b,x[k+3],59,0xD4EF3085);b=2K(b,c,d,a,x[k+6],5a,0x4881D05);a=2K(a,b,c,d,x[k+9],57,0xD9D4D039);d=2K(d,a,b,c,x[k+12],58,0xE6DB99E5);c=2K(c,d,a,b,x[k+15],59,0x1FA27CF8);b=2K(b,c,d,a,x[k+2],5a,0xC4AC5665);a=2L(a,b,c,d,x[k+0],5b,0xF4292244);d=2L(d,a,b,c,x[k+7],5c,0x432AFF97);c=2L(c,d,a,b,x[k+14],5d,0xAB9423A7);b=2L(b,c,d,a,x[k+5],5e,0xFC93A039);a=2L(a,b,c,d,x[k+12],5b,0x655B59C3);d=2L(d,a,b,c,x[k+3],5c,0x8F0CCC92);c=2L(c,d,a,b,x[k+10],5d,0xFFEFF47D);b=2L(b,c,d,a,x[k+1],5e,0x85845DD1);a=2L(a,b,c,d,x[k+8],5b,0x6FA87E4F);d=2L(d,a,b,c,x[k+15],5c,0xFE2CE6E0);c=2L(c,d,a,b,x[k+6],5d,0xA3014314);b=2L(b,c,d,a,x[k+13],5e,0x4E0811A1);a=2L(a,b,c,d,x[k+4],5b,0xF7537E82);d=2L(d,a,b,c,x[k+11],5c,0xBD3AF235);c=2L(c,d,a,b,x[k+2],5d,0x2AD7D2BB);b=2L(b,c,d,a,x[k+9],5e,0xEB86D391);a=2l(a,AA);b=2l(b,BB);c=2l(c,CC);d=2l(d,DD)}1l(4W(a)+4W(b)+4W(c)+4W(d)).toLowerCase()}l 2R(){A 3G=2S 7G().7H("yyyyMMddHHmmssS");A 5f=\'\';v(3G.33===15){5f=3G.4g(-1,1);3G=3G.4g(0,14)+\'00\'+5f}I v(3G.33===16){5f=3G.4g(-2,1);3G=3G.4g(0,15)+\'0\'+5f}1l 3G}A $=l(){1l{3A:l 3A(3Y){A 1C=3Y.1C,J=3Y.J,j=3Y.j,5g=3Y.5g,6P=3Y.6P,1X=3Y.1X,1R=3Y.1R;v(!J){console.5h(\'请输入请求地址\');1l}A 1q=2S XMLHttpRequest();A 5i=[],5j;3W(A 4h in j){5i.push(7J(4h)+\'=\'+7J(j[4h]))}5j=5i.join(\'&\');v(1C===\'1P\'){J+=5j?(J.2T(\'?\')===-1?\'?\':\'&\')+5j:\'\'}1q.open(1C||\'1P\',J,6P||6Q);3W(A 3Z in 5g){1q.5P(3Z,5g[3Z])}3W(A 6R in 4p){1q.5P(6R,4p[6R])}1q.5P(\'7K-7L\',\'H5\');v(6S){1q.5P(\'Trace-Id\',6S)}v(1t.2d.2M>0){1q.1Y=1t.2d.2M;4q=1t.7N(l(){1t.2d.2M=1t.2d.2M-1},1);1q.onreadystatechange=l(){v(1q.6T==4&&1q.5Q==302){1R&&1R(1q.5Q)}I v(1q.6T==4&&1q.5Q==7O){1X&&1X(1q,1q.7P)}I v(1q.6T==4&&1q.5Q!=7O){1R&&1R(1q.7P)}6U(4q)};1q.ontimeout=l(e){1R&&1R(\'1Y\');6U(4q)};v(1C===\'7Q\'){1q.7R(5j)}I{1q.7R()}}I{1R&&1R(\'1Y\')}}}}();l 5R(J,j,35){1l 2S 3l(l(1E,P){v(1t.2d.2M){4q=1t.7N(l(){1t.2d.2M=1t.2d.2M-1},1)}A 5S;5S=40(l(){P(\'1Y\')},1t.2d.2M);A 5k=V.4r(\'5k\');v(35!==\'7S\'){v(J.2T(\'?\')!==-1){J+="&35=".p(35)}I{J+="?35=".p(35)}}v(j){Object.keys(j).7T(l(4h){J+="&".p(4h,"=").p(j[4h])})}5k.3P=J;V.3B.41(5k);1t[35]=l(j){6U(4q);v(5S){clearTimeout(5S)}delete 1t[35];V.3B.6V(5k);v(j){1E(j)}I{P("服务器暂没有获取到数据")}}})}A 4p={};A 6S=\'\';A 4q;7G.1n.7H=l(3H){v(!3H){3H="yyyy-MM-dd hh:mm:ss"}A o={"M+":1w.7U()+1,"d+":1w.getDate(),"H+":1w.7V(),"h+":1w.7V(),"m+":1w.getMinutes(),"s+":1w.getSeconds(),"q+":Math.floor((1w.7U()+3)/3),"S":1w.getMilliseconds()};v(/(y+)/.6W(3H)){3H=3H.3z(5l.$1,(1w.getFullYear()+"").4g(4-5l.$1.33))}3W(A k in o){v(2S 5l("("+k+")").6W(3H)){3H=3H.3z(5l.$1,5l.$1.33==1?o[k]:("00"+o[k]).4g((""+o[k]).33))}}1l 3H};l 7W(u,5m){v(5m==="7X"){1l u.3C("OS ")[1].3C(" like 7Z")[0]}I{1l u.3C("; ")[1]}}!l(80,5n){l w(6X){1w.6X=6X}w.1n.2q=l(5T,1r,6Y,6Z){A u=navigator.userAgent;A 70=u.2T(\'81\')>-1||u.2T(\'Adr\')>-1;A 82=!!u.match(/\\(i[^;]+;( U;)? CPU.+7Z OS X/);A j={"5m":70?"81":82?"7X":"PC","deviceModel":70?u.3C(": ")[2]:"","1p":w.L.1p,"5T":5T,"1r":1r,"6Y":6Y,"6Z":6Z,"28":"1.3.0","occurTime":2R()};j.deviceOS=j.5m+7W(u,j.5m);$.3A({1C:\'7Q\',J:\'18://19.wo.cn/terminal/log/5T/trace?1Z=1.1.1\',j:j,5g:{"Content-7L":"application/x-www-form-urlencoded"}})};w.1n.83=l(j){A F=1w;1l 2S 3l(l(1E,P){$.3A({1C:\'1P\',J:\'18://19.wo.cn/1x-3w-1y-id/t/1z/4s\',j:j,1X:l 1X(1q,B){B=1u.2U(B);v(B.1c!==0){A 1d={J:"18://19.wo.cn/1x-3w-1y-id/t/1z/4s",2N:"1P",L:j,K:B};A 1r=w.1e===0?"3":"2";F.2q(1u.2r(1d),1r,"2","5")}v(B.1c===0){w.5U=B.N.cm_h5_app_id||\'\';w.84=B.N.84;w.5o=6Q;1E({"T":"5V"})}I v(B.1c===104||B.1c===107){P({"1b":"18://19.wo.cn/1x-3w-1y-id/t/1z/4s?C="+j.C,"T":"1G"})}I{P({"1b":"18://19.wo.cn/1x-3w-1y-id/t/1z/4s?C="+j.C,"T":"85","1H":B.1c})}},1R:l 1R(1q,B){B=1u.2U(B);A 1d={J:"18://19.wo.cn/1x-3w-1y-id/t/1z/4s",2N:"1P",L:j,K:B};A 1r=w.1e===0?"3":"2";F.2q(1u.2r(1d),1r,"2","5");P({"1b":"18://19.wo.cn/1x-3w-1y-id/t/1z/4s?C="+j.C,"T":"85","1H":B.1c})}})})};w.1n.72=l(){A F=1w;1l 2S 3l(l(1E,P){A j={1e:w.1e,1p:w.L.1p,2e:\'H5\',C:"".p(w.L.1p).p(w.L.2V||2R()),2f:w.L.2V||2R(),3m:\'5W\',28:\'1.3.0\',1Z:\'1.3.0\'};v(w.5X){j.5X=w.5X}j.1I=w.L.1I;j.4i=3O("1I=".p(j.1I,"&1e=").p(j.1e,"&1p=").p(j.1p,"&2e=").p(j.2e,"&C=").p(j.C,"&2a=&5p=&2f=").p(j.2f,"&3m=").p(j.3m,"&28=").p(j.28,"&1Z=").p(j.1Z));$.3A({1C:\'1P\',J:\'18://19.wo.cn/1x-3w-1y-id/1z/2b\',j:j,1X:l 1X(1q,B){B=1u.2U(B);v(B.1c!==0){A 1d={J:"18://19.wo.cn/1x-3w-1y-id/1z/2b",2N:"1P",L:j,K:B};A 1r=w.1e===0?"3":"2";F.2q(1u.2r(1d),1r,"2","5")}v(B.1c===0){v(B.N.2a===\'CU\'){F.5q(B.N).2g(l(1N){1E(1N)})["2h"](l(1j){P(1j)})}I v(B.N.2a===\'CT\'){F.5r(B.N).2g(l(1N){1E(1N)})["2h"](l(1j){P(1j)})}I v(B.N.2a===\'CM\'){F.5Z(B.N).2g(l(1N){1E(1N)})["2h"](l(1j){P(1j)})}}I v(B.1c===1){P({"1b":"18://19.wo.cn/1x-3w-1y-id/1z/2b?C="+j.C,"T":"1G","1H":B.3c})}I{P({"1b":"18://19.wo.cn/1x-3w-1y-id/1z/2b?C="+j.C,"T":"1G","1H":B.1c})}},1R:l 1R(1q,B){B=1u.2U(B);A 1d={};A 1r=w.1e===0?"3":"2";v(B!==\'1Y\'){v(B.1c!==0){1d={J:"18://19.wo.cn/1x-3w-1y-id/1z/2b",2N:"1P",L:j,K:B};F.2q(1u.2r(1d),1r,"2","5")}}v(B===\'1Y\'){1d={J:"18://19.wo.cn/1x-3w-1y-id/1z/2b",2N:"1P",L:j,4j:"-1"};F.2q(1u.2r(1d),1r,"3","4");P({"1b":"18://19.wo.cn/1x-3w-1y-id/1z/2b?C="+j.C,"T":"3I"})}I v(B.1c===1){P({"1b":"18://19.wo.cn/1x-3w-1y-id/1z/2b?C="+j.C,"T":"1G","1H":B.3c})}I{P({"1b":"18://19.wo.cn/1x-3w-1y-id/1z/2b?C="+j.C,"T":"1G","1H":B.1c})}}})})};w.1n.5q=l(K){A F=1w;1l 2S 3l(l(1E,P){5R(K.J,{},\'86\').2g(l(4v){F.60(K.2B,4v).2g(l(1N){1E(1N)})["2h"](l(1j){P(1j)})})["2h"](l(1j){A 1r=w.1e===0?"3":"2";v(1j===\'1Y\'){A 1d={J:K.J,2N:"1P",L:{},4j:"-1"};F.2q(1u.2r(1d),1r,"3","4");P({"1b":K.J+(K.J.2T("?")?"&":"?")+"?C=","T":"3I"})}I{A 61=1u.2r(1j);F.2q(61,1r,"1","5");P({"1b":K.J+(K.J.2T("?")?"&":"?")+"?C=","T":"73"})}})})};w.1n.5r=l(2O){A F=1w;1l 2S 3l(l(1E,P){5R(2O.J,{},\'7S\').2g(l(K){v(K.j){F.60(2O.2B,K).2g(l(4v){1E(4v)})["2h"](l(1j){P(1j)})}I{A 1d={J:2O.J,2N:"1P",L:{},K:K};A 1r=w.1e===0?"3":"2";F.2q(1u.2r(1d),1r,"2","5");P({"1b":2O.J+(2O.J.2T("?")?"&":"?")+"?C=","T":"1G"})}})["2h"](l(1j){A 1r=w.1e===0?"3":"2";v(1j===\'1Y\'){A 1d={J:2O.J,2N:"1P",L:{},4j:"-1"};F.2q(1u.2r(1d),1r,"3","4");P({"1b":2O.J+(2O.J.2T("?")?"&":"?")+"?C=","T":"3I"})}I{A 61=1u.2r(1j);F.2q(61,1r,"1","5");P({"1b":2O.J+(2O.J.2T("?")?"&":"?")+"?C=","T":"73"})}})})};w.1n.5Z=l(j){A F=1w;j.5U=w.5U;j.1Z=\'1.0\';1l 2S 3l(l(1E,P){A 36=5s,74=\'18://19.wo.cn/3d-deploy/h5/cmframe.37\';v(j.1C===\'1\'){36=V.4r("36");36.id=\'87\';36.3P=74;36.24.2i="25";v(36.88){36.88("89",l(){36.75.76(j,\'*\');1t.77=l(e){1E(e.j)}})}I{36.89=l(){36.75.76(j,\'*\');1t.77=l(e){1E(e.j)}}}V.3B.41(36)}I{36=V.42("87");36.75.76(j,74);1t.77=l(e){V.3B.6V(36);F.60(j.2B,e.j).2g(l(1N){1E(1N)})["2h"](l(1j){P(1j)})}}})};w.1n.60=l(2B,2O){A F=1w;1l 2S 3l(l(1E,P){A 1m={1e:w.1e,2e:\'H5\',C:"".p(w.L.1p).p(w.L.2V||2R()),2f:w.L.2V||2R(),resp:1u.2r(2O),3m:\'5W\',28:\'1.3.0\',1Z:\'1.3.0\'};1m.1I=w.L.1I?w.L.1I:3O("$".p(w.L.8a,"$").p(w.L.1p,"$").p(1m.2f,"$").p(w.L.packageName,"$").p(w.L.8a,"$"));1m.4i=3O("1I=".p(1m.1I,"&1e=").p(1m.1e,"&1p=").p(w.L.1p,"&2e=").p(1m.2e,"&C=").p(1m.C,"&2f=").p(1m.2f,"&3m=").p(1m.3m,"&28=").p(1m.28,"&1Z=").p(1m.1Z));$.3A({1C:\'1P\',J:2B,j:1m,1X:l 1X(1q,K){K=1u.2U(K);A 1r=w.1e===0?"3":"2";v(K.1c!==0){A 1d={J:2B,2N:"1P",L:1m,K:K};F.2q(1u.2r(1d),1r,"2","5")}v(K.1c===0){w.4w=K.N.4w||\'\';v(K.N.J){v(K.N.2a===\'CU\'){F.5q(K.N).2g(l(1N){1E(1N)})["2h"](l(1j){P(1j)})}I v(K.N.2a===\'CT\'){F.5r(K.N).2g(l(1N){1E(1N)})["2h"](l(1j){P(1j)})}I v(K.N.2a===\'CM\'){F.5Z(K.N).2g(l(1N){1E(1N)})["2h"](l(1j){P(1j)})}}I{w.2a=K.N.2a;1E({"T":"5V","j":K.N})}}I v(K.1c===1){P({"1b":2B+(2B.2T("?")!==-1?"&":"?")+"C="+1m.C,"T":"1G","1H":K.3c})}I{P({"1b":2B+(2B.2T("?")!==-1?"&":"?")+"C="+1m.C,"T":"1G","1H":K.1c})}},1R:l 1R(1q,K){K=1u.2U(K);A 1d={};A 1r=w.1e===0?"3":"2";v(K!==\'1Y\'){v(K.1c!==0){1d={J:2B,2N:"1P",L:1m,K:K};F.2q(1u.2r(1d),1r,"2","5")}}v(K===\'1Y\'){1d={J:2B,2N:"1P",L:1m,4j:"-1"};F.2q(1u.2r(1d),1r,"3","4");P({"1b":2B+(2B.2T("?")!==-1?"&":"?")+"C="+1m.C,"T":"3I"})}I v(K.1c===1){P({"1b":2B+(2B.2T("?")!==-1?"&":"?")+"C="+1m.C,"T":"1G","1H":K.3c})}I{P({"1b":2B+(2B.2T("?")!==-1?"&":"?")+"C="+1m.C,"T":"1G","1H":K.1c})}}})})};w.1n.78=l(t,K){A O=\'\',4x=\'\',3e=\'\',3f=\'\',2W=\'\',2X=\'\';8b(w.2a){4y\'CU\':3e=\'18://19.wo.cn/3d-3n/2m/3o/hz/cu.3D\';2W=\'中国联通认证服务条款\';2X=\'18://19.wo.cn/3d-3n/62/65.37\';3f=\'联通\';44;4y\'CM\':3e=\'18://19.wo.cn/3d-3n/2m/3o/hz/cm.3D\';2W=\'中国移动认证服务条款\';2X=\'18://8c.8d.8e/8f/37/8g.37\';3f=\'移动\';44;4y\'CT\':3e=\'18://19.wo.cn/3d-3n/2m/3o/hz/ct.3D\';2W=\'中国电信认证服务条款\';2X=\'18://id.8h.cn/37/8i.37\';3f=\'电信\';44;8j:3e=\'18://19.wo.cn/3d-3n/2m/3o/hz/cu.3D\';2W=\'中国联通认证服务条款\';2X=\'18://19.wo.cn/3d-3n/62/65.37\';3f=\'联通\';44}v(t&&t.66){3e=t.66}4x=t&&t.67?t.67:\'j:3E/3D;5t,8k/8l/8m+8n/8o+8p/8q+8r/8s+8t+mB+8v=\';v(t&&t.68){O=t.68.3z(\':8w\',t.4z?"<a 1S=\\"2C\\" 2s=\\"".p(2X,"\\">\\4A").p(2W,"\\4B</a>"):"<a  1S=\\"2C\\" 2s=\\"".p(2X,"\\">").p(2W,"</a>"));v(t.2t&&t.2t[0]){O=O.3z(\':8x\',t.4z?"<a 1S=\\"2C\\" 2s=\\"".p(t.2t[1],"\\">\\4A").p(t.2t[0],"\\4B</a>"):"<a 1S=\\"2C\\" 2s=\\"".p(t.2t[1],"\\">").p(t.2t[0],"</a>"))}v(t.2u&&t.2u[0]){O=O.3z(\':8y\',t.4z?"<a 1S=\\"2C\\" 2s=\\"".p(t.2u[1],"\\">\\4A").p(t.2u[0],"\\4B</a>"):"<a 1S=\\"2C\\" 2s=\\"".p(t.2u[1],"\\">").p(t.2u[0],"</a>"))}}A D=V.4r(\'E\');D.79(\'id\',\'f-D\');A 47="<E R=\\"f-3p-1O\\">\\n        <2m 3P=\\"".p(4x,"\\" 4k=\\"\\" R=\\"f-69-6a\\"><2D R=\\"f-3p\\">").p(t&&t.6b?t.6b:\'中国\'+3f,"</2D>\\n      </E>\\n      <E R=\\"f-N\\">\\n        <E R=\\"f-3E-Q\\"><2m 3P=\\"").p(3e,"\\" 4k=\\"\\" R=\\"f-3o\\"></E>\\n        <E R=\\"f-2E\\">").p(K.8z.3z(\'8A\',\'****\'),"</E>\\n        <E R=\\"f-1k-Q\\"><2D R=\\"f-1k\\">").p(t&&t.6c?t.6c:\'一键登录\',"</2D></E>\\n        <E R=\\"f-2P\\">\\6d\\4C\\8B\\8C\\8D").p(3f,"\\8E\\8F\\6d\\4C\\8G\\8H</E>\\n      </E>\\n      <E R=\\"f-2n\\">\\n        <E R=\\"f-1f-Q\\">\\n          <E R=\\"f-1f-1A\\">\\n            <E R=\\"f-1f-1O-bg\\"></E>\\n            <E R=\\"f-1f-1O-1T\\" 8I=\\"1l 3q;\\">\\7a\\8J\\8K\\8L\\8M\\8N\\8O\\8P\\8Q\\8R\\8S</E>\\n            <E R=\\"f-1f-1k\\"><2m 3P=\\"j:3E/8T;5t,/9j/8U/8V/8W+8X/8Y+8Z+90+91+92+93+/+94/95/96/97/98/99+9a/9b/9c+9d/9e+9f+9g+9h+9i/9k/9l+9m/n1/9o/9p//Z\\" 4k=\\"\\"></E>\\n          </E>\\n        </E>\\n      </E>\\n      <E R=\\"f-O-Q\\">");47+=t&&9q(t.9r)===1?"<E R=\\"f-1V is-2Q\\">\\n          <2D R=\\"f-3r\\"></2D>\\n          <2c 1C=\\"6e\\" R=\\"f-4D\\" 2Q=\\"2Q\\" 2o=\\"\\" id=\\"3t\\">\\n          <E R=\\"f-O-2P\\">\\6f\\6g\\6h\\4E\\4F\\6i\\6j\\6k\\6l</E>\\n        </E>":"<E R=\\"f-1V\\">\\n          <2D R=\\"f-3r\\"></2D>\\n          <2c 1C=\\"6e\\" R=\\"f-4D\\" 2o=\\"\\" id=\\"3t\\">\\n          <E R=\\"f-O-2P\\">\\6f\\6g\\6h\\4E\\4F\\6i\\6j\\6k\\6l</E>\\n        </E>";v(!O){O="<E R=\\"f-O\\">\\9s\\9t\\9u\\4E\\4F\\n        <a 1S=\\"2C\\" 2s=\\"".p(2X,"\\">").p(2W,"</a>")+(t&&t.2t&&t.2t[0]?"<a 1S=\\"2C\\" 2s=\\"".p(t.2t[1],"\\">").p(t.2t[0],"</a>"):\'\')+(t&&t.2u&&t.2u[0]?"<a 1S=\\"2C\\" 2s=\\"".p(t.2u[1],"\\">").p(t.2u[0],"</a>"):\'\')+"\\9v\\9w\\9x\\9y\\7b\\7c\\7d\\9z\\9A\\9B\\4C</E>\\n        </E>"}47+="<E R=\\"f-O\\">".p(O,"</E></E>");D.4G=47;A 4H=V.4r(\'24\');4H.4G="37,3B{1o:-1D-9C-9D;}\\n    #f-D{1B: 6m; 2Y: 0; 1Q: 0; 1h: 3Q; 1o: 26%; 1v: #3R; z-3J: 9E; -1D-Y: 2v 0.3s; -1F-Y: 2v 0.3s; -ms-Y: 2v 0.3s; -o-Y: 2v 0.3s; Y: 2v 0.3s; -1D-G: 1J(26%); -1F-G: 1J(26%); -ms-G: 1J(26%); -o-G: 1J(26%); G: 1J(26%);}\\n    #f-D.f-is-5u {-1D-G: 1J(0); -1F-G: 1J(0); -ms-G: 1J(0); -o-G: 1J(0); G: 1J(0);}\\n    #f-D>.f-3p-1O{2p-2Z: 4.5v; 1o: 7.3i; 1O-1o: 7.3i; 1T-2F: 1M; 1B: 48;}\\n    #f-D>.f-3p-1O>2m{1h: 3i; 1B: 2j; 1Q: 1.9F; 2Y: 0.7e;}\\n    #f-D>.f-3p-1O>.f-3p{1h: 3i;}\\n    #f-D>.f-N{1B: 2j; 1Q: 0; 2Y: 45%; -1D-G: 1J(-50%); -1F-G: 1J(-50%); -ms-G: 1J(-50%); -o-G: 1J(-50%); G: 1J(-50%); 1h: 3Q;}\\n    #f-D>.f-N>.f-3E-Q{1h: 9G; 30: 0 3u 9H 3u;}\\n    #f-D>.f-N>.f-3E-Q>2m.f-3o{1h: 26%;}\\n    #f-D>.f-N>.f-2E{2p-2Z: 4.7e; 2p-7f: 7g; 1T-2F: 1M; 30: 0 3u 7.3i 3u;}\\n    #f-D>.f-N>.f-1k-Q{1h: 71.9I; 1o: 10.6n; 1O-1o: 3g; 1T-2F: 1M; 30: 0 3u 5w 3u; 1v: #9J; -1D-W-2A: 5.2k; -1F-W-2A: 5.2k; W-2A: 5.2k;}\\n    #f-D>.f-N>.f-1k-Q>.f-1k{2p-2Z: 4.5v; 1g: #3R;}\\n    #f-D>.f-N>.f-2P{2p-2Z: 3.2k; 1g: #9K; 1T-2F: 1M;}\\n    #f-D>.f-O-Q{1B: 2j; 1Q: 6n; 1W: 3g; 1h: 9L; 2p-2Z: 3.2k; 1g: #7h; 2i: 6o; 2F-6p: 1M; 6q-N: 1M;}\\n    #f-D>.f-O-Q>.f-O{30-1Q: 9M;}\\n    #f-D>.f-O-Q>.f-1V { 9N-7i: 9O; 6r: 9P; 5x: 25; 2i: 4I-5y; 1O-1o: 1; 1B: 48; 9Q-2F: 9R;}\\n    #f-D>.f-O-Q>.f-1V>.f-3r { 2i: 4I-5y; 1B: 48; W: 38 3j #9S; -1D-1A-49: W-1A; -1F-1A-49: W-1A; 1A-49: W-1A; 1h: 4J; 1o: 4J; 1v-1g: #3S; z-3J: 1; -1D-Y: W-1g .2w 2x-2y(.71, -.46, .29, 1.46), 1v-1g .2w 2x-2y(.71, -.46, .29, 1.46); -1F-Y: W-1g .2w 2x-2y(.71, -.46, .29, 1.46), 1v-1g .2w 2x-2y(.71, -.46, .29, 1.46); -ms-Y: W-1g .2w 2x-2y(.71, -.46, .29, 1.46), 1v-1g .2w 2x-2y(.71, -.46, .29, 1.46); -o-Y: W-1g .2w 2x-2y(.71, -.46, .29, 1.46), 1v-1g .2w 2x-2y(.71, -.46, .29, 1.46); Y: W-1g .2w 2x-2y(.71, -.46, .29, 1.46), 1v-1g .2w 2x-2y(.71, -.46, .29, 1.46); -1D-W-2A: 50%; -1F-W-2A: 50%; W-2A: 50%;}\\n    #f-D>.f-O-Q>.f-1V>.f-3r:4K { 1A-49: N-1A; N: \\"\\"; W: 38 3j #3S; W-1Q: 0; W-2Y: 0; 1h: 9T; 1o: 9U; 1B: 2j; 1Q: 4L; 2Y: 38; -1D-G: 1K(1L) 2z(0); -1F-G: 1K(1L) 2z(0); -ms-G: 1K(1L) 2z(0); -o-G: 1K(1L) 2z(0); G: 1K(1L) 2z(0); -1D-Y: G .3K 3v-in .3L; -1F-Y: G .3K 3v-in .3L; -ms-Y: G .3K 3v-in .3L; -o-Y: G .3K 3v-in .3L; Y: G .3K 3v-in .3L; -1D-G-3M: 1M; -1F-G-3M: 1M; -ms-G-3M: 1M; -o-G-3M: 1M; G-3M: 1M;}\\n    #f-D>.f-O-Q>.f-1V.is-2Q>.f-3r { 1v-1g: #6s; W-1g: #6s;}\\n    #f-D>.f-O-Q>.f-1V.is-2Q>.f-3r:4K { -1D-G: 1K(1L) 2z(1); -1F-G: 1K(1L) 2z(1); -ms-G: 1K(1L) 2z(1); -o-G: 1K(1L) 2z(1); G: 1K(1L) 2z(1);}\\n    #f-D>.f-O-Q>.f-1V>.f-4D { 4M: 0; 5x: 25; 1B: 2j; 30: 0; 1h: 0; 1o: 0; z-3J: -1;}\\n    #f-D>.f-O-Q>.f-O>a{1g: #9V; 1T-9W: 25;}\\n    #f-D>.f-O-Q>.f-1V>.f-O-2P{1B: 2j; 2Y: -3g; 1Q: -2.5w; 2p-2Z: 6t; 5z: 2k; 1v: #3S; 1A-9X: 25; W: 38 3j #4N; 4M: 0; -1D-Y: 2v 0.3s; -1F-Y: 2v 0.3s; -ms-Y: 2v 0.3s; -o-Y: 2v 0.3s; Y: 2v 0.3s;}\\n    #f-D>.f-O-Q>.f-1V>.f-O-2P.f-5A{4M: 1;}\\n    #f-D>.f-O-Q>.f-1V>.f-O-2P:4K{N: \'\'; 1B: 2j; 1h: 2k; 1o: 2k; -1D-G: 1K(1L); -1F-G: 1K(1L); -ms-G: 1K(1L); -o-G: 1K(1L); G: 1K(1L); 1W: -1.2k; 1Q: 2k; 1v: #3R; W-7j: 38 3j #4N; W-1W: 38 3j #4N;}\\n    #f-D>.f-2n {1B: 6m; 1h: 3Q; 1o: 26%; 1Q: 0; 2Y: 0; 1v: 9Y(0, 0, 0, 0.4); z-3J: 10; 2i: 25; 9Z-a0: 25;}\\n    #f-D>.f-2n>.f-1f-Q {1B: 2j; 1W: -26%; 1Q: 0; 1h: 3Q; 5z: 3g 0; 1v: #3R; -1D-Y: 1W 0.3s; -1F-Y: 1W 0.3s; -ms-Y: 1W 0.3s; -o-Y: 1W 0.3s; Y: 1W 0.3s;}\\n    #f-D>.f-2n>.f-6u-6v-1W {1W: 0;}\\n    #f-D>.f-2n>.f-1f-Q>.f-1f-1A {1h: a1; 1o: 4a; 1O-1o: 4a; 30-1Q: 3g; 1v-1g: #a2; 1B: 48; W-2A: 4L; a3: a4;}\\n    #f-D>.f-2n>.f-1f-Q>.f-1f-1A>.f-1f-1O-bg {1h: 4a; 1o: 26%; 1B: 2j; 1v-1g: #7k;}\\n    #f-D>.f-2n>.f-1f-Q>.f-1f-1A>.f-1f-1O-1T {1B: 2j; 1h: 26%; 1o: 26%; 1T-2F: 1M; 6w-6x: 25; 1g: #a5; 2p-2Z: 4J;}\\n    #f-D>.f-2n>.f-1f-Q>.f-1f-1A>.f-1f-1k {1h: 4a; 1o: a6; 1B: 2j; W: 38 3j #a7; 6r: a8; 1T-2F: 1M; 1v-1g: #3S; 6w-6x: 25; 1g: #a9; W-2A: 4L; z-3J: 10;}\\n    #f-D>.f-2n>.f-1f-Q>.f-1f-1A>.f-1f-1k 2m {1h: aa; 30-2Y: 6t;}";v(t&&t.6y){V.42(t.6y).41(D)}I{V.5B(\'3B\')[0].41(D)}V.5B(\'3B\')[0].41(4H);V.2G(".f-69-6a").39("4b",l(){1t.2d.6z()});V.2G(".f-1k-Q").39("4b",l(){v(t){1t.2d.5C(t)}I{1t.2d.5C()}});V.2G(".f-1V").39("4b",l(){1t.2d.7l()});v(1w.3x){V.2G(".f-O>a").39("4b",l(e){1t.2d.3x(3,{ab:e.1S.6A("2s"),ad:e.1S.ae})})}A F=1w;40(l(){v(F.3x){F.3x(1,5s)}V.42(\'f-D\').3N.5D(\'f-is-5u\')})};w.1n.7m=l(t,K){A O=\'\',4x=\'\',3e=\'\',3f=\'\',2W=\'\',2X=\'\';8b(w.2a){4y\'CU\':3e=\'18://19.wo.cn/3d-3n/2m/3o/hz/cu.3D\';2W=\'中国联通认证服务条款\';2X=\'18://19.wo.cn/3d-3n/62/65.37\';3f=\'联通\';44;4y\'CM\':3e=\'18://19.wo.cn/3d-3n/2m/3o/hz/cm.3D\';2W=\'中国移动认证服务条款\';2X=\'18://8c.8d.8e/8f/37/8g.37\';3f=\'移动\';44;4y\'CT\':3e=\'18://19.wo.cn/3d-3n/2m/3o/hz/ct.3D\';2W=\'中国电信认证服务条款\';2X=\'18://id.8h.cn/37/8i.37\';3f=\'电信\';44;8j:3e=\'18://19.wo.cn/3d-3n/2m/3o/hz/cu.3D\';2W=\'中国联通认证服务条款\';2X=\'18://19.wo.cn/3d-3n/62/65.37\';3f=\'联通\';44}v(t&&t.66){3e=t.66}4x=t&&t.67?t.67:\'j:3E/3D;5t,8k/8l/8m+8n/8o+8p/8q+8r/8s+8t+mB+8v=\';v(t&&t.68){O=t.68.3z(\':8w\',t.4z?"<a 1S=\\"2C\\" 2s=\\"".p(2X,"\\">\\4A").p(2W,"\\4B</a>"):"<a  1S=\\"2C\\" 2s=\\"".p(2X,"\\">").p(2W,"</a>"));v(t.2t&&t.2t[0]){O=O.3z(\':8x\',t.4z?"<a 1S=\\"2C\\" 2s=\\"".p(t.2t[1],"\\">\\4A").p(t.2t[0],"\\4B</a>"):"<a 1S=\\"2C\\" 2s=\\"".p(t.2t[1],"\\">").p(t.2t[0],"</a>"))}v(t.2u&&t.2u[0]){O=O.3z(\':8y\',t.4z?"<a 1S=\\"2C\\" 2s=\\"".p(t.2u[1],"\\">\\4A").p(t.2u[0],"\\4B</a>"):"<a 1S=\\"2C\\" 2s=\\"".p(t.2u[1],"\\">").p(t.2u[0],"</a>"))}}A D=V.4r(\'E\');D.79(\'id\',\'f-D\');A 47="<E R=\\"f-3p-1O\\">\\n        <2m 3P=\\"".p(4x,"\\" 4k=\\"\\" R=\\"f-69-6a\\"><2D R=\\"f-3p\\">").p(t&&t.6b?t.6b:\'中国\'+3f,"</2D>\\n      </E>\\n      <E R=\\"f-N\\">\\n        <E R=\\"f-3E-Q\\"><2m 3P=\\"").p(3e,"\\" 4k=\\"\\" R=\\"f-3o\\"></E>\\n        <E R=\\"f-2E\\">").p(K.8z.3z(\'8A\',\'<E R="f-2c-Q"><2c R="f-2E-3y-2c" 2o="" 6B="1" 1C="1T"><2c R="f-2E-3y-2c" 2o="" 6B="1" 1C="1T"><2c R="f-2E-3y-2c" 2o="" 6B="1" 1C="1T"><2c R="f-2E-3y-2c" 2o="" 6B="1" 1C="1T"></E>\'),"</E>\\n        <E R=\\"f-1k-Q\\"><2D R=\\"f-1k\\">").p(t&&t.6c?t.6c:\'一键登录\',"</2D><2D R=\'f-1k-5E\'>\\7a\\u8865\\u5168\\u624B\\7b\\7c\\7d</2D></E>\\n        <E R=\\"f-2P\\">\\6d\\4C\\8B\\8C\\8D").p(3f,"\\8E\\8F\\6d\\4C\\8G\\8H</E>\\n      </E>\\n      <E R=\\"f-2n\\">\\n        <E R=\\"f-1f-Q\\">\\n          <E R=\\"f-1f-1A\\">\\n            <E R=\\"f-1f-1O-bg\\"></E>\\n            <E R=\\"f-1f-1O-1T\\" 8I=\\"1l 3q;\\">\\7a\\8J\\8K\\8L\\8M\\8N\\8O\\8P\\8Q\\8R\\8S</E>\\n            <E R=\\"f-1f-1k\\"><2m 3P=\\"j:3E/8T;5t,/9j/8U/8V/8W+8X/8Y+8Z+90+91+92+93+/+94/95/96/97/98/99+9a/9b/9c+9d/9e+9f+9g+9h+9i/9k/9l+9m/n1/9o/9p//Z\\" 4k=\\"\\"></E>\\n          </E>\\n        </E>\\n      </E>\\n      <E R=\\"f-O-Q\\">");47+=t&&9q(t.9r)===1?"<E R=\\"f-1V is-2Q\\">\\n          <2D R=\\"f-3r\\"></2D>\\n          <2c 1C=\\"6e\\" R=\\"f-4D\\" 2Q=\\"2Q\\" 2o=\\"\\" id=\\"3t\\">\\n          <E R=\\"f-O-2P\\">\\6f\\6g\\6h\\4E\\4F\\6i\\6j\\6k\\6l</E>\\n        </E>":"<E R=\\"f-1V\\">\\n          <2D R=\\"f-3r\\"></2D>\\n          <2c 1C=\\"6e\\" R=\\"f-4D\\" 2o=\\"\\" id=\\"3t\\">\\n          <E R=\\"f-O-2P\\">\\6f\\6g\\6h\\4E\\4F\\6i\\6j\\6k\\6l</E>\\n        </E>";v(!O){O="<E R=\\"f-O\\">\\9s\\9t\\9u\\4E\\4F\\n        <a 1S=\\"2C\\" 2s=\\"".p(2X,"\\">").p(2W,"</a>")+(t&&t.2t&&t.2t[0]?"<a 1S=\\"2C\\" 2s=\\"".p(t.2t[1],"\\">").p(t.2t[0],"</a>"):\'\')+(t&&t.2u&&t.2u[0]?"<a 1S=\\"2C\\" 2s=\\"".p(t.2u[1],"\\">").p(t.2u[0],"</a>"):\'\')+"\\9v\\9w\\9x\\9y\\7b\\7c\\7d\\9z\\9A\\9B\\4C</E>\\n        </E>"}47+="<E R=\\"f-O\\">".p(O,"</E></E>");D.4G=47;A 4H=V.4r(\'24\');4H.4G="37,3B{1o:-1D-9C-9D;}\\n    #f-D{1B: 6m; 2Y: 0; 1Q: 0; 1h: 3Q; 1o: 26%; af-1o: 3Q; 1v: #3R; z-3J: 9E; -1D-Y: 2v 0.3s; -1F-Y: 2v 0.3s; -ms-Y: 2v 0.3s; -o-Y: 2v 0.3s; Y: 2v 0.3s; -1D-G: 1J(26%); -1F-G: 1J(26%); -ms-G: 1J(26%); -o-G: 1J(26%); G: 1J(26%);}\\n    #f-D.f-is-5u {-1D-G: 1J(0); -1F-G: 1J(0); -ms-G: 1J(0); -o-G: 1J(0); G: 1J(0);}\\n    #f-D>.f-3p-1O{2p-2Z: 4.5v; 1o: 7.3i; 1O-1o: 7.3i; 1T-2F: 1M; 1B: 48;}\\n    #f-D>.f-3p-1O>2m{1h: 3i; 1B: 2j; 1Q: 1.9F; 2Y: 0.7e;}\\n    #f-D>.f-3p-1O>.f-3p{1h: 3i;}\\n    #f-D>.f-N{1B: 2j; 1Q: 0; 2Y: 45%; -1D-G: 1J(-50%); -1F-G: 1J(-50%); -ms-G: 1J(-50%); -o-G: 1J(-50%); G: 1J(-50%); 1h: 3Q;}\\n    #f-D>.f-N>.f-3E-Q{1h: 9G; 30: 0 3u 9H 3u;}\\n    #f-D>.f-N>.f-3E-Q>2m.f-3o{1h: 26%;}\\n  #f-D>.f-N>.f-2E{ 1h: 78vw; 30: 0 3u 7.3i 3u; 1o: 3g; 1O-1o: 3g; 2i: 6o; 2F-6p: 1M; 6q-N: 7i-between; 2p-ag: ah; 2p-7f: 7g; 2p-2Z: 3i; letter-spacing: 2.5w;}  \\n #f-D>.f-N>.f-2E .f-2c-Q { 1h: 32vw; 30: 0 2k; 2i: 6o; 2F-6p: 1M; 6q-N: 1M;}  \\n #f-D>.f-N>.f-2E .f-2E-3y-2c{ W: 0; 5x: 25; -1D-W-2A: 0; -1F-W-2A: 0; W-2A: 0; af-1h: 0; 1h: 3i; 30-7j: 2k; 1o: 3g; 1O-1o: 3g; 1T-2F: 1M; 2p-2Z: 3i; 2p-7f: 7g; 2p-ag: ah; 5z: 0; 1v: 25; W-1W: #7h 3j 38;}  \\n  #f-D>.f-N>.f-1k-Q{1h: 71.9I; 1o: 10.6n; 1O-1o: 3g; 1T-2F: 1M; 30: 0 3u 5w 3u; 1v: #ai; -1D-W-2A: 5.2k; -1F-W-2A: 5.2k; W-2A: 5.2k;} \\n     #f-D>.f-N>.f-1k-Q>.f-1k{2p-2Z: 4.5v; 1g: #3R; 2i: 25;} \\n  #f-D>.f-N>.f-1k-Q>.f-1k-5E{2p-2Z: 4.5v; 1g: #3R;} \\n   #f-D>.f-N>.f-2P{2p-2Z: 3.2k; 1g: #9K; 1T-2F: 1M;}\\n    #f-D>.f-O-Q{1B: 2j; 1Q: 6n; 1W: 3g; 1h: 9L; 2p-2Z: 3.2k; 1g: #7h; 2i: 6o; 2F-6p: 1M; 6q-N: 1M;}\\n    #f-D>.f-O-Q>.f-O{30-1Q: 9M;}\\n    #f-D>.f-O-Q>.f-1V { 9N-7i: 9O; 6r: 9P; 5x: 25; 2i: 4I-5y; 1O-1o: 1; 1B: 48; 9Q-2F: 9R;}\\n    #f-D>.f-O-Q>.f-1V>.f-3r { 2i: 4I-5y; 1B: 48; W: 38 3j #9S; -1D-1A-49: W-1A; -1F-1A-49: W-1A; 1A-49: W-1A; 1h: 4J; 1o: 4J; 1v-1g: #3S; z-3J: 1; -1D-Y: W-1g .2w 2x-2y(.71, -.46, .29, 1.46), 1v-1g .2w 2x-2y(.71, -.46, .29, 1.46); -1F-Y: W-1g .2w 2x-2y(.71, -.46, .29, 1.46), 1v-1g .2w 2x-2y(.71, -.46, .29, 1.46); -ms-Y: W-1g .2w 2x-2y(.71, -.46, .29, 1.46), 1v-1g .2w 2x-2y(.71, -.46, .29, 1.46); -o-Y: W-1g .2w 2x-2y(.71, -.46, .29, 1.46), 1v-1g .2w 2x-2y(.71, -.46, .29, 1.46); Y: W-1g .2w 2x-2y(.71, -.46, .29, 1.46), 1v-1g .2w 2x-2y(.71, -.46, .29, 1.46); -1D-W-2A: 50%; -1F-W-2A: 50%; W-2A: 50%;}\\n    #f-D>.f-O-Q>.f-1V>.f-3r:4K { 1A-49: N-1A; N: \\"\\"; W: 38 3j #3S; W-1Q: 0; W-2Y: 0; 1h: 9T; 1o: 9U; 1B: 2j; 1Q: 4L; 2Y: 38; -1D-G: 1K(1L) 2z(0); -1F-G: 1K(1L) 2z(0); -ms-G: 1K(1L) 2z(0); -o-G: 1K(1L) 2z(0); G: 1K(1L) 2z(0); -1D-Y: G .3K 3v-in .3L; -1F-Y: G .3K 3v-in .3L; -ms-Y: G .3K 3v-in .3L; -o-Y: G .3K 3v-in .3L; Y: G .3K 3v-in .3L; -1D-G-3M: 1M; -1F-G-3M: 1M; -ms-G-3M: 1M; -o-G-3M: 1M; G-3M: 1M;}\\n    #f-D>.f-O-Q>.f-1V.is-2Q>.f-3r { 1v-1g: #6s; W-1g: #6s;}\\n    #f-D>.f-O-Q>.f-1V.is-2Q>.f-3r:4K { -1D-G: 1K(1L) 2z(1); -1F-G: 1K(1L) 2z(1); -ms-G: 1K(1L) 2z(1); -o-G: 1K(1L) 2z(1); G: 1K(1L) 2z(1);}\\n    #f-D>.f-O-Q>.f-1V>.f-4D { 4M: 0; 5x: 25; 1B: 2j; 30: 0; 1h: 0; 1o: 0; z-3J: -1;}\\n    #f-D>.f-O-Q>.f-O>a{1g: #9V; 1T-9W: 25;}\\n    #f-D>.f-O-Q>.f-1V>.f-O-2P{1B: 2j; 2Y: -3g; 1Q: -2.5w; 2p-2Z: 6t; 5z: 2k; 1v: #3S; 1A-9X: 25; W: 38 3j #4N; 4M: 0; -1D-Y: 2v 0.3s; -1F-Y: 2v 0.3s; -ms-Y: 2v 0.3s; -o-Y: 2v 0.3s; Y: 2v 0.3s;}\\n    #f-D>.f-O-Q>.f-1V>.f-O-2P.f-5A{4M: 1;}\\n    #f-D>.f-O-Q>.f-1V>.f-O-2P:4K{N: \'\'; 1B: 2j; 1h: 2k; 1o: 2k; -1D-G: 1K(1L); -1F-G: 1K(1L); -ms-G: 1K(1L); -o-G: 1K(1L); G: 1K(1L); 1W: -1.2k; 1Q: 2k; 1v: #3R; W-7j: 38 3j #4N; W-1W: 38 3j #4N;}\\n    #f-D>.f-2n {1B: 6m; 1h: 3Q; 1o: 26%; 1Q: 0; 2Y: 0; 1v: 9Y(0, 0, 0, 0.4); z-3J: 10; 2i: 25; 9Z-a0: 25;}\\n    #f-D>.f-2n>.f-1f-Q {1B: 2j; 1W: -26%; 1Q: 0; 1h: 3Q; 5z: 3g 0; 1v: #3R; -1D-Y: 1W 0.3s; -1F-Y: 1W 0.3s; -ms-Y: 1W 0.3s; -o-Y: 1W 0.3s; Y: 1W 0.3s;}\\n    #f-D>.f-2n>.f-6u-6v-1W {1W: 0;}\\n    #f-D>.f-2n>.f-1f-Q>.f-1f-1A {1h: a1; 1o: 4a; 1O-1o: 4a; 30-1Q: 3g; 1v-1g: #a2; 1B: 48; W-2A: 4L; a3: a4;}\\n    #f-D>.f-2n>.f-1f-Q>.f-1f-1A>.f-1f-1O-bg {1h: 4a; 1o: 26%; 1B: 2j; 1v-1g: #7k;}\\n    #f-D>.f-2n>.f-1f-Q>.f-1f-1A>.f-1f-1O-1T {1B: 2j; 1h: 26%; 1o: 26%; 1T-2F: 1M; 6w-6x: 25; 1g: #a5; 2p-2Z: 4J;}\\n    #f-D>.f-2n>.f-1f-Q>.f-1f-1A>.f-1f-1k {1h: 4a; 1o: a6; 1B: 2j; W: 38 3j #a7; 6r: a8; 1T-2F: 1M; 1v-1g: #3S; 6w-6x: 25; 1g: #a9; W-2A: 4L; z-3J: 10;}\\n    #f-D>.f-2n>.f-1f-Q>.f-1f-1A>.f-1f-1k 2m {1h: aa; 30-2Y: 6t;}";v(t&&t.6y){V.42(t.6y).41(D)}I{V.5B(\'3B\')[0].41(D)}V.5B(\'3B\')[0].41(4H);V.2G(".f-69-6a").39("4b",l(){1t.2d.6z()});A 31=V.2H(\'f-2E-3y-2c\');A 7n=l 7n(i){31[i].39(\'2c\',l(){1t.2d.aj(3a,i+1)});31[i].39(\'keyup\',l(){1t.2d.ak(3a,i+1)})};3W(A i=0;i<31.33;i++){7n(i)}V.2G(".f-1k-Q").39("4b",l(){v(t){1t.2d.5C(t)}I{1t.2d.5C()}});V.2G(".f-1V").39("4b",l(){1t.2d.7l()});v(1w.3x){V.2G(".f-O>a").39("4b",l(e){1t.2d.3x(3,{ab:e.1S.6A("2s"),ad:e.1S.ae})})}A F=1w;40(l(){v(F.3x){F.3x(1,5s)}V.42(\'f-D\').3N.5D(\'f-is-5u\')})};w.1n.al=l(){A 1A=V.2G(".f-1f-1A"),bg=V.2G(".f-1f-1O-bg"),1T=V.2G(".f-1f-1O-1T"),1k=V.2G(".f-1f-1k"),1X=3q,6C=1A.7o-1k.7o;V.2G(".f-2n").39("6D",l(e){v(e&&e.4c){e.4c();e.6E()}I{1t.3a.6F=3q}});V.2G(".f-1f-Q").39("6D",l(e){v(e&&e.4c){e.4c();e.6E()}I{1t.3a.6F=3q}});1A.39("6D",l(e){v(e&&e.4c){e.4c();e.6E()}I{1t.3a.6F=3q}});1k.39("6D",l(e){v(e&&e.4c){e.4c();e.6E()}I{1t.3a.6F=3q}1k.24.Y="";bg.24.Y="";bg.24.am="1";A e=e||1t.3a;A 4d=e.touches[0].clientX-1k.7o;v(4d>6C){4d=6C}I v(4d<0){4d=0}1k.24.1Q=4d+"px";bg.24.1h=4d+10+"px";v(4d==6C&&!1X){1T.4G="验证通过";1T.24.1g="#3S";1k.4G=\'<2m 3P="j:3E/3D;5t,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACFUlEQVRYR+2VQWvUQBTH/89FPIsgCB78BoIgQr+AbkKyopmgSEFtQQRpsbooIlQEUdFKoWyoYqmClDZJD5mQ2UM9eOq38FtUL2KfpLpLNiab3W1297I5Zmbe7zdvZt4jjPmjMfMxEZhkYKQZuLRpnK9UaJ6Zvyo7/BQ/gJEJaL5xFUwOgJNgvjVSAc01F0BYOtgx0fPIChZbz3/oGdB8cxmM+RjIzC+advg0WXuGJnBx+8qpyu9fDogu/wO+VEI+SRe+oQhofu0C7bPDhHN/Lxq9jkTwOKvqli6g+YbNTA4BJw7SDn7bFGE9r+SXKqB7tYcMftOGEd4pSz7o1m9KE9Bdc4UJ9xK3ezkS8n5Rs+sQ0DxzkUA7kQh2ixa2xqvb1dPYP9ogwGz9Y9BKUwRzvcRoC8RwAM8I2GNCXVlytSiA7tWmmNkB4WxibkMJ2c5EUYy2gO4aM0z0MbFg9Scfq3+zvb2sINqWcR1HqAHgeHKNEvJuETS3Dmie6QIQiQm7BKqnj0T3jEcMepUMxIQPTUve6Qee2QvSEukjqbqmQ4TOXTLWlC1n+4XnNqOMTMTV5DuAChhnOkG8rkR4exB4rkA8kCmRohDhc2TJm4PCuwr0IPFFCTl9GHihQK4E0YayghuHhfck8J8E8ZaywmtlwHsWiCdWffM9Mf9QIlwoC96XQJnQ3EI0LEi3uKV1w0HlJwJjz8AfbdWqIeoz4tAAAAAASUVORK5CYII=" 4k="">\';bg.24.backgroundColor="#7k";bg.24.am="0";1X=6Q;40(l(){1t.2d.7p();5n.2G(\'.f-1f-Q\').3N.5F(\'f-6u-6v-1W\')},ao);40(l(){5n.2G(\'.f-2n\').24.2i=\'25\'},600)}});1k.39("touchend",l(e){v(1X){1l 3q}I{1k.24.1Q="0";bg.24.1h="0";1k.24.Y="1Q 1s 3v";bg.24.Y="1h 1s 3v"}})};w.1n.5C=l(){A 1k=V.2H(\'f-1k-5E\')[0];A 2i=\'\';v(1k){2i=1k.24.2i;v(2i!==\'25\'){1l 3q}}A t=4O.33>0&&4O[0]!==ap?4O[0]:{};A 3t=V.42(\'3t\');v(3t.6A(\'2Q\')){5n.2G(\'.f-2n\').24.2i=\'5y\';v(t&&t.enableSlideVerification===3q){1w.7p()}I{1w.al();40(l(){5n.2G(\'.f-1f-Q\').3N.5D(\'f-6u-6v-1W\')})}}I v(!(t&&t.enableHintToast===3q)){V.2H(\'f-O-2P\')[0].3N.5D(\'f-5A\');40(l(){V.2H(\'f-O-2P\')[0].3N.5F(\'f-5A\')},1500)}};w.1n.7l=l(){A 3t=V.42(\'3t\');A 7q=V.2H(\'f-1V\')[0];v(3t.6A(\'2Q\')){3t.removeAttribute(\'2Q\');7q.3N.5F(\'is-2Q\')}I{3t.79(\'2Q\',\'2Q\');7q.3N.5D(\'is-2Q\');V.2H(\'f-O-2P\')[0].3N.5F(\'f-5A\')}};w.1n.aj=l(3a,1C){A 31=V.2H(\'f-2E-3y-2c\');A 4P=\'\';v(31.33){4P=31[0].2o+31[1].2o+31[2].2o+31[3].2o}v(4P.33===4){V.2H(\'f-1k-Q\')[0].24.1v=\'#9J\';V.2H(\'f-1k\')[0].24.2i=\'4I\';V.2H(\'f-1k-5E\')[0].24.2i=\'25\'}I{V.2H(\'f-1k-Q\')[0].24.1v=\'#ai\';V.2H(\'f-1k\')[0].24.2i=\'25\';V.2H(\'f-1k-5E\')[0].24.2i=\'4I\'}A aq=/^[0-9]*$/;v(!aq.6W(3a.1S.2o)){3a.1S.2o=\'\';1l 3q}v(3a.1S.2o){v(1C<4){V.2H(\'f-2E-3y-2c\')[1C].7r()}}I{v(1C>1){V.2H(\'f-2E-3y-2c\')[1C-2].7r()}}};w.1n.ak=l(3a,1C){A 7s=3a.4h||3a.T;v(7s===\'Backspace\'||7s===\'Delete\'){v(!3a.1S.2o&&1C>1){V.2H(\'f-2E-3y-2c\')[1C-2].2o=\'\';V.2H(\'f-2E-3y-2c\')[1C-2].7r()}}};w.1n.6z=l(){A D=V.42(\'f-D\');D.3N.5F(\'f-is-5u\');40(l(){V.5B(\'3B\')[0].6V(D);v(1w.3x){1w.3x(2,5s)}},ao)};w.1n.7p=l(){A 31=V.2H(\'f-2E-3y-2c\');A 4P=\'\';v(31.33){4P=31[0].2o+31[1].2o+31[2].2o+31[3].2o}1w.6z();A F=1w;A j={4w:w.4w,1e:w.1e,1p:w.L.1p,2e:\'H5\',7t:4P||\'\',C:"".p(w.L.1p).p(w.L.2V||2R()),2f:w.L.2V||2R(),28:\'1.3.0\',1Z:\'1.3.0\'};j.1I=w.L.1I;j.4i=3O("4w=".p(j.4w,"&1I=").p(j.1I,"&1e=").p(j.1e,"&1p=").p(j.1p,"&2e=").p(j.2e,"&7t=").p(j.7t,"&C=").p(j.C,"&2f=").p(j.2f,"&28=").p(j.28,"&1Z=").p(j.1Z));$.3A({1C:\'1P\',J:\'18://19.wo.cn/1x-3w-1y-id/1z/4Q\',j:j,1X:l 1X(1q,B){B=1u.2U(B);v(B.1c!==0){A 1d={J:"18://19.wo.cn/1x-3w-1y-id/1z/4Q",2N:"1P",L:j,K:B};A 1r=w.1e===0?"3":"2";F.2q(1u.2r(1d),1r,"2","5")}v(B.1c===0){F.1U({T:\'5V\',2a:w.2a,ar:B.N.ar})}I v(B.1c===1){F.1U({"1b":1d.J+"?C="+j.C,"T":"1G","1H":B.3c})}I{F.1U({"1b":1d.J+"?C="+j.C,"T":"1G","1H":B.1c})}},1R:l 1R(1q,B){B=1u.2U(B);A 1d={J:"18://19.wo.cn/1x-3w-1y-id/1z/4Q",2N:"1P",L:j,4j:"-1"};A 1r=w.1e===0?"3":"2";v(B===\'1Y\'){F.2q(1u.2r(1d),1r,"3","4");F.1U({"1b":1d.J+"?C="+j.C,"T":"3I"})}I v(B.1c===1){F.1U({"1b":1d.J+"?C="+j.C,"T":"1G","1H":B.3c})}I{F.1U({"1b":1d.J+"?C="+j.C,"T":"1G","1H":B.1c})}}})};w.1n.as=l(N){A F=1w;1l 2S 3l(l(1E,P){5R(N.J,{},\'86\').2g(l(4v){F.at(N.callBackUrl,4v).2g(l(1N){1E(1N)})["2h"](l(1j){P(1j)})})["2h"](l(1j){v(1j===\'1Y\'){P({"1b":N.J+(N.J.2T("?")?"&":"?")+"C=","T":"3I"})}I{P({"1b":N.J+(N.J.2T("?")?"&":"?")+"C=","T":"73"})}})})};w.1n.at=l(au,2O){A 35=1t.atob(au);A J=35.3C(\'?\')[0];A 5i=35.3C(\'?\')[1].3C(\'&\');1l 2S 3l(l(1E,P){A 1m={1I:w.L.1I,1e:w.1e,1p:w.L.1p,2e:\'H5\',T:2O.T||\'\',errCode:2O.err_code||\'\',7u:\'\',C:"".p(w.L.1p).p(w.L.2V||2R()),av:2O.av||\'\',3T:w.3T,2f:w.L.2V||2R(),28:\'1.3.0\',7v:\'\',1Z:\'1.0.0\'};5i.7T(l(3Z){v(3Z.3C(\'=\')[0]===\'7u\'){1m.7u=3Z.3C(\'=\')[1]}I v(3Z.3C(\'=\')[0]===\'7v\'){1m.7v=3Z.3C(\'=\')[1]}});1m.4i=3O("1I=".p(1m.1I,"&1e=").p(1m.1e,"&1p=").p(1m.1p,"&2e=").p(1m.2e,"&C=").p(1m.C,"&5p=&3T=").p(1m.3T,"&2f=").p(1m.2f,"&28=").p(1m.28,"&1Z=").p(1m.1Z));$.3A({1C:\'1P\',J:J,j:1m,1X:l 1X(1q,K){K=1u.2U(K);v(K.N.mark!==\'3d\'){1E({"T":"5V","j":K})}I v(K.1c===1){P({"1b":J+"?C="+1m.C,"T":"1G","1H":K.3c})}I{P({"1b":J+"?C="+1m.C,"T":"1G","1H":K.1c})}},1R:l 1R(1q,K){K=1u.2U(K);v(K===\'1Y\'){P({"1b":J+"?C="+1m.C,"T":"3I"})}I v(K.1c===1){P({"1b":J+"?C="+1m.C,"T":"1G","1H":K.3c})}I{P({"1b":J+"?C="+1m.C,"T":"1G","1H":K.1c})}}})})};w.1n.initWithAuth=l(L){w.1n.2M=3U;A F=1w;1l 2S 3l(l(1E,P){w.L=L;4p[\'Req-Timestamp\']=L.2V;4p[\'7K-Id\']=L.1p;4p[\'Authorization\']=\'Digest \'+L.1I;L.2e=\'H5\';L.1Z=\'1.3.0\';L.28=\'1.3.0\';L.C="".p(L.1p).p(L.2V);F.83(L).2g(l(K){1E(K)})["2h"](l(5h){P(5h)})})};w.1n.verifyMobile=l(){A t=4O.33>0&&4O[0]!==ap?4O[0]:5s;w.1n.2M=3U;A F=1w;w.1n.2M=t&&t.1Y?t.1Y:3U;w.1e=0;1l 2S 3l(l(1E,P){v(!w.5o){P({"1b":"","T":\'6G\'})}I{v(w.5U){F.5Z({1C:\'1\'}).2g(l(K){w.5X=K;F.72().2g(l(B){1E(B)})["2h"](l(1j){P(1j)})})["2h"](l(5h){P(5h)})}I{F.72().2g(l(B){1E(B)})["2h"](l(1j){P(1j)})}}})};w.1n.4Q=l(t){A F=1w;v(!w.5o){w.1n.1U=t.35;1w.1U({T:\'6G\'})}I{w.1n.2M=3U;w.1n.2M=t&&t.1Y?t.1Y:3U;w.1e=1;w.1n.1U=t.35;w.1n.3x=t.aw||\'\';A j={1e:w.1e,1p:w.L.1p,2e:\'H5\',C:"".p(w.L.1p).p(w.L.2V||2R()),2f:w.L.2V||2R(),3m:\'5W\',28:\'1.3.0\',1Z:\'1.3.0\'};j.1I=w.L.1I;j.4i=3O("1I=".p(j.1I,"&1e=").p(j.1e,"&1p=").p(j.1p,"&2e=").p(j.2e,"&C=").p(j.C,"&2a=&5p=&2f=").p(j.2f,"&3m=").p(j.3m,"&28=").p(j.28,"&1Z=").p(j.1Z));$.3A({1C:\'1P\',J:\'18://19.wo.cn/1x-3w-1y-id/1z/2b\',j:j,1X:l 1X(1q,B){B=1u.2U(B);w.2a=B.N.2a;v(B.1c!==0){A 1d={J:"18://19.wo.cn/1x-3w-1y-id/1z/4Q",2N:"1P",L:j,K:B};A 1r=w.1e===0?"3":"2";F.2q(1u.2r(1d),1r,"2","5")}v(B.1c===0){v(B.N.2a===\'CU\'){F.5q(B.N).2g(l(1N){F.78(t,1N.j)})["2h"](l(1j){F.1U(1j)})}I v(B.N.2a===\'CT\'){F.5r(B.N).2g(l(1N){F.78(t,1N.j)})["2h"](l(1j){F.1U(1j)})}}I v(B.1c===1){F.1U({"1b":"18://19.wo.cn/1x-3w-1y-id/1z/2b?C="+j.C,"T":"1G","1H":B.3c})}I{F.1U({"1b":"18://19.wo.cn/1x-3w-1y-id/1z/2b?C="+j.C,"T":"1G","1H":B.1c})}},1R:l 1R(1q,B){B=1u.2U(B);A 1d={J:"18://19.wo.cn/1x-3w-1y-id/1z/2b",2N:"1P",L:j,4j:"-1"};A 1r=w.1e===0?"3":"2";v(B===\'1Y\'){F.2q(1u.2r(1d),1r,"3","4");F.1U({"1b":1d.J+"?C="+j.C,"T":"3I"})}I v(B.1c===1){F.1U({"1b":1d.J+"?C="+j.C,"T":"1G","1H":B.3c})}I{F.1U({"1b":1d.J+"?C="+j.C,"T":"1G","1H":B.1c})}}})}};w.1n.loginWithInput=l(t){A F=1w;v(!w.5o){w.1n.1U=t.35;1w.1U({T:\'6G\'})}I{w.1n.2M=3U;w.1n.2M=t&&t.1Y?t.1Y:3U;w.1e=1;w.1n.1U=t.35;w.1n.3x=t.aw||\'\';A j={1e:w.1e,1p:w.L.1p,2e:\'H5\',C:"".p(w.L.1p).p(w.L.2V||2R()),2f:w.L.2V||2R(),3m:\'5W\',28:\'1.3.0\',1Z:\'1.3.0\'};j.1I=w.L.1I;j.4i=3O("1I=".p(j.1I,"&1e=").p(j.1e,"&1p=").p(j.1p,"&2e=").p(j.2e,"&C=").p(j.C,"&2a=&5p=&2f=").p(j.2f,"&3m=").p(j.3m,"&28=").p(j.28,"&1Z=").p(j.1Z));$.3A({1C:\'1P\',J:\'18://19.wo.cn/1x-3w-1y-id/1z/2b\',j:j,1X:l 1X(1q,B){B=1u.2U(B);w.2a=B.N.2a;v(B.1c!==0){A 1d={J:"18://19.wo.cn/1x-3w-1y-id/1z/4Q",2N:"1P",L:j,K:B};A 1r=w.1e===0?"3":"2";F.2q(1u.2r(1d),1r,"2","5")}v(B.1c===0){v(B.N.2a===\'CU\'){F.5q(B.N).2g(l(1N){F.7m(t,1N.j)})["2h"](l(1j){F.1U(1j)})}I v(B.N.2a===\'CT\'){F.5r(B.N).2g(l(1N){F.7m(t,1N.j)})["2h"](l(1j){F.1U(1j)})}}I v(B.1c===1){F.1U({"1b":"18://19.wo.cn/1x-3w-1y-id/1z/2b?C="+j.C,"T":"1G","1H":B.3c})}I{F.1U({"1b":"18://19.wo.cn/1x-3w-1y-id/1z/2b?C="+j.C,"T":"1G","1H":B.1c})}},1R:l 1R(1q,B){B=1u.2U(B);A 1d={J:"18://19.wo.cn/1x-3w-1y-id/1z/2b",2N:"1P",L:j,4j:"-1"};A 1r=w.1e===0?"3":"2";v(B===\'1Y\'){F.2q(1u.2r(1d),1r,"3","4");F.1U({"1b":1d.J+"?C="+j.C,"T":"3I"})}I v(B.1c===1){F.1U({"1b":1d.J+"?C="+j.C,"T":"1G","1H":B.3c})}I{F.1U({"1b":1d.J+"?C="+j.C,"T":"1G","1H":B.1c})}}})}};w.1n.getPseudoCode=l(t){w.1n.2M=3U;A F=1w;w.1n.2M=t&&t.1Y?t.1Y:3U;w.1e=2;w.3T=1t.btoa(t.ax);1l 2S 3l(l(1E,P){v(!w.5o){P({"1b":"","T":\'6G\'})}I v(!t.ax){P({"1b":"","T":\'100005\'})}I{A j={1I:w.L.1I,1e:w.1e,1p:w.L.1p,2e:\'H5\',C:"".p(w.L.1p).p(w.L.2V||2R()),3T:w.3T,2f:w.L.2V||2R(),28:\'1.3.0\',1Z:\'1.0.0\'};j.4i=3O("1I=".p(j.1I,"&1e=").p(j.1e,"&1p=").p(j.1p,"&2e=").p(j.2e,"&C=").p(j.C,"&5p=&3T=").p(j.3T,"&2f=").p(j.2f,"&28=").p(j.28,"&1Z=").p(j.1Z));$.3A({1C:\'1P\',J:\'18://19.wo.cn/1x-3w-1y-id/1z/H5-4R/2b\',j:j,1X:l 1X(1q,B){B=1u.2U(B);v(B.1c===0){F.as(B.N).2g(l(1N){1E(1N)})["2h"](l(1j){P(1j)})}I v(B.1c===1){P({"1b":"18://19.wo.cn/1x-3w-1y-id/1z/H5-4R/2b?C="+j.C,"T":"1G","1H":B.3c})}I{P({"1b":"18://19.wo.cn/1x-3w-1y-id/1z/H5-4R/2b?C="+j.C,"T":"1G","1H":B.1c})}},1R:l 1R(1q,B){B=1u.2U(B);v(B===\'1Y\'){P({"1b":"18://19.wo.cn/1x-3w-1y-id/1z/H5-4R/2b?C="+j.C,"T":"3I"})}I v(B.1c===1){P({"1b":"18://19.wo.cn/1x-3w-1y-id/1z/H5-4R/2b?C="+j.C,"T":"1G","1H":B.3c})}I{P({"1b":"18://19.wo.cn/1x-3w-1y-id/1z/H5-4R/2b?C="+j.C,"T":"1G","1H":B.1c})}}})}})};80.2d=2S w()}(1t,V);',[],654,'|||||||||||||||xw||||data||function||||concat||||config||if|SDK||||var|res|msgId|authorize|div|_this|transform||else|url|response|params||content|agreement|reject|container|class||code||document|border||transition||||||||||https|hmrz||errorUrl|result|obj|businessType|slider|color|width||err|btn|return|data2|prototype|height|clientId|xhr|serviceId||window|JSON|background|this|api|net|app|box|position|type|webkit|resolve|moz|100001|respCode|authorization|translateY|rotate|45deg|center|response3|line|GET|left|fail|target|text|loginCallback|checkbox__input|bottom|success|timeout|version|||||style|none|100||sdkVersion||netType|begin|input|JWuSDK|clientType|reqTimestamp|then|catch|display|absolute|2vw|md5_AddUnsigned|img|popup|value|font|_trace|stringify|href|appPrivacyOne|appPrivacyTwo|all|25s|cubic|bezier|scaleY|radius|retUrl|_blank|span|mobile|align|querySelector|getElementsByClassName|md5_FF|md5_GG|md5_HH|md5_II|wusdk_timeout|method|res2|tip|checked|getTimestamp|new|indexOf|parse|reqTimeStamp|agreementTitle|agreementLink|top|size|margin|inputs||length||callback|iframe|html|1px|addEventListener|event||errorCode|sdk|logoSrc|tipWord|10vw||6vw|solid|string|Promise|respType|resource|logo|title|false|checkbox__inner||xwAgree|auto|ease||loginWatch|number|replace|ajax|body|split|png|image|lByteCount|timestamp|format|100003|index|15s|05s|origin|classList|md5|src|100vw|ffffff|fff|redirectUrl|20000|lWordArray|for|utftext|_ref|item|setTimeout|appendChild|getElementById||break|||htmlStr|relative|sizing|40px|click|preventDefault|offsetX|lResult|lWordCount|substr|key|sign|interval|alt|lX8|lY8|String|fromCharCode|wusdk_headers|wusdk_timeInterval|createElement|authentication|||response1|accessCode|backImgSrc|case|appPrivacyWithBookMark|u300A|u300B|u8BC1|checkbox__original|u540C|u610F|innerHTML|styleTag|inline|14px|after|4px|opacity|3d3d3d|arguments|inputValue|login|mask|md5_RotateLeft|lValue|lMessageLength|lBytePosition|md5_WordToHex|lCount|S11|S12||S13|S14|S21|S22|S23|S24|S31|S32|S33|S34|S41|S42|S43|S44|million|headers|error|query|queryData|script|RegExp|deviceType|doc|isInited|privateIp|_getResponseContent|_getTeleResponseContent|null|base64|sliding|27vw|5vw|outline|block|padding|show|getElementsByTagName|_oneClickLogin|add|gray|remove|||lX4|lY4|0x40000000|lNumberOfWords|WordToHexValue|WordToHexValue_temp|128|setRequestHeader|status|jsonp|timer|msg|appId|000000|normal|preSign||_getCMResponseContent|_redirect|exception|terms|||number_authentication|logoImg|navBackImg|appPrivacyTemplate|back|icon|navText|loginBtnText|u8BA4|checkbox|u60A8|u8FD8|u672A|u534F|u8BAE|u6761|u6B3E|fixed|4vw|flex|items|justify|cursor|409eff|12px|slide|from|user|select|mount|_removeAuthorize|getAttribute|maxlength|distance|touchmove|stopPropagation|returnValue|100002|iShiftBits|0x80000000|lNumberOfWords_temp1|lByte|||||isAsync|true|key2|wusdk_traceId|readyState|clearInterval|removeChild|test|opt|msgType|level|isAndroid||_begin|100009|iframeSrc|contentWindow|postMessage|onmessage|_showAuthorizePage|setAttribute|u8BF7|u673A|u53F7|u7801|8vw|weight|bold|666666|space|right|4aab4e|_changeCheckedStatus|_showAuthorizePageWithNumber|_loop|offsetWidth|_getAccessToken|xwAgreeCon|focus|keyCode|maskValidateNum|hmrzId|traceId|0x3FFFFFFF|md5_F|md5_G|md5_H|md5_I|md5_ConvertToWordArray|lNumberOfWords_temp2|Array|charCodeAt|md5_Utf8Encode|Date|_format||encodeURIComponent|Client|Type||setInterval|200|responseText|POST|send|getTelePortal|forEach|getMonth|getHours|returnVersion|ios||Mac|win|Android|isIOS|_getConfig|nisPortalAddress|200001|getPortal|CMIframe|attachEvent|onload|clientSecret|switch|wap|cmpassport|com|resources|contract|189|agreement_539|default|iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3NpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw|eHBhY2tldCBiZWdpbj0i77u|IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8|IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDYuMC1jMDAyIDc5LjE2NDM2MCwgMjAyMC8wMi8xMy0wMTowNzoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowNTRiY2UxYy1jYmU1LTg3NGEtYTUzMS00Mzk2YjQwYTlmMWUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ODM1OEFFOTNBQUJGMTFFQTgxQ0ZENzEzRkZDMjg4QjYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ODM1OEFFOTJBQUJGMTFFQTgxQ0ZENzEzRkZDMjg4QjYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIxLjEgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MDU0YmNlMWMtY2JlNS04NzRhLWE1MzEtNDM5NmI0MGE5ZjFlIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjA1NGJjZTFjLWNiZTUtODc0YS1hNTMxLTQzOTZiNDBhOWYxZSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI|PiqmcLIAAADqSURBVHja7NlRDsIgDAbg1fjmTfQ|Xs93z6M7gfdgJdEH46a0EPr|EZK|LfBlg0GLpJQmtrabCNtA92p7y8Mi0mrco8bsXU8RbzqDrxoXlunxAp80Du5e8icqjQbgWx7yCTeN|ebohP4Ao6NXwcjoTTAq|isYEf0TjIYuAiOhi8EoaBMYAW0GR6Nd4Ei0GxyFrgJHoKvBvdFNwD3RzcA1aMoc8S||1CpP3l0W4utNs47YGJ9mhKmwTQplu0iS1tCYG2WENbFqMtQNKWelfhLEnArHHWuGs8vJ2I5Q2iXBTJuLEd6O22CDAAqFbCeh6fI3sAAAAASUVORK5CYII|wusdk|privacyOne|privacyTwo|maskMobile|xxxx|u670D|u52A1|u7531|u7EDF|u4E00|u63D0|u4F9B|onselectstart|u6309|u4F4F|u6ED1|u5757|u62D6|u52A8|u5230|u6700|u53F3|u8FB9|jpg|4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP|sABFEdWNreQABAAQAAAA8AAD|4QMsaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu|7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI|PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA2LjAtYzAwMiA3OS4xNjQzNjAsIDIwMjAvMDIvMTMtMDE6MDc6MjIgICAgICAgICI|IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI|IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCAyMS4xIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo2QTY2OTU5N0IzQUQxMUVBODNCNkM4OTJEMEI1QUE0MSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo2QTY2OTU5OEIzQUQxMUVBODNCNkM4OTJEMEI1QUE0MSI|IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjZBNjY5NTk1QjNBRDExRUE4M0I2Qzg5MkQwQjVBQTQxIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjZBNjY5NTk2QjNBRDExRUE4M0I2Qzg5MkQwQjVBQTQxIi8|IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY|IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8|4ADkFkb2JlAGTAAAAAAf|bAIQABgQEBAUEBgUFBgkGBQYJCwgGBggLDAoKCwoKDBAMDAwMDAwQDA4PEA8ODBMTFBQTExwbGxscHx8fHx8fHx8fHwEHBwcNDA0YEBAYGhURFRofHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8f|8AAEQgAIAAiAwERAAIRAQMRAf|EAJIAAAMBAQAAAAAAAAAAAAAAAAMFBgcEAQADAQEAAAAAAAAAAAAAAAAEBQYDAhAAAQIDAwYOAwAAAAAAAAAAAQIDABIEEQUHchMzwwY2IVFxMlKCI4OzFDRUtBVhIkURAAECAQcHCwUAAAAAAAAAAAEAAhExgcEDBAUGIbESMoIzNEFRYaEiQlKywhNDcZHRFBX|2gAMAwEAAhEDEQA|ANCw4q6pe1VM|48tbtaHTVKUonOdmpf7dYCIG6LXWOtwBJ7WlH7EpLZa1xrpZYq|xCqH2Nj7wWw4ppw5pE6TYZXHkIULRxpURFbe1YWWZ5bkMKQmdqcRVkhI8JVrTT3jTzHMtFlTbZNoSVzzEcsohJhave8VgcYgaPXH8IO7XkhwPQhYuuun6mlnUKd01DjrYNiVKbzYQTx2TmNMUVzmVbADLGhdXi8gCCjfub2927ofLc86HoRJ|wBO0eM6ujMln7D|fkgu|DbeO7MlzwVwdcvHt2vKVtZN8J8y0DEjcyvyqf5LcWV9cI|bOE1te6KSYUf1O41kIcJfLs|pB3Z3pqULFr1Ny5NVqY1xXqMnoXV5SBQkRKUJ1hvvHdmS54K4e3Lx7drylGWTfCfMtAxH3Nr8qn|Q3FlfXCPmzhNbXuikuFP9TuNZCHCXy7PqQd2d6alBxa9Tc2TVamNcV6jJ6F1eUgULESlCosPbvrWtpqVt1laF0gdFSCCJDm1I4esYo7ms7xbxEHs6UejIQj7Iw|9JJFXe39M||UbJV7TCC452S5Ei0yoeQtRs|CUkxXXuwusrwBEwpCZ2oE1ZgkuFlO8hm8H1IIadLSW1kcCiieazkmEI8KVbg2scRkOj1RjnQd2tIDj9ELFamfWq6qhKCplrzCHFgWhKnM2Ug8shjTFVW41bCBkBNC6vJp0QVIfQ3x7R3Q|Y5p0fSiS||gOrpSciWew|m5Ir|parseInt|defaultCheckBoxState|u767B|u5F55|u5373|u5E76|u4F7F|u7528|u672C|u8FDB|u884C|u9A8C|fill|available|99999|87vw|22vw|16vw|73vw|6a67ff|999999|92vw|1vw|white|nowrap|pointer|vertical|middle|dcdfe6|3px|7px|6969ff|decoration|shadow|rgba|touch|action|80vw|e8e8e8|overflow|hidden|88949d|38px|ccc|move|666|16px|link||name|innerText|min|family|Arial|bcbcbc|_onInputHandler|_onDeleteHandler|_showSlide|zIndex||300|undefined|regNumber|accessToken|_getResponseContentMask|_maskCallback|callbackUrl|province|watch|ret_url'.split('|'),0,{}))


/***/ }),

/***/ 0:
/*!****************************!*\
  !*** multi ./src/index.ts ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./src/index.ts */"./src/index.ts");


/***/ })

/******/ });
});
//# sourceMappingURL=http://127.0.0.1:8080/build/numberAuth-web-sdk.js.map